import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = { context: { clientName: 'wp' } } as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Acf_Content_Blocks =
  | Acf_Content_Blocks_2ColumnSection
  | Acf_Content_Blocks_Accordion
  | Acf_Content_Blocks_AppCta
  | Acf_Content_Blocks_BlogPosts
  | Acf_Content_Blocks_BrazeCard
  | Acf_Content_Blocks_BrazeMessage
  | Acf_Content_Blocks_CannabisCounselingCta
  | Acf_Content_Blocks_CardSteps
  | Acf_Content_Blocks_Cards
  | Acf_Content_Blocks_CardsImage
  | Acf_Content_Blocks_CardsList
  | Acf_Content_Blocks_Carousel
  | Acf_Content_Blocks_CircleList
  | Acf_Content_Blocks_ColumnChart
  | Acf_Content_Blocks_ColumnList
  | Acf_Content_Blocks_ContentAndBanner
  | Acf_Content_Blocks_ContentAndMedia
  | Acf_Content_Blocks_DateTime
  | Acf_Content_Blocks_Events
  | Acf_Content_Blocks_Faqs
  | Acf_Content_Blocks_Form
  | Acf_Content_Blocks_Image
  | Acf_Content_Blocks_Info
  | Acf_Content_Blocks_InfoCard
  | Acf_Content_Blocks_InfoGrid
  | Acf_Content_Blocks_InfoIcons
  | Acf_Content_Blocks_Intro
  | Acf_Content_Blocks_Line
  | Acf_Content_Blocks_Marquee
  | Acf_Content_Blocks_MedicalCardCta
  | Acf_Content_Blocks_MedicalConditions
  | Acf_Content_Blocks_Method
  | Acf_Content_Blocks_MosaicCards
  | Acf_Content_Blocks_OnceApproved
  | Acf_Content_Blocks_PartnersLocation
  | Acf_Content_Blocks_PriceComparison
  | Acf_Content_Blocks_PricingForm
  | Acf_Content_Blocks_Reviews
  | Acf_Content_Blocks_RichText
  | Acf_Content_Blocks_RoundedSection
  | Acf_Content_Blocks_SeenOn
  | Acf_Content_Blocks_SignUpForm
  | Acf_Content_Blocks_SimpleCardCta
  | Acf_Content_Blocks_SizzleVideo
  | Acf_Content_Blocks_Slider
  | Acf_Content_Blocks_StateLawsMap
  | Acf_Content_Blocks_Stats
  | Acf_Content_Blocks_StatsHighlight
  | Acf_Content_Blocks_Steps
  | Acf_Content_Blocks_Table
  | Acf_Content_Blocks_TableOfContents
  | Acf_Content_Blocks_Team
  | Acf_Content_Blocks_Timeline
  | Acf_Content_Blocks_YoutubeVideo;

/** Group within the flex field */
export type Acf_Content_Blocks_2ColumnSection = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_2ColumnSection';
  background: Maybe<MediaItem>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  leftContent: Maybe<Scalars['String']>;
  leftTitle: Maybe<Scalars['String']>;
  rightContent: Maybe<Scalars['String']>;
  rightTitle: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Accordion = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Accordion';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Icon to be displayed above the title */
  icon: Maybe<MediaItem>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Accordion_Items>>>;
  /**
   * This field is used for mapping the section id defined in a content table block - it must be url safe.
   * Leave this field empty if this is not a section to be displayed in the content table.
   */
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Accordion_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Accordion_items';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_AppCta = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_AppCta';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_BlogPosts = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_BlogPosts';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  posts: Maybe<Array<Maybe<Acf_Content_Blocks_BlogPosts_Posts>>>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type Acf_Content_Blocks_BlogPosts_Posts = Post;

/** Group within the flex field */
export type Acf_Content_Blocks_BrazeCard = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_BrazeCard';
  brazeId: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_BrazeMessage = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_BrazeMessage';
  brazeMessageId: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_CannabisCounselingCta = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CannabisCounselingCta';
  button: Maybe<AcfLink>;
  description: Maybe<Scalars['String']>;
  externalImage: Maybe<MediaItem>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  internalImage: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_CardSteps = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardSteps';
  bottomText: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  intro: Maybe<Scalars['String']>;
  steps: Maybe<Array<Maybe<Acf_Content_Blocks_CardSteps_Steps>>>;
};

/** Field Group */
export type Acf_Content_Blocks_CardSteps_Steps = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardSteps_steps';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  link: Maybe<AcfLink>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Cards = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Cards';
  /**
   * The distance between text content and image will be larger.
   * Also, content will be aligned from the top instead from center.
   */
  columnGap: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Cards_Items>>>;
  sectionId: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_CardsImage = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardsImage';
  button: Maybe<AcfLink>;
  cards: Maybe<Array<Maybe<Acf_Content_Blocks_CardsImage_Cards>>>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_CardsImage_Cards = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardsImage_cards';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_CardsList = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardsList';
  button: Maybe<AcfLink>;
  content: Maybe<Scalars['String']>;
  contentAlignment: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['String']>;
  divider: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  image: Maybe<MediaItem>;
  list: Maybe<Array<Maybe<Acf_Content_Blocks_CardsList_List>>>;
  listColor: Maybe<Scalars['String']>;
  listColumns: Maybe<Scalars['Float']>;
  listNumbered: Maybe<Scalars['Boolean']>;
  listStep: Maybe<Scalars['Boolean']>;
  listTitleSize: Maybe<Scalars['String']>;
  listVariant: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleSize: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline underline-green-400 underline-offset-small&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  titleAlignment: Maybe<Scalars['String']>;
  titleLayout: Maybe<Scalars['String']>;
  titleSize: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_CardsList_List = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CardsList_list';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** True will set the image with the same width as the card */
  fullWidthImage: Maybe<Scalars['Boolean']>;
  image: Maybe<MediaItem>;
  /** Leave blank to hide */
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Cards_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Cards_items';
  button: Maybe<AcfLink>;
  buttonVariant: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  descriptionTextColor: Maybe<Scalars['String']>;
  descriptionTextSize: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  imageStyle: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline line-simple&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green simple line underline&lt;br/&gt;
   */
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Carousel = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Carousel';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  list: Maybe<Array<Maybe<Acf_Content_Blocks_Carousel_List>>>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Carousel_List = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Carousel_list';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  signature: Maybe<MediaItem>;
  thumbnail: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
  videoUrl: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_CircleList = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CircleList';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  list: Maybe<Array<Maybe<Acf_Content_Blocks_CircleList_List>>>;
  subtitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_CircleList_List = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_CircleList_list';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_ColumnChart = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_ColumnChart';
  chartColumnsOneBar: Maybe<
    Array<Maybe<Acf_Content_Blocks_ColumnChart_ChartColumnsOneBar>>
  >;
  chartColumnsTwoBars: Maybe<
    Array<Maybe<Acf_Content_Blocks_ColumnChart_ChartColumnsTwoBars>>
  >;
  /** Please check &lt;a href=https://dev.leafwell.com/block-examples/#column-chart target=&quot;_blank&quot;&gt;here&lt;/a&gt; to see the design for each option */
  chartLayout: Maybe<Scalars['String']>;
  chartType: Maybe<Scalars['String']>;
  /** Represents the type of data that is being measured (example: Patients, Studies, Male, Female, etc.) */
  columnOneDataSeries: Maybe<Scalars['String']>;
  /** Represents the type of data that is being measured (example: Patients, Studies, Male, Female, etc.) */
  columnTwoDataSeries: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleSize: Maybe<Scalars['String']>;
  titleTag: Maybe<Scalars['String']>;
  valueType: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_ColumnChart_ChartColumnsOneBar =
  AcfFieldGroup & {
    __typename?: 'ACF_Content_Blocks_ColumnChart_chartColumnsOneBar';
    /** Represents the type of subject that is being measured (example: Patients, Studies, etc.) */
    dataSeries: Maybe<Scalars['String']>;
    /** The name of the ACF Field Group */
    fieldGroupName: Maybe<Scalars['String']>;
    label: Maybe<Scalars['String']>;
    /** Insert only the value without units */
    value: Maybe<Scalars['String']>;
  };

/** Field Group */
export type Acf_Content_Blocks_ColumnChart_ChartColumnsTwoBars =
  AcfFieldGroup & {
    __typename?: 'ACF_Content_Blocks_ColumnChart_chartColumnsTwoBars';
    /** The name of the ACF Field Group */
    fieldGroupName: Maybe<Scalars['String']>;
    label: Maybe<Scalars['String']>;
    /** Insert only the value without units */
    valueOne: Maybe<Scalars['String']>;
    /** Insert only the value without units */
    valueTwo: Maybe<Scalars['String']>;
  };

/** Group within the flex field */
export type Acf_Content_Blocks_ColumnList = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_ColumnList';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  list: Maybe<Array<Maybe<Acf_Content_Blocks_ColumnList_List>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_ColumnList_List = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_ColumnList_list';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_ContentAndBanner = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_ContentAndBanner';
  bannerImage: Maybe<MediaItem>;
  bannerLabel: Maybe<Scalars['String']>;
  bannerTitle: Maybe<Scalars['String']>;
  /** The content will be displayed on the right column of the grid */
  contentLeft: Maybe<Scalars['String']>;
  /** The content will be displayed on the left column of the grid */
  contentRight: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_ContentAndMedia = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_ContentAndMedia';
  /** Content will be displayed (on desktop) on the right column of the grid */
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Image will be displayed (on desktop) on the left column of the grid */
  image: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
  mediaLabel: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  /**
   * Video will be displayed (on desktop) on the left column of the grid
   *
   * The youtube video id (example: 3VS0pv-EPcc in https://www.youtube.com/watch?v=3VS0pv-EPcc)
   */
  youtubeVideoId: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_DateTime = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_DateTime';
  dateTimes: Maybe<Array<Maybe<Acf_Content_Blocks_DateTime_DateTimes>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_DateTime_DateTimes = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_DateTime_dateTimes';
  dateTime: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Events = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Events';
  events: Maybe<Array<Maybe<Acf_Content_Blocks_Events_Events>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Events_Events = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Events_events';
  eventEndDate: Maybe<Scalars['String']>;
  eventStartDate: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Faqs = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Faqs';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Faqs_Items>>>;
  sectionId: Maybe<Scalars['String']>;
  showIcon: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

export type Acf_Content_Blocks_Faqs_Items = Faq;

/** Group within the flex field */
export type Acf_Content_Blocks_Form = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Form';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  formDescription: Maybe<Scalars['String']>;
  /** ID to use both as anchor and for the braze event. Must be url safe - no spaces or special character (eg: a-valid-id) */
  formId: Maybe<Scalars['String']>;
  formTitle: Maybe<Scalars['String']>;
  formType: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Image = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Image';
  description: Maybe<Scalars['String']>;
  descriptionPosition: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  largerParagraph: Maybe<Scalars['Boolean']>;
  /** This field will display a stars rating value - from 1 to 5 - in the bottom-left corner of the image. Please select the number to de displayed. If the value is zero, the rating won&#039;t be shown. */
  ratingStars: Maybe<Scalars['Float']>;
  roundedCorners: Maybe<Scalars['Boolean']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Info = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Info';
  columns: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline underline-green-400 underline-offset-small&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  label: Maybe<Scalars['String']>;
  largerParagraph: Maybe<Scalars['Boolean']>;
  sectionId: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  teamMember: Maybe<Array<Maybe<Acf_Content_Blocks_Info_TeamMember>>>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline underline-green-400 underline-offset-small&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  titleSize: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_InfoCard = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoCard';
  arrowButton: Maybe<AcfLink>;
  cards: Maybe<Array<Maybe<Acf_Content_Blocks_InfoCard_Cards>>>;
  description: Maybe<Scalars['String']>;
  descriptionAlignment: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** This will display a card with only the selected image */
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  layout: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  tag: Maybe<Scalars['String']>;
  tagIcon: Maybe<MediaItem>;
};

/** Field Group */
export type Acf_Content_Blocks_InfoCard_Cards = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoCard_cards';
  button: Maybe<AcfLink>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_InfoGrid = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoGrid';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_InfoGrid_Items>>>;
  largerParagraph: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type Acf_Content_Blocks_InfoGrid_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoGrid_items';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_InfoIcons = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoIcons';
  backgroundColor: Maybe<Scalars['String']>;
  button: Maybe<AcfLink>;
  description: Maybe<Scalars['String']>;
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_InfoIcons_Items>>>;
  sectionId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_InfoIcons_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_InfoIcons_items';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

export type Acf_Content_Blocks_Info_TeamMember = TeamMember;

/** Group within the flex field */
export type Acf_Content_Blocks_Intro = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Intro';
  alignment: Maybe<Scalars['String']>;
  button: Maybe<AcfLink>;
  buttonColor: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  descriptionSize: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  iconSize: Maybe<Scalars['String']>;
  note: Maybe<Scalars['String']>;
  /**
   * This field is used for mapping the section id defined in a content table block - it must be url safe.
   * Leave this field empty if this is not a section to be displayed in the content table.
   */
  sectionId: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;fade-in&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use a fade-in effect
   */
  title: Maybe<Scalars['String']>;
  topIcon: Maybe<MediaItem>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Line = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Line';
  color: Maybe<Scalars['String']>;
  containerSize: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Marquee = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Marquee';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_MedicalCardCta = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_MedicalCardCta';
  backgroundColor: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_MedicalConditions = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_MedicalConditions';
  conditions: Maybe<
    Array<Maybe<Acf_Content_Blocks_MedicalConditions_Conditions>>
  >;
  description: Maybe<Scalars['String']>;
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  showIcon: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
};

export type Acf_Content_Blocks_MedicalConditions_Conditions = Condition;

/** Group within the flex field */
export type Acf_Content_Blocks_Method = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Method';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  method: Maybe<Array<Maybe<Acf_Content_Blocks_Method_Method>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Method_Method = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Method_method';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Method_Method_Items>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Method_Method_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Method_method_items';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_MosaicCards = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_MosaicCards';
  cards: Maybe<Array<Maybe<Acf_Content_Blocks_MosaicCards_Cards>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_MosaicCards_Cards = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_MosaicCards_cards';
  button: Maybe<AcfLink>;
  cardColor: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  /**
   * Middle - displays image between title and content
   * Icon : displays image as an icon after the title
   * Right Corner: the image is placed in the right corner of the card
   * Right : the image is placed on the right of the title and content
   */
  imageAlignment: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_OnceApproved = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_OnceApproved';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  perksList: Maybe<Array<Maybe<Acf_Content_Blocks_OnceApproved_PerksList>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_OnceApproved_PerksList = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_OnceApproved_perksList';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_PartnersLocation = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_PartnersLocation';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  partners: Maybe<Array<Maybe<Affiliate>>>;
  partnersMap: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_PriceComparison = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_PriceComparison';
  button: Maybe<AcfLink>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  intro: Maybe<Scalars['String']>;
  pricesTable: Maybe<Acf_Content_Blocks_PriceComparison_PricesTable>;
  sectionId: Maybe<Scalars['String']>;
  tableImage: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
  titleTag: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_PriceComparison_PricesTable = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_PriceComparison_PricesTable';
  competitionTable: Maybe<
    Array<
      Maybe<Acf_Content_Blocks_PriceComparison_PricesTable_CompetitionTable>
    >
  >;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  leafwellCertification: Maybe<Scalars['Float']>;
  leafwellRenewal: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Acf_Content_Blocks_PriceComparison_PricesTable_CompetitionTable =
  AcfFieldGroup & {
    __typename?: 'ACF_Content_Blocks_PriceComparison_PricesTable_competitionTable';
    certification: Maybe<Scalars['Float']>;
    /** The name of the ACF Field Group */
    fieldGroupName: Maybe<Scalars['String']>;
    name: Maybe<Scalars['String']>;
    renewal: Maybe<Scalars['Float']>;
  };

/** Group within the flex field */
export type Acf_Content_Blocks_PricingForm = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_PricingForm';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Reviews = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Reviews';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  intro: Maybe<Scalars['String']>;
  quoted: Maybe<Scalars['Boolean']>;
  sectionId: Maybe<Scalars['String']>;
  showTrustSignals: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
  trustpilot: Maybe<Scalars['Boolean']>;
  variant: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_RichText = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_RichText';
  containerSize: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  largerParagraph: Maybe<Scalars['Boolean']>;
  sectionId: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_RoundedSection = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_RoundedSection';
  color: Maybe<Scalars['String']>;
  /** 3 columns layout is only available if subtitle is not empty. */
  columns: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** Add content to be displayed on the right side of the section. Only applies if image alignment is center. */
  contentRight: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  link: Maybe<AcfLink>;
  sectionId: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline underline-green-400 underline-offset-small&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  titleFont: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_SeenOn = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_SeenOn';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Select this field if this block should have the screen full width */
  fullWidth: Maybe<Scalars['Boolean']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_SeenOn_Items>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_SeenOn_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_SeenOn_items';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  logo: Maybe<MediaItem>;
  url: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_SignUpForm = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_SignUpForm';
  address: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  formDescription: Maybe<Scalars['String']>;
  formType: Maybe<Scalars['String']>;
  /** Custom form url. Leave blank to use the default. */
  formUrl: Maybe<Scalars['String']>;
  layout: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_SimpleCardCta = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_SimpleCardCta';
  button: Maybe<AcfLink>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
  layout: Maybe<Scalars['String']>;
  stateSelect: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_SizzleVideo = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_SizzleVideo';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  thumbnail: Maybe<MediaItem>;
  video: Maybe<MediaItem>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Slider = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Slider';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Slider_Items>>>;
};

/** Field Group */
export type Acf_Content_Blocks_Slider_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Slider_items';
  bottomContent: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_StateLawsMap = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_StateLawsMap';
  button: Maybe<AcfLink>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Leave this field as is. It&#039;s used as a placeholder for the map data. */
  lawStatuses: Maybe<RootQueryToLawStatusConnection>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_StateLawsMapLawStatusesArgs = {
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToLawStatusConnectionWhereArgs>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Stats = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Stats';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Stats_Items>>>;
  title: Maybe<Scalars['String']>;
  titleSize: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_StatsHighlight = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_StatsHighlight';
  button: Maybe<AcfLink>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_StatsHighlight_Items>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_StatsHighlight_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_StatsHighlight_items';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Stats_Items = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Stats_items';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Steps = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Steps';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  steps: Maybe<Array<Maybe<Acf_Content_Blocks_Steps_Steps>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Steps_Steps = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Steps_steps';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  /** Should this link somewhere? */
  url: Maybe<Acf_Content_Blocks_Steps_Steps_Url>;
};

export type Acf_Content_Blocks_Steps_Steps_Url = Page | Post;

/** Group within the flex field */
export type Acf_Content_Blocks_Table = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Table';
  button: Maybe<AcfLink>;
  displayProductStateImage: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  introText: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  table: Maybe<Acf_Content_Blocks_Table_Table>;
  title: Maybe<Scalars['String']>;
  titleTag: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_TableOfContents = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_TableOfContents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  tableOfContents: Maybe<
    Array<Maybe<Acf_Content_Blocks_TableOfContents_TableOfContents>>
  >;
};

/** Field Group */
export type Acf_Content_Blocks_TableOfContents_TableOfContents =
  AcfFieldGroup & {
    __typename?: 'ACF_Content_Blocks_TableOfContents_tableOfContents';
    /** The name of the ACF Field Group */
    fieldGroupName: Maybe<Scalars['String']>;
    /**
     * Add the section id without the #
     * Example: section-id
     */
    id: Maybe<Scalars['String']>;
    label: Maybe<Scalars['String']>;
  };

/** Field Group */
export type Acf_Content_Blocks_Table_Table = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Table_Table';
  columns: Maybe<Array<Maybe<Acf_Content_Blocks_Table_Table_Columns>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Table_Table_Columns = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Table_Table_columns';
  columnType: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  values: Maybe<Array<Maybe<Acf_Content_Blocks_Table_Table_Columns_Values>>>;
};

/** Field Group */
export type Acf_Content_Blocks_Table_Table_Columns_Values = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Table_Table_columns_values';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  valueCheck: Maybe<Scalars['Boolean']>;
  valueText: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_Team = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Team';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<Acf_Content_Blocks_Team_Items>>>;
  layout: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type Acf_Content_Blocks_Team_Items = TeamMember;

/** Group within the flex field */
export type Acf_Content_Blocks_Timeline = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Timeline';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  timeline: Maybe<Array<Maybe<Acf_Content_Blocks_Timeline_Timeline>>>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Blocks_Timeline_Timeline = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_Timeline_timeline';
  color: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
};

/** Group within the flex field */
export type Acf_Content_Blocks_YoutubeVideo = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_YoutubeVideo';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  sectionId: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
  /**
   * Large size will display the video with the same window size as the others page blocks
   * Small size will add some extra padding to the video window
   */
  videoSize: Maybe<Scalars['String']>;
  youtubeVideos: Maybe<
    Array<Maybe<Acf_Content_Blocks_YoutubeVideo_YoutubeVideos>>
  >;
};

/** Field Group */
export type Acf_Content_Blocks_YoutubeVideo_YoutubeVideos = AcfFieldGroup & {
  __typename?: 'ACF_Content_Blocks_YoutubeVideo_youtubeVideos';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** You can use this field to display a custom video thumbnail */
  image: Maybe<MediaItem>;
  playButtonStyle: Maybe<Scalars['String']>;
  /** The youtube video ID (example: &lt;strong&gt;3VS0pv-EPcc&lt;/strong&gt; in https://www.youtube.com/watch?v=3VS0pv-EPcc)&lt;br/&gt; */
  youtubeVideoId: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Content_Contentblocks = AcfFieldGroup & {
  __typename?: 'ACF_Content_Contentblocks';
  blocks: Maybe<Array<Maybe<Acf_Content_Blocks>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Hero = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero';
  address: Maybe<Scalars['String']>;
  badges: Maybe<Array<Maybe<Acf_Page_Hero_Badges>>>;
  button: Maybe<AcfLink>;
  buttonColor: Maybe<Scalars['String']>;
  buttonType: Maybe<Scalars['String']>;
  /**
   * This field should have the month and the year.
   * Example: December 2022
   */
  date: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  descriptionTextColor: Maybe<Scalars['String']>;
  downloadApp: Maybe<Scalars['Boolean']>;
  downloadFile: Maybe<Acf_Page_Hero_DownloadFile>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  formId: Maybe<Scalars['String']>;
  formLabel: Maybe<Scalars['String']>;
  formTitle: Maybe<Scalars['String']>;
  googleMyBusinessDetails: Maybe<Acf_Page_Hero_GoogleMyBusinessDetails>;
  icon: Maybe<MediaItem>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  richTitle: Maybe<Scalars['String']>;
  steps: Maybe<Array<Maybe<Acf_Page_Hero_Steps>>>;
  subTitle: Maybe<Scalars['String']>;
  tag: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  titleFont: Maybe<Scalars['String']>;
  video: Maybe<MediaItem>;
  webinarMembers: Maybe<Array<Maybe<Acf_Page_Hero_WebinarMembers>>>;
};

/** Field Group */
export type Acf_Page_Hero_DownloadFile = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero_DownloadFile';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  file: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Hero_GoogleMyBusinessDetails = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero_GoogleMyBusinessDetails';
  cannabisCounselingServicesUtm: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  medicalCardUtm: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Hero_Badges = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero_badges';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  label: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Hero_Steps = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero_steps';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Hero_WebinarMembers = AcfFieldGroup & {
  __typename?: 'ACF_Page_Hero_webinarMembers';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  photo: Maybe<MediaItem>;
  position: Maybe<Scalars['String']>;
  role: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Linktree = AcfFieldGroup & {
  __typename?: 'ACF_Page_Linktree';
  categories: Maybe<Array<Maybe<Acf_Page_Linktree_Categories>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Field Group */
export type Acf_Page_Linktree_Categories = AcfFieldGroup & {
  __typename?: 'ACF_Page_Linktree_categories';
  categoryName: Maybe<Scalars['String']>;
  contentType: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  otherLinks: Maybe<Array<Maybe<Acf_Page_Linktree_Categories_OtherLinks>>>;
  posts: Maybe<Array<Maybe<Acf_Page_Linktree_Categories_Posts>>>;
};

export type Acf_Page_Linktree_Categories_Posts = Post;

/** Field Group */
export type Acf_Page_Linktree_Categories_OtherLinks = AcfFieldGroup & {
  __typename?: 'ACF_Page_Linktree_categories_otherLinks';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
  url: Maybe<AcfLink>;
};

/** Field Group */
export type Acf_Page_Pagedetails = AcfFieldGroup & {
  __typename?: 'ACF_Page_Pagedetails';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  hasReferral: Maybe<Scalars['Boolean']>;
  hero: Maybe<Acf_Page_Hero>;
  linktree: Maybe<Acf_Page_Linktree>;
  pageType: Maybe<Scalars['String']>;
};

/** A Field Group registered by ACF */
export type AcfFieldGroup = {
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** ACF Link field */
export type AcfLink = {
  __typename?: 'AcfLink';
  /** The target of the link (_blank, etc) */
  target: Maybe<Scalars['String']>;
  /** The title of the link */
  title: Maybe<Scalars['String']>;
  /** The url of the link */
  url: Maybe<Scalars['String']>;
};

/** The affiliate type */
export type Affiliate = DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Affiliate';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<Affiliate_Activestates>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    affiliateId: Maybe<Scalars['Int']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Medical Card Partner Settings&quot; was set to Show in GraphQL. */
    affiliateSettings: Maybe<Affiliate_Affiliatesettings>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the Affiliate type and the ContentNode type */
    contentNodes: Maybe<AffiliateToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Connection between the Affiliate type and the page type */
    pages: Maybe<AffiliateToPageConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Scrapping settings&quot; was set to Show in GraphQL. */
    scrappingSettings: Maybe<Affiliate_Scrappingsettings>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Affiliate type and the Taxonomy type */
    taxonomy: Maybe<AffiliateToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Affiliate>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Affiliate>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The affiliate type */
export type AffiliateContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AffiliateToContentNodeConnectionWhereArgs>;
};

/** The affiliate type */
export type AffiliateEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The affiliate type */
export type AffiliateEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The affiliate type */
export type AffiliatePagesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AffiliateToPageConnectionWhereArgs>;
};

/** The affiliate type */
export type AffiliateTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to affiliate Nodes */
export type AffiliateConnection = {
  /** A list of edges (relational context) between RootQuery and connected affiliate Nodes */
  edges: Array<AffiliateConnectionEdge>;
  /** A list of connected affiliate Nodes */
  nodes: Array<Affiliate>;
  /** Information about pagination in a connection. */
  pageInfo: AffiliateConnectionPageInfo;
};

/** Edge between a Node and a connected affiliate */
export type AffiliateConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected affiliate Node */
  node: Affiliate;
};

/** Page Info on the connected AffiliateConnectionEdge */
export type AffiliateConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum AffiliateIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Affiliate type and the ContentNode type */
export type AffiliateToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'AffiliateToContentNodeConnection';
    /** Edges for the AffiliateToContentNodeConnection connection */
    edges: Array<AffiliateToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: AffiliateToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type AffiliateToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'AffiliateToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;AffiliateToContentNodeConnection&quot; */
export type AffiliateToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'AffiliateToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the AffiliateToContentNodeConnection connection */
export type AffiliateToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfAffiliateEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<AffiliateToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type AffiliateToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<AffiliateToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<AffiliateToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum AffiliateToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type AffiliateToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<AffiliateToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum AffiliateToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Affiliate type and the page type */
export type AffiliateToPageConnection = Connection &
  PageConnection & {
    __typename?: 'AffiliateToPageConnection';
    /** Edges for the AffiliateToPageConnection connection */
    edges: Array<AffiliateToPageConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Page>;
    /** Information about pagination in a connection. */
    pageInfo: AffiliateToPageConnectionPageInfo;
  };

/** An edge in a connection */
export type AffiliateToPageConnectionEdge = Edge &
  PageConnectionEdge & {
    __typename?: 'AffiliateToPageConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Page;
  };

/** Page Info on the &quot;AffiliateToPageConnection&quot; */
export type AffiliateToPageConnectionPageInfo = PageConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'AffiliateToPageConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the AffiliateToPageConnection connection */
export type AffiliateToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<AffiliateToPageConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type AffiliateToPageConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<AffiliateToPageConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<AffiliateToPageConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum AffiliateToPageConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type AffiliateToPageConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<AffiliateToPageConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum AffiliateToPageConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Affiliate type and the Taxonomy type */
export type AffiliateToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'AffiliateToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type Affiliate_Activestates = AcfFieldGroup & {
  __typename?: 'Affiliate_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type Affiliate_Affiliatesettings = AcfFieldGroup & {
  __typename?: 'Affiliate_Affiliatesettings';
  addressCountry: Maybe<Scalars['String']>;
  addressLocality: Maybe<Scalars['String']>;
  addressRegion: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Example: 115 Aulenbrock Dr, Building 200, Suite A Canton, MS 39046 */
  formattedAddress: Maybe<Scalars['String']>;
  /** Example: +1 601-202-8443 */
  internationalPhoneNumber: Maybe<Scalars['String']>;
  /** Example: 32.510536 */
  latitude: Maybe<Scalars['Float']>;
  /** Leave this field blank to display the name. */
  logo: Maybe<MediaItem>;
  /** Example: -90.080164 */
  longitude: Maybe<Scalars['Float']>;
  /**
   * &lt;strong&gt;No need to fill this field.&lt;/strong&gt; If the scrapping id is not provided, a default value will be used.
   * It will be properly formatted in the frontend
   */
  openingHours: Maybe<Scalars['String']>;
  /** Example: ChIJ71_4K8tn54gRuhiN3aNjHws */
  placeId: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  priceRange: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  streetAddress: Maybe<Scalars['String']>;
  userRatingsTotal: Maybe<Scalars['Float']>;
  /** This needs to match the &lt;strong&gt;utm_source&lt;/strong&gt; param that will come in the url. */
  utmSource: Maybe<Scalars['String']>;
  /** Leave this field empty to display just the logo. */
  website: Maybe<Scalars['String']>;
};

/** Field Group */
export type Affiliate_Scrappingsettings = AcfFieldGroup & {
  __typename?: 'Affiliate_Scrappingsettings';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Content ID in scrapping database. Leave empty if no link exists between this item and scrapping data. */
  leafwellScrappingId: Maybe<Scalars['String']>;
};

/** The aroma type */
export type Aroma = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Aroma';
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    aromaId: Maybe<Scalars['Int']>;
    /** Connection between the Aroma type and the ContentNode type */
    contentNodes: Maybe<AromaToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Aroma type and the strain type */
    strains: Maybe<AromaToStrainConnection>;
    /** Connection between the Aroma type and the Taxonomy type */
    taxonomy: Maybe<AromaToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Aroma>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Aroma>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The aroma type */
export type AromaContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AromaToContentNodeConnectionWhereArgs>;
};

/** The aroma type */
export type AromaEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The aroma type */
export type AromaEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The aroma type */
export type AromaStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AromaToStrainConnectionWhereArgs>;
};

/** The aroma type */
export type AromaTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to aroma Nodes */
export type AromaConnection = {
  /** A list of edges (relational context) between RootQuery and connected aroma Nodes */
  edges: Array<AromaConnectionEdge>;
  /** A list of connected aroma Nodes */
  nodes: Array<Aroma>;
  /** Information about pagination in a connection. */
  pageInfo: AromaConnectionPageInfo;
};

/** Edge between a Node and a connected aroma */
export type AromaConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected aroma Node */
  node: Aroma;
};

/** Page Info on the connected AromaConnectionEdge */
export type AromaConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum AromaIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Aroma type and the ContentNode type */
export type AromaToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'AromaToContentNodeConnection';
    /** Edges for the AromaToContentNodeConnection connection */
    edges: Array<AromaToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: AromaToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type AromaToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'AromaToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;AromaToContentNodeConnection&quot; */
export type AromaToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'AromaToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the AromaToContentNodeConnection connection */
export type AromaToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfAromaEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<AromaToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type AromaToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<AromaToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<AromaToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum AromaToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type AromaToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<AromaToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum AromaToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Aroma type and the strain type */
export type AromaToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'AromaToStrainConnection';
    /** Edges for the AromaToStrainConnection connection */
    edges: Array<AromaToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: AromaToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type AromaToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'AromaToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;AromaToStrainConnection&quot; */
export type AromaToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'AromaToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the AromaToStrainConnection connection */
export type AromaToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<AromaToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type AromaToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<AromaToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<AromaToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum AromaToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type AromaToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<AromaToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum AromaToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Aroma type and the Taxonomy type */
export type AromaToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'AromaToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Avatars are profile images for users. WordPress by default uses the Gravatar service to host and fetch avatars from. */
export type Avatar = {
  __typename?: 'Avatar';
  /** URL for the default image or a default type. Accepts &#039;404&#039; (return a 404 instead of a default image), &#039;retro&#039; (8bit), &#039;monsterid&#039; (monster), &#039;wavatar&#039; (cartoon face), &#039;indenticon&#039; (the &#039;quilt&#039;), &#039;mystery&#039;, &#039;mm&#039;, or &#039;mysteryman&#039; (The Oyster Man), &#039;blank&#039; (transparent GIF), or &#039;gravatar_default&#039; (the Gravatar logo). */
  default: Maybe<Scalars['String']>;
  /** HTML attributes to insert in the IMG element. Is not sanitized. */
  extraAttr: Maybe<Scalars['String']>;
  /** Whether to always show the default image, never the Gravatar. */
  forceDefault: Maybe<Scalars['Boolean']>;
  /** Whether the avatar was successfully found. */
  foundAvatar: Maybe<Scalars['Boolean']>;
  /** Height of the avatar image. */
  height: Maybe<Scalars['Int']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** What rating to display avatars up to. Accepts &#039;G&#039;, &#039;PG&#039;, &#039;R&#039;, &#039;X&#039;, and are judged in that order. */
  rating: Maybe<Scalars['String']>;
  /** Type of url scheme to use. Typically HTTP vs. HTTPS. */
  scheme: Maybe<Scalars['String']>;
  /** The size of the avatar in pixels. A value of 96 will match a 96px x 96px gravatar image. */
  size: Maybe<Scalars['Int']>;
  /** URL for the gravatar image source. */
  url: Maybe<Scalars['String']>;
  /** Width of the avatar image. */
  width: Maybe<Scalars['Int']>;
};

/** What rating to display avatars up to. Accepts 'G', 'PG', 'R', 'X', and are judged in that order. Default is the value of the 'avatar_rating' option */
export enum AvatarRatingEnum {
  /** Indicates a G level avatar rating level. */
  G = 'G',
  /** Indicates a PG level avatar rating level. */
  Pg = 'PG',
  /** Indicates an R level avatar rating level. */
  R = 'R',
  /** Indicates an X level avatar rating level. */
  X = 'X',
}

/** Base 64 encoded file */
export type Base64File = {
  /** File name */
  data: Scalars['String'];
  /** File name */
  name: Scalars['String'];
  /** File size */
  size: Scalars['Int'];
  /** File type */
  type: Scalars['String'];
};

/** The category type */
export type Category = DatabaseIdentifier &
  HierarchicalNode &
  HierarchicalTermNode &
  MenuItemLinkable &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Category';
    /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
    ancestors: Maybe<CategoryToAncestorsCategoryConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    categoryId: Maybe<Scalars['Int']>;
    /** Connection between the category type and its children categories. */
    children: Maybe<CategoryToCategoryConnection>;
    /** Connection between the Category type and the ContentNode type */
    contentNodes: Maybe<CategoryToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Connection between the category type and its parent category. */
    parent: Maybe<CategoryToParentCategoryConnectionEdge>;
    /** Database id of the parent node */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent node. */
    parentId: Maybe<Scalars['ID']>;
    /** Connection between the Category type and the post type */
    posts: Maybe<CategoryToPostConnection>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Category type and the Taxonomy type */
    taxonomy: Maybe<CategoryToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Category>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Category>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The category type */
export type CategoryAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The category type */
export type CategoryChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CategoryToCategoryConnectionWhereArgs>;
};

/** The category type */
export type CategoryContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CategoryToContentNodeConnectionWhereArgs>;
};

/** The category type */
export type CategoryEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The category type */
export type CategoryEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The category type */
export type CategoryPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CategoryToPostConnectionWhereArgs>;
};

/** The category type */
export type CategoryTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to category Nodes */
export type CategoryConnection = {
  /** A list of edges (relational context) between RootQuery and connected category Nodes */
  edges: Array<CategoryConnectionEdge>;
  /** A list of connected category Nodes */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryConnectionPageInfo;
};

/** Edge between a Node and a connected category */
export type CategoryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected category Node */
  node: Category;
};

/** Page Info on the connected CategoryConnectionEdge */
export type CategoryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum CategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Category type and the category type */
export type CategoryToAncestorsCategoryConnection = CategoryConnection &
  Connection & {
    __typename?: 'CategoryToAncestorsCategoryConnection';
    /** Edges for the CategoryToAncestorsCategoryConnection connection */
    edges: Array<CategoryToAncestorsCategoryConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Category>;
    /** Information about pagination in a connection. */
    pageInfo: CategoryToAncestorsCategoryConnectionPageInfo;
  };

/** An edge in a connection */
export type CategoryToAncestorsCategoryConnectionEdge = CategoryConnectionEdge &
  Edge & {
    __typename?: 'CategoryToAncestorsCategoryConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Category;
  };

/** Page Info on the &quot;CategoryToAncestorsCategoryConnection&quot; */
export type CategoryToAncestorsCategoryConnectionPageInfo =
  CategoryConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'CategoryToAncestorsCategoryConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the Category type and the category type */
export type CategoryToCategoryConnection = CategoryConnection &
  Connection & {
    __typename?: 'CategoryToCategoryConnection';
    /** Edges for the CategoryToCategoryConnection connection */
    edges: Array<CategoryToCategoryConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Category>;
    /** Information about pagination in a connection. */
    pageInfo: CategoryToCategoryConnectionPageInfo;
  };

/** An edge in a connection */
export type CategoryToCategoryConnectionEdge = CategoryConnectionEdge &
  Edge & {
    __typename?: 'CategoryToCategoryConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Category;
  };

/** Page Info on the &quot;CategoryToCategoryConnection&quot; */
export type CategoryToCategoryConnectionPageInfo = CategoryConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'CategoryToCategoryConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the CategoryToCategoryConnection connection */
export type CategoryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Category type and the ContentNode type */
export type CategoryToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'CategoryToContentNodeConnection';
    /** Edges for the CategoryToContentNodeConnection connection */
    edges: Array<CategoryToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: CategoryToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type CategoryToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'CategoryToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;CategoryToContentNodeConnection&quot; */
export type CategoryToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'CategoryToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the CategoryToContentNodeConnection connection */
export type CategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<CategoryToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type CategoryToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<CategoryToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<CategoryToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum CategoryToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type CategoryToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<CategoryToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum CategoryToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Category type and the category type */
export type CategoryToParentCategoryConnectionEdge = CategoryConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'CategoryToParentCategoryConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Category;
  };

/** Connection between the Category type and the post type */
export type CategoryToPostConnection = Connection &
  PostConnection & {
    __typename?: 'CategoryToPostConnection';
    /** Edges for the CategoryToPostConnection connection */
    edges: Array<CategoryToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: CategoryToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type CategoryToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'CategoryToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;CategoryToPostConnection&quot; */
export type CategoryToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'CategoryToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the CategoryToPostConnection connection */
export type CategoryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<CategoryToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type CategoryToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<CategoryToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<CategoryToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum CategoryToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type CategoryToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<CategoryToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum CategoryToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Category type and the Taxonomy type */
export type CategoryToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'CategoryToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** A Comment object */
export type Comment = DatabaseIdentifier &
  Node &
  UniformResourceIdentifiable & {
    __typename?: 'Comment';
    /** User agent used to post the comment. This field is equivalent to WP_Comment-&gt;comment_agent and the value matching the &quot;comment_agent&quot; column in SQL. */
    agent: Maybe<Scalars['String']>;
    /**
     * The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL.
     * @deprecated Deprecated in favor of the `status` field
     */
    approved: Maybe<Scalars['Boolean']>;
    /** The author of the comment */
    author: Maybe<CommentToCommenterConnectionEdge>;
    /** IP address for the author. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL. */
    authorIp: Maybe<Scalars['String']>;
    /**
     * ID for the comment, unique among comments.
     * @deprecated Deprecated in favor of databaseId
     */
    commentId: Maybe<Scalars['Int']>;
    /** Connection between the Comment type and the ContentNode type */
    commentedOn: Maybe<CommentToContentNodeConnectionEdge>;
    /** Content of the comment. This field is equivalent to WP_Comment-&gt;comment_content and the value matching the &quot;comment_content&quot; column in SQL. */
    content: Maybe<Scalars['String']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Date the comment was posted in local time. This field is equivalent to WP_Comment-&gt;date and the value matching the &quot;date&quot; column in SQL. */
    date: Maybe<Scalars['String']>;
    /** Date the comment was posted in GMT. This field is equivalent to WP_Comment-&gt;date_gmt and the value matching the &quot;date_gmt&quot; column in SQL. */
    dateGmt: Maybe<Scalars['String']>;
    /** The globally unique identifier for the comment object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Karma value for the comment. This field is equivalent to WP_Comment-&gt;comment_karma and the value matching the &quot;comment_karma&quot; column in SQL. */
    karma: Maybe<Scalars['Int']>;
    /** The permalink of the comment */
    link: Maybe<Scalars['String']>;
    /** Connection between the Comment type and the Comment type */
    parent: Maybe<CommentToParentCommentConnectionEdge>;
    /** The database id of the parent comment node or null if it is the root comment */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent comment node. */
    parentId: Maybe<Scalars['ID']>;
    /** Connection between the Comment type and the Comment type */
    replies: Maybe<CommentToCommentConnection>;
    /** The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL. */
    status: Maybe<CommentStatusEnum>;
    /** Type of comment. This field is equivalent to WP_Comment-&gt;comment_type and the value matching the &quot;comment_type&quot; column in SQL. */
    type: Maybe<Scalars['String']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** A Comment object */
export type CommentContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A Comment object */
export type CommentParentArgs = {
  where: InputMaybe<CommentToParentCommentConnectionWhereArgs>;
};

/** A Comment object */
export type CommentRepliesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CommentToCommentConnectionWhereArgs>;
};

/** A Comment Author object */
export type CommentAuthor = Commenter &
  DatabaseIdentifier &
  Node & {
    __typename?: 'CommentAuthor';
    /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
    avatar: Maybe<Avatar>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The email for the comment author */
    email: Maybe<Scalars['String']>;
    /** The globally unique identifier for the comment author object */
    id: Scalars['ID'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** The name for the comment author. */
    name: Maybe<Scalars['String']>;
    /** The url the comment author. */
    url: Maybe<Scalars['String']>;
  };

/** A Comment Author object */
export type CommentAuthorAvatarArgs = {
  forceDefault: InputMaybe<Scalars['Boolean']>;
  rating: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};

/** Connection to Comment Nodes */
export type CommentConnection = {
  /** A list of edges (relational context) between RootQuery and connected Comment Nodes */
  edges: Array<CommentConnectionEdge>;
  /** A list of connected Comment Nodes */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: CommentConnectionPageInfo;
};

/** Edge between a Node and a connected Comment */
export type CommentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Comment Node */
  node: Comment;
};

/** Page Info on the connected CommentConnectionEdge */
export type CommentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single comment node. Default is "ID". To be used along with the "id" field. */
export enum CommentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
}

/** The status of the comment object. */
export enum CommentStatusEnum {
  /** Comments with the Approved status */
  Approve = 'APPROVE',
  /** Comments with the Unapproved status */
  Hold = 'HOLD',
  /** Comments with the Spam status */
  Spam = 'SPAM',
  /** Comments with the Trash status */
  Trash = 'TRASH',
}

/** Connection between the Comment type and the Comment type */
export type CommentToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'CommentToCommentConnection';
    /** Edges for the CommentToCommentConnection connection */
    edges: Array<CommentToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: CommentToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type CommentToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'CommentToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;CommentToCommentConnection&quot; */
export type CommentToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'CommentToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the CommentToCommentConnection connection */
export type CommentToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Connection between the Comment type and the Commenter type */
export type CommentToCommenterConnectionEdge = CommenterConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'CommentToCommenterConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Commenter;
  };

/** Connection between the Comment type and the ContentNode type */
export type CommentToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'CommentToContentNodeConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: ContentNode;
  };

/** Connection between the Comment type and the Comment type */
export type CommentToParentCommentConnectionEdge = CommentConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'CommentToParentCommentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Comment;
  };

/** Arguments for filtering the CommentToParentCommentConnection connection */
export type CommentToParentCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** The author of a comment */
export type Commenter = {
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The email address of the author of a comment. */
  email: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment author. */
  id: Scalars['ID'];
  /** Whether the author information is considered restricted. (not fully public) */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** The name of the author of a comment. */
  name: Maybe<Scalars['String']>;
  /** The url of the author of a comment. */
  url: Maybe<Scalars['String']>;
};

/** Edge between a Node and a connected Commenter */
export type CommenterConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Commenter Node */
  node: Commenter;
};

/** Options for ordering the connection */
export enum CommentsConnectionOrderbyEnum {
  /** Order by browser user agent of the commenter. */
  CommentAgent = 'COMMENT_AGENT',
  /** Order by approval status of the comment. */
  CommentApproved = 'COMMENT_APPROVED',
  /** Order by name of the comment author. */
  CommentAuthor = 'COMMENT_AUTHOR',
  /** Order by e-mail of the comment author. */
  CommentAuthorEmail = 'COMMENT_AUTHOR_EMAIL',
  /** Order by IP address of the comment author. */
  CommentAuthorIp = 'COMMENT_AUTHOR_IP',
  /** Order by URL address of the comment author. */
  CommentAuthorUrl = 'COMMENT_AUTHOR_URL',
  /** Order by the comment contents. */
  CommentContent = 'COMMENT_CONTENT',
  /** Order by date/time timestamp of the comment. */
  CommentDate = 'COMMENT_DATE',
  /** Order by GMT timezone date/time timestamp of the comment. */
  CommentDateGmt = 'COMMENT_DATE_GMT',
  /** Order by the globally unique identifier for the comment object */
  CommentId = 'COMMENT_ID',
  /** Order by the array list of comment IDs listed in the where clause. */
  CommentIn = 'COMMENT_IN',
  /** Order by the comment karma score. */
  CommentKarma = 'COMMENT_KARMA',
  /** Order by the comment parent ID. */
  CommentParent = 'COMMENT_PARENT',
  /** Order by the post object ID. */
  CommentPostId = 'COMMENT_POST_ID',
  /** Order by the the type of comment, such as 'comment', 'pingback', or 'trackback'. */
  CommentType = 'COMMENT_TYPE',
  /** Order by the user ID. */
  UserId = 'USER_ID',
}

/** The condition type */
export type Condition = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Condition';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<ConditionToConditionConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    conditionId: Scalars['Int'];
    /** Connection between the Condition type and the conditionType type */
    conditionTypes: Maybe<ConditionToConditionTypeConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Conditions Details&quot; was set to Show in GraphQL. */
    conditionsDetails: Maybe<Condition_Conditionsdetails>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the medical_conditions object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the medical_conditions object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<ConditionToParentConnectionEdge>;
    /** The password for the medical_conditions object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Condition type and the condition type */
    preview: Maybe<ConditionToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Condition type and the condition type */
    revisions: Maybe<ConditionToRevisionConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Scrapping settings&quot; was set to Show in GraphQL. */
    scrappingSettings: Maybe<Condition_Scrappingsettings>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the Condition type and the TermNode type */
    terms: Maybe<ConditionToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Condition>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Condition>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The condition type */
export type ConditionAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The condition type */
export type ConditionConditionTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionToConditionTypeConnectionWhereArgs>;
};

/** The condition type */
export type ConditionContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The condition type */
export type ConditionEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The condition type */
export type ConditionEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The condition type */
export type ConditionRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionToRevisionConnectionWhereArgs>;
};

/** The condition type */
export type ConditionTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionToTermNodeConnectionWhereArgs>;
};

/** The condition type */
export type ConditionTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The condition type */
export type ConditionTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Set relationships between the condition to conditionTypes */
export type ConditionConditionTypesInput = {
  /** If true, this will append the conditionType to existing related conditionTypes. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<ConditionConditionTypesNodeInput>>>;
};

/** List of conditionTypes to connect the condition to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type ConditionConditionTypesNodeInput = {
  /** The description of the conditionType. This field is used to set a description of the conditionType if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the conditionType. If present, this will be used to connect to the condition. If no existing conditionType exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the conditionType. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the conditionType. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection to condition Nodes */
export type ConditionConnection = {
  /** A list of edges (relational context) between RootQuery and connected condition Nodes */
  edges: Array<ConditionConnectionEdge>;
  /** A list of connected condition Nodes */
  nodes: Array<Condition>;
  /** Information about pagination in a connection. */
  pageInfo: ConditionConnectionPageInfo;
};

/** Edge between a Node and a connected condition */
export type ConditionConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected condition Node */
  node: Condition;
};

/** Page Info on the connected ConditionConnectionEdge */
export type ConditionConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ConditionIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Condition type and the condition type */
export type ConditionToConditionConnection = ConditionConnection &
  Connection & {
    __typename?: 'ConditionToConditionConnection';
    /** Edges for the ConditionToConditionConnection connection */
    edges: Array<ConditionToConditionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Condition>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionToConditionConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionToConditionConnectionEdge = ConditionConnectionEdge &
  Edge & {
    __typename?: 'ConditionToConditionConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Condition;
  };

/** Page Info on the &quot;ConditionToConditionConnection&quot; */
export type ConditionToConditionConnectionPageInfo =
  ConditionConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionToConditionConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the Condition type and the conditionType type */
export type ConditionToConditionTypeConnection = ConditionTypeConnection &
  Connection & {
    __typename?: 'ConditionToConditionTypeConnection';
    /** Edges for the ConditionToConditionTypeConnection connection */
    edges: Array<ConditionToConditionTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ConditionType>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionToConditionTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionToConditionTypeConnectionEdge =
  ConditionTypeConnectionEdge &
    Edge & {
      __typename?: 'ConditionToConditionTypeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ConditionType;
    };

/** Page Info on the &quot;ConditionToConditionTypeConnection&quot; */
export type ConditionToConditionTypeConnectionPageInfo =
  ConditionTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionToConditionTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ConditionToConditionTypeConnection connection */
export type ConditionToConditionTypeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Condition type and the condition type */
export type ConditionToParentConnectionEdge = ConditionConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'ConditionToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Condition;
  };

/** Connection between the Condition type and the condition type */
export type ConditionToPreviewConnectionEdge = ConditionConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'ConditionToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Condition;
  };

/** Connection between the Condition type and the condition type */
export type ConditionToRevisionConnection = ConditionConnection &
  Connection & {
    __typename?: 'ConditionToRevisionConnection';
    /** Edges for the ConditionToRevisionConnection connection */
    edges: Array<ConditionToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Condition>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionToRevisionConnectionEdge = ConditionConnectionEdge &
  Edge & {
    __typename?: 'ConditionToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Condition;
  };

/** Page Info on the &quot;ConditionToRevisionConnection&quot; */
export type ConditionToRevisionConnectionPageInfo =
  ConditionConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionToRevisionConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ConditionToRevisionConnection connection */
export type ConditionToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ConditionToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ConditionToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ConditionToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ConditionToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ConditionToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ConditionToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ConditionToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ConditionToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Condition type and the TermNode type */
export type ConditionToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'ConditionToTermNodeConnection';
    /** Edges for the ConditionToTermNodeConnection connection */
    edges: Array<ConditionToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'ConditionToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;ConditionToTermNodeConnection&quot; */
export type ConditionToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ConditionToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the ConditionToTermNodeConnection connection */
export type ConditionToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** The conditionType type */
export type ConditionType = DatabaseIdentifier &
  HierarchicalNode &
  HierarchicalTermNode &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'ConditionType';
    /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
    ancestors: Maybe<ConditionTypeToAncestorsConditionTypeConnection>;
    /** Connection between the conditionType type and its children conditionTypes. */
    children: Maybe<ConditionTypeToConditionTypeConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    conditionTypeId: Maybe<Scalars['Int']>;
    /** Connection between the ConditionType type and the condition type */
    conditions: Maybe<ConditionTypeToConditionConnection>;
    /** Connection between the ConditionType type and the ContentNode type */
    contentNodes: Maybe<ConditionTypeToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Connection between the conditionType type and its parent conditionType. */
    parent: Maybe<ConditionTypeToParentConditionTypeConnectionEdge>;
    /** Database id of the parent node */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent node. */
    parentId: Maybe<Scalars['ID']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Scrapping settings&quot; was set to Show in GraphQL. */
    scrappingSettings: Maybe<ConditionType_Scrappingsettings>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Condition Types&quot; was set to Show in GraphQL. */
    settings: Maybe<ConditionType_Settings>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the ConditionType type and the Taxonomy type */
    taxonomy: Maybe<ConditionTypeToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<ConditionType>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<ConditionType>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The conditionType type */
export type ConditionTypeAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The conditionType type */
export type ConditionTypeChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionTypeToConditionTypeConnectionWhereArgs>;
};

/** The conditionType type */
export type ConditionTypeConditionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionTypeToConditionConnectionWhereArgs>;
};

/** The conditionType type */
export type ConditionTypeContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ConditionTypeToContentNodeConnectionWhereArgs>;
};

/** The conditionType type */
export type ConditionTypeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The conditionType type */
export type ConditionTypeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The conditionType type */
export type ConditionTypeTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to conditionType Nodes */
export type ConditionTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected conditionType Nodes */
  edges: Array<ConditionTypeConnectionEdge>;
  /** A list of connected conditionType Nodes */
  nodes: Array<ConditionType>;
  /** Information about pagination in a connection. */
  pageInfo: ConditionTypeConnectionPageInfo;
};

/** Edge between a Node and a connected conditionType */
export type ConditionTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected conditionType Node */
  node: ConditionType;
};

/** Page Info on the connected ConditionTypeConnectionEdge */
export type ConditionTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ConditionTypeIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the ConditionType type and the conditionType type */
export type ConditionTypeToAncestorsConditionTypeConnection =
  ConditionTypeConnection &
    Connection & {
      __typename?: 'ConditionTypeToAncestorsConditionTypeConnection';
      /** Edges for the ConditionTypeToAncestorsConditionTypeConnection connection */
      edges: Array<ConditionTypeToAncestorsConditionTypeConnectionEdge>;
      /** The nodes of the connection, without the edges */
      nodes: Array<ConditionType>;
      /** Information about pagination in a connection. */
      pageInfo: ConditionTypeToAncestorsConditionTypeConnectionPageInfo;
    };

/** An edge in a connection */
export type ConditionTypeToAncestorsConditionTypeConnectionEdge =
  ConditionTypeConnectionEdge &
    Edge & {
      __typename?: 'ConditionTypeToAncestorsConditionTypeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ConditionType;
    };

/** Page Info on the &quot;ConditionTypeToAncestorsConditionTypeConnection&quot; */
export type ConditionTypeToAncestorsConditionTypeConnectionPageInfo =
  ConditionTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionTypeToAncestorsConditionTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the ConditionType type and the condition type */
export type ConditionTypeToConditionConnection = ConditionConnection &
  Connection & {
    __typename?: 'ConditionTypeToConditionConnection';
    /** Edges for the ConditionTypeToConditionConnection connection */
    edges: Array<ConditionTypeToConditionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Condition>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionTypeToConditionConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionTypeToConditionConnectionEdge = ConditionConnectionEdge &
  Edge & {
    __typename?: 'ConditionTypeToConditionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Condition;
  };

/** Page Info on the &quot;ConditionTypeToConditionConnection&quot; */
export type ConditionTypeToConditionConnectionPageInfo =
  ConditionConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionTypeToConditionConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ConditionTypeToConditionConnection connection */
export type ConditionTypeToConditionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ConditionTypeToConditionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ConditionTypeToConditionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ConditionTypeToConditionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ConditionTypeToConditionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ConditionTypeToConditionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ConditionTypeToConditionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ConditionTypeToConditionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ConditionTypeToConditionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the ConditionType type and the conditionType type */
export type ConditionTypeToConditionTypeConnection = ConditionTypeConnection &
  Connection & {
    __typename?: 'ConditionTypeToConditionTypeConnection';
    /** Edges for the ConditionTypeToConditionTypeConnection connection */
    edges: Array<ConditionTypeToConditionTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ConditionType>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionTypeToConditionTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionTypeToConditionTypeConnectionEdge =
  ConditionTypeConnectionEdge &
    Edge & {
      __typename?: 'ConditionTypeToConditionTypeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ConditionType;
    };

/** Page Info on the &quot;ConditionTypeToConditionTypeConnection&quot; */
export type ConditionTypeToConditionTypeConnectionPageInfo =
  ConditionTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionTypeToConditionTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ConditionTypeToConditionTypeConnection connection */
export type ConditionTypeToConditionTypeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the ConditionType type and the ContentNode type */
export type ConditionTypeToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'ConditionTypeToContentNodeConnection';
    /** Edges for the ConditionTypeToContentNodeConnection connection */
    edges: Array<ConditionTypeToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: ConditionTypeToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type ConditionTypeToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'ConditionTypeToContentNodeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;ConditionTypeToContentNodeConnection&quot; */
export type ConditionTypeToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ConditionTypeToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ConditionTypeToContentNodeConnection connection */
export type ConditionTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfConditionTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ConditionTypeToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ConditionTypeToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ConditionTypeToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ConditionTypeToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ConditionTypeToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ConditionTypeToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ConditionTypeToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ConditionTypeToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the ConditionType type and the conditionType type */
export type ConditionTypeToParentConditionTypeConnectionEdge =
  ConditionTypeConnectionEdge &
    Edge &
    OneToOneConnection & {
      __typename?: 'ConditionTypeToParentConditionTypeConnectionEdge';
      /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
      cursor: Maybe<Scalars['String']>;
      /** The node of the connection, without the edges */
      node: ConditionType;
    };

/** Connection between the ConditionType type and the Taxonomy type */
export type ConditionTypeToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'ConditionTypeToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type ConditionType_Scrappingsettings = AcfFieldGroup & {
  __typename?: 'ConditionType_Scrappingsettings';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Content ID in scrapping database. Leave empty if no link exists between this item and scrapping data. */
  leafwellScrappingId: Maybe<Scalars['String']>;
};

/** Field Group */
export type ConditionType_Settings = AcfFieldGroup & {
  __typename?: 'ConditionType_Settings';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Only upload transparent png or svg. */
  icon: Maybe<MediaItem>;
  /**
   * Image is customizable &lt;a href=&quot;http://leafwell.test/wp/wp-admin/admin.php?page=theme-settings&quot; target=&quot;_blank&quot; style=&quot;display:block&quot;&gt;in the theme settings - condition tab&lt;/a&gt;
   * &lt;p&gt;Select the top and left coordinates (in percentage) to locate the condition type in the image above.&lt;/p&gt;
   * &lt;p&gt;(Ex:. top=0% and left=0% is the upper left corner of image square)&lt;/p&gt;
   */
  position: Maybe<ConditionType_Settings_Position>;
};

/** Field Group */
export type ConditionType_Settings_Position = AcfFieldGroup & {
  __typename?: 'ConditionType_Settings_Position';
  display: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  left: Maybe<Scalars['Float']>;
  top: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Condition_Conditionsdetails = AcfFieldGroup & {
  __typename?: 'Condition_Conditionsdetails';
  cta: Maybe<Condition_Conditionsdetails_Cta>;
  dosingTitle: Maybe<Scalars['String']>;
  /**
   * A short label describing how effective cannabis is for this particular condition.&lt;br/&gt;
   * Max 30 characters
   */
  efficiency: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  studiesDescription: Maybe<Scalars['String']>;
  studiesTitle: Maybe<Scalars['String']>;
};

/** Field Group */
export type Condition_Conditionsdetails_Cta = AcfFieldGroup & {
  __typename?: 'Condition_Conditionsdetails_Cta';
  backgroundColor: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Field Group */
export type Condition_Scrappingsettings = AcfFieldGroup & {
  __typename?: 'Condition_Scrappingsettings';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Content ID in scrapping database. Leave empty if no link exists between this item and scrapping data. */
  leafwellScrappingId: Maybe<Scalars['String']>;
};

/** A plural connection from one Node Type in the Graph to another Node Type, with support for relational data via &quot;edges&quot;. */
export type Connection = {
  /** A list of edges (relational context) between connected nodes */
  edges: Array<Edge>;
  /** A list of connected nodes */
  nodes: Array<Node>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
};

/** Nodes used to manage content */
export type ContentNode = {
  /** Connection between the ContentNode type and the ContentType type */
  contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The ID of the node in the database. */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt: Maybe<Scalars['String']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug: Maybe<Scalars['String']>;
  /** The current status of the object */
  status: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Nodes used to manage content */
export type ContentNodeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Nodes used to manage content */
export type ContentNodeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Connection to ContentNode Nodes */
export type ContentNodeConnection = {
  /** A list of edges (relational context) between ContentType and connected ContentNode Nodes */
  edges: Array<ContentNodeConnectionEdge>;
  /** A list of connected ContentNode Nodes */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeConnectionPageInfo;
};

/** Edge between a Node and a connected ContentNode */
export type ContentNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected ContentNode Node */
  node: ContentNode;
};

/** Page Info on the connected ContentNodeConnectionEdge */
export type ContentNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the ContentNode type and the ContentType type */
export type ContentNodeToContentTypeConnectionEdge = ContentTypeConnectionEdge &
  Edge &
  OneToOneConnection & {
    __typename?: 'ContentNodeToContentTypeConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: ContentType;
  };

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLastConnectionEdge = Edge &
  OneToOneConnection &
  UserConnectionEdge & {
    __typename?: 'ContentNodeToEditLastConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: User;
  };

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLockConnectionEdge = Edge &
  OneToOneConnection &
  UserConnectionEdge & {
    __typename?: 'ContentNodeToEditLockConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The timestamp for when the node was last edited */
    lockTimestamp: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: User;
  };

/** Connection between the ContentNode type and the EnqueuedScript type */
export type ContentNodeToEnqueuedScriptConnection = Connection &
  EnqueuedScriptConnection & {
    __typename?: 'ContentNodeToEnqueuedScriptConnection';
    /** Edges for the ContentNodeToEnqueuedScriptConnection connection */
    edges: Array<ContentNodeToEnqueuedScriptConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedScript>;
    /** Information about pagination in a connection. */
    pageInfo: ContentNodeToEnqueuedScriptConnectionPageInfo;
  };

/** An edge in a connection */
export type ContentNodeToEnqueuedScriptConnectionEdge = Edge &
  EnqueuedScriptConnectionEdge & {
    __typename?: 'ContentNodeToEnqueuedScriptConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedScript;
  };

/** Page Info on the &quot;ContentNodeToEnqueuedScriptConnection&quot; */
export type ContentNodeToEnqueuedScriptConnectionPageInfo =
  EnqueuedScriptConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ContentNodeToEnqueuedScriptConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the ContentNode type and the EnqueuedStylesheet type */
export type ContentNodeToEnqueuedStylesheetConnection = Connection &
  EnqueuedStylesheetConnection & {
    __typename?: 'ContentNodeToEnqueuedStylesheetConnection';
    /** Edges for the ContentNodeToEnqueuedStylesheetConnection connection */
    edges: Array<ContentNodeToEnqueuedStylesheetConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedStylesheet>;
    /** Information about pagination in a connection. */
    pageInfo: ContentNodeToEnqueuedStylesheetConnectionPageInfo;
  };

/** An edge in a connection */
export type ContentNodeToEnqueuedStylesheetConnectionEdge = Edge &
  EnqueuedStylesheetConnectionEdge & {
    __typename?: 'ContentNodeToEnqueuedStylesheetConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedStylesheet;
  };

/** Page Info on the &quot;ContentNodeToEnqueuedStylesheetConnection&quot; */
export type ContentNodeToEnqueuedStylesheetConnectionPageInfo =
  EnqueuedStylesheetConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ContentNodeToEnqueuedStylesheetConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** The template assigned to a node of content */
export type ContentTemplate = {
  /** The name of the template */
  templateName: Maybe<Scalars['String']>;
};

/** An Post Type object */
export type ContentType = Node &
  UniformResourceIdentifiable & {
    __typename?: 'ContentType';
    /** Whether this content type should can be exported. */
    canExport: Maybe<Scalars['Boolean']>;
    /** Connection between the ContentType type and the Taxonomy type */
    connectedTaxonomies: Maybe<ContentTypeToTaxonomyConnection>;
    /** Connection between the ContentType type and the ContentNode type */
    contentNodes: Maybe<ContentTypeToContentNodeConnection>;
    /** Whether content of this type should be deleted when the author of it is deleted from the system. */
    deleteWithUser: Maybe<Scalars['Boolean']>;
    /** Description of the content type. */
    description: Maybe<Scalars['String']>;
    /** Whether to exclude nodes of this content type from front end search results. */
    excludeFromSearch: Maybe<Scalars['Boolean']>;
    /** The plural name of the content type within the GraphQL Schema. */
    graphqlPluralName: Maybe<Scalars['String']>;
    /** The singular name of the content type within the GraphQL Schema. */
    graphqlSingleName: Maybe<Scalars['String']>;
    /** Whether this content type should have archives. Content archives are generated by type and by date. */
    hasArchive: Maybe<Scalars['Boolean']>;
    /** Whether the content type is hierarchical, for example pages. */
    hierarchical: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the post-type object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether this page is set to the static front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether this page is set to the blog posts page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Display name of the content type. */
    label: Maybe<Scalars['String']>;
    /** Details about the content type labels. */
    labels: Maybe<PostTypeLabelDetails>;
    /** The name of the icon file to display as a menu icon. */
    menuIcon: Maybe<Scalars['String']>;
    /** The position of this post type in the menu. Only applies if show_in_menu is true. */
    menuPosition: Maybe<Scalars['Int']>;
    /** The internal name of the post type. This should not be used for display purposes. */
    name: Maybe<Scalars['String']>;
    /** Whether a content type is intended for use publicly either via the admin interface or by front-end users. While the default settings of exclude_from_search, publicly_queryable, show_ui, and show_in_nav_menus are inherited from public, each does not rely on this relationship and controls a very specific intention. */
    public: Maybe<Scalars['Boolean']>;
    /** Whether queries can be performed on the front end for the content type as part of parse_request(). */
    publiclyQueryable: Maybe<Scalars['Boolean']>;
    /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
    restBase: Maybe<Scalars['String']>;
    /** The REST Controller class assigned to handling this content type. */
    restControllerClass: Maybe<Scalars['String']>;
    /** Makes this content type available via the admin bar. */
    showInAdminBar: Maybe<Scalars['Boolean']>;
    /** Whether to add the content type to the GraphQL Schema. */
    showInGraphql: Maybe<Scalars['Boolean']>;
    /** Where to show the content type in the admin menu. To work, $show_ui must be true. If true, the post type is shown in its own top level menu. If false, no menu is shown. If a string of an existing top level menu (eg. &quot;tools.php&quot; or &quot;edit.php?post_type=page&quot;), the post type will be placed as a sub-menu of that. */
    showInMenu: Maybe<Scalars['Boolean']>;
    /** Makes this content type available for selection in navigation menus. */
    showInNavMenus: Maybe<Scalars['Boolean']>;
    /** Whether the content type is associated with a route under the the REST API &quot;wp/v2&quot; namespace. */
    showInRest: Maybe<Scalars['Boolean']>;
    /** Whether to generate and allow a UI for managing this content type in the admin. */
    showUi: Maybe<Scalars['Boolean']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** An Post Type object */
export type ContentTypeConnectedTaxonomiesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** An Post Type object */
export type ContentTypeContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ContentTypeToContentNodeConnectionWhereArgs>;
};

/** Connection to ContentType Nodes */
export type ContentTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected ContentType Nodes */
  edges: Array<ContentTypeConnectionEdge>;
  /** A list of connected ContentType Nodes */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeConnectionPageInfo;
};

/** Edge between a Node and a connected ContentType */
export type ContentTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected ContentType Node */
  node: ContentType;
};

/** Page Info on the connected ContentTypeConnectionEdge */
export type ContentTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Allowed Content Types */
export enum ContentTypeEnum {
  /** The Type of Content object */
  Attachment = 'ATTACHMENT',
  /** The Type of Content object */
  Event = 'EVENT',
  /** The Type of Content object */
  Faqs = 'FAQS',
  /** The Type of Content object */
  GraphqlDocument = 'GRAPHQL_DOCUMENT',
  /** The Type of Content object */
  Job = 'JOB',
  /** The Type of Content object */
  MedicalConditions = 'MEDICAL_CONDITIONS',
  /** The Type of Content object */
  Page = 'PAGE',
  /** The Type of Content object */
  Post = 'POST',
  /** The Type of Content object */
  Review = 'REVIEW',
  /** The Type of Content object */
  Scholarship = 'SCHOLARSHIP',
  /** The Type of Content object */
  StateLaws = 'STATE_LAWS',
  /** The Type of Content object */
  Strain = 'STRAIN',
  /** The Type of Content object */
  Team = 'TEAM',
  /** The Type of Content object */
  UsLanding = 'US_LANDING',
  /** The Type of Content object */
  Webinar = 'WEBINAR',
}

/** The Type of Identifier used to fetch a single Content Type node. To be used along with the "id" field. Default is "ID". */
export enum ContentTypeIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the content type. */
  Name = 'NAME',
}

/** Connection between the ContentType type and the ContentNode type */
export type ContentTypeToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'ContentTypeToContentNodeConnection';
    /** Edges for the ContentTypeToContentNodeConnection connection */
    edges: Array<ContentTypeToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: ContentTypeToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type ContentTypeToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'ContentTypeToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;ContentTypeToContentNodeConnection&quot; */
export type ContentTypeToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'ContentTypeToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the ContentTypeToContentNodeConnection connection */
export type ContentTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ContentTypeToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ContentTypeToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ContentTypeToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ContentTypeToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ContentTypeToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ContentTypeToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ContentTypeToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ContentTypeToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the ContentType type and the Taxonomy type */
export type ContentTypeToTaxonomyConnection = Connection &
  TaxonomyConnection & {
    __typename?: 'ContentTypeToTaxonomyConnection';
    /** Edges for the ContentTypeToTaxonomyConnection connection */
    edges: Array<ContentTypeToTaxonomyConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Taxonomy>;
    /** Information about pagination in a connection. */
    pageInfo: ContentTypeToTaxonomyConnectionPageInfo;
  };

/** An edge in a connection */
export type ContentTypeToTaxonomyConnectionEdge = Edge &
  TaxonomyConnectionEdge & {
    __typename?: 'ContentTypeToTaxonomyConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Taxonomy;
  };

/** Page Info on the &quot;ContentTypeToTaxonomyConnection&quot; */
export type ContentTypeToTaxonomyConnectionPageInfo = PageInfo &
  TaxonomyConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ContentTypeToTaxonomyConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Allowed Content Types of the Affiliate taxonomy. */
export enum ContentTypesOfAffiliateEnum {
  /** The Type of Content object */
  Page = 'PAGE',
}

/** Allowed Content Types of the Aroma taxonomy. */
export enum ContentTypesOfAromaEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the Category taxonomy. */
export enum ContentTypesOfCategoryEnum {
  /** The Type of Content object */
  Post = 'POST',
}

/** Allowed Content Types of the ConditionType taxonomy. */
export enum ContentTypesOfConditionTypeEnum {
  /** The Type of Content object */
  MedicalConditions = 'MEDICAL_CONDITIONS',
}

/** Allowed Content Types of the CuratedStrainsList taxonomy. */
export enum ContentTypesOfCuratedStrainsListEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the Flavor taxonomy. */
export enum ContentTypesOfFlavorEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the GraphqlDocumentGroup taxonomy. */
export enum ContentTypesOfGraphqlDocumentGroupEnum {
  /** The Type of Content object */
  GraphqlDocument = 'GRAPHQL_DOCUMENT',
}

/** Allowed Content Types of the Job taxonomy. */
export enum ContentTypesOfJobEnum {
  /** The Type of Content object */
  Team = 'TEAM',
}

/** Allowed Content Types of the LawStatus taxonomy. */
export enum ContentTypesOfLawStatusEnum {
  /** The Type of Content object */
  StateLaws = 'STATE_LAWS',
}

/** Allowed Content Types of the NegativeEffect taxonomy. */
export enum ContentTypesOfNegativeEffectEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the PositiveEffect taxonomy. */
export enum ContentTypesOfPositiveEffectEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the PostAuthor taxonomy. */
export enum ContentTypesOfPostAuthorEnum {
  /** The Type of Content object */
  Post = 'POST',
}

/** Allowed Content Types of the PostFormat taxonomy. */
export enum ContentTypesOfPostFormatEnum {
  /** The Type of Content object */
  Post = 'POST',
}

/** Allowed Content Types of the StrainType taxonomy. */
export enum ContentTypesOfStrainTypeEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Allowed Content Types of the Tag taxonomy. */
export enum ContentTypesOfTagEnum {
  /** The Type of Content object */
  Post = 'POST',
}

/** Allowed Content Types of the Team taxonomy. */
export enum ContentTypesOfTeamEnum {
  /** The Type of Content object */
  Job = 'JOB',
}

/** Allowed Content Types of the Terpene taxonomy. */
export enum ContentTypesOfTerpeneEnum {
  /** The Type of Content object */
  Strain = 'STRAIN',
}

/** Input for the createAffiliate mutation. */
export type CreateAffiliateInput = {
  /** The slug that the affiliate will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the affiliate object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the affiliate object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createAffiliate mutation. */
export type CreateAffiliatePayload = {
  __typename?: 'CreateAffiliatePayload';
  /** The created affiliate */
  affiliate: Maybe<Affiliate>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the createAroma mutation. */
export type CreateAromaInput = {
  /** The slug that the aroma will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the aroma object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the aroma object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createAroma mutation. */
export type CreateAromaPayload = {
  __typename?: 'CreateAromaPayload';
  /** The created aroma */
  aroma: Maybe<Aroma>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the createCategory mutation. */
export type CreateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the category object to mutate */
  name: Scalars['String'];
  /** The ID of the category that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createCategory mutation. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The created category */
  category: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the createComment mutation. */
export type CreateCommentInput = {
  /** The approval status of the comment. */
  approved: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Parent comment ID of current comment. */
  parent: InputMaybe<Scalars['ID']>;
  /** The approval status of the comment */
  status: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type: InputMaybe<Scalars['String']>;
};

/** The payload for the createComment mutation. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success: Maybe<Scalars['Boolean']>;
};

/** Input for the createCondition mutation. */
export type CreateConditionInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Set connections between the condition and conditionTypes */
  conditionTypes: InputMaybe<ConditionConditionTypesInput>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createCondition mutation. */
export type CreateConditionPayload = {
  __typename?: 'CreateConditionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  condition: Maybe<Condition>;
};

/** Input for the createConditionType mutation. */
export type CreateConditionTypeInput = {
  /** The slug that the medical_conditions_types will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the medical_conditions_types object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the medical_conditions_types object to mutate */
  name: Scalars['String'];
  /** The ID of the medical_conditions_types that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createConditionType mutation. */
export type CreateConditionTypePayload = {
  __typename?: 'CreateConditionTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created medical_conditions_types */
  conditionType: Maybe<ConditionType>;
};

/** Input for the createCuratedStrainsList mutation. */
export type CreateCuratedStrainsListInput = {
  /** The slug that the curated_strains_list will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the curated_strains_list object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the curated_strains_list object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createCuratedStrainsList mutation. */
export type CreateCuratedStrainsListPayload = {
  __typename?: 'CreateCuratedStrainsListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created curated_strains_list */
  curatedStrainsList: Maybe<CuratedStrainsList>;
};

/** Input for the createEvent mutation. */
export type CreateEventInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createEvent mutation. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  event: Maybe<Event>;
};

/** Input for the createFaq mutation. */
export type CreateFaqInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createFaq mutation. */
export type CreateFaqPayload = {
  __typename?: 'CreateFaqPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  faq: Maybe<Faq>;
};

/** Input for the createFlavor mutation. */
export type CreateFlavorInput = {
  /** The slug that the flavor will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the flavor object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the flavor object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createFlavor mutation. */
export type CreateFlavorPayload = {
  __typename?: 'CreateFlavorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created flavor */
  flavor: Maybe<Flavor>;
};

/** Input for the createGraphqlDocumentGroup mutation. */
export type CreateGraphqlDocumentGroupInput = {
  /** The slug that the graphql_document_group will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the graphql_document_group object */
  description: InputMaybe<Scalars['String']>;
  /** The name of the graphql_document_group object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createGraphqlDocumentGroup mutation. */
export type CreateGraphqlDocumentGroupPayload = {
  __typename?: 'CreateGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created graphql_document_group */
  graphqlDocumentGroup: Maybe<GraphqlDocumentGroup>;
};

/** Input for the createGraphqlDocument mutation. */
export type CreateGraphqlDocumentInput = {
  /** Alias names for saved GraphQL query documents */
  alias: InputMaybe<Array<Scalars['String']>>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Description for the saved GraphQL document */
  description: InputMaybe<Scalars['String']>;
  /** Allow, deny or default access grant for specific query */
  grant: InputMaybe<Scalars['String']>;
  /** Set connections between the graphqlDocument and graphqlDocumentGroups */
  graphqlDocumentGroups: InputMaybe<GraphqlDocumentGraphqlDocumentGroupsInput>;
  /** HTTP Cache-Control max-age directive for a saved GraphQL document */
  maxAgeHeader: InputMaybe<Scalars['Int']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createGraphqlDocument mutation. */
export type CreateGraphqlDocumentPayload = {
  __typename?: 'CreateGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  graphqlDocument: Maybe<GraphqlDocument>;
};

/** Input for the createJob mutation. */
export type CreateJobInput = {
  /** The slug that the job will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the job object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the job object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** Input for the createJobOffer mutation. */
export type CreateJobOfferInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the jobOffer and teams */
  teams: InputMaybe<JobOfferTeamsInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createJobOffer mutation. */
export type CreateJobOfferPayload = {
  __typename?: 'CreateJobOfferPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  jobOffer: Maybe<JobOffer>;
};

/** The payload for the createJob mutation. */
export type CreateJobPayload = {
  __typename?: 'CreateJobPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created job */
  job: Maybe<Job>;
};

/** Input for the createLaw mutation. */
export type CreateLawInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** Set connections between the law and lawStatuses */
  lawStatuses: InputMaybe<LawLawStatusesInput>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createLaw mutation. */
export type CreateLawPayload = {
  __typename?: 'CreateLawPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  law: Maybe<Law>;
};

/** Input for the createLawStatus mutation. */
export type CreateLawStatusInput = {
  /** The slug that the state_laws_status will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the state_laws_status object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the state_laws_status object to mutate */
  name: Scalars['String'];
  /** The ID of the state_laws_status that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createLawStatus mutation. */
export type CreateLawStatusPayload = {
  __typename?: 'CreateLawStatusPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created state_laws_status */
  lawStatus: Maybe<LawStatus>;
};

/** Input for the createMediaItem mutation. */
export type CreateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  parentId: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createMediaItem mutation. */
export type CreateMediaItemPayload = {
  __typename?: 'CreateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem: Maybe<MediaItem>;
};

/** Input for the createNegativeEffect mutation. */
export type CreateNegativeEffectInput = {
  /** The slug that the negative_effect will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the negative_effect object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the negative_effect object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createNegativeEffect mutation. */
export type CreateNegativeEffectPayload = {
  __typename?: 'CreateNegativeEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created negative_effect */
  negativeEffect: Maybe<NegativeEffect>;
};

/** Input for the createPage mutation. */
export type CreatePageInput = {
  /** Set connections between the page and affiliates */
  affiliates: InputMaybe<PageAffiliatesInput>;
  /** The userId to assign as the author of the object */
  authorId: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createPage mutation. */
export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page: Maybe<Page>;
};

/** Input for the createPositiveEffect mutation. */
export type CreatePositiveEffectInput = {
  /** The slug that the positive_effect will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the positive_effect object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the positive_effect object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createPositiveEffect mutation. */
export type CreatePositiveEffectPayload = {
  __typename?: 'CreatePositiveEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created positive_effect */
  positiveEffect: Maybe<PositiveEffect>;
};

/** Input for the createPostAuthor mutation. */
export type CreatePostAuthorInput = {
  /** The slug that the post_author will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_author object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the post_author object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createPostAuthor mutation. */
export type CreatePostAuthorPayload = {
  __typename?: 'CreatePostAuthorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_author */
  postAuthor: Maybe<PostAuthor>;
};

/** Input for the createPostFormat mutation. */
export type CreatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description: InputMaybe<Scalars['String']>;
  /** The name of the post_format object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createPostFormat mutation. */
export type CreatePostFormatPayload = {
  __typename?: 'CreatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat: Maybe<PostFormat>;
};

/** Input for the createPost mutation. */
export type CreatePostInput = {
  /** The userId to assign as the author of the object */
  authorId: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postAuthors */
  postAuthors: InputMaybe<PostPostAuthorsInput>;
  /** Set connections between the post and postFormats */
  postFormats: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the createPost mutation. */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post: Maybe<Post>;
};

/** Input for the createPublicReview mutation. */
export type CreatePublicReviewInput = {
  /** Reviewer name */
  author: Scalars['String'];
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Review content */
  content: Scalars['String'];
  /** Reviewer email */
  email: InputMaybe<Scalars['String']>;
  /** Reviewer location */
  location: InputMaybe<Scalars['String']>;
  /** Reviewer photo */
  photo: InputMaybe<Base64File>;
  /** Review rating */
  rating: Scalars['Int'];
};

/** The payload for the createPublicReview mutation. */
export type CreatePublicReviewPayload = {
  __typename?: 'CreatePublicReviewPayload';
  author: Maybe<Scalars['String']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the createReview mutation. */
export type CreateReviewInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createReview mutation. */
export type CreateReviewPayload = {
  __typename?: 'CreateReviewPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  review: Maybe<Review>;
};

/** Input for the createScholarship mutation. */
export type CreateScholarshipInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createScholarship mutation. */
export type CreateScholarshipPayload = {
  __typename?: 'CreateScholarshipPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  scholarship: Maybe<Scholarship>;
};

/** Input for the createStrain mutation. */
export type CreateStrainInput = {
  /** Set connections between the strain and aromas */
  aromas: InputMaybe<StrainAromasInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and curatedStrainsLists */
  curatedStrainsLists: InputMaybe<StrainCuratedStrainsListsInput>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and flavors */
  flavors: InputMaybe<StrainFlavorsInput>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** Set connections between the strain and negativeEffects */
  negativeEffects: InputMaybe<StrainNegativeEffectsInput>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and positiveEffects */
  positiveEffects: InputMaybe<StrainPositiveEffectsInput>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the strain and strainTypes */
  strainTypes: InputMaybe<StrainStrainTypesInput>;
  /** Set connections between the strain and terpenes */
  terpenes: InputMaybe<StrainTerpenesInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createStrain mutation. */
export type CreateStrainPayload = {
  __typename?: 'CreateStrainPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  strain: Maybe<Strain>;
};

/** Input for the createStrainType mutation. */
export type CreateStrainTypeInput = {
  /** The slug that the strain_type will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the strain_type object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the strain_type object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createStrainType mutation. */
export type CreateStrainTypePayload = {
  __typename?: 'CreateStrainTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created strain_type */
  strainType: Maybe<StrainType>;
};

/** Input for the createTag mutation. */
export type CreateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the post_tag object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createTag mutation. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag: Maybe<Tag>;
};

/** Input for the createTeam mutation. */
export type CreateTeamInput = {
  /** The slug that the job_area will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the job_area object */
  description: InputMaybe<Scalars['String']>;
  /** The name of the job_area object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** Input for the createTeamMember mutation. */
export type CreateTeamMemberInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Set connections between the teamMember and jobs */
  jobs: InputMaybe<TeamMemberJobsInput>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createTeamMember mutation. */
export type CreateTeamMemberPayload = {
  __typename?: 'CreateTeamMemberPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  teamMember: Maybe<TeamMember>;
};

/** The payload for the createTeam mutation. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created job_area */
  team: Maybe<Team>;
};

/** Input for the createTerpene mutation. */
export type CreateTerpeneInput = {
  /** The slug that the terpene will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the terpene object */
  description: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the terpene object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the createTerpene mutation. */
export type CreateTerpenePayload = {
  __typename?: 'CreateTerpenePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created terpene */
  terpene: Maybe<Terpene>;
};

/** Input for the createUsLanding mutation. */
export type CreateUsLandingInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createUsLanding mutation. */
export type CreateUsLandingPayload = {
  __typename?: 'CreateUsLandingPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  usLanding: Maybe<UsLanding>;
};

/** Input for the createUser mutation. */
export type CreateUserInput = {
  /** User's AOL IM account. */
  aim: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password: InputMaybe<Scalars['String']>;
  /** If true, this will refresh the users JWT secret. */
  refreshJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered: InputMaybe<Scalars['String']>;
  /** If true, this will revoke the users JWT secret. If false, this will unrevoke the JWT secret AND issue a new one. To revoke, the user must have proper capabilities to edit users JWT secrets. */
  revokeJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string that contains the user's username for logging in. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim: InputMaybe<Scalars['String']>;
};

/** The payload for the createUser mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user: Maybe<User>;
};

/** Input for the createWebinar mutation. */
export type CreateWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the createWebinar mutation. */
export type CreateWebinarPayload = {
  __typename?: 'CreateWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  webinar: Maybe<Webinar>;
};

/** The curatedStrainsList type */
export type CuratedStrainsList = DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'CuratedStrainsList';
    /** Connection between the CuratedStrainsList type and the ContentNode type */
    contentNodes: Maybe<CuratedStrainsListToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    curatedStrainsListId: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the CuratedStrainsList type and the strain type */
    strains: Maybe<CuratedStrainsListToStrainConnection>;
    /** Connection between the CuratedStrainsList type and the Taxonomy type */
    taxonomy: Maybe<CuratedStrainsListToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<CuratedStrainsList>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<CuratedStrainsList>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The curatedStrainsList type */
export type CuratedStrainsListContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CuratedStrainsListToContentNodeConnectionWhereArgs>;
};

/** The curatedStrainsList type */
export type CuratedStrainsListEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The curatedStrainsList type */
export type CuratedStrainsListEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The curatedStrainsList type */
export type CuratedStrainsListStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CuratedStrainsListToStrainConnectionWhereArgs>;
};

/** The curatedStrainsList type */
export type CuratedStrainsListTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to curatedStrainsList Nodes */
export type CuratedStrainsListConnection = {
  /** A list of edges (relational context) between RootQuery and connected curatedStrainsList Nodes */
  edges: Array<CuratedStrainsListConnectionEdge>;
  /** A list of connected curatedStrainsList Nodes */
  nodes: Array<CuratedStrainsList>;
  /** Information about pagination in a connection. */
  pageInfo: CuratedStrainsListConnectionPageInfo;
};

/** Edge between a Node and a connected curatedStrainsList */
export type CuratedStrainsListConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected curatedStrainsList Node */
  node: CuratedStrainsList;
};

/** Page Info on the connected CuratedStrainsListConnectionEdge */
export type CuratedStrainsListConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum CuratedStrainsListIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the CuratedStrainsList type and the ContentNode type */
export type CuratedStrainsListToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'CuratedStrainsListToContentNodeConnection';
    /** Edges for the CuratedStrainsListToContentNodeConnection connection */
    edges: Array<CuratedStrainsListToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: CuratedStrainsListToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type CuratedStrainsListToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'CuratedStrainsListToContentNodeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;CuratedStrainsListToContentNodeConnection&quot; */
export type CuratedStrainsListToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'CuratedStrainsListToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the CuratedStrainsListToContentNodeConnection connection */
export type CuratedStrainsListToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<
    Array<InputMaybe<ContentTypesOfCuratedStrainsListEnum>>
  >;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<CuratedStrainsListToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type CuratedStrainsListToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<CuratedStrainsListToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<CuratedStrainsListToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum CuratedStrainsListToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type CuratedStrainsListToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<
      InputMaybe<CuratedStrainsListToContentNodeConnectionWhereArgsMetaArray>
    >
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum CuratedStrainsListToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the CuratedStrainsList type and the strain type */
export type CuratedStrainsListToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'CuratedStrainsListToStrainConnection';
    /** Edges for the CuratedStrainsListToStrainConnection connection */
    edges: Array<CuratedStrainsListToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: CuratedStrainsListToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type CuratedStrainsListToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'CuratedStrainsListToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;CuratedStrainsListToStrainConnection&quot; */
export type CuratedStrainsListToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'CuratedStrainsListToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the CuratedStrainsListToStrainConnection connection */
export type CuratedStrainsListToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<CuratedStrainsListToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type CuratedStrainsListToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<CuratedStrainsListToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<CuratedStrainsListToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum CuratedStrainsListToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type CuratedStrainsListToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<CuratedStrainsListToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum CuratedStrainsListToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the CuratedStrainsList type and the Taxonomy type */
export type CuratedStrainsListToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'CuratedStrainsListToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Object that can be identified with a Database ID */
export type DatabaseIdentifier = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
};

/** Date values */
export type DateInput = {
  /** Day of the month (from 1 to 31) */
  day: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year: InputMaybe<Scalars['Int']>;
};

/** Filter the connection based on input */
export type DateQueryInput = {
  /** Nodes should be returned after this date */
  after: InputMaybe<DateInput>;
  /** Nodes should be returned before this date */
  before: InputMaybe<DateInput>;
  /** Column to query against */
  column: InputMaybe<PostObjectsConnectionDateColumnEnum>;
  /** For after/before, whether exact value should be matched or not */
  compare: InputMaybe<Scalars['String']>;
  /** Day of the month (from 1 to 31) */
  day: InputMaybe<Scalars['Int']>;
  /** Hour (from 0 to 23) */
  hour: InputMaybe<Scalars['Int']>;
  /** For after/before, whether exact value should be matched or not */
  inclusive: InputMaybe<Scalars['Boolean']>;
  /** Minute (from 0 to 59) */
  minute: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month: InputMaybe<Scalars['Int']>;
  /** OR or AND, how the sub-arrays should be compared */
  relation: InputMaybe<RelationEnum>;
  /** Second (0 to 59) */
  second: InputMaybe<Scalars['Int']>;
  /** Week of the year (from 0 to 53) */
  week: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year: InputMaybe<Scalars['Int']>;
};

/** The template assigned to the node */
export type DefaultTemplate = ContentTemplate & {
  __typename?: 'DefaultTemplate';
  /** The name of the template */
  templateName: Maybe<Scalars['String']>;
};

/** Input for the deleteAffiliate mutation. */
export type DeleteAffiliateInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the affiliate to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteAffiliate mutation. */
export type DeleteAffiliatePayload = {
  __typename?: 'DeleteAffiliatePayload';
  /** The deleted term object */
  affiliate: Maybe<Affiliate>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteAroma mutation. */
export type DeleteAromaInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the aroma to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteAroma mutation. */
export type DeleteAromaPayload = {
  __typename?: 'DeleteAromaPayload';
  /** The deleted term object */
  aroma: Maybe<Aroma>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteCategory mutation. */
export type DeleteCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the category to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteCategory mutation. */
export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** The deleted term object */
  category: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteComment mutation. */
export type DeleteCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the comment should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The deleted comment ID */
  id: Scalars['ID'];
};

/** The payload for the deleteComment mutation. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The deleted comment object */
  comment: Maybe<Comment>;
  /** The deleted comment ID */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteCondition mutation. */
export type DeleteConditionInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the condition to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteCondition mutation. */
export type DeleteConditionPayload = {
  __typename?: 'DeleteConditionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The object before it was deleted */
  condition: Maybe<Condition>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteConditionType mutation. */
export type DeleteConditionTypeInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the conditionType to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteConditionType mutation. */
export type DeleteConditionTypePayload = {
  __typename?: 'DeleteConditionTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The deleted term object */
  conditionType: Maybe<ConditionType>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteCuratedStrainsList mutation. */
export type DeleteCuratedStrainsListInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the curatedStrainsList to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteCuratedStrainsList mutation. */
export type DeleteCuratedStrainsListPayload = {
  __typename?: 'DeleteCuratedStrainsListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The deleted term object */
  curatedStrainsList: Maybe<CuratedStrainsList>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
};

/** Input for the deleteEvent mutation. */
export type DeleteEventInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the event to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteEvent mutation. */
export type DeleteEventPayload = {
  __typename?: 'DeleteEventPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  event: Maybe<Event>;
};

/** Input for the deleteFaq mutation. */
export type DeleteFaqInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the faq to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteFaq mutation. */
export type DeleteFaqPayload = {
  __typename?: 'DeleteFaqPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  faq: Maybe<Faq>;
};

/** Input for the deleteFlavor mutation. */
export type DeleteFlavorInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the flavor to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteFlavor mutation. */
export type DeleteFlavorPayload = {
  __typename?: 'DeleteFlavorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  flavor: Maybe<Flavor>;
};

/** Input for the deleteGraphqlDocumentGroup mutation. */
export type DeleteGraphqlDocumentGroupInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the graphqlDocumentGroup to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteGraphqlDocumentGroup mutation. */
export type DeleteGraphqlDocumentGroupPayload = {
  __typename?: 'DeleteGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  graphqlDocumentGroup: Maybe<GraphqlDocumentGroup>;
};

/** Input for the deleteGraphqlDocument mutation. */
export type DeleteGraphqlDocumentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the graphqlDocument to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteGraphqlDocument mutation. */
export type DeleteGraphqlDocumentPayload = {
  __typename?: 'DeleteGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  graphqlDocument: Maybe<GraphqlDocument>;
};

/** Input for the deleteJob mutation. */
export type DeleteJobInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the job to delete */
  id: Scalars['ID'];
};

/** Input for the deleteJobOffer mutation. */
export type DeleteJobOfferInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the jobOffer to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteJobOffer mutation. */
export type DeleteJobOfferPayload = {
  __typename?: 'DeleteJobOfferPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  jobOffer: Maybe<JobOffer>;
};

/** The payload for the deleteJob mutation. */
export type DeleteJobPayload = {
  __typename?: 'DeleteJobPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  job: Maybe<Job>;
};

/** Input for the deleteLaw mutation. */
export type DeleteLawInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the law to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteLaw mutation. */
export type DeleteLawPayload = {
  __typename?: 'DeleteLawPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  law: Maybe<Law>;
};

/** Input for the deleteLawStatus mutation. */
export type DeleteLawStatusInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the lawStatus to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteLawStatus mutation. */
export type DeleteLawStatusPayload = {
  __typename?: 'DeleteLawStatusPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  lawStatus: Maybe<LawStatus>;
};

/** Input for the deleteMediaItem mutation. */
export type DeleteMediaItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the mediaItem should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the mediaItem to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteMediaItem mutation. */
export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted mediaItem */
  deletedId: Maybe<Scalars['ID']>;
  /** The mediaItem before it was deleted */
  mediaItem: Maybe<MediaItem>;
};

/** Input for the deleteNegativeEffect mutation. */
export type DeleteNegativeEffectInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the negativeEffect to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteNegativeEffect mutation. */
export type DeleteNegativeEffectPayload = {
  __typename?: 'DeleteNegativeEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  negativeEffect: Maybe<NegativeEffect>;
};

/** Input for the deletePage mutation. */
export type DeletePageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the page to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deletePage mutation. */
export type DeletePagePayload = {
  __typename?: 'DeletePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  page: Maybe<Page>;
};

/** Input for the deletePositiveEffect mutation. */
export type DeletePositiveEffectInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the positiveEffect to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePositiveEffect mutation. */
export type DeletePositiveEffectPayload = {
  __typename?: 'DeletePositiveEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  positiveEffect: Maybe<PositiveEffect>;
};

/** Input for the deletePostAuthor mutation. */
export type DeletePostAuthorInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the postAuthor to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePostAuthor mutation. */
export type DeletePostAuthorPayload = {
  __typename?: 'DeletePostAuthorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  postAuthor: Maybe<PostAuthor>;
};

/** Input for the deletePostFormat mutation. */
export type DeletePostFormatInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePostFormat mutation. */
export type DeletePostFormatPayload = {
  __typename?: 'DeletePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  postFormat: Maybe<PostFormat>;
};

/** Input for the deletePost mutation. */
export type DeletePostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the post to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deletePost mutation. */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  post: Maybe<Post>;
};

/** Input for the deleteReview mutation. */
export type DeleteReviewInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the review to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteReview mutation. */
export type DeleteReviewPayload = {
  __typename?: 'DeleteReviewPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  review: Maybe<Review>;
};

/** Input for the deleteScholarship mutation. */
export type DeleteScholarshipInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the scholarship to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteScholarship mutation. */
export type DeleteScholarshipPayload = {
  __typename?: 'DeleteScholarshipPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  scholarship: Maybe<Scholarship>;
};

/** Input for the deleteStrain mutation. */
export type DeleteStrainInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the strain to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteStrain mutation. */
export type DeleteStrainPayload = {
  __typename?: 'DeleteStrainPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  strain: Maybe<Strain>;
};

/** Input for the deleteStrainType mutation. */
export type DeleteStrainTypeInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the strainType to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteStrainType mutation. */
export type DeleteStrainTypePayload = {
  __typename?: 'DeleteStrainTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  strainType: Maybe<StrainType>;
};

/** Input for the deleteTag mutation. */
export type DeleteTagInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the tag to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteTag mutation. */
export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  tag: Maybe<Tag>;
};

/** Input for the deleteTeam mutation. */
export type DeleteTeamInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the team to delete */
  id: Scalars['ID'];
};

/** Input for the deleteTeamMember mutation. */
export type DeleteTeamMemberInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the teamMember to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteTeamMember mutation. */
export type DeleteTeamMemberPayload = {
  __typename?: 'DeleteTeamMemberPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  teamMember: Maybe<TeamMember>;
};

/** The payload for the deleteTeam mutation. */
export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  team: Maybe<Team>;
};

/** Input for the deleteTerpene mutation. */
export type DeleteTerpeneInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the terpene to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteTerpene mutation. */
export type DeleteTerpenePayload = {
  __typename?: 'DeleteTerpenePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted term object */
  terpene: Maybe<Terpene>;
};

/** Input for the deleteUsLanding mutation. */
export type DeleteUsLandingInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the usLanding to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteUsLanding mutation. */
export type DeleteUsLandingPayload = {
  __typename?: 'DeleteUsLandingPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  usLanding: Maybe<UsLanding>;
};

/** Input for the deleteUser mutation. */
export type DeleteUserInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the user you want to delete */
  id: Scalars['ID'];
  /** Reassign posts and links to new User ID. */
  reassignId: InputMaybe<Scalars['ID']>;
};

/** The payload for the deleteUser mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the user that you just deleted */
  deletedId: Maybe<Scalars['ID']>;
  /** The deleted user object */
  user: Maybe<User>;
};

/** Input for the deleteWebinar mutation. */
export type DeleteWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete: InputMaybe<Scalars['Boolean']>;
  /** The ID of the webinar to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deleteWebinar mutation. */
export type DeleteWebinarPayload = {
  __typename?: 'DeleteWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  webinar: Maybe<Webinar>;
};

/** The discussion setting type */
export type DiscussionSettings = {
  __typename?: 'DiscussionSettings';
  /** Allow people to submit comments on new posts. */
  defaultCommentStatus: Maybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  defaultPingStatus: Maybe<Scalars['String']>;
};

/** Relational context between connected nodes */
export type Edge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected node */
  node: Node;
};

/** Asset enqueued by the CMS */
export type EnqueuedAsset = {
  /** The inline code to be run after the asset is loaded. */
  after: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args: Maybe<Scalars['Boolean']>;
  /** The inline code to be run before the asset is loaded. */
  before: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional: Maybe<Scalars['String']>;
  /** Dependencies needed to use this asset */
  dependencies: Maybe<Array<Maybe<EnqueuedAsset>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle: Maybe<Scalars['String']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID'];
  /** The source of the asset */
  src: Maybe<Scalars['String']>;
  /** The version of the enqueued asset */
  version: Maybe<Scalars['String']>;
};

/** Script enqueued by the CMS */
export type EnqueuedScript = EnqueuedAsset &
  Node & {
    __typename?: 'EnqueuedScript';
    /** The inline code to be run after the asset is loaded. */
    after: Maybe<Array<Maybe<Scalars['String']>>>;
    /**
     * Deprecated
     * @deprecated Use `EnqueuedAsset.media` instead.
     */
    args: Maybe<Scalars['Boolean']>;
    /** The inline code to be run before the asset is loaded. */
    before: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
    conditional: Maybe<Scalars['String']>;
    /** Dependencies needed to use this asset */
    dependencies: Maybe<Array<Maybe<EnqueuedScript>>>;
    /**
     * Extra information needed for the script
     * @deprecated Use `EnqueuedScript.extraData` instead.
     */
    extra: Maybe<Scalars['String']>;
    /** Extra data supplied to the enqueued script */
    extraData: Maybe<Scalars['String']>;
    /** The handle of the enqueued asset */
    handle: Maybe<Scalars['String']>;
    /** The global ID of the enqueued script */
    id: Scalars['ID'];
    /** The source of the asset */
    src: Maybe<Scalars['String']>;
    /** The loading strategy to use on the script tag */
    strategy: Maybe<ScriptLoadingStrategyEnum>;
    /** The version of the enqueued script */
    version: Maybe<Scalars['String']>;
  };

/** Connection to EnqueuedScript Nodes */
export type EnqueuedScriptConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedScript Nodes */
  edges: Array<EnqueuedScriptConnectionEdge>;
  /** A list of connected EnqueuedScript Nodes */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedScriptConnectionPageInfo;
};

/** Edge between a Node and a connected EnqueuedScript */
export type EnqueuedScriptConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected EnqueuedScript Node */
  node: EnqueuedScript;
};

/** Page Info on the connected EnqueuedScriptConnectionEdge */
export type EnqueuedScriptConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Stylesheet enqueued by the CMS */
export type EnqueuedStylesheet = EnqueuedAsset &
  Node & {
    __typename?: 'EnqueuedStylesheet';
    /** The inline code to be run after the asset is loaded. */
    after: Maybe<Array<Maybe<Scalars['String']>>>;
    /**
     * Deprecated
     * @deprecated Use `EnqueuedAsset.media` instead.
     */
    args: Maybe<Scalars['Boolean']>;
    /** The inline code to be run before the asset is loaded. */
    before: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
    conditional: Maybe<Scalars['String']>;
    /** Dependencies needed to use this asset */
    dependencies: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
    /**
     * Extra information needed for the script
     * @deprecated Use `EnqueuedScript.extraData` instead.
     */
    extra: Maybe<Scalars['String']>;
    /** The handle of the enqueued asset */
    handle: Maybe<Scalars['String']>;
    /** The global ID of the enqueued stylesheet */
    id: Scalars['ID'];
    /** Whether the enqueued style is RTL or not */
    isRtl: Maybe<Scalars['Boolean']>;
    /** The media attribute to use for the link */
    media: Maybe<Scalars['String']>;
    /** The absolute path to the enqueued style. Set when the stylesheet is meant to load inline. */
    path: Maybe<Scalars['String']>;
    /** The `rel` attribute to use for the link */
    rel: Maybe<Scalars['String']>;
    /** The source of the asset */
    src: Maybe<Scalars['String']>;
    /** Optional suffix, used in combination with RTL */
    suffix: Maybe<Scalars['String']>;
    /** The title of the enqueued style. Used for preferred/alternate stylesheets. */
    title: Maybe<Scalars['String']>;
    /** The version of the enqueued style */
    version: Maybe<Scalars['String']>;
  };

/** Connection to EnqueuedStylesheet Nodes */
export type EnqueuedStylesheetConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedStylesheet Nodes */
  edges: Array<EnqueuedStylesheetConnectionEdge>;
  /** A list of connected EnqueuedStylesheet Nodes */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedStylesheetConnectionPageInfo;
};

/** Edge between a Node and a connected EnqueuedStylesheet */
export type EnqueuedStylesheetConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected EnqueuedStylesheet Node */
  node: EnqueuedStylesheet;
};

/** Page Info on the connected EnqueuedStylesheetConnectionEdge */
export type EnqueuedStylesheetConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The event type */
export type Event = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Event';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<Event_Activestates>;
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<EventToEventConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Medical Card Page Settings&quot; was set to Show in GraphQL. */
    cardPageSettings: Maybe<Event_Cardpagesettings>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    eventId: Scalars['Int'];
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the event object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the event object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Page settings&quot; was set to Show in GraphQL. */
    pageDetails: Maybe<Acf_Page_Pagedetails>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<EventToParentConnectionEdge>;
    /** The password for the event object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Event type and the event type */
    preview: Maybe<EventToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Event type and the event type */
    revisions: Maybe<EventToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Event>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Event>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The event type */
export type EventAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The event type */
export type EventEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The event type */
export type EventEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The event type */
export type EventRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<EventToRevisionConnectionWhereArgs>;
};

/** The event type */
export type EventTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The event type */
export type EventTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to event Nodes */
export type EventConnection = {
  /** A list of edges (relational context) between RootQuery and connected event Nodes */
  edges: Array<EventConnectionEdge>;
  /** A list of connected event Nodes */
  nodes: Array<Event>;
  /** Information about pagination in a connection. */
  pageInfo: EventConnectionPageInfo;
};

/** Edge between a Node and a connected event */
export type EventConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected event Node */
  node: Event;
};

/** Page Info on the connected EventConnectionEdge */
export type EventConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum EventIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Event type and the event type */
export type EventToEventConnection = Connection &
  EventConnection & {
    __typename?: 'EventToEventConnection';
    /** Edges for the EventToEventConnection connection */
    edges: Array<EventToEventConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Event>;
    /** Information about pagination in a connection. */
    pageInfo: EventToEventConnectionPageInfo;
  };

/** An edge in a connection */
export type EventToEventConnectionEdge = Edge &
  EventConnectionEdge & {
    __typename?: 'EventToEventConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Event;
  };

/** Page Info on the &quot;EventToEventConnection&quot; */
export type EventToEventConnectionPageInfo = EventConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'EventToEventConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Event type and the event type */
export type EventToParentConnectionEdge = Edge &
  EventConnectionEdge &
  OneToOneConnection & {
    __typename?: 'EventToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Event;
  };

/** Connection between the Event type and the event type */
export type EventToPreviewConnectionEdge = Edge &
  EventConnectionEdge &
  OneToOneConnection & {
    __typename?: 'EventToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Event;
  };

/** Connection between the Event type and the event type */
export type EventToRevisionConnection = Connection &
  EventConnection & {
    __typename?: 'EventToRevisionConnection';
    /** Edges for the EventToRevisionConnection connection */
    edges: Array<EventToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Event>;
    /** Information about pagination in a connection. */
    pageInfo: EventToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type EventToRevisionConnectionEdge = Edge &
  EventConnectionEdge & {
    __typename?: 'EventToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Event;
  };

/** Page Info on the &quot;EventToRevisionConnection&quot; */
export type EventToRevisionConnectionPageInfo = EventConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'EventToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the EventToRevisionConnection connection */
export type EventToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<EventToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type EventToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<EventToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<EventToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum EventToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type EventToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<EventToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum EventToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Field Group */
export type Event_Activestates = AcfFieldGroup & {
  __typename?: 'Event_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type Event_Cardpagesettings = AcfFieldGroup & {
  __typename?: 'Event_Cardpagesettings';
  affiliateLogo: Maybe<MediaItem>;
  affiliatePage: Maybe<Array<Maybe<Event_Cardpagesettings_AffiliatePage>>>;
  affiliateWebsite: Maybe<Scalars['String']>;
  customStateCode: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Custom form url. Leave blank to use the default. */
  formUrl: Maybe<Scalars['String']>;
  imageObjectCaption: Maybe<Scalars['String']>;
  isAffiliate: Maybe<Scalars['Boolean']>;
  /**
   * Leave this section blank if this is a regular medical card or affiliate page. &lt;br/&gt;
   * This flag is being used to control A/B Testing
   */
  isExperiment: Maybe<Scalars['Boolean']>;
  isRenewal: Maybe<Scalars['Boolean']>;
  isVpdLanding: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  /** If checked, the registration form will disconnect from Medical Card but continue to collect contact information so patients can be followed up. */
  pauseAppointments: Maybe<Scalars['Boolean']>;
  /**
   * Price: Price (in $) without any discount. &lt;strong&gt; Leave it blank if the VPD is set to multi-state&lt;/strong&gt;&lt;br/&gt;
   * New Price: Price (in $) after applying a discount. &lt;strong&gt; Leave it blank &lt;/strong&gt; if &lt;em&gt;no discount or a percentage discount&lt;/em&gt; should be applied&lt;br/&gt;
   * Percentage Discount: Between 0-100.&lt;strong&gt;Leave it blank&lt;/strong&gt; if the discount is a $ value&lt;br/&gt;
   * &lt;strong&gt;Note:&lt;/strong&gt; either fill &quot;New Price&quot; - for a value discount -  or &quot;Percentage Discount&quot; - for a percentage discount
   */
  price: Maybe<Event_Cardpagesettings_Price>;
  product: Maybe<Event_Cardpagesettings_Product>;
  redirectMedicalCard: Maybe<Scalars['Boolean']>;
  stateProductImage: Maybe<MediaItem>;
  totalMedicalCardPrice: Maybe<Scalars['String']>;
  vpdLogo: Maybe<MediaItem>;
  vpdPage: Maybe<Event_Cardpagesettings_VpdPage>;
  vpdPartnerName: Maybe<Scalars['String']>;
  webinarInfo: Maybe<Event_Cardpagesettings_WebinarInfo>;
};

export type Event_Cardpagesettings_AffiliatePage = Page;

/** Field Group */
export type Event_Cardpagesettings_Price = AcfFieldGroup & {
  __typename?: 'Event_Cardpagesettings_Price';
  discountCode: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  newPrice: Maybe<Scalars['Float']>;
  percentageDiscount: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Event_Cardpagesettings_Product = AcfFieldGroup & {
  __typename?: 'Event_Cardpagesettings_Product';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  imageUrl: Maybe<MediaItem>;
  name: Maybe<Scalars['String']>;
};

export type Event_Cardpagesettings_VpdPage = Event;

/** Field Group */
export type Event_Cardpagesettings_WebinarInfo = AcfFieldGroup & {
  __typename?: 'Event_Cardpagesettings_WebinarInfo';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  webinarDescription: Maybe<Scalars['String']>;
  webinarTitle: Maybe<Scalars['String']>;
  webinarZoomUrl: Maybe<Scalars['String']>;
};

/** The faq type */
export type Faq = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Faq';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<FaqToFaqConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    faqId: Scalars['Int'];
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the faqs object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the faqs object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<FaqToParentConnectionEdge>;
    /** The password for the faqs object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Faq type and the faq type */
    preview: Maybe<FaqToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Faq type and the faq type */
    revisions: Maybe<FaqToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Faq>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Faq>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The faq type */
export type FaqAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The faq type */
export type FaqContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The faq type */
export type FaqEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The faq type */
export type FaqEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The faq type */
export type FaqRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<FaqToRevisionConnectionWhereArgs>;
};

/** The faq type */
export type FaqTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The faq type */
export type FaqTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to faq Nodes */
export type FaqConnection = {
  /** A list of edges (relational context) between RootQuery and connected faq Nodes */
  edges: Array<FaqConnectionEdge>;
  /** A list of connected faq Nodes */
  nodes: Array<Faq>;
  /** Information about pagination in a connection. */
  pageInfo: FaqConnectionPageInfo;
};

/** Edge between a Node and a connected faq */
export type FaqConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected faq Node */
  node: Faq;
};

/** Page Info on the connected FaqConnectionEdge */
export type FaqConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum FaqIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Faq type and the faq type */
export type FaqToFaqConnection = Connection &
  FaqConnection & {
    __typename?: 'FaqToFaqConnection';
    /** Edges for the FaqToFaqConnection connection */
    edges: Array<FaqToFaqConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Faq>;
    /** Information about pagination in a connection. */
    pageInfo: FaqToFaqConnectionPageInfo;
  };

/** An edge in a connection */
export type FaqToFaqConnectionEdge = Edge &
  FaqConnectionEdge & {
    __typename?: 'FaqToFaqConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Faq;
  };

/** Page Info on the &quot;FaqToFaqConnection&quot; */
export type FaqToFaqConnectionPageInfo = FaqConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'FaqToFaqConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Faq type and the faq type */
export type FaqToParentConnectionEdge = Edge &
  FaqConnectionEdge &
  OneToOneConnection & {
    __typename?: 'FaqToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Faq;
  };

/** Connection between the Faq type and the faq type */
export type FaqToPreviewConnectionEdge = Edge &
  FaqConnectionEdge &
  OneToOneConnection & {
    __typename?: 'FaqToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Faq;
  };

/** Connection between the Faq type and the faq type */
export type FaqToRevisionConnection = Connection &
  FaqConnection & {
    __typename?: 'FaqToRevisionConnection';
    /** Edges for the FaqToRevisionConnection connection */
    edges: Array<FaqToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Faq>;
    /** Information about pagination in a connection. */
    pageInfo: FaqToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type FaqToRevisionConnectionEdge = Edge &
  FaqConnectionEdge & {
    __typename?: 'FaqToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Faq;
  };

/** Page Info on the &quot;FaqToRevisionConnection&quot; */
export type FaqToRevisionConnectionPageInfo = FaqConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'FaqToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the FaqToRevisionConnection connection */
export type FaqToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<FaqToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type FaqToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<FaqToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<FaqToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum FaqToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type FaqToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<FaqToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum FaqToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** The flavor type */
export type Flavor = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Flavor';
    /** Connection between the Flavor type and the ContentNode type */
    contentNodes: Maybe<FlavorToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    flavorId: Maybe<Scalars['Int']>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Flavor type and the strain type */
    strains: Maybe<FlavorToStrainConnection>;
    /** Connection between the Flavor type and the Taxonomy type */
    taxonomy: Maybe<FlavorToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Flavor>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Flavor>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The flavor type */
export type FlavorContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<FlavorToContentNodeConnectionWhereArgs>;
};

/** The flavor type */
export type FlavorEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The flavor type */
export type FlavorEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The flavor type */
export type FlavorStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<FlavorToStrainConnectionWhereArgs>;
};

/** The flavor type */
export type FlavorTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to flavor Nodes */
export type FlavorConnection = {
  /** A list of edges (relational context) between RootQuery and connected flavor Nodes */
  edges: Array<FlavorConnectionEdge>;
  /** A list of connected flavor Nodes */
  nodes: Array<Flavor>;
  /** Information about pagination in a connection. */
  pageInfo: FlavorConnectionPageInfo;
};

/** Edge between a Node and a connected flavor */
export type FlavorConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected flavor Node */
  node: Flavor;
};

/** Page Info on the connected FlavorConnectionEdge */
export type FlavorConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum FlavorIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Flavor type and the ContentNode type */
export type FlavorToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'FlavorToContentNodeConnection';
    /** Edges for the FlavorToContentNodeConnection connection */
    edges: Array<FlavorToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: FlavorToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type FlavorToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'FlavorToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;FlavorToContentNodeConnection&quot; */
export type FlavorToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'FlavorToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the FlavorToContentNodeConnection connection */
export type FlavorToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfFlavorEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<FlavorToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type FlavorToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<FlavorToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<FlavorToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum FlavorToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type FlavorToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<FlavorToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum FlavorToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Flavor type and the strain type */
export type FlavorToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'FlavorToStrainConnection';
    /** Edges for the FlavorToStrainConnection connection */
    edges: Array<FlavorToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: FlavorToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type FlavorToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'FlavorToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;FlavorToStrainConnection&quot; */
export type FlavorToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'FlavorToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the FlavorToStrainConnection connection */
export type FlavorToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<FlavorToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type FlavorToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<FlavorToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<FlavorToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum FlavorToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type FlavorToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<FlavorToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum FlavorToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Flavor type and the Taxonomy type */
export type FlavorToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'FlavorToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** The general setting type */
export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  /** A date format for all date strings. */
  dateFormat: Maybe<Scalars['String']>;
  /** Site tagline. */
  description: Maybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  email: Maybe<Scalars['String']>;
  /** WordPress locale code. */
  language: Maybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  startOfWeek: Maybe<Scalars['Int']>;
  /** A time format for all time strings. */
  timeFormat: Maybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  timezone: Maybe<Scalars['String']>;
  /** Site title. */
  title: Maybe<Scalars['String']>;
  /** Site URL. */
  url: Maybe<Scalars['String']>;
};

/** The graphqlDocument type */
export type GraphqlDocument = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithTemplate &
  NodeWithTitle &
  UniformResourceIdentifiable & {
    __typename?: 'GraphqlDocument';
    /** Alias names for saved GraphQL query documents */
    alias: Maybe<Array<Scalars['String']>>;
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<GraphqlDocumentToGraphqlDocumentConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** Description for the saved GraphQL document */
    description: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Allow, deny or default access grant for specific query */
    grant: Maybe<Scalars['String']>;
    /** Connection between the GraphqlDocument type and the graphqlDocumentGroup type */
    graphqlDocumentGroups: Maybe<GraphqlDocumentToGraphqlDocumentGroupConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    graphqlDocumentId: Scalars['Int'];
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the graphql_document object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the graphql_document object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** HTTP Cache-Control max-age directive for a saved GraphQL document */
    maxAgeHeader: Maybe<Scalars['Int']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<GraphqlDocumentToParentConnectionEdge>;
    /** The password for the graphql_document object. */
    password: Maybe<Scalars['String']>;
    /**
     * Connection between the GraphqlDocument type and the graphqlDocument type
     * @deprecated The &quot;GraphqlDocument&quot; Type is not publicly queryable and does not support previews. This field will be removed in the future.
     */
    preview: Maybe<GraphqlDocumentToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the GraphqlDocument type and the TermNode type */
    terms: Maybe<GraphqlDocumentToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The graphqlDocument type */
export type GraphqlDocumentAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The graphqlDocument type */
export type GraphqlDocumentContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The graphqlDocument type */
export type GraphqlDocumentEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The graphqlDocument type */
export type GraphqlDocumentEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The graphqlDocument type */
export type GraphqlDocumentGraphqlDocumentGroupsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<GraphqlDocumentToGraphqlDocumentGroupConnectionWhereArgs>;
};

/** The graphqlDocument type */
export type GraphqlDocumentTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<GraphqlDocumentToTermNodeConnectionWhereArgs>;
};

/** The graphqlDocument type */
export type GraphqlDocumentTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Connection to graphqlDocument Nodes */
export type GraphqlDocumentConnection = {
  /** A list of edges (relational context) between RootQuery and connected graphqlDocument Nodes */
  edges: Array<GraphqlDocumentConnectionEdge>;
  /** A list of connected graphqlDocument Nodes */
  nodes: Array<GraphqlDocument>;
  /** Information about pagination in a connection. */
  pageInfo: GraphqlDocumentConnectionPageInfo;
};

/** Edge between a Node and a connected graphqlDocument */
export type GraphqlDocumentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected graphqlDocument Node */
  node: GraphqlDocument;
};

/** Page Info on the connected GraphqlDocumentConnectionEdge */
export type GraphqlDocumentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Set relationships between the graphqlDocument to graphqlDocumentGroups */
export type GraphqlDocumentGraphqlDocumentGroupsInput = {
  /** If true, this will append the graphqlDocumentGroup to existing related graphqlDocumentGroups. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<
    Array<InputMaybe<GraphqlDocumentGraphqlDocumentGroupsNodeInput>>
  >;
};

/** List of graphqlDocumentGroups to connect the graphqlDocument to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type GraphqlDocumentGraphqlDocumentGroupsNodeInput = {
  /** The description of the graphqlDocumentGroup. This field is used to set a description of the graphqlDocumentGroup if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the graphqlDocumentGroup. If present, this will be used to connect to the graphqlDocument. If no existing graphqlDocumentGroup exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the graphqlDocumentGroup. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the graphqlDocumentGroup. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** The graphqlDocumentGroup type */
export type GraphqlDocumentGroup = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'GraphqlDocumentGroup';
    /** Connection between the GraphqlDocumentGroup type and the ContentNode type */
    contentNodes: Maybe<GraphqlDocumentGroupToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    graphqlDocumentGroupId: Maybe<Scalars['Int']>;
    /** Connection between the GraphqlDocumentGroup type and the graphqlDocument type */
    graphqlDocuments: Maybe<GraphqlDocumentGroupToGraphqlDocumentConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the GraphqlDocumentGroup type and the Taxonomy type */
    taxonomy: Maybe<GraphqlDocumentGroupToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The graphqlDocumentGroup type */
export type GraphqlDocumentGroupContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgs>;
};

/** The graphqlDocumentGroup type */
export type GraphqlDocumentGroupEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The graphqlDocumentGroup type */
export type GraphqlDocumentGroupEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The graphqlDocumentGroup type */
export type GraphqlDocumentGroupGraphqlDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgs>;
};

/** Connection to graphqlDocumentGroup Nodes */
export type GraphqlDocumentGroupConnection = {
  /** A list of edges (relational context) between RootQuery and connected graphqlDocumentGroup Nodes */
  edges: Array<GraphqlDocumentGroupConnectionEdge>;
  /** A list of connected graphqlDocumentGroup Nodes */
  nodes: Array<GraphqlDocumentGroup>;
  /** Information about pagination in a connection. */
  pageInfo: GraphqlDocumentGroupConnectionPageInfo;
};

/** Edge between a Node and a connected graphqlDocumentGroup */
export type GraphqlDocumentGroupConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected graphqlDocumentGroup Node */
  node: GraphqlDocumentGroup;
};

/** Page Info on the connected GraphqlDocumentGroupConnectionEdge */
export type GraphqlDocumentGroupConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum GraphqlDocumentGroupIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the GraphqlDocumentGroup type and the ContentNode type */
export type GraphqlDocumentGroupToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'GraphqlDocumentGroupToContentNodeConnection';
    /** Edges for the GraphqlDocumentGroupToContentNodeConnection connection */
    edges: Array<GraphqlDocumentGroupToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: GraphqlDocumentGroupToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type GraphqlDocumentGroupToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'GraphqlDocumentGroupToContentNodeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;GraphqlDocumentGroupToContentNodeConnection&quot; */
export type GraphqlDocumentGroupToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'GraphqlDocumentGroupToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the GraphqlDocumentGroupToContentNodeConnection connection */
export type GraphqlDocumentGroupToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<
    Array<InputMaybe<ContentTypesOfGraphqlDocumentGroupEnum>>
  >;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<
      InputMaybe<GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaArray>
    >
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum GraphqlDocumentGroupToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the GraphqlDocumentGroup type and the graphqlDocument type */
export type GraphqlDocumentGroupToGraphqlDocumentConnection = Connection &
  GraphqlDocumentConnection & {
    __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnection';
    /** Edges for the GraphqlDocumentGroupToGraphqlDocumentConnection connection */
    edges: Array<GraphqlDocumentGroupToGraphqlDocumentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<GraphqlDocument>;
    /** Information about pagination in a connection. */
    pageInfo: GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo;
  };

/** An edge in a connection */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionEdge = Edge &
  GraphqlDocumentConnectionEdge & {
    __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: GraphqlDocument;
  };

/** Page Info on the &quot;GraphqlDocumentGroupToGraphqlDocumentConnection&quot; */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo =
  GraphqlDocumentConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'GraphqlDocumentGroupToGraphqlDocumentConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the GraphqlDocumentGroupToGraphqlDocumentConnection connection */
export type GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaArray =
  {
    /** Custom field value */
    compare: InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaCompareEnum>;
    /** Custom field key */
    key: InputMaybe<Scalars['String']>;
    /** Custom field value */
    type: InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaTypeEnum>;
    /** Custom field value */
    value: InputMaybe<Scalars['String']>;
  };

export enum GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaQuery =
  {
    metaArray: InputMaybe<
      Array<
        InputMaybe<GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaArray>
      >
    >;
    relation: InputMaybe<RelationEnum>;
  };

export enum GraphqlDocumentGroupToGraphqlDocumentConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the GraphqlDocumentGroup type and the Taxonomy type */
export type GraphqlDocumentGroupToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'GraphqlDocumentGroupToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum GraphqlDocumentIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToGraphqlDocumentConnection = Connection &
  GraphqlDocumentConnection & {
    __typename?: 'GraphqlDocumentToGraphqlDocumentConnection';
    /** Edges for the GraphqlDocumentToGraphqlDocumentConnection connection */
    edges: Array<GraphqlDocumentToGraphqlDocumentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<GraphqlDocument>;
    /** Information about pagination in a connection. */
    pageInfo: GraphqlDocumentToGraphqlDocumentConnectionPageInfo;
  };

/** An edge in a connection */
export type GraphqlDocumentToGraphqlDocumentConnectionEdge = Edge &
  GraphqlDocumentConnectionEdge & {
    __typename?: 'GraphqlDocumentToGraphqlDocumentConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: GraphqlDocument;
  };

/** Page Info on the &quot;GraphqlDocumentToGraphqlDocumentConnection&quot; */
export type GraphqlDocumentToGraphqlDocumentConnectionPageInfo =
  GraphqlDocumentConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'GraphqlDocumentToGraphqlDocumentConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the GraphqlDocument type and the graphqlDocumentGroup type */
export type GraphqlDocumentToGraphqlDocumentGroupConnection = Connection &
  GraphqlDocumentGroupConnection & {
    __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnection';
    /** Edges for the GraphqlDocumentToGraphqlDocumentGroupConnection connection */
    edges: Array<GraphqlDocumentToGraphqlDocumentGroupConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<GraphqlDocumentGroup>;
    /** Information about pagination in a connection. */
    pageInfo: GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo;
  };

/** An edge in a connection */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionEdge = Edge &
  GraphqlDocumentGroupConnectionEdge & {
    __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: GraphqlDocumentGroup;
  };

/** Page Info on the &quot;GraphqlDocumentToGraphqlDocumentGroupConnection&quot; */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo =
  GraphqlDocumentGroupConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'GraphqlDocumentToGraphqlDocumentGroupConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the GraphqlDocumentToGraphqlDocumentGroupConnection connection */
export type GraphqlDocumentToGraphqlDocumentGroupConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToParentConnectionEdge = Edge &
  GraphqlDocumentConnectionEdge &
  OneToOneConnection & {
    __typename?: 'GraphqlDocumentToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: GraphqlDocument;
  };

/** Connection between the GraphqlDocument type and the graphqlDocument type */
export type GraphqlDocumentToPreviewConnectionEdge = Edge &
  GraphqlDocumentConnectionEdge &
  OneToOneConnection & {
    __typename?: 'GraphqlDocumentToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated The &quot;GraphqlDocument&quot; Type is not publicly queryable and does not support previews. This field will be removed in the future.
     */
    node: GraphqlDocument;
  };

/** Connection between the GraphqlDocument type and the TermNode type */
export type GraphqlDocumentToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'GraphqlDocumentToTermNodeConnection';
    /** Edges for the GraphqlDocumentToTermNodeConnection connection */
    edges: Array<GraphqlDocumentToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: GraphqlDocumentToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type GraphqlDocumentToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'GraphqlDocumentToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;GraphqlDocumentToTermNodeConnection&quot; */
export type GraphqlDocumentToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'GraphqlDocumentToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the GraphqlDocumentToTermNodeConnection connection */
export type GraphqlDocumentToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNode = {
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt: Maybe<Scalars['String']>;
  /** The parent of the node. The parent object can be of various types */
  parent: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId: Maybe<Scalars['ID']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug: Maybe<Scalars['String']>;
  /** The current status of the object */
  status: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeAncestorsConnection =
  Connection &
    ContentNodeConnection & {
      __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnection';
      /** Edges for the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
      edges: Array<HierarchicalContentNodeToContentNodeAncestorsConnectionEdge>;
      /** The nodes of the connection, without the edges */
      nodes: Array<ContentNode>;
      /** Information about pagination in a connection. */
      pageInfo: HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo;
    };

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;HierarchicalContentNodeToContentNodeAncestorsConnection&quot; */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaArray =
  {
    /** Custom field value */
    compare: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaCompareEnum>;
    /** Custom field key */
    key: InputMaybe<Scalars['String']>;
    /** Custom field value */
    type: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaTypeEnum>;
    /** Custom field value */
    value: InputMaybe<Scalars['String']>;
  };

export enum HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaQuery =
  {
    metaArray: InputMaybe<
      Array<
        InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaArray>
      >
    >;
    relation: InputMaybe<RelationEnum>;
  };

export enum HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeChildrenConnection =
  Connection &
    ContentNodeConnection & {
      __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnection';
      /** Edges for the HierarchicalContentNodeToContentNodeChildrenConnection connection */
      edges: Array<HierarchicalContentNodeToContentNodeChildrenConnectionEdge>;
      /** The nodes of the connection, without the edges */
      nodes: Array<ContentNode>;
      /** Information about pagination in a connection. */
      pageInfo: HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo;
    };

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;HierarchicalContentNodeToContentNodeChildrenConnection&quot; */
export type HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the HierarchicalContentNodeToContentNodeChildrenConnection connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaArray =
  {
    /** Custom field value */
    compare: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaCompareEnum>;
    /** Custom field key */
    key: InputMaybe<Scalars['String']>;
    /** Custom field value */
    type: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaTypeEnum>;
    /** Custom field value */
    value: InputMaybe<Scalars['String']>;
  };

export enum HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaQuery =
  {
    metaArray: InputMaybe<
      Array<
        InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaArray>
      >
    >;
    relation: InputMaybe<RelationEnum>;
  };

export enum HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToParentContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge &
    OneToOneConnection & {
      __typename?: 'HierarchicalContentNodeToParentContentNodeConnectionEdge';
      /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
      cursor: Maybe<Scalars['String']>;
      /** The node of the connection, without the edges */
      node: ContentNode;
    };

/** Node with hierarchical (parent/child) relationships */
export type HierarchicalNode = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Database id of the parent node */
  parentDatabaseId: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId: Maybe<Scalars['ID']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNode = {
  /** The number of objects connected to the object */
  count: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name: Maybe<Scalars['String']>;
  /** Database id of the parent node */
  parentDatabaseId: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId: Maybe<Scalars['ID']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug: Maybe<Scalars['String']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The job type */
export type Job = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Job';
    /** Connection between the Job type and the ContentNode type */
    contentNodes: Maybe<JobToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    jobId: Maybe<Scalars['Int']>;
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Job type and the Taxonomy type */
    taxonomy: Maybe<JobToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** Connection between the Job type and the teamMember type */
    teamMembers: Maybe<JobToTeamMemberConnection>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Job>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Job>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The job type */
export type JobContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<JobToContentNodeConnectionWhereArgs>;
};

/** The job type */
export type JobEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The job type */
export type JobEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The job type */
export type JobTeamMembersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<JobToTeamMemberConnectionWhereArgs>;
};

/** The job type */
export type JobTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to job Nodes */
export type JobConnection = {
  /** A list of edges (relational context) between RootQuery and connected job Nodes */
  edges: Array<JobConnectionEdge>;
  /** A list of connected job Nodes */
  nodes: Array<Job>;
  /** Information about pagination in a connection. */
  pageInfo: JobConnectionPageInfo;
};

/** Edge between a Node and a connected job */
export type JobConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected job Node */
  node: Job;
};

/** Page Info on the connected JobConnectionEdge */
export type JobConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum JobIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** The jobOffer type */
export type JobOffer = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'JobOffer';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<JobOfferToJobOfferConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the job object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the job object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    jobOfferId: Scalars['Int'];
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Jobs Fields&quot; was set to Show in GraphQL. */
    jobsFields: Maybe<JobOffer_Jobsfields>;
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<JobOfferToParentConnectionEdge>;
    /** The password for the job object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the JobOffer type and the jobOffer type */
    preview: Maybe<JobOfferToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the JobOffer type and the jobOffer type */
    revisions: Maybe<JobOfferToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** Connection between the JobOffer type and the team type */
    teams: Maybe<JobOfferToTeamConnection>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the JobOffer type and the TermNode type */
    terms: Maybe<JobOfferToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<JobOffer>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<JobOffer>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The jobOffer type */
export type JobOfferAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The jobOffer type */
export type JobOfferContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The jobOffer type */
export type JobOfferEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The jobOffer type */
export type JobOfferEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The jobOffer type */
export type JobOfferRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<JobOfferToRevisionConnectionWhereArgs>;
};

/** The jobOffer type */
export type JobOfferTeamsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<JobOfferToTeamConnectionWhereArgs>;
};

/** The jobOffer type */
export type JobOfferTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<JobOfferToTermNodeConnectionWhereArgs>;
};

/** The jobOffer type */
export type JobOfferTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The jobOffer type */
export type JobOfferTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to jobOffer Nodes */
export type JobOfferConnection = {
  /** A list of edges (relational context) between RootQuery and connected jobOffer Nodes */
  edges: Array<JobOfferConnectionEdge>;
  /** A list of connected jobOffer Nodes */
  nodes: Array<JobOffer>;
  /** Information about pagination in a connection. */
  pageInfo: JobOfferConnectionPageInfo;
};

/** Edge between a Node and a connected jobOffer */
export type JobOfferConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected jobOffer Node */
  node: JobOffer;
};

/** Page Info on the connected JobOfferConnectionEdge */
export type JobOfferConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum JobOfferIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Set relationships between the jobOffer to teams */
export type JobOfferTeamsInput = {
  /** If true, this will append the team to existing related teams. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<JobOfferTeamsNodeInput>>>;
};

/** List of teams to connect the jobOffer to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type JobOfferTeamsNodeInput = {
  /** The description of the team. This field is used to set a description of the team if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the team. If present, this will be used to connect to the jobOffer. If no existing team exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the team. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the team. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection between the JobOffer type and the jobOffer type */
export type JobOfferToJobOfferConnection = Connection &
  JobOfferConnection & {
    __typename?: 'JobOfferToJobOfferConnection';
    /** Edges for the JobOfferToJobOfferConnection connection */
    edges: Array<JobOfferToJobOfferConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<JobOffer>;
    /** Information about pagination in a connection. */
    pageInfo: JobOfferToJobOfferConnectionPageInfo;
  };

/** An edge in a connection */
export type JobOfferToJobOfferConnectionEdge = Edge &
  JobOfferConnectionEdge & {
    __typename?: 'JobOfferToJobOfferConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: JobOffer;
  };

/** Page Info on the &quot;JobOfferToJobOfferConnection&quot; */
export type JobOfferToJobOfferConnectionPageInfo = JobOfferConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'JobOfferToJobOfferConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the JobOffer type and the jobOffer type */
export type JobOfferToParentConnectionEdge = Edge &
  JobOfferConnectionEdge &
  OneToOneConnection & {
    __typename?: 'JobOfferToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: JobOffer;
  };

/** Connection between the JobOffer type and the jobOffer type */
export type JobOfferToPreviewConnectionEdge = Edge &
  JobOfferConnectionEdge &
  OneToOneConnection & {
    __typename?: 'JobOfferToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: JobOffer;
  };

/** Connection between the JobOffer type and the jobOffer type */
export type JobOfferToRevisionConnection = Connection &
  JobOfferConnection & {
    __typename?: 'JobOfferToRevisionConnection';
    /** Edges for the JobOfferToRevisionConnection connection */
    edges: Array<JobOfferToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<JobOffer>;
    /** Information about pagination in a connection. */
    pageInfo: JobOfferToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type JobOfferToRevisionConnectionEdge = Edge &
  JobOfferConnectionEdge & {
    __typename?: 'JobOfferToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: JobOffer;
  };

/** Page Info on the &quot;JobOfferToRevisionConnection&quot; */
export type JobOfferToRevisionConnectionPageInfo = JobOfferConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'JobOfferToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the JobOfferToRevisionConnection connection */
export type JobOfferToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<JobOfferToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type JobOfferToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<JobOfferToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<JobOfferToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum JobOfferToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type JobOfferToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<JobOfferToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum JobOfferToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the JobOffer type and the team type */
export type JobOfferToTeamConnection = Connection &
  TeamConnection & {
    __typename?: 'JobOfferToTeamConnection';
    /** Edges for the JobOfferToTeamConnection connection */
    edges: Array<JobOfferToTeamConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Team>;
    /** Information about pagination in a connection. */
    pageInfo: JobOfferToTeamConnectionPageInfo;
  };

/** An edge in a connection */
export type JobOfferToTeamConnectionEdge = Edge &
  TeamConnectionEdge & {
    __typename?: 'JobOfferToTeamConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Team;
  };

/** Page Info on the &quot;JobOfferToTeamConnection&quot; */
export type JobOfferToTeamConnectionPageInfo = PageInfo &
  TeamConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'JobOfferToTeamConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the JobOfferToTeamConnection connection */
export type JobOfferToTeamConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the JobOffer type and the TermNode type */
export type JobOfferToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'JobOfferToTermNodeConnection';
    /** Edges for the JobOfferToTermNodeConnection connection */
    edges: Array<JobOfferToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: JobOfferToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type JobOfferToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'JobOfferToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;JobOfferToTermNodeConnection&quot; */
export type JobOfferToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'JobOfferToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the JobOfferToTermNodeConnection connection */
export type JobOfferToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type JobOffer_Jobsfields = AcfFieldGroup & {
  __typename?: 'JobOffer_Jobsfields';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  formId: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  /** Text to use as anchor. Must be url safe - no spaces or special character (eg: a-valid-id) */
  sectionId: Maybe<Scalars['String']>;
};

/** Connection between the Job type and the ContentNode type */
export type JobToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'JobToContentNodeConnection';
    /** Edges for the JobToContentNodeConnection connection */
    edges: Array<JobToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: JobToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type JobToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'JobToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;JobToContentNodeConnection&quot; */
export type JobToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'JobToContentNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the JobToContentNodeConnection connection */
export type JobToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfJobEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<JobToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type JobToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<JobToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<JobToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum JobToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type JobToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<JobToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum JobToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Job type and the Taxonomy type */
export type JobToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'JobToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Connection between the Job type and the teamMember type */
export type JobToTeamMemberConnection = Connection &
  TeamMemberConnection & {
    __typename?: 'JobToTeamMemberConnection';
    /** Edges for the JobToTeamMemberConnection connection */
    edges: Array<JobToTeamMemberConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TeamMember>;
    /** Information about pagination in a connection. */
    pageInfo: JobToTeamMemberConnectionPageInfo;
  };

/** An edge in a connection */
export type JobToTeamMemberConnectionEdge = Edge &
  TeamMemberConnectionEdge & {
    __typename?: 'JobToTeamMemberConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TeamMember;
  };

/** Page Info on the &quot;JobToTeamMemberConnection&quot; */
export type JobToTeamMemberConnectionPageInfo = PageInfo &
  TeamMemberConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'JobToTeamMemberConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the JobToTeamMemberConnection connection */
export type JobToTeamMemberConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<JobToTeamMemberConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type JobToTeamMemberConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<JobToTeamMemberConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<JobToTeamMemberConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum JobToTeamMemberConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type JobToTeamMemberConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<JobToTeamMemberConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum JobToTeamMemberConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Language (Polylang) */
export type Language = {
  __typename?: 'Language';
  /** Language code (Polylang) */
  code: Maybe<LanguageCodeEnum>;
  /** Language term front page URL */
  homeUrl: Maybe<Scalars['String']>;
  /** Language ID (Polylang) */
  id: Scalars['ID'];
  /** Language locale (Polylang) */
  locale: Maybe<Scalars['String']>;
  /** Human readable language name (Polylang) */
  name: Maybe<Scalars['String']>;
  /** Language term slug. Prefer the &quot;code&quot; field if possible (Polylang) */
  slug: Maybe<Scalars['String']>;
};

/** Enum of all available language codes */
export enum LanguageCodeEnum {
  Br = 'BR',
  De = 'DE',
  En = 'EN',
  Es = 'ES',
}

/** Filter item by specific language, default language or list all languages */
export enum LanguageCodeFilterEnum {
  All = 'ALL',
  Br = 'BR',
  De = 'DE',
  Default = 'DEFAULT',
  En = 'EN',
  Es = 'ES',
}

/** The law type */
export type Law = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Law';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<Law_Activestates>;
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<LawToLawConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the state_laws object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the state_laws object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    lawId: Scalars['Int'];
    /** Connection between the Law type and the lawStatus type */
    lawStatuses: Maybe<LawToLawStatusConnection>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<LawToParentConnectionEdge>;
    /** The password for the state_laws object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Law type and the law type */
    preview: Maybe<LawToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Law type and the law type */
    revisions: Maybe<LawToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;State Laws&quot; was set to Show in GraphQL. */
    stateLaws: Maybe<Law_Statelaws>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Table of contents&quot; was set to Show in GraphQL. */
    tableOfContents: Maybe<Law_Tableofcontents>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the Law type and the TermNode type */
    terms: Maybe<LawToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Law>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Law>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The law type */
export type LawAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The law type */
export type LawContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The law type */
export type LawEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The law type */
export type LawEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The law type */
export type LawLawStatusesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawToLawStatusConnectionWhereArgs>;
};

/** The law type */
export type LawRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawToRevisionConnectionWhereArgs>;
};

/** The law type */
export type LawTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawToTermNodeConnectionWhereArgs>;
};

/** The law type */
export type LawTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The law type */
export type LawTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to law Nodes */
export type LawConnection = {
  /** A list of edges (relational context) between RootQuery and connected law Nodes */
  edges: Array<LawConnectionEdge>;
  /** A list of connected law Nodes */
  nodes: Array<Law>;
  /** Information about pagination in a connection. */
  pageInfo: LawConnectionPageInfo;
};

/** Edge between a Node and a connected law */
export type LawConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected law Node */
  node: Law;
};

/** Page Info on the connected LawConnectionEdge */
export type LawConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum LawIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Set relationships between the law to lawStatuses */
export type LawLawStatusesInput = {
  /** If true, this will append the lawStatus to existing related lawStatuses. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<LawLawStatusesNodeInput>>>;
};

/** List of lawStatuses to connect the law to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type LawLawStatusesNodeInput = {
  /** The description of the lawStatus. This field is used to set a description of the lawStatus if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the lawStatus. If present, this will be used to connect to the law. If no existing lawStatus exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the lawStatus. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the lawStatus. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** The lawStatus type */
export type LawStatus = DatabaseIdentifier &
  HierarchicalNode &
  HierarchicalTermNode &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'LawStatus';
    /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
    ancestors: Maybe<LawStatusToAncestorsLawStatusConnection>;
    /** Connection between the lawStatus type and its children lawStatuses. */
    children: Maybe<LawStatusToLawStatusConnection>;
    /** Connection between the LawStatus type and the ContentNode type */
    contentNodes: Maybe<LawStatusToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    lawStatusId: Maybe<Scalars['Int']>;
    /** Connection between the LawStatus type and the law type */
    laws: Maybe<LawStatusToLawConnection>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Connection between the lawStatus type and its parent lawStatus. */
    parent: Maybe<LawStatusToParentLawStatusConnectionEdge>;
    /** Database id of the parent node */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent node. */
    parentId: Maybe<Scalars['ID']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;State Laws Status&quot; was set to Show in GraphQL. */
    statusSettings: Maybe<LawStatus_Statussettings>;
    /** Connection between the LawStatus type and the Taxonomy type */
    taxonomy: Maybe<LawStatusToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<LawStatus>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<LawStatus>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The lawStatus type */
export type LawStatusAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The lawStatus type */
export type LawStatusChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawStatusToLawStatusConnectionWhereArgs>;
};

/** The lawStatus type */
export type LawStatusContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawStatusToContentNodeConnectionWhereArgs>;
};

/** The lawStatus type */
export type LawStatusEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The lawStatus type */
export type LawStatusEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The lawStatus type */
export type LawStatusLawsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<LawStatusToLawConnectionWhereArgs>;
};

/** The lawStatus type */
export type LawStatusTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to lawStatus Nodes */
export type LawStatusConnection = {
  /** A list of edges (relational context) between RootQuery and connected lawStatus Nodes */
  edges: Array<LawStatusConnectionEdge>;
  /** A list of connected lawStatus Nodes */
  nodes: Array<LawStatus>;
  /** Information about pagination in a connection. */
  pageInfo: LawStatusConnectionPageInfo;
};

/** Edge between a Node and a connected lawStatus */
export type LawStatusConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected lawStatus Node */
  node: LawStatus;
};

/** Page Info on the connected LawStatusConnectionEdge */
export type LawStatusConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum LawStatusIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the LawStatus type and the lawStatus type */
export type LawStatusToAncestorsLawStatusConnection = Connection &
  LawStatusConnection & {
    __typename?: 'LawStatusToAncestorsLawStatusConnection';
    /** Edges for the LawStatusToAncestorsLawStatusConnection connection */
    edges: Array<LawStatusToAncestorsLawStatusConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<LawStatus>;
    /** Information about pagination in a connection. */
    pageInfo: LawStatusToAncestorsLawStatusConnectionPageInfo;
  };

/** An edge in a connection */
export type LawStatusToAncestorsLawStatusConnectionEdge = Edge &
  LawStatusConnectionEdge & {
    __typename?: 'LawStatusToAncestorsLawStatusConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: LawStatus;
  };

/** Page Info on the &quot;LawStatusToAncestorsLawStatusConnection&quot; */
export type LawStatusToAncestorsLawStatusConnectionPageInfo =
  LawStatusConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'LawStatusToAncestorsLawStatusConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the LawStatus type and the ContentNode type */
export type LawStatusToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'LawStatusToContentNodeConnection';
    /** Edges for the LawStatusToContentNodeConnection connection */
    edges: Array<LawStatusToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: LawStatusToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type LawStatusToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'LawStatusToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;LawStatusToContentNodeConnection&quot; */
export type LawStatusToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'LawStatusToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the LawStatusToContentNodeConnection connection */
export type LawStatusToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfLawStatusEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<LawStatusToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type LawStatusToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<LawStatusToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<LawStatusToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum LawStatusToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type LawStatusToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<LawStatusToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum LawStatusToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the LawStatus type and the law type */
export type LawStatusToLawConnection = Connection &
  LawConnection & {
    __typename?: 'LawStatusToLawConnection';
    /** Edges for the LawStatusToLawConnection connection */
    edges: Array<LawStatusToLawConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Law>;
    /** Information about pagination in a connection. */
    pageInfo: LawStatusToLawConnectionPageInfo;
  };

/** An edge in a connection */
export type LawStatusToLawConnectionEdge = Edge &
  LawConnectionEdge & {
    __typename?: 'LawStatusToLawConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Law;
  };

/** Page Info on the &quot;LawStatusToLawConnection&quot; */
export type LawStatusToLawConnectionPageInfo = LawConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'LawStatusToLawConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the LawStatusToLawConnection connection */
export type LawStatusToLawConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<LawStatusToLawConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type LawStatusToLawConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<LawStatusToLawConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<LawStatusToLawConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum LawStatusToLawConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type LawStatusToLawConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<LawStatusToLawConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum LawStatusToLawConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the LawStatus type and the lawStatus type */
export type LawStatusToLawStatusConnection = Connection &
  LawStatusConnection & {
    __typename?: 'LawStatusToLawStatusConnection';
    /** Edges for the LawStatusToLawStatusConnection connection */
    edges: Array<LawStatusToLawStatusConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<LawStatus>;
    /** Information about pagination in a connection. */
    pageInfo: LawStatusToLawStatusConnectionPageInfo;
  };

/** An edge in a connection */
export type LawStatusToLawStatusConnectionEdge = Edge &
  LawStatusConnectionEdge & {
    __typename?: 'LawStatusToLawStatusConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: LawStatus;
  };

/** Page Info on the &quot;LawStatusToLawStatusConnection&quot; */
export type LawStatusToLawStatusConnectionPageInfo =
  LawStatusConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'LawStatusToLawStatusConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the LawStatusToLawStatusConnection connection */
export type LawStatusToLawStatusConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the LawStatus type and the lawStatus type */
export type LawStatusToParentLawStatusConnectionEdge = Edge &
  LawStatusConnectionEdge &
  OneToOneConnection & {
    __typename?: 'LawStatusToParentLawStatusConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: LawStatus;
  };

/** Connection between the LawStatus type and the Taxonomy type */
export type LawStatusToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'LawStatusToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type LawStatus_Statussettings = AcfFieldGroup & {
  __typename?: 'LawStatus_Statussettings';
  /** Legal status icon for this category */
  checkIcon: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Connection between the Law type and the law type */
export type LawToLawConnection = Connection &
  LawConnection & {
    __typename?: 'LawToLawConnection';
    /** Edges for the LawToLawConnection connection */
    edges: Array<LawToLawConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Law>;
    /** Information about pagination in a connection. */
    pageInfo: LawToLawConnectionPageInfo;
  };

/** An edge in a connection */
export type LawToLawConnectionEdge = Edge &
  LawConnectionEdge & {
    __typename?: 'LawToLawConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Law;
  };

/** Page Info on the &quot;LawToLawConnection&quot; */
export type LawToLawConnectionPageInfo = LawConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'LawToLawConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Law type and the lawStatus type */
export type LawToLawStatusConnection = Connection &
  LawStatusConnection & {
    __typename?: 'LawToLawStatusConnection';
    /** Edges for the LawToLawStatusConnection connection */
    edges: Array<LawToLawStatusConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<LawStatus>;
    /** Information about pagination in a connection. */
    pageInfo: LawToLawStatusConnectionPageInfo;
  };

/** An edge in a connection */
export type LawToLawStatusConnectionEdge = Edge &
  LawStatusConnectionEdge & {
    __typename?: 'LawToLawStatusConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: LawStatus;
  };

/** Page Info on the &quot;LawToLawStatusConnection&quot; */
export type LawToLawStatusConnectionPageInfo = LawStatusConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'LawToLawStatusConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the LawToLawStatusConnection connection */
export type LawToLawStatusConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Law type and the law type */
export type LawToParentConnectionEdge = Edge &
  LawConnectionEdge &
  OneToOneConnection & {
    __typename?: 'LawToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Law;
  };

/** Connection between the Law type and the law type */
export type LawToPreviewConnectionEdge = Edge &
  LawConnectionEdge &
  OneToOneConnection & {
    __typename?: 'LawToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Law;
  };

/** Connection between the Law type and the law type */
export type LawToRevisionConnection = Connection &
  LawConnection & {
    __typename?: 'LawToRevisionConnection';
    /** Edges for the LawToRevisionConnection connection */
    edges: Array<LawToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Law>;
    /** Information about pagination in a connection. */
    pageInfo: LawToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type LawToRevisionConnectionEdge = Edge &
  LawConnectionEdge & {
    __typename?: 'LawToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Law;
  };

/** Page Info on the &quot;LawToRevisionConnection&quot; */
export type LawToRevisionConnectionPageInfo = LawConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'LawToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the LawToRevisionConnection connection */
export type LawToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<LawToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type LawToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<LawToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<LawToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum LawToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type LawToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<LawToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum LawToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Law type and the TermNode type */
export type LawToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'LawToTermNodeConnection';
    /** Edges for the LawToTermNodeConnection connection */
    edges: Array<LawToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: LawToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type LawToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'LawToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;LawToTermNodeConnection&quot; */
export type LawToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'LawToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the LawToTermNodeConnection connection */
export type LawToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type Law_Activestates = AcfFieldGroup & {
  __typename?: 'Law_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type Law_Statelaws = AcfFieldGroup & {
  __typename?: 'Law_Statelaws';
  /**
   * To hide this section clear all the content (title, description, extra info).&lt;br/&gt;
   * The steps displayed in the frontend come from the corresponding medical card page.
   */
  applicationProcess: Maybe<Law_Statelaws_ApplicationProcess>;
  cultivation: Maybe<Law_Statelaws_Cultivation>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  possession: Maybe<Law_Statelaws_Possession>;
  /** Add any tax info here. Leave blank if none exists. */
  taxes: Maybe<Array<Maybe<Law_Statelaws_Taxes>>>;
};

/** Field Group */
export type Law_Statelaws_ApplicationProcess = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_ApplicationProcess';
  description: Maybe<Scalars['String']>;
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type Law_Statelaws_Cultivation = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_Cultivation';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  info: Maybe<Array<Maybe<Law_Statelaws_Cultivation_Info>>>;
  legal: Maybe<Scalars['Boolean']>;
  show: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type Law_Statelaws_Cultivation_Info = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_Cultivation_info';
  /** Add any extra info related to the cultivation status */
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Field Group */
export type Law_Statelaws_Possession = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_Possession';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  info: Maybe<Array<Maybe<Law_Statelaws_Possession_Info>>>;
  legal: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type Law_Statelaws_Possession_Info = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_Possession_info';
  /** Add any extra info related to the possession status */
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Field Group */
export type Law_Statelaws_Taxes = AcfFieldGroup & {
  __typename?: 'Law_Statelaws_taxes';
  /** Add any extra info related to the tax info */
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Field Group */
export type Law_Tableofcontents = AcfFieldGroup & {
  __typename?: 'Law_Tableofcontents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Add the article table of contents here. */
  tableOfContents: Maybe<Array<Maybe<Law_Tableofcontents_TableOfContents>>>;
};

/** Field Group */
export type Law_Tableofcontents_TableOfContents = AcfFieldGroup & {
  __typename?: 'Law_Tableofcontents_tableOfContents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /**
   * Add the section id without the &lt;strong&gt;#&lt;/strong&gt;&lt;br/&gt;
   * Example: section-id
   */
  id: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
};

/** Input for the login mutation. */
export type LoginInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The plain-text password for the user logging in. */
  password: Scalars['String'];
  /** The username used for login. Typically a unique or email address depending on specific configuration */
  username: Scalars['String'];
};

/** The payload for the login mutation. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** JWT Token that can be used in future requests for Authentication */
  authToken: Maybe<Scalars['String']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** A JWT token that can be used in future requests to get a refreshed jwtAuthToken. If the refresh token used in a request is revoked or otherwise invalid, a valid Auth token will NOT be issued in the response headers. */
  refreshToken: Maybe<Scalars['String']>;
  /** The user that was logged in */
  user: Maybe<User>;
};

/** File details for a Media Item */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /** The filename of the mediaItem */
  file: Maybe<Scalars['String']>;
  /** The height of the mediaItem */
  height: Maybe<Scalars['Int']>;
  /** Meta information associated with the mediaItem */
  meta: Maybe<MediaItemMeta>;
  /** The available sizes of the mediaItem */
  sizes: Maybe<Array<Maybe<MediaSize>>>;
  /** The width of the mediaItem */
  width: Maybe<Scalars['Int']>;
};

/** File details for a Media Item */
export type MediaDetailsSizesArgs = {
  exclude: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
  include: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
};

/** The mediaItem type */
export type MediaItem = ContentNode &
  DatabaseIdentifier &
  HierarchicalContentNode &
  HierarchicalNode &
  Node &
  NodeWithAuthor &
  NodeWithComments &
  NodeWithTemplate &
  NodeWithTitle &
  UniformResourceIdentifiable & {
    __typename?: 'MediaItem';
    /** Alternative text to display when resource is not displayed */
    altText: Maybe<Scalars['String']>;
    /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
    ancestors: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
    /** Connection between the NodeWithAuthor type and the User type */
    author: Maybe<NodeWithAuthorToUserConnectionEdge>;
    /** The database identifier of the author of the node */
    authorDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the author of the node */
    authorId: Maybe<Scalars['ID']>;
    /** The caption for the resource */
    caption: Maybe<Scalars['String']>;
    /** Connection between the HierarchicalContentNode type and the ContentNode type */
    children: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
    /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
    commentCount: Maybe<Scalars['Int']>;
    /** Whether the comments are open or closed for this particular post. */
    commentStatus: Maybe<Scalars['String']>;
    /** Connection between the MediaItem type and the Comment type */
    comments: Maybe<MediaItemToCommentConnection>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** Description of the image (stored as post_content) */
    description: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** The filesize in bytes of the resource */
    fileSize: Maybe<Scalars['Int']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the attachment object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the attachment object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** Details about the mediaItem */
    mediaDetails: Maybe<MediaDetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    mediaItemId: Scalars['Int'];
    /** Url of the mediaItem */
    mediaItemUrl: Maybe<Scalars['String']>;
    /** Type of resource */
    mediaType: Maybe<Scalars['String']>;
    /** The mime type of the mediaItem */
    mimeType: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** The parent of the node. The parent object can be of various types */
    parent: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
    /** Database id of the parent node */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent node. */
    parentId: Maybe<Scalars['ID']>;
    /** The password for the attachment object. */
    password: Maybe<Scalars['String']>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The sizes attribute value for an image. */
    sizes: Maybe<Scalars['String']>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** Url of the mediaItem */
    sourceUrl: Maybe<Scalars['String']>;
    /** The srcset attribute specifies the URL of the image to use in different situations. It is a comma separated string of urls and their widths. */
    srcSet: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to a node of content */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The mediaItem type */
export type MediaItemAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};

/** The mediaItem type */
export type MediaItemCaptionArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The mediaItem type */
export type MediaItemChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};

/** The mediaItem type */
export type MediaItemCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<MediaItemToCommentConnectionWhereArgs>;
};

/** The mediaItem type */
export type MediaItemDescriptionArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The mediaItem type */
export type MediaItemEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The mediaItem type */
export type MediaItemEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The mediaItem type */
export type MediaItemFileSizeArgs = {
  size: InputMaybe<MediaItemSizeEnum>;
};

/** The mediaItem type */
export type MediaItemSizesArgs = {
  size: InputMaybe<MediaItemSizeEnum>;
};

/** The mediaItem type */
export type MediaItemSourceUrlArgs = {
  size: InputMaybe<MediaItemSizeEnum>;
};

/** The mediaItem type */
export type MediaItemSrcSetArgs = {
  size: InputMaybe<MediaItemSizeEnum>;
};

/** The mediaItem type */
export type MediaItemTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Connection to mediaItem Nodes */
export type MediaItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected mediaItem Nodes */
  edges: Array<MediaItemConnectionEdge>;
  /** A list of connected mediaItem Nodes */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: MediaItemConnectionPageInfo;
};

/** Edge between a Node and a connected mediaItem */
export type MediaItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected mediaItem Node */
  node: MediaItem;
};

/** Page Info on the connected MediaItemConnectionEdge */
export type MediaItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum MediaItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a media item by its source url */
  SourceUrl = 'SOURCE_URL',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Meta connected to a MediaItem */
export type MediaItemMeta = {
  __typename?: 'MediaItemMeta';
  /** Aperture measurement of the media item. */
  aperture: Maybe<Scalars['Float']>;
  /** Information about the camera used to create the media item. */
  camera: Maybe<Scalars['String']>;
  /** The text string description associated with the media item. */
  caption: Maybe<Scalars['String']>;
  /** Copyright information associated with the media item. */
  copyright: Maybe<Scalars['String']>;
  /** The date/time when the media was created. */
  createdTimestamp: Maybe<Scalars['Int']>;
  /** The original creator of the media item. */
  credit: Maybe<Scalars['String']>;
  /** The focal length value of the media item. */
  focalLength: Maybe<Scalars['Float']>;
  /** The ISO (International Organization for Standardization) value of the media item. */
  iso: Maybe<Scalars['Int']>;
  /** List of keywords used to describe or identfy the media item. */
  keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The vertical or horizontal aspect of the media item. */
  orientation: Maybe<Scalars['String']>;
  /** The shutter speed information of the media item. */
  shutterSpeed: Maybe<Scalars['Float']>;
  /** A useful title for the media item. */
  title: Maybe<Scalars['String']>;
};

/** The size of the media item object. */
export enum MediaItemSizeEnum {
  /** MediaItem with the large size */
  Large = 'LARGE',
  /** MediaItem with the medium size */
  Medium = 'MEDIUM',
  /** MediaItem with the medium_large size */
  MediumLarge = 'MEDIUM_LARGE',
  /** MediaItem with the thumbnail size */
  Thumbnail = 'THUMBNAIL',
  /** MediaItem with the 1536x1536 size */
  '1536X1536' = '_1536X1536',
  /** MediaItem with the 2048x2048 size */
  '2048X2048' = '_2048X2048',
}

/** The status of the media item object. */
export enum MediaItemStatusEnum {
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the trash status */
  Trash = 'TRASH',
}

/** Connection between the MediaItem type and the Comment type */
export type MediaItemToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'MediaItemToCommentConnection';
    /** Edges for the MediaItemToCommentConnection connection */
    edges: Array<MediaItemToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: MediaItemToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type MediaItemToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'MediaItemToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;MediaItemToCommentConnection&quot; */
export type MediaItemToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'MediaItemToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the MediaItemToCommentConnection connection */
export type MediaItemToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Details of an available size for a media item */
export type MediaSize = {
  __typename?: 'MediaSize';
  /** The filename of the referenced size */
  file: Maybe<Scalars['String']>;
  /** The filesize of the resource */
  fileSize: Maybe<Scalars['Int']>;
  /** The height of the referenced size */
  height: Maybe<Scalars['String']>;
  /** The mime type of the referenced size */
  mimeType: Maybe<Scalars['String']>;
  /** The referenced size name */
  name: Maybe<Scalars['String']>;
  /** The url of the referenced size */
  sourceUrl: Maybe<Scalars['String']>;
  /** The width of the referenced size */
  width: Maybe<Scalars['String']>;
};

/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type Menu = DatabaseIdentifier &
  Node & {
    __typename?: 'Menu';
    /** The number of items in the menu */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The globally unique identifier of the nav menu object. */
    id: Scalars['ID'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** The locations a menu is assigned to */
    locations: Maybe<Array<Maybe<MenuLocationEnum>>>;
    /**
     * WP ID of the nav menu.
     * @deprecated Deprecated in favor of the databaseId field
     */
    menuId: Maybe<Scalars['Int']>;
    /** Connection between the Menu type and the MenuItem type */
    menuItems: Maybe<MenuToMenuItemConnection>;
    /** Display name of the menu. Equivalent to WP_Term-&gt;name. */
    name: Maybe<Scalars['String']>;
    /** The url friendly name of the menu. Equivalent to WP_Term-&gt;slug */
    slug: Maybe<Scalars['String']>;
  };

/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type MenuMenuItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<MenuToMenuItemConnectionWhereArgs>;
};

/** Connection to Menu Nodes */
export type MenuConnection = {
  /** A list of edges (relational context) between RootQuery and connected Menu Nodes */
  edges: Array<MenuConnectionEdge>;
  /** A list of connected Menu Nodes */
  nodes: Array<Menu>;
  /** Information about pagination in a connection. */
  pageInfo: MenuConnectionPageInfo;
};

/** Edge between a Node and a connected Menu */
export type MenuConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Menu Node */
  node: Menu;
};

/** Page Info on the connected MenuConnectionEdge */
export type MenuConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItem = DatabaseIdentifier &
  Node & {
    __typename?: 'MenuItem';
    /** Connection between the MenuItem type and the MenuItem type */
    childItems: Maybe<MenuItemToMenuItemConnection>;
    /** Connection from MenuItem to it&#039;s connected node */
    connectedNode: Maybe<MenuItemToMenuItemLinkableConnectionEdge>;
    /**
     * The object connected to this menu item.
     * @deprecated Deprecated in favor of the connectedNode field
     */
    connectedObject: Maybe<MenuItemObjectUnion>;
    /** Class attribute for the menu item link */
    cssClasses: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Description of the menu item. */
    description: Maybe<Scalars['String']>;
    /** The globally unique identifier of the nav menu item object. */
    id: Scalars['ID'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Label or title of the menu item. */
    label: Maybe<Scalars['String']>;
    /** Link relationship (XFN) of the menu item. */
    linkRelationship: Maybe<Scalars['String']>;
    /** The locations the menu item&#039;s Menu is assigned to */
    locations: Maybe<Array<Maybe<MenuLocationEnum>>>;
    /** The Menu a MenuItem is part of */
    menu: Maybe<MenuItemToMenuConnectionEdge>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Main menu item details&quot; was set to Show in GraphQL. */
    menuDetails: Maybe<MenuItem_Menudetails>;
    /**
     * WP ID of the menu item.
     * @deprecated Deprecated in favor of the databaseId field
     */
    menuItemId: Maybe<Scalars['Int']>;
    /** Menu item order */
    order: Maybe<Scalars['Int']>;
    /** The database id of the parent menu item or null if it is the root */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent nav menu item object. */
    parentId: Maybe<Scalars['ID']>;
    /** Path for the resource. Relative path for internal resources. Absolute path for external resources. */
    path: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Submenu item details&quot; was set to Show in GraphQL. */
    submenuDetails: Maybe<MenuItem_Submenudetails>;
    /** Target attribute for the menu item link. */
    target: Maybe<Scalars['String']>;
    /** Title attribute for the menu item link */
    title: Maybe<Scalars['String']>;
    /** The uri of the resource the menu item links to */
    uri: Maybe<Scalars['String']>;
    /** URL or destination of the menu item. */
    url: Maybe<Scalars['String']>;
  };

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItemChildItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<MenuItemToMenuItemConnectionWhereArgs>;
};

/** Connection to MenuItem Nodes */
export type MenuItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected MenuItem Nodes */
  edges: Array<MenuItemConnectionEdge>;
  /** A list of connected MenuItem Nodes */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuItemConnectionPageInfo;
};

/** Edge between a Node and a connected MenuItem */
export type MenuItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected MenuItem Node */
  node: MenuItem;
};

/** Page Info on the connected MenuItemConnectionEdge */
export type MenuItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Nodes that can be linked to as Menu Items */
export type MenuItemLinkable = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Edge between a Node and a connected MenuItemLinkable */
export type MenuItemLinkableConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected MenuItemLinkable Node */
  node: MenuItemLinkable;
};

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuItemNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
}

/** Deprecated in favor of MenuItemLinkeable Interface */
export type MenuItemObjectUnion =
  | Affiliate
  | Category
  | Condition
  | CuratedStrainsList
  | Event
  | Law
  | Page
  | Post
  | PostAuthor
  | Strain
  | Tag
  | UsLanding
  | Webinar;

/** Connection between the MenuItem type and the Menu type */
export type MenuItemToMenuConnectionEdge = Edge &
  MenuConnectionEdge &
  OneToOneConnection & {
    __typename?: 'MenuItemToMenuConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Menu;
  };

/** Connection between the MenuItem type and the MenuItem type */
export type MenuItemToMenuItemConnection = Connection &
  MenuItemConnection & {
    __typename?: 'MenuItemToMenuItemConnection';
    /** Edges for the MenuItemToMenuItemConnection connection */
    edges: Array<MenuItemToMenuItemConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<MenuItem>;
    /** Information about pagination in a connection. */
    pageInfo: MenuItemToMenuItemConnectionPageInfo;
  };

/** An edge in a connection */
export type MenuItemToMenuItemConnectionEdge = Edge &
  MenuItemConnectionEdge & {
    __typename?: 'MenuItemToMenuItemConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: MenuItem;
  };

/** Page Info on the &quot;MenuItemToMenuItemConnection&quot; */
export type MenuItemToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'MenuItemToMenuItemConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the MenuItemToMenuItemConnection connection */
export type MenuItemToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId: InputMaybe<Scalars['ID']>;
};

/** Connection between the MenuItem type and the MenuItemLinkable type */
export type MenuItemToMenuItemLinkableConnectionEdge = Edge &
  MenuItemLinkableConnectionEdge &
  OneToOneConnection & {
    __typename?: 'MenuItemToMenuItemLinkableConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: MenuItemLinkable;
  };

/** Field Group */
export type MenuItem_Menudetails = AcfFieldGroup & {
  __typename?: 'MenuItem_Menudetails';
  /**
   * Text to display above the menu item. &lt;br/&gt;
   * Leave empty if there should be no badge.
   */
  badge: Maybe<Scalars['String']>;
  ctas: Maybe<Array<Maybe<MenuItem_Menudetails_Ctas>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** This icon will only be displayed for the mobile version */
  icon: Maybe<MediaItem>;
  mobileOnly: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type MenuItem_Menudetails_Ctas = AcfFieldGroup & {
  __typename?: 'MenuItem_Menudetails_ctas';
  button: Maybe<AcfLink>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
};

/** Field Group */
export type MenuItem_Submenudetails = AcfFieldGroup & {
  __typename?: 'MenuItem_Submenudetails';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  icon: Maybe<MediaItem>;
  /** Text to display below menu item */
  subTitle: Maybe<Scalars['String']>;
};

/** Registered menu locations */
export enum MenuLocationEnum {
  /** Put the menu in the primary_navigation location */
  PrimaryNavigation = 'PRIMARY_NAVIGATION',
  /** Put the menu in the primary_navigation___br location */
  PrimaryNavigationBr = 'PRIMARY_NAVIGATION___BR',
  /** Put the menu in the primary_navigation___de location */
  PrimaryNavigationDe = 'PRIMARY_NAVIGATION___DE',
  /** Put the menu in the primary_navigation___es location */
  PrimaryNavigationEs = 'PRIMARY_NAVIGATION___ES',
  /** Put the menu in the secondary_navigation location */
  SecondaryNavigation = 'SECONDARY_NAVIGATION',
  /** Put the menu in the secondary_navigation___br location */
  SecondaryNavigationBr = 'SECONDARY_NAVIGATION___BR',
  /** Put the menu in the secondary_navigation___de location */
  SecondaryNavigationDe = 'SECONDARY_NAVIGATION___DE',
  /** Put the menu in the secondary_navigation___es location */
  SecondaryNavigationEs = 'SECONDARY_NAVIGATION___ES',
}

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuNodeIdTypeEnum {
  /** Identify a menu node by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a menu node by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a menu node by the slug of menu location to which it is assigned */
  Location = 'LOCATION',
  /** Identify a menu node by its name */
  Name = 'NAME',
  /** Identify a menu node by its slug */
  Slug = 'SLUG',
}

/** Connection between the Menu type and the MenuItem type */
export type MenuToMenuItemConnection = Connection &
  MenuItemConnection & {
    __typename?: 'MenuToMenuItemConnection';
    /** Edges for the MenuToMenuItemConnection connection */
    edges: Array<MenuToMenuItemConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<MenuItem>;
    /** Information about pagination in a connection. */
    pageInfo: MenuToMenuItemConnectionPageInfo;
  };

/** An edge in a connection */
export type MenuToMenuItemConnectionEdge = Edge &
  MenuItemConnectionEdge & {
    __typename?: 'MenuToMenuItemConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: MenuItem;
  };

/** Page Info on the &quot;MenuToMenuItemConnection&quot; */
export type MenuToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'MenuToMenuItemConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the MenuToMenuItemConnection connection */
export type MenuToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId: InputMaybe<Scalars['ID']>;
};

/** The MimeType of the object */
export enum MimeTypeEnum {
  /** application/java mime type. */
  ApplicationJava = 'APPLICATION_JAVA',
  /** application/msword mime type. */
  ApplicationMsword = 'APPLICATION_MSWORD',
  /** application/octet-stream mime type. */
  ApplicationOctetStream = 'APPLICATION_OCTET_STREAM',
  /** application/onenote mime type. */
  ApplicationOnenote = 'APPLICATION_ONENOTE',
  /** application/oxps mime type. */
  ApplicationOxps = 'APPLICATION_OXPS',
  /** application/pdf mime type. */
  ApplicationPdf = 'APPLICATION_PDF',
  /** application/rar mime type. */
  ApplicationRar = 'APPLICATION_RAR',
  /** application/rtf mime type. */
  ApplicationRtf = 'APPLICATION_RTF',
  /** application/ttaf+xml mime type. */
  ApplicationTtafXml = 'APPLICATION_TTAF_XML',
  /** application/vnd.apple.keynote mime type. */
  ApplicationVndAppleKeynote = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** application/vnd.apple.numbers mime type. */
  ApplicationVndAppleNumbers = 'APPLICATION_VND_APPLE_NUMBERS',
  /** application/vnd.apple.pages mime type. */
  ApplicationVndApplePages = 'APPLICATION_VND_APPLE_PAGES',
  /** application/vnd.ms-access mime type. */
  ApplicationVndMsAccess = 'APPLICATION_VND_MS_ACCESS',
  /** application/vnd.ms-excel mime type. */
  ApplicationVndMsExcel = 'APPLICATION_VND_MS_EXCEL',
  /** application/vnd.ms-excel.addin.macroEnabled.12 mime type. */
  ApplicationVndMsExcelAddinMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetBinaryMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** application/vnd.ms-excel.template.macroEnabled.12 mime type. */
  ApplicationVndMsExcelTemplateMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint mime type. */
  ApplicationVndMsPowerpoint = 'APPLICATION_VND_MS_POWERPOINT',
  /** application/vnd.ms-powerpoint.addin.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointAddinMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointPresentationMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideshowMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slide.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.template.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointTemplateMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-project mime type. */
  ApplicationVndMsProject = 'APPLICATION_VND_MS_PROJECT',
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  ApplicationVndMsWordDocumentMacroenabled_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** application/vnd.ms-word.template.macroEnabled.12 mime type. */
  ApplicationVndMsWordTemplateMacroenabled_12 = 'APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-write mime type. */
  ApplicationVndMsWrite = 'APPLICATION_VND_MS_WRITE',
  /** application/vnd.ms-xpsdocument mime type. */
  ApplicationVndMsXpsdocument = 'APPLICATION_VND_MS_XPSDOCUMENT',
  /** application/vnd.oasis.opendocument.chart mime type. */
  ApplicationVndOasisOpendocumentChart = 'APPLICATION_VND_OASIS_OPENDOCUMENT_CHART',
  /** application/vnd.oasis.opendocument.database mime type. */
  ApplicationVndOasisOpendocumentDatabase = 'APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE',
  /** application/vnd.oasis.opendocument.formula mime type. */
  ApplicationVndOasisOpendocumentFormula = 'APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA',
  /** application/vnd.oasis.opendocument.graphics mime type. */
  ApplicationVndOasisOpendocumentGraphics = 'APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS',
  /** application/vnd.oasis.opendocument.presentation mime type. */
  ApplicationVndOasisOpendocumentPresentation = 'APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION',
  /** application/vnd.oasis.opendocument.spreadsheet mime type. */
  ApplicationVndOasisOpendocumentSpreadsheet = 'APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET',
  /** application/vnd.oasis.opendocument.text mime type. */
  ApplicationVndOasisOpendocumentText = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** application/vnd.openxmlformats-officedocument.presentationml.slide mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE',
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** application/vnd.openxmlformats-officedocument.presentationml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE',
  /** application/wordperfect mime type. */
  ApplicationWordperfect = 'APPLICATION_WORDPERFECT',
  /** application/x-7z-compressed mime type. */
  ApplicationX_7ZCompressed = 'APPLICATION_X_7Z_COMPRESSED',
  /** application/x-gzip mime type. */
  ApplicationXGzip = 'APPLICATION_X_GZIP',
  /** application/x-tar mime type. */
  ApplicationXTar = 'APPLICATION_X_TAR',
  /** application/zip mime type. */
  ApplicationZip = 'APPLICATION_ZIP',
  /** audio/aac mime type. */
  AudioAac = 'AUDIO_AAC',
  /** audio/flac mime type. */
  AudioFlac = 'AUDIO_FLAC',
  /** audio/midi mime type. */
  AudioMidi = 'AUDIO_MIDI',
  /** audio/mpeg mime type. */
  AudioMpeg = 'AUDIO_MPEG',
  /** audio/ogg mime type. */
  AudioOgg = 'AUDIO_OGG',
  /** audio/wav mime type. */
  AudioWav = 'AUDIO_WAV',
  /** audio/x-matroska mime type. */
  AudioXMatroska = 'AUDIO_X_MATROSKA',
  /** audio/x-ms-wax mime type. */
  AudioXMsWax = 'AUDIO_X_MS_WAX',
  /** audio/x-ms-wma mime type. */
  AudioXMsWma = 'AUDIO_X_MS_WMA',
  /** audio/x-realaudio mime type. */
  AudioXRealaudio = 'AUDIO_X_REALAUDIO',
  /** image/avif mime type. */
  ImageAvif = 'IMAGE_AVIF',
  /** image/bmp mime type. */
  ImageBmp = 'IMAGE_BMP',
  /** image/gif mime type. */
  ImageGif = 'IMAGE_GIF',
  /** image/heic mime type. */
  ImageHeic = 'IMAGE_HEIC',
  /** image/jpeg mime type. */
  ImageJpeg = 'IMAGE_JPEG',
  /** image/png mime type. */
  ImagePng = 'IMAGE_PNG',
  /** image/tiff mime type. */
  ImageTiff = 'IMAGE_TIFF',
  /** image/webp mime type. */
  ImageWebp = 'IMAGE_WEBP',
  /** image/x-icon mime type. */
  ImageXIcon = 'IMAGE_X_ICON',
  /** text/calendar mime type. */
  TextCalendar = 'TEXT_CALENDAR',
  /** text/css mime type. */
  TextCss = 'TEXT_CSS',
  /** text/csv mime type. */
  TextCsv = 'TEXT_CSV',
  /** text/plain mime type. */
  TextPlain = 'TEXT_PLAIN',
  /** text/richtext mime type. */
  TextRichtext = 'TEXT_RICHTEXT',
  /** text/tab-separated-values mime type. */
  TextTabSeparatedValues = 'TEXT_TAB_SEPARATED_VALUES',
  /** text/vtt mime type. */
  TextVtt = 'TEXT_VTT',
  /** video/3gpp mime type. */
  Video_3Gpp = 'VIDEO_3GPP',
  /** video/3gpp2 mime type. */
  Video_3Gpp2 = 'VIDEO_3GPP2',
  /** video/avi mime type. */
  VideoAvi = 'VIDEO_AVI',
  /** video/divx mime type. */
  VideoDivx = 'VIDEO_DIVX',
  /** video/mp4 mime type. */
  VideoMp4 = 'VIDEO_MP4',
  /** video/mpeg mime type. */
  VideoMpeg = 'VIDEO_MPEG',
  /** video/ogg mime type. */
  VideoOgg = 'VIDEO_OGG',
  /** video/quicktime mime type. */
  VideoQuicktime = 'VIDEO_QUICKTIME',
  /** video/webm mime type. */
  VideoWebm = 'VIDEO_WEBM',
  /** video/x-flv mime type. */
  VideoXFlv = 'VIDEO_X_FLV',
  /** video/x-matroska mime type. */
  VideoXMatroska = 'VIDEO_X_MATROSKA',
  /** video/x-ms-asf mime type. */
  VideoXMsAsf = 'VIDEO_X_MS_ASF',
  /** video/x-ms-wm mime type. */
  VideoXMsWm = 'VIDEO_X_MS_WM',
  /** video/x-ms-wmv mime type. */
  VideoXMsWmv = 'VIDEO_X_MS_WMV',
  /** video/x-ms-wmx mime type. */
  VideoXMsWmx = 'VIDEO_X_MS_WMX',
}

/** The negativeEffect type */
export type NegativeEffect = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'NegativeEffect';
    /** Connection between the NegativeEffect type and the ContentNode type */
    contentNodes: Maybe<NegativeEffectToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    negativeEffectId: Maybe<Scalars['Int']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the NegativeEffect type and the strain type */
    strains: Maybe<NegativeEffectToStrainConnection>;
    /** Connection between the NegativeEffect type and the Taxonomy type */
    taxonomy: Maybe<NegativeEffectToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<NegativeEffect>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<NegativeEffect>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The negativeEffect type */
export type NegativeEffectContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<NegativeEffectToContentNodeConnectionWhereArgs>;
};

/** The negativeEffect type */
export type NegativeEffectEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The negativeEffect type */
export type NegativeEffectEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The negativeEffect type */
export type NegativeEffectStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<NegativeEffectToStrainConnectionWhereArgs>;
};

/** The negativeEffect type */
export type NegativeEffectTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to negativeEffect Nodes */
export type NegativeEffectConnection = {
  /** A list of edges (relational context) between RootQuery and connected negativeEffect Nodes */
  edges: Array<NegativeEffectConnectionEdge>;
  /** A list of connected negativeEffect Nodes */
  nodes: Array<NegativeEffect>;
  /** Information about pagination in a connection. */
  pageInfo: NegativeEffectConnectionPageInfo;
};

/** Edge between a Node and a connected negativeEffect */
export type NegativeEffectConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected negativeEffect Node */
  node: NegativeEffect;
};

/** Page Info on the connected NegativeEffectConnectionEdge */
export type NegativeEffectConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum NegativeEffectIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the NegativeEffect type and the ContentNode type */
export type NegativeEffectToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'NegativeEffectToContentNodeConnection';
    /** Edges for the NegativeEffectToContentNodeConnection connection */
    edges: Array<NegativeEffectToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: NegativeEffectToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type NegativeEffectToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'NegativeEffectToContentNodeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;NegativeEffectToContentNodeConnection&quot; */
export type NegativeEffectToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'NegativeEffectToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the NegativeEffectToContentNodeConnection connection */
export type NegativeEffectToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfNegativeEffectEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<NegativeEffectToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type NegativeEffectToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<NegativeEffectToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<NegativeEffectToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum NegativeEffectToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type NegativeEffectToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<NegativeEffectToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum NegativeEffectToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the NegativeEffect type and the strain type */
export type NegativeEffectToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'NegativeEffectToStrainConnection';
    /** Edges for the NegativeEffectToStrainConnection connection */
    edges: Array<NegativeEffectToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: NegativeEffectToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type NegativeEffectToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'NegativeEffectToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;NegativeEffectToStrainConnection&quot; */
export type NegativeEffectToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'NegativeEffectToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the NegativeEffectToStrainConnection connection */
export type NegativeEffectToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<NegativeEffectToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type NegativeEffectToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<NegativeEffectToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<NegativeEffectToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum NegativeEffectToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type NegativeEffectToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<NegativeEffectToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum NegativeEffectToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the NegativeEffect type and the Taxonomy type */
export type NegativeEffectToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'NegativeEffectToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** An object with an ID */
export type Node = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that can have an author assigned to it */
export type NodeWithAuthor = {
  /** Connection between the NodeWithAuthor type and the User type */
  author: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithAuthor type and the User type */
export type NodeWithAuthorToUserConnectionEdge = Edge &
  OneToOneConnection &
  UserConnectionEdge & {
    __typename?: 'NodeWithAuthorToUserConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: User;
  };

/** A node that can have comments associated with it */
export type NodeWithComments = {
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that supports the content editor */
export type NodeWithContentEditor = {
  /** The content of the post. */
  content: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that supports the content editor */
export type NodeWithContentEditorContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have an excerpt */
export type NodeWithExcerpt = {
  /** The excerpt of the post. */
  excerpt: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that can have an excerpt */
export type NodeWithExcerptExcerptArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have a featured image set */
export type NodeWithFeaturedImage = {
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithFeaturedImage type and the MediaItem type */
export type NodeWithFeaturedImageToMediaItemConnectionEdge = Edge &
  MediaItemConnectionEdge &
  OneToOneConnection & {
    __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: MediaItem;
  };

/** A node that can have page attributes */
export type NodeWithPageAttributes = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: Maybe<Scalars['Int']>;
};

/** A node that can have revisions */
export type NodeWithRevisions = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** True if the node is a revision of another node */
  isRevision: Maybe<Scalars['Boolean']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
};

/** Connection between the NodeWithRevisions type and the ContentNode type */
export type NodeWithRevisionsToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge &
    OneToOneConnection & {
      __typename?: 'NodeWithRevisionsToContentNodeConnectionEdge';
      /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
      cursor: Maybe<Scalars['String']>;
      /** The node of the connection, without the edges */
      node: ContentNode;
    };

/** A node that can have a template associated with it */
export type NodeWithTemplate = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The template assigned to the node */
  template: Maybe<ContentTemplate>;
};

/** A node that NodeWith a title */
export type NodeWithTitle = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title: Maybe<Scalars['String']>;
};

/** A node that NodeWith a title */
export type NodeWithTitleTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have trackbacks and pingbacks */
export type NodeWithTrackbacks = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the pings are open or closed for this particular post. */
  pingStatus: Maybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged: Maybe<Array<Maybe<Scalars['String']>>>;
  /** URLs queued to be pinged. */
  toPing: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Offset pagination input type */
export type OffsetPagination = {
  /** Number of post to show per page. Passed to posts_per_page of WP_Query. */
  offset: InputMaybe<Scalars['Int']>;
  /** Number of post to show per page. Passed to posts_per_page of WP_Query. */
  size: InputMaybe<Scalars['Int']>;
};

/** Get information about the offset pagination state */
export type OffsetPaginationPageInfo = {
  __typename?: 'OffsetPaginationPageInfo';
  /** True if there is one or more nodes available in this connection. Eg. you can increase the offset at least by one. */
  hasMore: Maybe<Scalars['Boolean']>;
  /** True when offset can be decresed eg. offset is 0&lt; */
  hasPrevious: Maybe<Scalars['Boolean']>;
  /** Total amount of nodes in this connection */
  total: Maybe<Scalars['Int']>;
};

/** A singular connection from one Node to another, with support for relational data on the &quot;edge&quot; of the connection. */
export type OneToOneConnection = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected node */
  node: Node;
};

/** The cardinality of the connection order */
export enum OrderEnum {
  /** Sort the query result set in an ascending order */
  Asc = 'ASC',
  /** Sort the query result set in a descending order */
  Desc = 'DESC',
}

/** The page type */
export type Page = ContentNode &
  DatabaseIdentifier &
  HierarchicalContentNode &
  HierarchicalNode &
  MenuItemLinkable &
  Node &
  NodeWithAuthor &
  NodeWithComments &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithPageAttributes &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Page';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<Page_Activestates>;
    /** Connection between the Page type and the affiliate type */
    affiliates: Maybe<PageToAffiliateConnection>;
    /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
    ancestors: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
    /** Connection between the NodeWithAuthor type and the User type */
    author: Maybe<NodeWithAuthorToUserConnectionEdge>;
    /** The database identifier of the author of the node */
    authorDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the author of the node */
    authorId: Maybe<Scalars['ID']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Cannabis Counseling Page Settings&quot; was set to Show in GraphQL. */
    cannabisCounselingPageSettings: Maybe<Page_Cannabiscounselingpagesettings>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Medical Card Page Settings&quot; was set to Show in GraphQL. */
    cardPageSettings: Maybe<Page_Cardpagesettings>;
    /** Connection between the HierarchicalContentNode type and the ContentNode type */
    children: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
    /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
    commentCount: Maybe<Scalars['Int']>;
    /** Whether the comments are open or closed for this particular post. */
    commentStatus: Maybe<Scalars['String']>;
    /** Connection between the Page type and the Comment type */
    comments: Maybe<PageToCommentConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the page object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the page object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether this page is set to the static front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether this page is set to the blog posts page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether this page is set to the privacy page. */
    isPrivacyPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
    menuOrder: Maybe<Scalars['Int']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Page settings&quot; was set to Show in GraphQL. */
    pageDetails: Maybe<Acf_Page_Pagedetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    pageId: Scalars['Int'];
    /** The parent of the node. The parent object can be of various types */
    parent: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
    /** Database id of the parent node */
    parentDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the parent node. */
    parentId: Maybe<Scalars['ID']>;
    /** The password for the page object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Page type and the page type */
    preview: Maybe<PageToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Page type and the page type */
    revisions: Maybe<PageToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Table of contents&quot; was set to Show in GraphQL. */
    tableOfContents: Maybe<Page_Tableofcontents>;
    /** The template assigned to a node of content */
    template: Maybe<ContentTemplate>;
    /** Connection between the Page type and the TermNode type */
    terms: Maybe<PageToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Page>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Page>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The page type */
export type PageAffiliatesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PageToAffiliateConnectionWhereArgs>;
};

/** The page type */
export type PageAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};

/** The page type */
export type PageChildrenArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};

/** The page type */
export type PageCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PageToCommentConnectionWhereArgs>;
};

/** The page type */
export type PageContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The page type */
export type PageEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The page type */
export type PageEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The page type */
export type PageRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PageToRevisionConnectionWhereArgs>;
};

/** The page type */
export type PageTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PageToTermNodeConnectionWhereArgs>;
};

/** The page type */
export type PageTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The page type */
export type PageTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Set relationships between the page to affiliates */
export type PageAffiliatesInput = {
  /** If true, this will append the affiliate to existing related affiliates. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<PageAffiliatesNodeInput>>>;
};

/** List of affiliates to connect the page to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PageAffiliatesNodeInput = {
  /** The description of the affiliate. This field is used to set a description of the affiliate if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the affiliate. If present, this will be used to connect to the page. If no existing affiliate exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the affiliate. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the affiliate. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection to page Nodes */
export type PageConnection = {
  /** A list of edges (relational context) between RootQuery and connected page Nodes */
  edges: Array<PageConnectionEdge>;
  /** A list of connected page Nodes */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: PageConnectionPageInfo;
};

/** Edge between a Node and a connected page */
export type PageConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected page Node */
  node: Page;
};

/** Page Info on the connected PageConnectionEdge */
export type PageConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PageIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Connection between the Page type and the affiliate type */
export type PageToAffiliateConnection = AffiliateConnection &
  Connection & {
    __typename?: 'PageToAffiliateConnection';
    /** Edges for the PageToAffiliateConnection connection */
    edges: Array<PageToAffiliateConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Affiliate>;
    /** Information about pagination in a connection. */
    pageInfo: PageToAffiliateConnectionPageInfo;
  };

/** An edge in a connection */
export type PageToAffiliateConnectionEdge = AffiliateConnectionEdge &
  Edge & {
    __typename?: 'PageToAffiliateConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Affiliate;
  };

/** Page Info on the &quot;PageToAffiliateConnection&quot; */
export type PageToAffiliateConnectionPageInfo = AffiliateConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'PageToAffiliateConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PageToAffiliateConnection connection */
export type PageToAffiliateConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Page type and the Comment type */
export type PageToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'PageToCommentConnection';
    /** Edges for the PageToCommentConnection connection */
    edges: Array<PageToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: PageToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type PageToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'PageToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;PageToCommentConnection&quot; */
export type PageToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'PageToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PageToCommentConnection connection */
export type PageToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Connection between the Page type and the page type */
export type PageToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  PageConnectionEdge & {
    __typename?: 'PageToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Page;
  };

/** Connection between the Page type and the page type */
export type PageToRevisionConnection = Connection &
  PageConnection & {
    __typename?: 'PageToRevisionConnection';
    /** Edges for the PageToRevisionConnection connection */
    edges: Array<PageToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Page>;
    /** Information about pagination in a connection. */
    pageInfo: PageToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type PageToRevisionConnectionEdge = Edge &
  PageConnectionEdge & {
    __typename?: 'PageToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Page;
  };

/** Page Info on the &quot;PageToRevisionConnection&quot; */
export type PageToRevisionConnectionPageInfo = PageConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'PageToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PageToRevisionConnection connection */
export type PageToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PageToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PageToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PageToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PageToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PageToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PageToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PageToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PageToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Page type and the TermNode type */
export type PageToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'PageToTermNodeConnection';
    /** Edges for the PageToTermNodeConnection connection */
    edges: Array<PageToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: PageToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type PageToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'PageToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;PageToTermNodeConnection&quot; */
export type PageToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PageToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PageToTermNodeConnection connection */
export type PageToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type Page_Activestates = AcfFieldGroup & {
  __typename?: 'Page_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type Page_Cannabiscounselingpagesettings = AcfFieldGroup & {
  __typename?: 'Page_Cannabiscounselingpagesettings';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  redirectCannabisCounseling: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type Page_Cardpagesettings = AcfFieldGroup & {
  __typename?: 'Page_Cardpagesettings';
  affiliateLogo: Maybe<MediaItem>;
  affiliatePage: Maybe<Array<Maybe<Page_Cardpagesettings_AffiliatePage>>>;
  affiliateWebsite: Maybe<Scalars['String']>;
  customStateCode: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Custom form url. Leave blank to use the default. */
  formUrl: Maybe<Scalars['String']>;
  imageObjectCaption: Maybe<Scalars['String']>;
  isAffiliate: Maybe<Scalars['Boolean']>;
  /**
   * Leave this section blank if this is a regular medical card or affiliate page. &lt;br/&gt;
   * This flag is being used to control A/B Testing
   */
  isExperiment: Maybe<Scalars['Boolean']>;
  isRenewal: Maybe<Scalars['Boolean']>;
  isVpdLanding: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  /** If checked, the registration form will disconnect from Medical Card but continue to collect contact information so patients can be followed up. */
  pauseAppointments: Maybe<Scalars['Boolean']>;
  /**
   * Price: Price (in $) without any discount. &lt;strong&gt; Leave it blank if the VPD is set to multi-state&lt;/strong&gt;&lt;br/&gt;
   * New Price: Price (in $) after applying a discount. &lt;strong&gt; Leave it blank &lt;/strong&gt; if &lt;em&gt;no discount or a percentage discount&lt;/em&gt; should be applied&lt;br/&gt;
   * Percentage Discount: Between 0-100.&lt;strong&gt;Leave it blank&lt;/strong&gt; if the discount is a $ value&lt;br/&gt;
   * &lt;strong&gt;Note:&lt;/strong&gt; either fill &quot;New Price&quot; - for a value discount -  or &quot;Percentage Discount&quot; - for a percentage discount
   */
  price: Maybe<Page_Cardpagesettings_Price>;
  product: Maybe<Page_Cardpagesettings_Product>;
  redirectMedicalCard: Maybe<Scalars['Boolean']>;
  stateProductImage: Maybe<MediaItem>;
  totalMedicalCardPrice: Maybe<Scalars['String']>;
  vpdLogo: Maybe<MediaItem>;
  vpdPage: Maybe<Page_Cardpagesettings_VpdPage>;
  vpdPartnerName: Maybe<Scalars['String']>;
  webinarInfo: Maybe<Page_Cardpagesettings_WebinarInfo>;
};

export type Page_Cardpagesettings_AffiliatePage = Page;

/** Field Group */
export type Page_Cardpagesettings_Price = AcfFieldGroup & {
  __typename?: 'Page_Cardpagesettings_Price';
  discountCode: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  newPrice: Maybe<Scalars['Float']>;
  percentageDiscount: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Page_Cardpagesettings_Product = AcfFieldGroup & {
  __typename?: 'Page_Cardpagesettings_Product';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  imageUrl: Maybe<MediaItem>;
  name: Maybe<Scalars['String']>;
};

export type Page_Cardpagesettings_VpdPage = Event;

/** Field Group */
export type Page_Cardpagesettings_WebinarInfo = AcfFieldGroup & {
  __typename?: 'Page_Cardpagesettings_WebinarInfo';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  webinarDescription: Maybe<Scalars['String']>;
  webinarTitle: Maybe<Scalars['String']>;
  webinarZoomUrl: Maybe<Scalars['String']>;
};

/** Field Group */
export type Page_Tableofcontents = AcfFieldGroup & {
  __typename?: 'Page_Tableofcontents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Add the article table of contents here. */
  tableOfContents: Maybe<Array<Maybe<Page_Tableofcontents_TableOfContents>>>;
};

/** Field Group */
export type Page_Tableofcontents_TableOfContents = AcfFieldGroup & {
  __typename?: 'Page_Tableofcontents_tableOfContents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /**
   * Add the section id without the &lt;strong&gt;#&lt;/strong&gt;&lt;br/&gt;
   * Example: section-id
   */
  id: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
};

/** An plugin object */
export type Plugin = Node & {
  __typename?: 'Plugin';
  /** Name of the plugin author(s), may also be a company name. */
  author: Maybe<Scalars['String']>;
  /** URI for the related author(s)/company website. */
  authorUri: Maybe<Scalars['String']>;
  /** Description of the plugin. */
  description: Maybe<Scalars['String']>;
  /** The globally unique identifier of the plugin object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Display name of the plugin. */
  name: Maybe<Scalars['String']>;
  /** Plugin path. */
  path: Maybe<Scalars['String']>;
  /** URI for the plugin website. This is useful for directing users for support requests etc. */
  pluginUri: Maybe<Scalars['String']>;
  /** Current version of the plugin. */
  version: Maybe<Scalars['String']>;
};

/** Connection to Plugin Nodes */
export type PluginConnection = {
  /** A list of edges (relational context) between RootQuery and connected Plugin Nodes */
  edges: Array<PluginConnectionEdge>;
  /** A list of connected Plugin Nodes */
  nodes: Array<Plugin>;
  /** Information about pagination in a connection. */
  pageInfo: PluginConnectionPageInfo;
};

/** Edge between a Node and a connected Plugin */
export type PluginConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Plugin Node */
  node: Plugin;
};

/** Page Info on the connected PluginConnectionEdge */
export type PluginConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The status of the WordPress plugin. */
export enum PluginStatusEnum {
  /** The plugin is currently active. */
  Active = 'ACTIVE',
  /** The plugin is a drop-in plugin. */
  DropIn = 'DROP_IN',
  /** The plugin is currently inactive. */
  Inactive = 'INACTIVE',
  /** The plugin is a must-use plugin. */
  MustUse = 'MUST_USE',
  /** The plugin is technically active but was paused while loading. */
  Paused = 'PAUSED',
  /** The plugin was active recently. */
  RecentlyActive = 'RECENTLY_ACTIVE',
  /** The plugin has an upgrade available. */
  Upgrade = 'UPGRADE',
}

/** The positiveEffect type */
export type PositiveEffect = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'PositiveEffect';
    /** Connection between the PositiveEffect type and the ContentNode type */
    contentNodes: Maybe<PositiveEffectToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    positiveEffectId: Maybe<Scalars['Int']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the PositiveEffect type and the strain type */
    strains: Maybe<PositiveEffectToStrainConnection>;
    /** Connection between the PositiveEffect type and the Taxonomy type */
    taxonomy: Maybe<PositiveEffectToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<PositiveEffect>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<PositiveEffect>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The positiveEffect type */
export type PositiveEffectContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PositiveEffectToContentNodeConnectionWhereArgs>;
};

/** The positiveEffect type */
export type PositiveEffectEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The positiveEffect type */
export type PositiveEffectEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The positiveEffect type */
export type PositiveEffectStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PositiveEffectToStrainConnectionWhereArgs>;
};

/** The positiveEffect type */
export type PositiveEffectTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to positiveEffect Nodes */
export type PositiveEffectConnection = {
  /** A list of edges (relational context) between RootQuery and connected positiveEffect Nodes */
  edges: Array<PositiveEffectConnectionEdge>;
  /** A list of connected positiveEffect Nodes */
  nodes: Array<PositiveEffect>;
  /** Information about pagination in a connection. */
  pageInfo: PositiveEffectConnectionPageInfo;
};

/** Edge between a Node and a connected positiveEffect */
export type PositiveEffectConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected positiveEffect Node */
  node: PositiveEffect;
};

/** Page Info on the connected PositiveEffectConnectionEdge */
export type PositiveEffectConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PositiveEffectIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the PositiveEffect type and the ContentNode type */
export type PositiveEffectToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'PositiveEffectToContentNodeConnection';
    /** Edges for the PositiveEffectToContentNodeConnection connection */
    edges: Array<PositiveEffectToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: PositiveEffectToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type PositiveEffectToContentNodeConnectionEdge =
  ContentNodeConnectionEdge &
    Edge & {
      __typename?: 'PositiveEffectToContentNodeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ContentNode;
    };

/** Page Info on the &quot;PositiveEffectToContentNodeConnection&quot; */
export type PositiveEffectToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'PositiveEffectToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the PositiveEffectToContentNodeConnection connection */
export type PositiveEffectToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfPositiveEffectEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PositiveEffectToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PositiveEffectToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PositiveEffectToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PositiveEffectToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PositiveEffectToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PositiveEffectToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PositiveEffectToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PositiveEffectToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PositiveEffect type and the strain type */
export type PositiveEffectToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'PositiveEffectToStrainConnection';
    /** Edges for the PositiveEffectToStrainConnection connection */
    edges: Array<PositiveEffectToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: PositiveEffectToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type PositiveEffectToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'PositiveEffectToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;PositiveEffectToStrainConnection&quot; */
export type PositiveEffectToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PositiveEffectToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PositiveEffectToStrainConnection connection */
export type PositiveEffectToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PositiveEffectToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PositiveEffectToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PositiveEffectToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PositiveEffectToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PositiveEffectToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PositiveEffectToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PositiveEffectToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PositiveEffectToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PositiveEffect type and the Taxonomy type */
export type PositiveEffectToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'PositiveEffectToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** The post type */
export type Post = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithAuthor &
  NodeWithComments &
  NodeWithContentEditor &
  NodeWithExcerpt &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  NodeWithTrackbacks &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Post';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<PostToPostConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Article Details&quot; was set to Show in GraphQL. */
    articleDetails: Maybe<Post_Articledetails>;
    /** Connection between the NodeWithAuthor type and the User type */
    author: Maybe<NodeWithAuthorToUserConnectionEdge>;
    /** The database identifier of the author of the node */
    authorDatabaseId: Maybe<Scalars['Int']>;
    /** The globally unique identifier of the author of the node */
    authorId: Maybe<Scalars['ID']>;
    /** Connection between the Post type and the category type */
    categories: Maybe<PostToCategoryConnection>;
    /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
    commentCount: Maybe<Scalars['Int']>;
    /** Whether the comments are open or closed for this particular post. */
    commentStatus: Maybe<Scalars['String']>;
    /** Connection between the Post type and the Comment type */
    comments: Maybe<PostToCommentConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** The excerpt of the post. */
    excerpt: Maybe<Scalars['String']>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the post object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the post object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether this page is sticky */
    isSticky: Scalars['Boolean'];
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<PostToParentConnectionEdge>;
    /** The password for the post object. */
    password: Maybe<Scalars['String']>;
    /** Whether the pings are open or closed for this particular post. */
    pingStatus: Maybe<Scalars['String']>;
    /** URLs that have been pinged. */
    pinged: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Connection between the Post type and the postAuthor type */
    postAuthors: Maybe<PostToPostAuthorConnection>;
    /** Connection between the Post type and the postFormat type */
    postFormats: Maybe<PostToPostFormatConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    postId: Scalars['Int'];
    /** Connection between the Post type and the post type */
    preview: Maybe<PostToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Post type and the post type */
    revisions: Maybe<PostToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Table of contents&quot; was set to Show in GraphQL. */
    tableOfContents: Maybe<Post_Tableofcontents>;
    /** Connection between the Post type and the tag type */
    tags: Maybe<PostToTagConnection>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the Post type and the TermNode type */
    terms: Maybe<PostToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** URLs queued to be pinged. */
    toPing: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Get specific translation version of this object */
    translation: Maybe<Post>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Post>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The post type */
export type PostAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The post type */
export type PostCategoriesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToCategoryConnectionWhereArgs>;
};

/** The post type */
export type PostCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToCommentConnectionWhereArgs>;
};

/** The post type */
export type PostContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The post type */
export type PostEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The post type */
export type PostEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The post type */
export type PostExcerptArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The post type */
export type PostPostAuthorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToPostAuthorConnectionWhereArgs>;
};

/** The post type */
export type PostPostFormatsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToPostFormatConnectionWhereArgs>;
};

/** The post type */
export type PostRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToRevisionConnectionWhereArgs>;
};

/** The post type */
export type PostTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToTagConnectionWhereArgs>;
};

/** The post type */
export type PostTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostToTermNodeConnectionWhereArgs>;
};

/** The post type */
export type PostTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The post type */
export type PostTranslationArgs = {
  language: LanguageCodeEnum;
};

/** The postAuthor type */
export type PostAuthor = DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'PostAuthor';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Author&quot; was set to Show in GraphQL. */
    authorDetails: Maybe<PostAuthor_Authordetails>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the PostAuthor type and the ContentNode type */
    contentNodes: Maybe<PostAuthorToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    postAuthorId: Maybe<Scalars['Int']>;
    /** Connection between the PostAuthor type and the post type */
    posts: Maybe<PostAuthorToPostConnection>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the PostAuthor type and the Taxonomy type */
    taxonomy: Maybe<PostAuthorToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<PostAuthor>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<PostAuthor>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The postAuthor type */
export type PostAuthorContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostAuthorToContentNodeConnectionWhereArgs>;
};

/** The postAuthor type */
export type PostAuthorEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The postAuthor type */
export type PostAuthorEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The postAuthor type */
export type PostAuthorPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostAuthorToPostConnectionWhereArgs>;
};

/** The postAuthor type */
export type PostAuthorTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to postAuthor Nodes */
export type PostAuthorConnection = {
  /** A list of edges (relational context) between RootQuery and connected postAuthor Nodes */
  edges: Array<PostAuthorConnectionEdge>;
  /** A list of connected postAuthor Nodes */
  nodes: Array<PostAuthor>;
  /** Information about pagination in a connection. */
  pageInfo: PostAuthorConnectionPageInfo;
};

/** Edge between a Node and a connected postAuthor */
export type PostAuthorConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected postAuthor Node */
  node: PostAuthor;
};

/** Page Info on the connected PostAuthorConnectionEdge */
export type PostAuthorConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostAuthorIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the PostAuthor type and the ContentNode type */
export type PostAuthorToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'PostAuthorToContentNodeConnection';
    /** Edges for the PostAuthorToContentNodeConnection connection */
    edges: Array<PostAuthorToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: PostAuthorToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type PostAuthorToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'PostAuthorToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;PostAuthorToContentNodeConnection&quot; */
export type PostAuthorToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'PostAuthorToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the PostAuthorToContentNodeConnection connection */
export type PostAuthorToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfPostAuthorEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PostAuthorToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PostAuthorToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PostAuthorToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PostAuthorToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PostAuthorToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PostAuthorToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PostAuthorToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PostAuthorToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PostAuthor type and the post type */
export type PostAuthorToPostConnection = Connection &
  PostConnection & {
    __typename?: 'PostAuthorToPostConnection';
    /** Edges for the PostAuthorToPostConnection connection */
    edges: Array<PostAuthorToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: PostAuthorToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type PostAuthorToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'PostAuthorToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;PostAuthorToPostConnection&quot; */
export type PostAuthorToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostAuthorToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostAuthorToPostConnection connection */
export type PostAuthorToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PostAuthorToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PostAuthorToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PostAuthorToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PostAuthorToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PostAuthorToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PostAuthorToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PostAuthorToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PostAuthorToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PostAuthor type and the Taxonomy type */
export type PostAuthorToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'PostAuthorToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type PostAuthor_Authordetails = AcfFieldGroup & {
  __typename?: 'PostAuthor_Authordetails';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  list: Maybe<Array<Maybe<PostAuthor_Authordetails_List>>>;
  quote: Maybe<Scalars['String']>;
  socialNetworks: Maybe<Array<Maybe<PostAuthor_Authordetails_SocialNetworks>>>;
};

/** Field Group */
export type PostAuthor_Authordetails_List = AcfFieldGroup & {
  __typename?: 'PostAuthor_Authordetails_list';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  jobTitle: Maybe<Scalars['String']>;
};

/** Field Group */
export type PostAuthor_Authordetails_SocialNetworks = AcfFieldGroup & {
  __typename?: 'PostAuthor_Authordetails_socialNetworks';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  socialNetwork: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** Set relationships between the post to categories */
export type PostCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<PostCategoriesNodeInput>>>;
};

/** List of categories to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the category. If present, this will be used to connect to the post. If no existing category exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection to post Nodes */
export type PostConnection = {
  /** A list of edges (relational context) between RootQuery and connected post Nodes */
  edges: Array<PostConnectionEdge>;
  /** A list of connected post Nodes */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostConnectionPageInfo;
};

/** Edge between a Node and a connected post */
export type PostConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected post Node */
  node: Post;
};

/** Page Info on the connected PostConnectionEdge */
export type PostConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The postFormat type */
export type PostFormat = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'PostFormat';
    /** Connection between the PostFormat type and the ContentNode type */
    contentNodes: Maybe<PostFormatToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    postFormatId: Maybe<Scalars['Int']>;
    /** Connection between the PostFormat type and the post type */
    posts: Maybe<PostFormatToPostConnection>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the PostFormat type and the Taxonomy type */
    taxonomy: Maybe<PostFormatToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The postFormat type */
export type PostFormatContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostFormatToContentNodeConnectionWhereArgs>;
};

/** The postFormat type */
export type PostFormatEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The postFormat type */
export type PostFormatEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The postFormat type */
export type PostFormatPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PostFormatToPostConnectionWhereArgs>;
};

/** Connection to postFormat Nodes */
export type PostFormatConnection = {
  /** A list of edges (relational context) between RootQuery and connected postFormat Nodes */
  edges: Array<PostFormatConnectionEdge>;
  /** A list of connected postFormat Nodes */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatConnectionPageInfo;
};

/** Edge between a Node and a connected postFormat */
export type PostFormatConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected postFormat Node */
  node: PostFormat;
};

/** Page Info on the connected PostFormatConnectionEdge */
export type PostFormatConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostFormatIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the PostFormat type and the ContentNode type */
export type PostFormatToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'PostFormatToContentNodeConnection';
    /** Edges for the PostFormatToContentNodeConnection connection */
    edges: Array<PostFormatToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: PostFormatToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type PostFormatToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'PostFormatToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;PostFormatToContentNodeConnection&quot; */
export type PostFormatToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'PostFormatToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the PostFormatToContentNodeConnection connection */
export type PostFormatToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfPostFormatEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PostFormatToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PostFormatToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PostFormatToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PostFormatToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PostFormatToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PostFormatToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PostFormatToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PostFormatToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PostFormat type and the post type */
export type PostFormatToPostConnection = Connection &
  PostConnection & {
    __typename?: 'PostFormatToPostConnection';
    /** Edges for the PostFormatToPostConnection connection */
    edges: Array<PostFormatToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: PostFormatToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type PostFormatToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'PostFormatToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;PostFormatToPostConnection&quot; */
export type PostFormatToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostFormatToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostFormatToPostConnection connection */
export type PostFormatToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PostFormatToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PostFormatToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PostFormatToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PostFormatToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PostFormatToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PostFormatToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PostFormatToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PostFormatToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the PostFormat type and the Taxonomy type */
export type PostFormatToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'PostFormatToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** The format of post field data. */
export enum PostObjectFieldFormatEnum {
  /** Provide the field value directly from database. Null on unauthenticated requests. */
  Raw = 'RAW',
  /** Provide the field value as rendered by WordPress. Default. */
  Rendered = 'RENDERED',
}

/** The column to use when filtering by date */
export enum PostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  Date = 'DATE',
  /** The most recent modification date of the comment. */
  Modified = 'MODIFIED',
}

/** Field to order the connection by */
export enum PostObjectsConnectionOrderbyEnum {
  /** Order by author */
  Author = 'AUTHOR',
  /** Order by the number of comments it has acquired */
  CommentCount = 'COMMENT_COUNT',
  /** Order by publish date */
  Date = 'DATE',
  /** Preserve the ID order given in the IN array */
  In = 'IN',
  /** Order by the menu order value */
  MenuOrder = 'MENU_ORDER',
  /** Order by last modified date */
  Modified = 'MODIFIED',
  /** Preserve slug order given in the NAME_IN array */
  NameIn = 'NAME_IN',
  /** Order by parent ID */
  Parent = 'PARENT',
  /** Order by slug */
  Slug = 'SLUG',
  /** Order by title */
  Title = 'TITLE',
}

/** Options for ordering the connection */
export type PostObjectsConnectionOrderbyInput = {
  /** The field to order the connection by */
  field: PostObjectsConnectionOrderbyEnum;
  /** Possible directions in which to order a list of items */
  order: OrderEnum;
};

/** Set relationships between the post to postAuthors */
export type PostPostAuthorsInput = {
  /** If true, this will append the postAuthor to existing related postAuthors. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<PostPostAuthorsNodeInput>>>;
};

/** List of postAuthors to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostAuthorsNodeInput = {
  /** The description of the postAuthor. This field is used to set a description of the postAuthor if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the postAuthor. If present, this will be used to connect to the post. If no existing postAuthor exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the postAuthor. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the postAuthor. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Set relationships between the post to postFormats */
export type PostPostFormatsInput = {
  /** If true, this will append the postFormat to existing related postFormats. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<PostPostFormatsNodeInput>>>;
};

/** List of postFormats to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostFormatsNodeInput = {
  /** The description of the postFormat. This field is used to set a description of the postFormat if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat. If present, this will be used to connect to the post. If no existing postFormat exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the postFormat. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the postFormat. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** The status of the object. */
export enum PostStatusEnum {
  /** Objects with the acf-disabled status */
  AcfDisabled = 'ACF_DISABLED',
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the draft status */
  Draft = 'DRAFT',
  /** Objects with the future status */
  Future = 'FUTURE',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the pending status */
  Pending = 'PENDING',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the publish status */
  Publish = 'PUBLISH',
  /** Objects with the request-completed status */
  RequestCompleted = 'REQUEST_COMPLETED',
  /** Objects with the request-confirmed status */
  RequestConfirmed = 'REQUEST_CONFIRMED',
  /** Objects with the request-failed status */
  RequestFailed = 'REQUEST_FAILED',
  /** Objects with the request-pending status */
  RequestPending = 'REQUEST_PENDING',
  /** Objects with the trash status */
  Trash = 'TRASH',
}

/** Set relationships between the post to tags */
export type PostTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<PostTagsNodeInput>>>;
};

/** List of tags to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the tag. If present, this will be used to connect to the post. If no existing tag exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection between the Post type and the category type */
export type PostToCategoryConnection = CategoryConnection &
  Connection & {
    __typename?: 'PostToCategoryConnection';
    /** Edges for the PostToCategoryConnection connection */
    edges: Array<PostToCategoryConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Category>;
    /** Information about pagination in a connection. */
    pageInfo: PostToCategoryConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToCategoryConnectionEdge = CategoryConnectionEdge &
  Edge & {
    __typename?: 'PostToCategoryConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Category;
  };

/** Page Info on the &quot;PostToCategoryConnection&quot; */
export type PostToCategoryConnectionPageInfo = CategoryConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'PostToCategoryConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToCategoryConnection connection */
export type PostToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the Comment type */
export type PostToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'PostToCommentConnection';
    /** Edges for the PostToCommentConnection connection */
    edges: Array<PostToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: PostToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'PostToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;PostToCommentConnection&quot; */
export type PostToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'PostToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToCommentConnection connection */
export type PostToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Connection between the Post type and the post type */
export type PostToParentConnectionEdge = Edge &
  OneToOneConnection &
  PostConnectionEdge & {
    __typename?: 'PostToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Post;
  };

/** Connection between the Post type and the postAuthor type */
export type PostToPostAuthorConnection = Connection &
  PostAuthorConnection & {
    __typename?: 'PostToPostAuthorConnection';
    /** Edges for the PostToPostAuthorConnection connection */
    edges: Array<PostToPostAuthorConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PostAuthor>;
    /** Information about pagination in a connection. */
    pageInfo: PostToPostAuthorConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToPostAuthorConnectionEdge = Edge &
  PostAuthorConnectionEdge & {
    __typename?: 'PostToPostAuthorConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PostAuthor;
  };

/** Page Info on the &quot;PostToPostAuthorConnection&quot; */
export type PostToPostAuthorConnectionPageInfo = PageInfo &
  PostAuthorConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToPostAuthorConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToPostAuthorConnection connection */
export type PostToPostAuthorConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the post type */
export type PostToPostConnection = Connection &
  PostConnection & {
    __typename?: 'PostToPostConnection';
    /** Edges for the PostToPostConnection connection */
    edges: Array<PostToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: PostToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'PostToPostConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Post;
  };

/** Page Info on the &quot;PostToPostConnection&quot; */
export type PostToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Post type and the postFormat type */
export type PostToPostFormatConnection = Connection &
  PostFormatConnection & {
    __typename?: 'PostToPostFormatConnection';
    /** Edges for the PostToPostFormatConnection connection */
    edges: Array<PostToPostFormatConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PostFormat>;
    /** Information about pagination in a connection. */
    pageInfo: PostToPostFormatConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToPostFormatConnectionEdge = Edge &
  PostFormatConnectionEdge & {
    __typename?: 'PostToPostFormatConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PostFormat;
  };

/** Page Info on the &quot;PostToPostFormatConnection&quot; */
export type PostToPostFormatConnectionPageInfo = PageInfo &
  PostFormatConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToPostFormatConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToPostFormatConnection connection */
export type PostToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the post type */
export type PostToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  PostConnectionEdge & {
    __typename?: 'PostToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Post;
  };

/** Connection between the Post type and the post type */
export type PostToRevisionConnection = Connection &
  PostConnection & {
    __typename?: 'PostToRevisionConnection';
    /** Edges for the PostToRevisionConnection connection */
    edges: Array<PostToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: PostToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToRevisionConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'PostToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;PostToRevisionConnection&quot; */
export type PostToRevisionConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToRevisionConnection connection */
export type PostToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<PostToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type PostToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<PostToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<PostToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum PostToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type PostToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<PostToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum PostToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Post type and the tag type */
export type PostToTagConnection = Connection &
  TagConnection & {
    __typename?: 'PostToTagConnection';
    /** Edges for the PostToTagConnection connection */
    edges: Array<PostToTagConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Tag>;
    /** Information about pagination in a connection. */
    pageInfo: PostToTagConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToTagConnectionEdge = Edge &
  TagConnectionEdge & {
    __typename?: 'PostToTagConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Tag;
  };

/** Page Info on the &quot;PostToTagConnection&quot; */
export type PostToTagConnectionPageInfo = PageInfo &
  TagConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToTagConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToTagConnection connection */
export type PostToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the TermNode type */
export type PostToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'PostToTermNodeConnection';
    /** Edges for the PostToTermNodeConnection connection */
    edges: Array<PostToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: PostToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type PostToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'PostToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;PostToTermNodeConnection&quot; */
export type PostToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'PostToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the PostToTermNodeConnection connection */
export type PostToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Details for labels of the PostType */
export type PostTypeLabelDetails = {
  __typename?: 'PostTypeLabelDetails';
  /** Default is ‘Add New’ for both hierarchical and non-hierarchical types. */
  addNew: Maybe<Scalars['String']>;
  /** Label for adding a new singular item. */
  addNewItem: Maybe<Scalars['String']>;
  /** Label to signify all items in a submenu link. */
  allItems: Maybe<Scalars['String']>;
  /** Label for archives in nav menus */
  archives: Maybe<Scalars['String']>;
  /** Label for the attributes meta box. */
  attributes: Maybe<Scalars['String']>;
  /** Label for editing a singular item. */
  editItem: Maybe<Scalars['String']>;
  /** Label for the Featured Image meta box title. */
  featuredImage: Maybe<Scalars['String']>;
  /** Label for the table views hidden heading. */
  filterItemsList: Maybe<Scalars['String']>;
  /** Label for the media frame button. */
  insertIntoItem: Maybe<Scalars['String']>;
  /** Label for the table hidden heading. */
  itemsList: Maybe<Scalars['String']>;
  /** Label for the table pagination hidden heading. */
  itemsListNavigation: Maybe<Scalars['String']>;
  /** Label for the menu name. */
  menuName: Maybe<Scalars['String']>;
  /** General name for the post type, usually plural. */
  name: Maybe<Scalars['String']>;
  /** Label for the new item page title. */
  newItem: Maybe<Scalars['String']>;
  /** Label used when no items are found. */
  notFound: Maybe<Scalars['String']>;
  /** Label used when no items are in the trash. */
  notFoundInTrash: Maybe<Scalars['String']>;
  /** Label used to prefix parents of hierarchical items. */
  parentItemColon: Maybe<Scalars['String']>;
  /** Label for removing the featured image. */
  removeFeaturedImage: Maybe<Scalars['String']>;
  /** Label for searching plural items. */
  searchItems: Maybe<Scalars['String']>;
  /** Label for setting the featured image. */
  setFeaturedImage: Maybe<Scalars['String']>;
  /** Name for one object of this post type. */
  singularName: Maybe<Scalars['String']>;
  /** Label for the media frame filter. */
  uploadedToThisItem: Maybe<Scalars['String']>;
  /** Label in the media frame for using a featured image. */
  useFeaturedImage: Maybe<Scalars['String']>;
  /** Label for viewing a singular item. */
  viewItem: Maybe<Scalars['String']>;
  /** Label for viewing post type archives. */
  viewItems: Maybe<Scalars['String']>;
};

/** Field Group */
export type Post_Articledetails = AcfFieldGroup & {
  __typename?: 'Post_Articledetails';
  featuredExperts: Maybe<Array<Maybe<Post_Articledetails_FeaturedExperts>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  relatedArticles: Maybe<Array<Maybe<Post_Articledetails_RelatedArticles>>>;
  reviewer: Maybe<PostAuthor>;
};

export type Post_Articledetails_RelatedArticles = Page | Post;

/** Field Group */
export type Post_Articledetails_FeaturedExperts = AcfFieldGroup & {
  __typename?: 'Post_Articledetails_featuredExperts';
  expert: Maybe<PostAuthor>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** Field Group */
export type Post_Tableofcontents = AcfFieldGroup & {
  __typename?: 'Post_Tableofcontents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Add the article table of contents here. */
  tableOfContents: Maybe<Array<Maybe<Post_Tableofcontents_TableOfContents>>>;
};

/** Field Group */
export type Post_Tableofcontents_TableOfContents = AcfFieldGroup & {
  __typename?: 'Post_Tableofcontents_tableOfContents';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /**
   * Add the section id without the &lt;strong&gt;#&lt;/strong&gt;&lt;br/&gt;
   * Example: section-id
   */
  id: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
};

/** Nodes that can be seen in a preview (unpublished) state. */
export type Previewable = {
  /** Whether the object is a node in the preview state */
  isPreview: Maybe<Scalars['Boolean']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId: Maybe<Scalars['ID']>;
};

/** Filter the connection based on input */
export type RangeInput = {
  /** Greater than or equal to value */
  gt: InputMaybe<Scalars['Int']>;
  /** Greater than value */
  gte: InputMaybe<Scalars['Int']>;
  /** Less than value */
  lt: InputMaybe<Scalars['Int']>;
  /** Less than or equal to value */
  lte: InputMaybe<Scalars['Int']>;
};

/** The reading setting type */
export type ReadingSettings = {
  __typename?: 'ReadingSettings';
  /** The ID of the page that should display the latest posts */
  pageForPosts: Maybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  pageOnFront: Maybe<Scalars['Int']>;
  /** Blog pages show at most. */
  postsPerPage: Maybe<Scalars['Int']>;
  /** What to show on the front page */
  showOnFront: Maybe<Scalars['String']>;
};

/** Input for the refreshJwtAuthToken mutation. */
export type RefreshJwtAuthTokenInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** A valid, previously issued JWT refresh token. If valid a new Auth token will be provided. If invalid, expired, revoked or otherwise invalid, a new AuthToken will not be provided. */
  jwtRefreshToken: Scalars['String'];
};

/** The payload for the refreshJwtAuthToken mutation. */
export type RefreshJwtAuthTokenPayload = {
  __typename?: 'RefreshJwtAuthTokenPayload';
  /** JWT Token that can be used in future requests for Authentication */
  authToken: Maybe<Scalars['String']>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the registerUser mutation. */
export type RegisterUserInput = {
  /** User's AOL IM account. */
  aim: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password: InputMaybe<Scalars['String']>;
  /** If true, this will refresh the users JWT secret. */
  refreshJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered: InputMaybe<Scalars['String']>;
  /** If true, this will revoke the users JWT secret. If false, this will unrevoke the JWT secret AND issue a new one. To revoke, the user must have proper capabilities to edit users JWT secrets. */
  revokeJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim: InputMaybe<Scalars['String']>;
};

/** The payload for the registerUser mutation. */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user: Maybe<User>;
};

/** The logical relation between each item in the array when there are more than one. */
export enum RelationEnum {
  /** The logical AND condition returns true if both operands are true, otherwise, it returns false. */
  And = 'AND',
  /** The logical OR condition returns false if both operands are false, otherwise, it returns true. */
  Or = 'OR',
}

/** Input for the resetUserPassword mutation. */
export type ResetUserPasswordInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Password reset key */
  key: InputMaybe<Scalars['String']>;
  /** The user's login (username). */
  login: InputMaybe<Scalars['String']>;
  /** The new password. */
  password: InputMaybe<Scalars['String']>;
};

/** The payload for the resetUserPassword mutation. */
export type ResetUserPasswordPayload = {
  __typename?: 'ResetUserPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user: Maybe<User>;
};

/** Input for the restoreComment mutation. */
export type RestoreCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The ID of the comment to be restored */
  id: Scalars['ID'];
};

/** The payload for the restoreComment mutation. */
export type RestoreCommentPayload = {
  __typename?: 'RestoreCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The restored comment object */
  comment: Maybe<Comment>;
  /** The ID of the restored comment */
  restoredId: Maybe<Scalars['ID']>;
};

/** The review type */
export type Review = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Review';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<ReviewToReviewConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the review object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the review object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<ReviewToParentConnectionEdge>;
    /** The password for the review object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Review type and the review type */
    preview: Maybe<ReviewToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Review details&quot; was set to Show in GraphQL. */
    reviewDetails: Maybe<Review_Reviewdetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    reviewId: Scalars['Int'];
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Review type and the review type */
    revisions: Maybe<ReviewToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Review>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Review>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The review type */
export type ReviewAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The review type */
export type ReviewContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The review type */
export type ReviewEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The review type */
export type ReviewEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The review type */
export type ReviewRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ReviewToRevisionConnectionWhereArgs>;
};

/** The review type */
export type ReviewTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The review type */
export type ReviewTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to review Nodes */
export type ReviewConnection = {
  /** A list of edges (relational context) between RootQuery and connected review Nodes */
  edges: Array<ReviewConnectionEdge>;
  /** A list of connected review Nodes */
  nodes: Array<Review>;
  /** Information about pagination in a connection. */
  pageInfo: ReviewConnectionPageInfo;
};

/** Edge between a Node and a connected review */
export type ReviewConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected review Node */
  node: Review;
};

/** Page Info on the connected ReviewConnectionEdge */
export type ReviewConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ReviewIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Review type and the review type */
export type ReviewToParentConnectionEdge = Edge &
  OneToOneConnection &
  ReviewConnectionEdge & {
    __typename?: 'ReviewToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Review;
  };

/** Connection between the Review type and the review type */
export type ReviewToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  ReviewConnectionEdge & {
    __typename?: 'ReviewToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Review;
  };

/** Connection between the Review type and the review type */
export type ReviewToReviewConnection = Connection &
  ReviewConnection & {
    __typename?: 'ReviewToReviewConnection';
    /** Edges for the ReviewToReviewConnection connection */
    edges: Array<ReviewToReviewConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Review>;
    /** Information about pagination in a connection. */
    pageInfo: ReviewToReviewConnectionPageInfo;
  };

/** An edge in a connection */
export type ReviewToReviewConnectionEdge = Edge &
  ReviewConnectionEdge & {
    __typename?: 'ReviewToReviewConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Review;
  };

/** Page Info on the &quot;ReviewToReviewConnection&quot; */
export type ReviewToReviewConnectionPageInfo = PageInfo &
  ReviewConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ReviewToReviewConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Review type and the review type */
export type ReviewToRevisionConnection = Connection &
  ReviewConnection & {
    __typename?: 'ReviewToRevisionConnection';
    /** Edges for the ReviewToRevisionConnection connection */
    edges: Array<ReviewToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Review>;
    /** Information about pagination in a connection. */
    pageInfo: ReviewToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type ReviewToRevisionConnectionEdge = Edge &
  ReviewConnectionEdge & {
    __typename?: 'ReviewToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Review;
  };

/** Page Info on the &quot;ReviewToRevisionConnection&quot; */
export type ReviewToRevisionConnectionPageInfo = PageInfo &
  ReviewConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ReviewToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the ReviewToRevisionConnection connection */
export type ReviewToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ReviewToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ReviewToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ReviewToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ReviewToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ReviewToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ReviewToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ReviewToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ReviewToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Field Group */
export type Review_Reviewdetails = AcfFieldGroup & {
  __typename?: 'Review_Reviewdetails';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  rating: Maybe<Scalars['Float']>;
  reviewAuthor: Maybe<Review_Reviewdetails_ReviewAuthor>;
};

/** Field Group */
export type Review_Reviewdetails_ReviewAuthor = AcfFieldGroup & {
  __typename?: 'Review_Reviewdetails_ReviewAuthor';
  email: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** The root mutation */
export type RootMutation = {
  __typename?: 'RootMutation';
  /** The createAffiliate mutation */
  createAffiliate: Maybe<CreateAffiliatePayload>;
  /** The createAroma mutation */
  createAroma: Maybe<CreateAromaPayload>;
  /** The createCategory mutation */
  createCategory: Maybe<CreateCategoryPayload>;
  /** The createComment mutation */
  createComment: Maybe<CreateCommentPayload>;
  /** The createCondition mutation */
  createCondition: Maybe<CreateConditionPayload>;
  /** The createConditionType mutation */
  createConditionType: Maybe<CreateConditionTypePayload>;
  /** The createCuratedStrainsList mutation */
  createCuratedStrainsList: Maybe<CreateCuratedStrainsListPayload>;
  /** The createEvent mutation */
  createEvent: Maybe<CreateEventPayload>;
  /** The createFaq mutation */
  createFaq: Maybe<CreateFaqPayload>;
  /** The createFlavor mutation */
  createFlavor: Maybe<CreateFlavorPayload>;
  /** The createGraphqlDocument mutation */
  createGraphqlDocument: Maybe<CreateGraphqlDocumentPayload>;
  /** The createGraphqlDocumentGroup mutation */
  createGraphqlDocumentGroup: Maybe<CreateGraphqlDocumentGroupPayload>;
  /** The createJob mutation */
  createJob: Maybe<CreateJobPayload>;
  /** The createJobOffer mutation */
  createJobOffer: Maybe<CreateJobOfferPayload>;
  /** The createLaw mutation */
  createLaw: Maybe<CreateLawPayload>;
  /** The createLawStatus mutation */
  createLawStatus: Maybe<CreateLawStatusPayload>;
  /** The createMediaItem mutation */
  createMediaItem: Maybe<CreateMediaItemPayload>;
  /** The createNegativeEffect mutation */
  createNegativeEffect: Maybe<CreateNegativeEffectPayload>;
  /** The createPage mutation */
  createPage: Maybe<CreatePagePayload>;
  /** The createPositiveEffect mutation */
  createPositiveEffect: Maybe<CreatePositiveEffectPayload>;
  /** The createPost mutation */
  createPost: Maybe<CreatePostPayload>;
  /** The createPostAuthor mutation */
  createPostAuthor: Maybe<CreatePostAuthorPayload>;
  /** The createPostFormat mutation */
  createPostFormat: Maybe<CreatePostFormatPayload>;
  /** The createPublicReview mutation */
  createPublicReview: Maybe<CreatePublicReviewPayload>;
  /** The createReview mutation */
  createReview: Maybe<CreateReviewPayload>;
  /** The createScholarship mutation */
  createScholarship: Maybe<CreateScholarshipPayload>;
  /** The createStrain mutation */
  createStrain: Maybe<CreateStrainPayload>;
  /** The createStrainType mutation */
  createStrainType: Maybe<CreateStrainTypePayload>;
  /** The createTag mutation */
  createTag: Maybe<CreateTagPayload>;
  /** The createTeam mutation */
  createTeam: Maybe<CreateTeamPayload>;
  /** The createTeamMember mutation */
  createTeamMember: Maybe<CreateTeamMemberPayload>;
  /** The createTerpene mutation */
  createTerpene: Maybe<CreateTerpenePayload>;
  /** The createUsLanding mutation */
  createUsLanding: Maybe<CreateUsLandingPayload>;
  /** The createUser mutation */
  createUser: Maybe<CreateUserPayload>;
  /** The createWebinar mutation */
  createWebinar: Maybe<CreateWebinarPayload>;
  /** The deleteAffiliate mutation */
  deleteAffiliate: Maybe<DeleteAffiliatePayload>;
  /** The deleteAroma mutation */
  deleteAroma: Maybe<DeleteAromaPayload>;
  /** The deleteCategory mutation */
  deleteCategory: Maybe<DeleteCategoryPayload>;
  /** The deleteComment mutation */
  deleteComment: Maybe<DeleteCommentPayload>;
  /** The deleteCondition mutation */
  deleteCondition: Maybe<DeleteConditionPayload>;
  /** The deleteConditionType mutation */
  deleteConditionType: Maybe<DeleteConditionTypePayload>;
  /** The deleteCuratedStrainsList mutation */
  deleteCuratedStrainsList: Maybe<DeleteCuratedStrainsListPayload>;
  /** The deleteEvent mutation */
  deleteEvent: Maybe<DeleteEventPayload>;
  /** The deleteFaq mutation */
  deleteFaq: Maybe<DeleteFaqPayload>;
  /** The deleteFlavor mutation */
  deleteFlavor: Maybe<DeleteFlavorPayload>;
  /** The deleteGraphqlDocument mutation */
  deleteGraphqlDocument: Maybe<DeleteGraphqlDocumentPayload>;
  /** The deleteGraphqlDocumentGroup mutation */
  deleteGraphqlDocumentGroup: Maybe<DeleteGraphqlDocumentGroupPayload>;
  /** The deleteJob mutation */
  deleteJob: Maybe<DeleteJobPayload>;
  /** The deleteJobOffer mutation */
  deleteJobOffer: Maybe<DeleteJobOfferPayload>;
  /** The deleteLaw mutation */
  deleteLaw: Maybe<DeleteLawPayload>;
  /** The deleteLawStatus mutation */
  deleteLawStatus: Maybe<DeleteLawStatusPayload>;
  /** The deleteMediaItem mutation */
  deleteMediaItem: Maybe<DeleteMediaItemPayload>;
  /** The deleteNegativeEffect mutation */
  deleteNegativeEffect: Maybe<DeleteNegativeEffectPayload>;
  /** The deletePage mutation */
  deletePage: Maybe<DeletePagePayload>;
  /** The deletePositiveEffect mutation */
  deletePositiveEffect: Maybe<DeletePositiveEffectPayload>;
  /** The deletePost mutation */
  deletePost: Maybe<DeletePostPayload>;
  /** The deletePostAuthor mutation */
  deletePostAuthor: Maybe<DeletePostAuthorPayload>;
  /** The deletePostFormat mutation */
  deletePostFormat: Maybe<DeletePostFormatPayload>;
  /** The deleteReview mutation */
  deleteReview: Maybe<DeleteReviewPayload>;
  /** The deleteScholarship mutation */
  deleteScholarship: Maybe<DeleteScholarshipPayload>;
  /** The deleteStrain mutation */
  deleteStrain: Maybe<DeleteStrainPayload>;
  /** The deleteStrainType mutation */
  deleteStrainType: Maybe<DeleteStrainTypePayload>;
  /** The deleteTag mutation */
  deleteTag: Maybe<DeleteTagPayload>;
  /** The deleteTeam mutation */
  deleteTeam: Maybe<DeleteTeamPayload>;
  /** The deleteTeamMember mutation */
  deleteTeamMember: Maybe<DeleteTeamMemberPayload>;
  /** The deleteTerpene mutation */
  deleteTerpene: Maybe<DeleteTerpenePayload>;
  /** The deleteUsLanding mutation */
  deleteUsLanding: Maybe<DeleteUsLandingPayload>;
  /** The deleteUser mutation */
  deleteUser: Maybe<DeleteUserPayload>;
  /** The deleteWebinar mutation */
  deleteWebinar: Maybe<DeleteWebinarPayload>;
  /** Increase the count. */
  increaseCount: Maybe<Scalars['Int']>;
  /** Login a user. Request for an authToken and User details in response */
  login: Maybe<LoginPayload>;
  /** Use a valid JWT Refresh token to retrieve a new JWT Auth Token */
  refreshJwtAuthToken: Maybe<RefreshJwtAuthTokenPayload>;
  /** The registerUser mutation */
  registerUser: Maybe<RegisterUserPayload>;
  /** The resetUserPassword mutation */
  resetUserPassword: Maybe<ResetUserPasswordPayload>;
  /** The restoreComment mutation */
  restoreComment: Maybe<RestoreCommentPayload>;
  /** Send password reset email to user */
  sendPasswordResetEmail: Maybe<SendPasswordResetEmailPayload>;
  /** The updateAffiliate mutation */
  updateAffiliate: Maybe<UpdateAffiliatePayload>;
  /** The updateAroma mutation */
  updateAroma: Maybe<UpdateAromaPayload>;
  /** The updateCategory mutation */
  updateCategory: Maybe<UpdateCategoryPayload>;
  /** The updateComment mutation */
  updateComment: Maybe<UpdateCommentPayload>;
  /** The updateCondition mutation */
  updateCondition: Maybe<UpdateConditionPayload>;
  /** The updateConditionType mutation */
  updateConditionType: Maybe<UpdateConditionTypePayload>;
  /** The updateCuratedStrainsList mutation */
  updateCuratedStrainsList: Maybe<UpdateCuratedStrainsListPayload>;
  /** The updateEvent mutation */
  updateEvent: Maybe<UpdateEventPayload>;
  /** The updateFaq mutation */
  updateFaq: Maybe<UpdateFaqPayload>;
  /** The updateFlavor mutation */
  updateFlavor: Maybe<UpdateFlavorPayload>;
  /** The updateGraphqlDocument mutation */
  updateGraphqlDocument: Maybe<UpdateGraphqlDocumentPayload>;
  /** The updateGraphqlDocumentGroup mutation */
  updateGraphqlDocumentGroup: Maybe<UpdateGraphqlDocumentGroupPayload>;
  /** The updateJob mutation */
  updateJob: Maybe<UpdateJobPayload>;
  /** The updateJobOffer mutation */
  updateJobOffer: Maybe<UpdateJobOfferPayload>;
  /** The updateLaw mutation */
  updateLaw: Maybe<UpdateLawPayload>;
  /** The updateLawStatus mutation */
  updateLawStatus: Maybe<UpdateLawStatusPayload>;
  /** The updateMediaItem mutation */
  updateMediaItem: Maybe<UpdateMediaItemPayload>;
  /** The updateNegativeEffect mutation */
  updateNegativeEffect: Maybe<UpdateNegativeEffectPayload>;
  /** The updatePage mutation */
  updatePage: Maybe<UpdatePagePayload>;
  /** The updatePositiveEffect mutation */
  updatePositiveEffect: Maybe<UpdatePositiveEffectPayload>;
  /** The updatePost mutation */
  updatePost: Maybe<UpdatePostPayload>;
  /** The updatePostAuthor mutation */
  updatePostAuthor: Maybe<UpdatePostAuthorPayload>;
  /** The updatePostFormat mutation */
  updatePostFormat: Maybe<UpdatePostFormatPayload>;
  /** The updateReview mutation */
  updateReview: Maybe<UpdateReviewPayload>;
  /** The updateScholarship mutation */
  updateScholarship: Maybe<UpdateScholarshipPayload>;
  /** The updateSettings mutation */
  updateSettings: Maybe<UpdateSettingsPayload>;
  /** The updateStrain mutation */
  updateStrain: Maybe<UpdateStrainPayload>;
  /** The updateStrainType mutation */
  updateStrainType: Maybe<UpdateStrainTypePayload>;
  /** The updateTag mutation */
  updateTag: Maybe<UpdateTagPayload>;
  /** The updateTeam mutation */
  updateTeam: Maybe<UpdateTeamPayload>;
  /** The updateTeamMember mutation */
  updateTeamMember: Maybe<UpdateTeamMemberPayload>;
  /** The updateTerpene mutation */
  updateTerpene: Maybe<UpdateTerpenePayload>;
  /** The updateUsLanding mutation */
  updateUsLanding: Maybe<UpdateUsLandingPayload>;
  /** The updateUser mutation */
  updateUser: Maybe<UpdateUserPayload>;
  /** The updateWebinar mutation */
  updateWebinar: Maybe<UpdateWebinarPayload>;
};

/** The root mutation */
export type RootMutationCreateAffiliateArgs = {
  input: CreateAffiliateInput;
};

/** The root mutation */
export type RootMutationCreateAromaArgs = {
  input: CreateAromaInput;
};

/** The root mutation */
export type RootMutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};

/** The root mutation */
export type RootMutationCreateCommentArgs = {
  input: CreateCommentInput;
};

/** The root mutation */
export type RootMutationCreateConditionArgs = {
  input: CreateConditionInput;
};

/** The root mutation */
export type RootMutationCreateConditionTypeArgs = {
  input: CreateConditionTypeInput;
};

/** The root mutation */
export type RootMutationCreateCuratedStrainsListArgs = {
  input: CreateCuratedStrainsListInput;
};

/** The root mutation */
export type RootMutationCreateEventArgs = {
  input: CreateEventInput;
};

/** The root mutation */
export type RootMutationCreateFaqArgs = {
  input: CreateFaqInput;
};

/** The root mutation */
export type RootMutationCreateFlavorArgs = {
  input: CreateFlavorInput;
};

/** The root mutation */
export type RootMutationCreateGraphqlDocumentArgs = {
  input: CreateGraphqlDocumentInput;
};

/** The root mutation */
export type RootMutationCreateGraphqlDocumentGroupArgs = {
  input: CreateGraphqlDocumentGroupInput;
};

/** The root mutation */
export type RootMutationCreateJobArgs = {
  input: CreateJobInput;
};

/** The root mutation */
export type RootMutationCreateJobOfferArgs = {
  input: CreateJobOfferInput;
};

/** The root mutation */
export type RootMutationCreateLawArgs = {
  input: CreateLawInput;
};

/** The root mutation */
export type RootMutationCreateLawStatusArgs = {
  input: CreateLawStatusInput;
};

/** The root mutation */
export type RootMutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
};

/** The root mutation */
export type RootMutationCreateNegativeEffectArgs = {
  input: CreateNegativeEffectInput;
};

/** The root mutation */
export type RootMutationCreatePageArgs = {
  input: CreatePageInput;
};

/** The root mutation */
export type RootMutationCreatePositiveEffectArgs = {
  input: CreatePositiveEffectInput;
};

/** The root mutation */
export type RootMutationCreatePostArgs = {
  input: CreatePostInput;
};

/** The root mutation */
export type RootMutationCreatePostAuthorArgs = {
  input: CreatePostAuthorInput;
};

/** The root mutation */
export type RootMutationCreatePostFormatArgs = {
  input: CreatePostFormatInput;
};

/** The root mutation */
export type RootMutationCreatePublicReviewArgs = {
  input: CreatePublicReviewInput;
};

/** The root mutation */
export type RootMutationCreateReviewArgs = {
  input: CreateReviewInput;
};

/** The root mutation */
export type RootMutationCreateScholarshipArgs = {
  input: CreateScholarshipInput;
};

/** The root mutation */
export type RootMutationCreateStrainArgs = {
  input: CreateStrainInput;
};

/** The root mutation */
export type RootMutationCreateStrainTypeArgs = {
  input: CreateStrainTypeInput;
};

/** The root mutation */
export type RootMutationCreateTagArgs = {
  input: CreateTagInput;
};

/** The root mutation */
export type RootMutationCreateTeamArgs = {
  input: CreateTeamInput;
};

/** The root mutation */
export type RootMutationCreateTeamMemberArgs = {
  input: CreateTeamMemberInput;
};

/** The root mutation */
export type RootMutationCreateTerpeneArgs = {
  input: CreateTerpeneInput;
};

/** The root mutation */
export type RootMutationCreateUsLandingArgs = {
  input: CreateUsLandingInput;
};

/** The root mutation */
export type RootMutationCreateUserArgs = {
  input: CreateUserInput;
};

/** The root mutation */
export type RootMutationCreateWebinarArgs = {
  input: CreateWebinarInput;
};

/** The root mutation */
export type RootMutationDeleteAffiliateArgs = {
  input: DeleteAffiliateInput;
};

/** The root mutation */
export type RootMutationDeleteAromaArgs = {
  input: DeleteAromaInput;
};

/** The root mutation */
export type RootMutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};

/** The root mutation */
export type RootMutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};

/** The root mutation */
export type RootMutationDeleteConditionArgs = {
  input: DeleteConditionInput;
};

/** The root mutation */
export type RootMutationDeleteConditionTypeArgs = {
  input: DeleteConditionTypeInput;
};

/** The root mutation */
export type RootMutationDeleteCuratedStrainsListArgs = {
  input: DeleteCuratedStrainsListInput;
};

/** The root mutation */
export type RootMutationDeleteEventArgs = {
  input: DeleteEventInput;
};

/** The root mutation */
export type RootMutationDeleteFaqArgs = {
  input: DeleteFaqInput;
};

/** The root mutation */
export type RootMutationDeleteFlavorArgs = {
  input: DeleteFlavorInput;
};

/** The root mutation */
export type RootMutationDeleteGraphqlDocumentArgs = {
  input: DeleteGraphqlDocumentInput;
};

/** The root mutation */
export type RootMutationDeleteGraphqlDocumentGroupArgs = {
  input: DeleteGraphqlDocumentGroupInput;
};

/** The root mutation */
export type RootMutationDeleteJobArgs = {
  input: DeleteJobInput;
};

/** The root mutation */
export type RootMutationDeleteJobOfferArgs = {
  input: DeleteJobOfferInput;
};

/** The root mutation */
export type RootMutationDeleteLawArgs = {
  input: DeleteLawInput;
};

/** The root mutation */
export type RootMutationDeleteLawStatusArgs = {
  input: DeleteLawStatusInput;
};

/** The root mutation */
export type RootMutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};

/** The root mutation */
export type RootMutationDeleteNegativeEffectArgs = {
  input: DeleteNegativeEffectInput;
};

/** The root mutation */
export type RootMutationDeletePageArgs = {
  input: DeletePageInput;
};

/** The root mutation */
export type RootMutationDeletePositiveEffectArgs = {
  input: DeletePositiveEffectInput;
};

/** The root mutation */
export type RootMutationDeletePostArgs = {
  input: DeletePostInput;
};

/** The root mutation */
export type RootMutationDeletePostAuthorArgs = {
  input: DeletePostAuthorInput;
};

/** The root mutation */
export type RootMutationDeletePostFormatArgs = {
  input: DeletePostFormatInput;
};

/** The root mutation */
export type RootMutationDeleteReviewArgs = {
  input: DeleteReviewInput;
};

/** The root mutation */
export type RootMutationDeleteScholarshipArgs = {
  input: DeleteScholarshipInput;
};

/** The root mutation */
export type RootMutationDeleteStrainArgs = {
  input: DeleteStrainInput;
};

/** The root mutation */
export type RootMutationDeleteStrainTypeArgs = {
  input: DeleteStrainTypeInput;
};

/** The root mutation */
export type RootMutationDeleteTagArgs = {
  input: DeleteTagInput;
};

/** The root mutation */
export type RootMutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};

/** The root mutation */
export type RootMutationDeleteTeamMemberArgs = {
  input: DeleteTeamMemberInput;
};

/** The root mutation */
export type RootMutationDeleteTerpeneArgs = {
  input: DeleteTerpeneInput;
};

/** The root mutation */
export type RootMutationDeleteUsLandingArgs = {
  input: DeleteUsLandingInput;
};

/** The root mutation */
export type RootMutationDeleteUserArgs = {
  input: DeleteUserInput;
};

/** The root mutation */
export type RootMutationDeleteWebinarArgs = {
  input: DeleteWebinarInput;
};

/** The root mutation */
export type RootMutationIncreaseCountArgs = {
  count: InputMaybe<Scalars['Int']>;
};

/** The root mutation */
export type RootMutationLoginArgs = {
  input: LoginInput;
};

/** The root mutation */
export type RootMutationRefreshJwtAuthTokenArgs = {
  input: RefreshJwtAuthTokenInput;
};

/** The root mutation */
export type RootMutationRegisterUserArgs = {
  input: RegisterUserInput;
};

/** The root mutation */
export type RootMutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};

/** The root mutation */
export type RootMutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};

/** The root mutation */
export type RootMutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};

/** The root mutation */
export type RootMutationUpdateAffiliateArgs = {
  input: UpdateAffiliateInput;
};

/** The root mutation */
export type RootMutationUpdateAromaArgs = {
  input: UpdateAromaInput;
};

/** The root mutation */
export type RootMutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};

/** The root mutation */
export type RootMutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};

/** The root mutation */
export type RootMutationUpdateConditionArgs = {
  input: UpdateConditionInput;
};

/** The root mutation */
export type RootMutationUpdateConditionTypeArgs = {
  input: UpdateConditionTypeInput;
};

/** The root mutation */
export type RootMutationUpdateCuratedStrainsListArgs = {
  input: UpdateCuratedStrainsListInput;
};

/** The root mutation */
export type RootMutationUpdateEventArgs = {
  input: UpdateEventInput;
};

/** The root mutation */
export type RootMutationUpdateFaqArgs = {
  input: UpdateFaqInput;
};

/** The root mutation */
export type RootMutationUpdateFlavorArgs = {
  input: UpdateFlavorInput;
};

/** The root mutation */
export type RootMutationUpdateGraphqlDocumentArgs = {
  input: UpdateGraphqlDocumentInput;
};

/** The root mutation */
export type RootMutationUpdateGraphqlDocumentGroupArgs = {
  input: UpdateGraphqlDocumentGroupInput;
};

/** The root mutation */
export type RootMutationUpdateJobArgs = {
  input: UpdateJobInput;
};

/** The root mutation */
export type RootMutationUpdateJobOfferArgs = {
  input: UpdateJobOfferInput;
};

/** The root mutation */
export type RootMutationUpdateLawArgs = {
  input: UpdateLawInput;
};

/** The root mutation */
export type RootMutationUpdateLawStatusArgs = {
  input: UpdateLawStatusInput;
};

/** The root mutation */
export type RootMutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};

/** The root mutation */
export type RootMutationUpdateNegativeEffectArgs = {
  input: UpdateNegativeEffectInput;
};

/** The root mutation */
export type RootMutationUpdatePageArgs = {
  input: UpdatePageInput;
};

/** The root mutation */
export type RootMutationUpdatePositiveEffectArgs = {
  input: UpdatePositiveEffectInput;
};

/** The root mutation */
export type RootMutationUpdatePostArgs = {
  input: UpdatePostInput;
};

/** The root mutation */
export type RootMutationUpdatePostAuthorArgs = {
  input: UpdatePostAuthorInput;
};

/** The root mutation */
export type RootMutationUpdatePostFormatArgs = {
  input: UpdatePostFormatInput;
};

/** The root mutation */
export type RootMutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};

/** The root mutation */
export type RootMutationUpdateScholarshipArgs = {
  input: UpdateScholarshipInput;
};

/** The root mutation */
export type RootMutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};

/** The root mutation */
export type RootMutationUpdateStrainArgs = {
  input: UpdateStrainInput;
};

/** The root mutation */
export type RootMutationUpdateStrainTypeArgs = {
  input: UpdateStrainTypeInput;
};

/** The root mutation */
export type RootMutationUpdateTagArgs = {
  input: UpdateTagInput;
};

/** The root mutation */
export type RootMutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};

/** The root mutation */
export type RootMutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};

/** The root mutation */
export type RootMutationUpdateTerpeneArgs = {
  input: UpdateTerpeneInput;
};

/** The root mutation */
export type RootMutationUpdateUsLandingArgs = {
  input: UpdateUsLandingInput;
};

/** The root mutation */
export type RootMutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root mutation */
export type RootMutationUpdateWebinarArgs = {
  input: UpdateWebinarInput;
};

/** The root entry point into the Graph */
export type RootQuery = {
  __typename?: 'RootQuery';
  /** A 0bject */
  affiliate: Maybe<Affiliate>;
  /** Connection between the RootQuery type and the affiliate type */
  affiliates: Maybe<RootQueryToAffiliateConnection>;
  /** Entry point to get all settings for the site */
  allSettings: Maybe<Settings>;
  /** A 0bject */
  aroma: Maybe<Aroma>;
  /** Connection between the RootQuery type and the aroma type */
  aromas: Maybe<RootQueryToAromaConnection>;
  /** Connection between the RootQuery type and the category type */
  categories: Maybe<RootQueryToCategoryConnection>;
  /** A 0bject */
  category: Maybe<Category>;
  /** Returns a Comment */
  comment: Maybe<Comment>;
  /** Connection between the RootQuery type and the Comment type */
  comments: Maybe<RootQueryToCommentConnection>;
  /** An object of the condition Type.  */
  condition: Maybe<Condition>;
  /**
   * A condition object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  conditionBy: Maybe<Condition>;
  /** A 0bject */
  conditionType: Maybe<ConditionType>;
  /** Connection between the RootQuery type and the conditionType type */
  conditionTypes: Maybe<RootQueryToConditionTypeConnection>;
  /** Connection between the RootQuery type and the condition type */
  conditions: Maybe<RootQueryToConditionConnection>;
  /** A node used to manage content */
  contentNode: Maybe<ContentNode>;
  /** Connection between the RootQuery type and the ContentNode type */
  contentNodes: Maybe<RootQueryToContentNodeConnection>;
  /** Fetch a Content Type node by unique Identifier */
  contentType: Maybe<ContentType>;
  /** Connection between the RootQuery type and the ContentType type */
  contentTypes: Maybe<RootQueryToContentTypeConnection>;
  /** A 0bject */
  curatedStrainsList: Maybe<CuratedStrainsList>;
  /** Connection between the RootQuery type and the curatedStrainsList type */
  curatedStrainsLists: Maybe<RootQueryToCuratedStrainsListConnection>;
  /** Get language list */
  defaultLanguage: Maybe<Language>;
  /** Fields of the &#039;DiscussionSettings&#039; settings group */
  discussionSettings: Maybe<DiscussionSettings>;
  /** An object of the event Type.  */
  event: Maybe<Event>;
  /**
   * A event object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  eventBy: Maybe<Event>;
  /** Connection between the RootQuery type and the event type */
  events: Maybe<RootQueryToEventConnection>;
  /** An object of the faq Type.  */
  faq: Maybe<Faq>;
  /**
   * A faq object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  faqBy: Maybe<Faq>;
  /** Connection between the RootQuery type and the faq type */
  faqs: Maybe<RootQueryToFaqConnection>;
  /** A 0bject */
  flavor: Maybe<Flavor>;
  /** Connection between the RootQuery type and the flavor type */
  flavors: Maybe<RootQueryToFlavorConnection>;
  /** Fields of the &#039;GeneralSettings&#039; settings group */
  generalSettings: Maybe<GeneralSettings>;
  /** An object of the graphqlDocument Type. Saved GraphQL Documents */
  graphqlDocument: Maybe<GraphqlDocument>;
  /**
   * A graphqlDocument object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  graphqlDocumentBy: Maybe<GraphqlDocument>;
  /** A 0bject */
  graphqlDocumentGroup: Maybe<GraphqlDocumentGroup>;
  /** Connection between the RootQuery type and the graphqlDocumentGroup type */
  graphqlDocumentGroups: Maybe<RootQueryToGraphqlDocumentGroupConnection>;
  /** Connection between the RootQuery type and the graphqlDocument type */
  graphqlDocuments: Maybe<RootQueryToGraphqlDocumentConnection>;
  /** A 0bject */
  job: Maybe<Job>;
  /** An object of the jobOffer Type.  */
  jobOffer: Maybe<JobOffer>;
  /**
   * A jobOffer object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  jobOfferBy: Maybe<JobOffer>;
  /** Connection between the RootQuery type and the jobOffer type */
  jobOffers: Maybe<RootQueryToJobOfferConnection>;
  /** Connection between the RootQuery type and the job type */
  jobs: Maybe<RootQueryToJobConnection>;
  /** List available languages */
  languages: Maybe<Array<Maybe<Language>>>;
  /** An object of the law Type.  */
  law: Maybe<Law>;
  /**
   * A law object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  lawBy: Maybe<Law>;
  /** A 0bject */
  lawStatus: Maybe<LawStatus>;
  /** Connection between the RootQuery type and the lawStatus type */
  lawStatuses: Maybe<RootQueryToLawStatusConnection>;
  /** Connection between the RootQuery type and the law type */
  laws: Maybe<RootQueryToLawConnection>;
  /** An object of the mediaItem Type.  */
  mediaItem: Maybe<MediaItem>;
  /**
   * A mediaItem object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  mediaItemBy: Maybe<MediaItem>;
  /** Connection between the RootQuery type and the mediaItem type */
  mediaItems: Maybe<RootQueryToMediaItemConnection>;
  /** A WordPress navigation menu */
  menu: Maybe<Menu>;
  /** A WordPress navigation menu item */
  menuItem: Maybe<MenuItem>;
  /** Connection between the RootQuery type and the MenuItem type */
  menuItems: Maybe<RootQueryToMenuItemConnection>;
  /** Connection between the RootQuery type and the Menu type */
  menus: Maybe<RootQueryToMenuConnection>;
  /** A 0bject */
  negativeEffect: Maybe<NegativeEffect>;
  /** Connection between the RootQuery type and the negativeEffect type */
  negativeEffects: Maybe<RootQueryToNegativeEffectConnection>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches an object given its Unique Resource Identifier */
  nodeByUri: Maybe<UniformResourceIdentifiable>;
  /** An object of the page Type.  */
  page: Maybe<Page>;
  /**
   * A page object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  pageBy: Maybe<Page>;
  /** Connection between the RootQuery type and the page type */
  pages: Maybe<RootQueryToPageConnection>;
  /** A WordPress plugin */
  plugin: Maybe<Plugin>;
  /** Connection between the RootQuery type and the Plugin type */
  plugins: Maybe<RootQueryToPluginConnection>;
  /** A 0bject */
  positiveEffect: Maybe<PositiveEffect>;
  /** Connection between the RootQuery type and the positiveEffect type */
  positiveEffects: Maybe<RootQueryToPositiveEffectConnection>;
  /** An object of the post Type.  */
  post: Maybe<Post>;
  /** A 0bject */
  postAuthor: Maybe<PostAuthor>;
  /** Connection between the RootQuery type and the postAuthor type */
  postAuthors: Maybe<RootQueryToPostAuthorConnection>;
  /**
   * A post object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  postBy: Maybe<Post>;
  /** A 0bject */
  postFormat: Maybe<PostFormat>;
  /** Connection between the RootQuery type and the postFormat type */
  postFormats: Maybe<RootQueryToPostFormatConnection>;
  /** Connection between the RootQuery type and the post type */
  posts: Maybe<RootQueryToPostConnection>;
  /** Fields of the &#039;ReadingSettings&#039; settings group */
  readingSettings: Maybe<ReadingSettings>;
  /** Connection between the RootQuery type and the EnqueuedScript type */
  registeredScripts: Maybe<RootQueryToEnqueuedScriptConnection>;
  /** Connection between the RootQuery type and the EnqueuedStylesheet type */
  registeredStylesheets: Maybe<RootQueryToEnqueuedStylesheetConnection>;
  /** An object of the review Type.  */
  review: Maybe<Review>;
  /**
   * A review object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  reviewBy: Maybe<Review>;
  /** Connection between the RootQuery type and the review type */
  reviews: Maybe<RootQueryToReviewConnection>;
  /** Connection between the RootQuery type and the ContentNode type */
  revisions: Maybe<RootQueryToRevisionsConnection>;
  /** An object of the scholarship Type.  */
  scholarship: Maybe<Scholarship>;
  /**
   * A scholarship object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  scholarshipBy: Maybe<Scholarship>;
  /** Connection between the RootQuery type and the scholarship type */
  scholarships: Maybe<RootQueryToScholarshipConnection>;
  /** The SEO Framework settings */
  seoSettings: Maybe<SeoSettings>;
  /** An object of the strain Type.  */
  strain: Maybe<Strain>;
  /**
   * A strain object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  strainBy: Maybe<Strain>;
  /** A 0bject */
  strainType: Maybe<StrainType>;
  /** Connection between the RootQuery type and the strainType type */
  strainTypes: Maybe<RootQueryToStrainTypeConnection>;
  /** Connection between the RootQuery type and the strain type */
  strains: Maybe<RootQueryToStrainConnection>;
  /** A 0bject */
  tag: Maybe<Tag>;
  /** Connection between the RootQuery type and the tag type */
  tags: Maybe<RootQueryToTagConnection>;
  /** Connection between the RootQuery type and the Taxonomy type */
  taxonomies: Maybe<RootQueryToTaxonomyConnection>;
  /** Fetch a Taxonomy node by unique Identifier */
  taxonomy: Maybe<Taxonomy>;
  /** A 0bject */
  team: Maybe<Team>;
  /** An object of the teamMember Type.  */
  teamMember: Maybe<TeamMember>;
  /**
   * A teamMember object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  teamMemberBy: Maybe<TeamMember>;
  /** Connection between the RootQuery type and the teamMember type */
  teamMembers: Maybe<RootQueryToTeamMemberConnection>;
  /** Connection between the RootQuery type and the team type */
  teams: Maybe<RootQueryToTeamConnection>;
  /** A node in a taxonomy used to group and relate content nodes */
  termNode: Maybe<TermNode>;
  /** Connection between the RootQuery type and the TermNode type */
  terms: Maybe<RootQueryToTermNodeConnection>;
  /** A 0bject */
  terpene: Maybe<Terpene>;
  /** Connection between the RootQuery type and the terpene type */
  terpenes: Maybe<RootQueryToTerpeneConnection>;
  /** A Theme object */
  theme: Maybe<Theme>;
  /** Theme Settings options. */
  themeSettings: Maybe<ThemeSettings>;
  /** Connection between the RootQuery type and the Theme type */
  themes: Maybe<RootQueryToThemeConnection>;
  /** Translate string using pll_translate_string() (Polylang) */
  translateString: Maybe<Scalars['String']>;
  /** An object of the usLanding Type.  */
  usLanding: Maybe<UsLanding>;
  /**
   * A usLanding object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  usLandingBy: Maybe<UsLanding>;
  /** Connection between the RootQuery type and the usLanding type */
  usLandings: Maybe<RootQueryToUsLandingConnection>;
  /** Returns a user */
  user: Maybe<User>;
  /** Returns a user role */
  userRole: Maybe<UserRole>;
  /** Connection between the RootQuery type and the UserRole type */
  userRoles: Maybe<RootQueryToUserRoleConnection>;
  /** Connection between the RootQuery type and the User type */
  users: Maybe<RootQueryToUserConnection>;
  /** Returns the current user */
  viewer: Maybe<User>;
  /** An object of the webinar Type.  */
  webinar: Maybe<Webinar>;
  /**
   * A webinar object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  webinarBy: Maybe<Webinar>;
  /** Connection between the RootQuery type and the webinar type */
  webinars: Maybe<RootQueryToWebinarConnection>;
  /** Fields of the &#039;WritingSettings&#039; settings group */
  writingSettings: Maybe<WritingSettings>;
};

/** The root entry point into the Graph */
export type RootQueryAffiliateArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<AffiliateIdType>;
};

/** The root entry point into the Graph */
export type RootQueryAffiliatesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToAffiliateConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryAromaArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<AromaIdType>;
};

/** The root entry point into the Graph */
export type RootQueryAromasArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToAromaConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryCategoriesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToCategoryConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryCategoryArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<CategoryIdType>;
};

/** The root entry point into the Graph */
export type RootQueryCommentArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<CommentNodeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToCommentConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryConditionArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<ConditionIdType>;
};

/** The root entry point into the Graph */
export type RootQueryConditionByArgs = {
  conditionId: InputMaybe<Scalars['Int']>;
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryConditionTypeArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<ConditionTypeIdType>;
};

/** The root entry point into the Graph */
export type RootQueryConditionTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToConditionTypeConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryConditionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToConditionConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryContentNodeArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  contentType: InputMaybe<ContentTypeEnum>;
  id: Scalars['ID'];
  idType: InputMaybe<ContentNodeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToContentNodeConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryContentTypeArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<ContentTypeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryContentTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryCuratedStrainsListArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<CuratedStrainsListIdType>;
};

/** The root entry point into the Graph */
export type RootQueryCuratedStrainsListsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToCuratedStrainsListConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryEventArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<EventIdType>;
};

/** The root entry point into the Graph */
export type RootQueryEventByArgs = {
  eventId: InputMaybe<Scalars['Int']>;
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryEventsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToEventConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryFaqArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<FaqIdType>;
};

/** The root entry point into the Graph */
export type RootQueryFaqByArgs = {
  faqId: InputMaybe<Scalars['Int']>;
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryFaqsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToFaqConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryFlavorArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<FlavorIdType>;
};

/** The root entry point into the Graph */
export type RootQueryFlavorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToFlavorConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<GraphqlDocumentIdType>;
};

/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentByArgs = {
  graphqlDocumentId: InputMaybe<Scalars['Int']>;
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentGroupArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<GraphqlDocumentGroupIdType>;
};

/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentGroupsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToGraphqlDocumentGroupConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryGraphqlDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryJobArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<JobIdType>;
};

/** The root entry point into the Graph */
export type RootQueryJobOfferArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<JobOfferIdType>;
};

/** The root entry point into the Graph */
export type RootQueryJobOfferByArgs = {
  id: InputMaybe<Scalars['ID']>;
  jobOfferId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryJobOffersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToJobOfferConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryJobsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToJobConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryLawArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<LawIdType>;
};

/** The root entry point into the Graph */
export type RootQueryLawByArgs = {
  id: InputMaybe<Scalars['ID']>;
  lawId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryLawStatusArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<LawStatusIdType>;
};

/** The root entry point into the Graph */
export type RootQueryLawStatusesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToLawStatusConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryLawsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToLawConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryMediaItemArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<MediaItemIdType>;
};

/** The root entry point into the Graph */
export type RootQueryMediaItemByArgs = {
  id: InputMaybe<Scalars['ID']>;
  mediaItemId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryMediaItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToMediaItemConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryMenuArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<MenuNodeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryMenuItemArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<MenuItemNodeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryMenuItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToMenuItemConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryMenusArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToMenuConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryNegativeEffectArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<NegativeEffectIdType>;
};

/** The root entry point into the Graph */
export type RootQueryNegativeEffectsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToNegativeEffectConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryNodeArgs = {
  id: InputMaybe<Scalars['ID']>;
};

/** The root entry point into the Graph */
export type RootQueryNodeByUriArgs = {
  uri: Scalars['String'];
};

/** The root entry point into the Graph */
export type RootQueryPageArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<PageIdType>;
};

/** The root entry point into the Graph */
export type RootQueryPageByArgs = {
  id: InputMaybe<Scalars['ID']>;
  pageId: InputMaybe<Scalars['Int']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryPagesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPageConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryPluginArgs = {
  id: Scalars['ID'];
};

/** The root entry point into the Graph */
export type RootQueryPluginsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPluginConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryPositiveEffectArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<PositiveEffectIdType>;
};

/** The root entry point into the Graph */
export type RootQueryPositiveEffectsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPositiveEffectConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryPostArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<PostIdType>;
};

/** The root entry point into the Graph */
export type RootQueryPostAuthorArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<PostAuthorIdType>;
};

/** The root entry point into the Graph */
export type RootQueryPostAuthorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPostAuthorConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryPostByArgs = {
  id: InputMaybe<Scalars['ID']>;
  postId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryPostFormatArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<PostFormatIdType>;
};

/** The root entry point into the Graph */
export type RootQueryPostFormatsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPostFormatConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToPostConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryRegisteredScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryRegisteredStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryReviewArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<ReviewIdType>;
};

/** The root entry point into the Graph */
export type RootQueryReviewByArgs = {
  id: InputMaybe<Scalars['ID']>;
  reviewId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryReviewsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToReviewConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToRevisionsConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryScholarshipArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<ScholarshipIdType>;
};

/** The root entry point into the Graph */
export type RootQueryScholarshipByArgs = {
  id: InputMaybe<Scalars['ID']>;
  scholarshipId: InputMaybe<Scalars['Int']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryScholarshipsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToScholarshipConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryStrainArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<StrainIdType>;
};

/** The root entry point into the Graph */
export type RootQueryStrainByArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  strainId: InputMaybe<Scalars['Int']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryStrainTypeArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<StrainTypeIdType>;
};

/** The root entry point into the Graph */
export type RootQueryStrainTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToStrainTypeConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToStrainConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryTagArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<TagIdType>;
};

/** The root entry point into the Graph */
export type RootQueryTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToTagConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryTaxonomiesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryTaxonomyArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<TaxonomyIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryTeamArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<TeamIdType>;
};

/** The root entry point into the Graph */
export type RootQueryTeamMemberArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<TeamMemberIdType>;
};

/** The root entry point into the Graph */
export type RootQueryTeamMemberByArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  teamMemberId: InputMaybe<Scalars['Int']>;
  uri: InputMaybe<Scalars['String']>;
};

/** The root entry point into the Graph */
export type RootQueryTeamMembersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToTeamMemberConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryTeamsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToTeamConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryTermNodeArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<TermNodeIdTypeEnum>;
  taxonomy: InputMaybe<TaxonomyEnum>;
};

/** The root entry point into the Graph */
export type RootQueryTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToTermNodeConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryTerpeneArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<TerpeneIdType>;
};

/** The root entry point into the Graph */
export type RootQueryTerpenesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToTerpeneConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryThemeArgs = {
  id: Scalars['ID'];
};

/** The root entry point into the Graph */
export type RootQueryThemeSettingsArgs = {
  language: InputMaybe<LanguageCodeFilterEnum>;
};

/** The root entry point into the Graph */
export type RootQueryThemesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryTranslateStringArgs = {
  language: LanguageCodeEnum;
  string: Scalars['String'];
};

/** The root entry point into the Graph */
export type RootQueryUsLandingArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<UsLandingIdType>;
};

/** The root entry point into the Graph */
export type RootQueryUsLandingByArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
  usLandingId: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryUsLandingsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToUsLandingConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryUserArgs = {
  id: Scalars['ID'];
  idType: InputMaybe<UserNodeIdTypeEnum>;
};

/** The root entry point into the Graph */
export type RootQueryUserRoleArgs = {
  id: Scalars['ID'];
};

/** The root entry point into the Graph */
export type RootQueryUserRolesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryUsersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToUserConnectionWhereArgs>;
};

/** The root entry point into the Graph */
export type RootQueryWebinarArgs = {
  asPreview: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType: InputMaybe<WebinarIdType>;
};

/** The root entry point into the Graph */
export type RootQueryWebinarByArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
  uri: InputMaybe<Scalars['String']>;
  webinarId: InputMaybe<Scalars['Int']>;
};

/** The root entry point into the Graph */
export type RootQueryWebinarsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RootQueryToWebinarConnectionWhereArgs>;
};

/** Connection between the RootQuery type and the affiliate type */
export type RootQueryToAffiliateConnection = AffiliateConnection &
  Connection & {
    __typename?: 'RootQueryToAffiliateConnection';
    /** Edges for the RootQueryToAffiliateConnection connection */
    edges: Array<RootQueryToAffiliateConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Affiliate>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToAffiliateConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToAffiliateConnectionEdge = AffiliateConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToAffiliateConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Affiliate;
  };

/** Page Info on the &quot;RootQueryToAffiliateConnection&quot; */
export type RootQueryToAffiliateConnectionPageInfo =
  AffiliateConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToAffiliateConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToAffiliateConnection connection */
export type RootQueryToAffiliateConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Affiliates by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Affiliates by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of scrapping IDs to query. Add an empty array to query all nodes with any scrapping ID. */
  scrappingIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the aroma type */
export type RootQueryToAromaConnection = AromaConnection &
  Connection & {
    __typename?: 'RootQueryToAromaConnection';
    /** Edges for the RootQueryToAromaConnection connection */
    edges: Array<RootQueryToAromaConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Aroma>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToAromaConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToAromaConnectionEdge = AromaConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToAromaConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Aroma;
  };

/** Page Info on the &quot;RootQueryToAromaConnection&quot; */
export type RootQueryToAromaConnectionPageInfo = AromaConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToAromaConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToAromaConnection connection */
export type RootQueryToAromaConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Aromas by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Aromas by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the category type */
export type RootQueryToCategoryConnection = CategoryConnection &
  Connection & {
    __typename?: 'RootQueryToCategoryConnection';
    /** Edges for the RootQueryToCategoryConnection connection */
    edges: Array<RootQueryToCategoryConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Category>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToCategoryConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToCategoryConnectionEdge = CategoryConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToCategoryConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Category;
  };

/** Page Info on the &quot;RootQueryToCategoryConnection&quot; */
export type RootQueryToCategoryConnectionPageInfo = CategoryConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToCategoryConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToCategoryConnection connection */
export type RootQueryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Categorys by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Categorys by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Comment type */
export type RootQueryToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'RootQueryToCommentConnection';
    /** Edges for the RootQueryToCommentConnection connection */
    edges: Array<RootQueryToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;RootQueryToCommentConnection&quot; */
export type RootQueryToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToCommentConnection connection */
export type RootQueryToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the condition type */
export type RootQueryToConditionConnection = ConditionConnection &
  Connection & {
    __typename?: 'RootQueryToConditionConnection';
    /** Edges for the RootQueryToConditionConnection connection */
    edges: Array<RootQueryToConditionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Condition>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToConditionConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToConditionConnectionEdge = ConditionConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToConditionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Condition;
  };

/** Page Info on the &quot;RootQueryToConditionConnection&quot; */
export type RootQueryToConditionConnectionPageInfo =
  ConditionConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToConditionConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToConditionConnection connection */
export type RootQueryToConditionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Conditions by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Conditions by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToConditionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Conditions with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Array of scrapping IDs to query. Add an empty array to query all nodes with any scrapping ID. */
  scrappingIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Search in title */
  searchTitle: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
  /** Filter by title start string */
  titleStartsWith: InputMaybe<Scalars['String']>;
};

export type RootQueryToConditionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToConditionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToConditionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToConditionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToConditionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToConditionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToConditionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the conditionType type */
export type RootQueryToConditionTypeConnection = ConditionTypeConnection &
  Connection & {
    __typename?: 'RootQueryToConditionTypeConnection';
    /** Edges for the RootQueryToConditionTypeConnection connection */
    edges: Array<RootQueryToConditionTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ConditionType>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToConditionTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToConditionTypeConnectionEdge =
  ConditionTypeConnectionEdge &
    Edge & {
      __typename?: 'RootQueryToConditionTypeConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: ConditionType;
    };

/** Page Info on the &quot;RootQueryToConditionTypeConnection&quot; */
export type RootQueryToConditionTypeConnectionPageInfo =
  ConditionTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToConditionTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToConditionTypeConnection connection */
export type RootQueryToConditionTypeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by ConditionTypes by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter ConditionTypes by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of scrapping IDs to query. Add an empty array to query all nodes with any scrapping ID. */
  scrappingIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'RootQueryToContentNodeConnection';
    /** Edges for the RootQueryToContentNodeConnection connection */
    edges: Array<RootQueryToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;RootQueryToContentNodeConnection&quot; */
export type RootQueryToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToContentNodeConnection connection */
export type RootQueryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter content nodes by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter content nodes by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate content nodes with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the ContentType type */
export type RootQueryToContentTypeConnection = Connection &
  ContentTypeConnection & {
    __typename?: 'RootQueryToContentTypeConnection';
    /** Edges for the RootQueryToContentTypeConnection connection */
    edges: Array<RootQueryToContentTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentType>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToContentTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToContentTypeConnectionEdge = ContentTypeConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToContentTypeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentType;
  };

/** Page Info on the &quot;RootQueryToContentTypeConnection&quot; */
export type RootQueryToContentTypeConnectionPageInfo =
  ContentTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToContentTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the RootQuery type and the curatedStrainsList type */
export type RootQueryToCuratedStrainsListConnection = Connection &
  CuratedStrainsListConnection & {
    __typename?: 'RootQueryToCuratedStrainsListConnection';
    /** Edges for the RootQueryToCuratedStrainsListConnection connection */
    edges: Array<RootQueryToCuratedStrainsListConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<CuratedStrainsList>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToCuratedStrainsListConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToCuratedStrainsListConnectionEdge =
  CuratedStrainsListConnectionEdge &
    Edge & {
      __typename?: 'RootQueryToCuratedStrainsListConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: CuratedStrainsList;
    };

/** Page Info on the &quot;RootQueryToCuratedStrainsListConnection&quot; */
export type RootQueryToCuratedStrainsListConnectionPageInfo =
  CuratedStrainsListConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToCuratedStrainsListConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToCuratedStrainsListConnection connection */
export type RootQueryToCuratedStrainsListConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by CuratedStrainsLists by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter CuratedStrainsLists by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the EnqueuedScript type */
export type RootQueryToEnqueuedScriptConnection = Connection &
  EnqueuedScriptConnection & {
    __typename?: 'RootQueryToEnqueuedScriptConnection';
    /** Edges for the RootQueryToEnqueuedScriptConnection connection */
    edges: Array<RootQueryToEnqueuedScriptConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedScript>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToEnqueuedScriptConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToEnqueuedScriptConnectionEdge = Edge &
  EnqueuedScriptConnectionEdge & {
    __typename?: 'RootQueryToEnqueuedScriptConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedScript;
  };

/** Page Info on the &quot;RootQueryToEnqueuedScriptConnection&quot; */
export type RootQueryToEnqueuedScriptConnectionPageInfo =
  EnqueuedScriptConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToEnqueuedScriptConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the RootQuery type and the EnqueuedStylesheet type */
export type RootQueryToEnqueuedStylesheetConnection = Connection &
  EnqueuedStylesheetConnection & {
    __typename?: 'RootQueryToEnqueuedStylesheetConnection';
    /** Edges for the RootQueryToEnqueuedStylesheetConnection connection */
    edges: Array<RootQueryToEnqueuedStylesheetConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedStylesheet>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToEnqueuedStylesheetConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToEnqueuedStylesheetConnectionEdge = Edge &
  EnqueuedStylesheetConnectionEdge & {
    __typename?: 'RootQueryToEnqueuedStylesheetConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedStylesheet;
  };

/** Page Info on the &quot;RootQueryToEnqueuedStylesheetConnection&quot; */
export type RootQueryToEnqueuedStylesheetConnectionPageInfo =
  EnqueuedStylesheetConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToEnqueuedStylesheetConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the RootQuery type and the event type */
export type RootQueryToEventConnection = Connection &
  EventConnection & {
    __typename?: 'RootQueryToEventConnection';
    /** Edges for the RootQueryToEventConnection connection */
    edges: Array<RootQueryToEventConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Event>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToEventConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToEventConnectionEdge = Edge &
  EventConnectionEdge & {
    __typename?: 'RootQueryToEventConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Event;
  };

/** Page Info on the &quot;RootQueryToEventConnection&quot; */
export type RootQueryToEventConnectionPageInfo = EventConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToEventConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToEventConnection connection */
export type RootQueryToEventConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Events by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Events by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToEventConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Events with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToEventConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToEventConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToEventConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToEventConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToEventConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToEventConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToEventConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the faq type */
export type RootQueryToFaqConnection = Connection &
  FaqConnection & {
    __typename?: 'RootQueryToFaqConnection';
    /** Edges for the RootQueryToFaqConnection connection */
    edges: Array<RootQueryToFaqConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Faq>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToFaqConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToFaqConnectionEdge = Edge &
  FaqConnectionEdge & {
    __typename?: 'RootQueryToFaqConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Faq;
  };

/** Page Info on the &quot;RootQueryToFaqConnection&quot; */
export type RootQueryToFaqConnectionPageInfo = FaqConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToFaqConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToFaqConnection connection */
export type RootQueryToFaqConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Faqs by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Faqs by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToFaqConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Faqs with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToFaqConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToFaqConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToFaqConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToFaqConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToFaqConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToFaqConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToFaqConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the flavor type */
export type RootQueryToFlavorConnection = Connection &
  FlavorConnection & {
    __typename?: 'RootQueryToFlavorConnection';
    /** Edges for the RootQueryToFlavorConnection connection */
    edges: Array<RootQueryToFlavorConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Flavor>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToFlavorConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToFlavorConnectionEdge = Edge &
  FlavorConnectionEdge & {
    __typename?: 'RootQueryToFlavorConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Flavor;
  };

/** Page Info on the &quot;RootQueryToFlavorConnection&quot; */
export type RootQueryToFlavorConnectionPageInfo = FlavorConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToFlavorConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToFlavorConnection connection */
export type RootQueryToFlavorConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Flavors by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Flavors by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the graphqlDocument type */
export type RootQueryToGraphqlDocumentConnection = Connection &
  GraphqlDocumentConnection & {
    __typename?: 'RootQueryToGraphqlDocumentConnection';
    /** Edges for the RootQueryToGraphqlDocumentConnection connection */
    edges: Array<RootQueryToGraphqlDocumentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<GraphqlDocument>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToGraphqlDocumentConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToGraphqlDocumentConnectionEdge = Edge &
  GraphqlDocumentConnectionEdge & {
    __typename?: 'RootQueryToGraphqlDocumentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: GraphqlDocument;
  };

/** Page Info on the &quot;RootQueryToGraphqlDocumentConnection&quot; */
export type RootQueryToGraphqlDocumentConnectionPageInfo =
  GraphqlDocumentConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToGraphqlDocumentConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToGraphqlDocumentConnection connection */
export type RootQueryToGraphqlDocumentConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate GraphqlDocuments with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToGraphqlDocumentConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToGraphqlDocumentConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToGraphqlDocumentConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToGraphqlDocumentConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToGraphqlDocumentConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the graphqlDocumentGroup type */
export type RootQueryToGraphqlDocumentGroupConnection = Connection &
  GraphqlDocumentGroupConnection & {
    __typename?: 'RootQueryToGraphqlDocumentGroupConnection';
    /** Edges for the RootQueryToGraphqlDocumentGroupConnection connection */
    edges: Array<RootQueryToGraphqlDocumentGroupConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<GraphqlDocumentGroup>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToGraphqlDocumentGroupConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToGraphqlDocumentGroupConnectionEdge = Edge &
  GraphqlDocumentGroupConnectionEdge & {
    __typename?: 'RootQueryToGraphqlDocumentGroupConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: GraphqlDocumentGroup;
  };

/** Page Info on the &quot;RootQueryToGraphqlDocumentGroupConnection&quot; */
export type RootQueryToGraphqlDocumentGroupConnectionPageInfo =
  GraphqlDocumentGroupConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToGraphqlDocumentGroupConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToGraphqlDocumentGroupConnection connection */
export type RootQueryToGraphqlDocumentGroupConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the job type */
export type RootQueryToJobConnection = Connection &
  JobConnection & {
    __typename?: 'RootQueryToJobConnection';
    /** Edges for the RootQueryToJobConnection connection */
    edges: Array<RootQueryToJobConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Job>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToJobConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToJobConnectionEdge = Edge &
  JobConnectionEdge & {
    __typename?: 'RootQueryToJobConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Job;
  };

/** Page Info on the &quot;RootQueryToJobConnection&quot; */
export type RootQueryToJobConnectionPageInfo = JobConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToJobConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToJobConnection connection */
export type RootQueryToJobConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Jobs by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Jobs by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the jobOffer type */
export type RootQueryToJobOfferConnection = Connection &
  JobOfferConnection & {
    __typename?: 'RootQueryToJobOfferConnection';
    /** Edges for the RootQueryToJobOfferConnection connection */
    edges: Array<RootQueryToJobOfferConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<JobOffer>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToJobOfferConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToJobOfferConnectionEdge = Edge &
  JobOfferConnectionEdge & {
    __typename?: 'RootQueryToJobOfferConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: JobOffer;
  };

/** Page Info on the &quot;RootQueryToJobOfferConnection&quot; */
export type RootQueryToJobOfferConnectionPageInfo = JobOfferConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToJobOfferConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToJobOfferConnection connection */
export type RootQueryToJobOfferConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by JobOffers by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter JobOffers by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToJobOfferConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate JobOffers with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToJobOfferConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToJobOfferConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToJobOfferConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToJobOfferConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToJobOfferConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToJobOfferConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToJobOfferConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the law type */
export type RootQueryToLawConnection = Connection &
  LawConnection & {
    __typename?: 'RootQueryToLawConnection';
    /** Edges for the RootQueryToLawConnection connection */
    edges: Array<RootQueryToLawConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Law>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToLawConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToLawConnectionEdge = Edge &
  LawConnectionEdge & {
    __typename?: 'RootQueryToLawConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Law;
  };

/** Page Info on the &quot;RootQueryToLawConnection&quot; */
export type RootQueryToLawConnectionPageInfo = LawConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToLawConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToLawConnection connection */
export type RootQueryToLawConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Laws by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Laws by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToLawConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Laws with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToLawConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToLawConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToLawConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToLawConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToLawConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToLawConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToLawConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the lawStatus type */
export type RootQueryToLawStatusConnection = Connection &
  LawStatusConnection & {
    __typename?: 'RootQueryToLawStatusConnection';
    /** Edges for the RootQueryToLawStatusConnection connection */
    edges: Array<RootQueryToLawStatusConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<LawStatus>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToLawStatusConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToLawStatusConnectionEdge = Edge &
  LawStatusConnectionEdge & {
    __typename?: 'RootQueryToLawStatusConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: LawStatus;
  };

/** Page Info on the &quot;RootQueryToLawStatusConnection&quot; */
export type RootQueryToLawStatusConnectionPageInfo =
  LawStatusConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToLawStatusConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToLawStatusConnection connection */
export type RootQueryToLawStatusConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by LawStatuss by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter LawStatuss by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the mediaItem type */
export type RootQueryToMediaItemConnection = Connection &
  MediaItemConnection & {
    __typename?: 'RootQueryToMediaItemConnection';
    /** Edges for the RootQueryToMediaItemConnection connection */
    edges: Array<RootQueryToMediaItemConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<MediaItem>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToMediaItemConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToMediaItemConnectionEdge = Edge &
  MediaItemConnectionEdge & {
    __typename?: 'RootQueryToMediaItemConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: MediaItem;
  };

/** Page Info on the &quot;RootQueryToMediaItemConnection&quot; */
export type RootQueryToMediaItemConnectionPageInfo =
  MediaItemConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToMediaItemConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToMediaItemConnection connection */
export type RootQueryToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<RootQueryToMediaItemConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate MediaItems with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToMediaItemConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToMediaItemConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToMediaItemConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToMediaItemConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToMediaItemConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToMediaItemConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToMediaItemConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the Menu type */
export type RootQueryToMenuConnection = Connection &
  MenuConnection & {
    __typename?: 'RootQueryToMenuConnection';
    /** Edges for the RootQueryToMenuConnection connection */
    edges: Array<RootQueryToMenuConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Menu>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToMenuConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToMenuConnectionEdge = Edge &
  MenuConnectionEdge & {
    __typename?: 'RootQueryToMenuConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Menu;
  };

/** Page Info on the &quot;RootQueryToMenuConnection&quot; */
export type RootQueryToMenuConnectionPageInfo = MenuConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToMenuConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToMenuConnection connection */
export type RootQueryToMenuConnectionWhereArgs = {
  /** The database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location: InputMaybe<MenuLocationEnum>;
  /** The slug of the menu to query items for */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the MenuItem type */
export type RootQueryToMenuItemConnection = Connection &
  MenuItemConnection & {
    __typename?: 'RootQueryToMenuItemConnection';
    /** Edges for the RootQueryToMenuItemConnection connection */
    edges: Array<RootQueryToMenuItemConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<MenuItem>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToMenuItemConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToMenuItemConnectionEdge = Edge &
  MenuItemConnectionEdge & {
    __typename?: 'RootQueryToMenuItemConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: MenuItem;
  };

/** Page Info on the &quot;RootQueryToMenuItemConnection&quot; */
export type RootQueryToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToMenuItemConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToMenuItemConnection connection */
export type RootQueryToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** The menu location for the menu being queried */
  location: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the negativeEffect type */
export type RootQueryToNegativeEffectConnection = Connection &
  NegativeEffectConnection & {
    __typename?: 'RootQueryToNegativeEffectConnection';
    /** Edges for the RootQueryToNegativeEffectConnection connection */
    edges: Array<RootQueryToNegativeEffectConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<NegativeEffect>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToNegativeEffectConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToNegativeEffectConnectionEdge = Edge &
  NegativeEffectConnectionEdge & {
    __typename?: 'RootQueryToNegativeEffectConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: NegativeEffect;
  };

/** Page Info on the &quot;RootQueryToNegativeEffectConnection&quot; */
export type RootQueryToNegativeEffectConnectionPageInfo =
  NegativeEffectConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToNegativeEffectConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToNegativeEffectConnection connection */
export type RootQueryToNegativeEffectConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by NegativeEffects by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter NegativeEffects by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the page type */
export type RootQueryToPageConnection = Connection &
  PageConnection & {
    __typename?: 'RootQueryToPageConnection';
    /** Edges for the RootQueryToPageConnection connection */
    edges: Array<RootQueryToPageConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Page>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPageConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPageConnectionEdge = Edge &
  PageConnectionEdge & {
    __typename?: 'RootQueryToPageConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Page;
  };

/** Page Info on the &quot;RootQueryToPageConnection&quot; */
export type RootQueryToPageConnectionPageInfo = PageConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPageConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPageConnection connection */
export type RootQueryToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Pages by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Pages by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToPageConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Pages with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToPageConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToPageConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToPageConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToPageConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToPageConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToPageConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToPageConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the Plugin type */
export type RootQueryToPluginConnection = Connection &
  PluginConnection & {
    __typename?: 'RootQueryToPluginConnection';
    /** Edges for the RootQueryToPluginConnection connection */
    edges: Array<RootQueryToPluginConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Plugin>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPluginConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPluginConnectionEdge = Edge &
  PluginConnectionEdge & {
    __typename?: 'RootQueryToPluginConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Plugin;
  };

/** Page Info on the &quot;RootQueryToPluginConnection&quot; */
export type RootQueryToPluginConnectionPageInfo = PageInfo &
  PluginConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPluginConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPluginConnection connection */
export type RootQueryToPluginConnectionWhereArgs = {
  /** Show plugin based on a keyword search. */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve plugins where plugin status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PluginStatusEnum>>>;
  /** Show plugins with a specific status. */
  status: InputMaybe<PluginStatusEnum>;
};

/** Connection between the RootQuery type and the positiveEffect type */
export type RootQueryToPositiveEffectConnection = Connection &
  PositiveEffectConnection & {
    __typename?: 'RootQueryToPositiveEffectConnection';
    /** Edges for the RootQueryToPositiveEffectConnection connection */
    edges: Array<RootQueryToPositiveEffectConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PositiveEffect>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPositiveEffectConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPositiveEffectConnectionEdge = Edge &
  PositiveEffectConnectionEdge & {
    __typename?: 'RootQueryToPositiveEffectConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PositiveEffect;
  };

/** Page Info on the &quot;RootQueryToPositiveEffectConnection&quot; */
export type RootQueryToPositiveEffectConnectionPageInfo = PageInfo &
  PositiveEffectConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPositiveEffectConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPositiveEffectConnection connection */
export type RootQueryToPositiveEffectConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by PositiveEffects by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter PositiveEffects by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the postAuthor type */
export type RootQueryToPostAuthorConnection = Connection &
  PostAuthorConnection & {
    __typename?: 'RootQueryToPostAuthorConnection';
    /** Edges for the RootQueryToPostAuthorConnection connection */
    edges: Array<RootQueryToPostAuthorConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PostAuthor>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPostAuthorConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPostAuthorConnectionEdge = Edge &
  PostAuthorConnectionEdge & {
    __typename?: 'RootQueryToPostAuthorConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PostAuthor;
  };

/** Page Info on the &quot;RootQueryToPostAuthorConnection&quot; */
export type RootQueryToPostAuthorConnectionPageInfo = PageInfo &
  PostAuthorConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPostAuthorConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPostAuthorConnection connection */
export type RootQueryToPostAuthorConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by PostAuthors by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter PostAuthors by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the post type */
export type RootQueryToPostConnection = Connection &
  PostConnection & {
    __typename?: 'RootQueryToPostConnection';
    /** Edges for the RootQueryToPostConnection connection */
    edges: Array<RootQueryToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'RootQueryToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;RootQueryToPostConnection&quot; */
export type RootQueryToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPostConnection connection */
export type RootQueryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Posts by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Posts by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Posts with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the postFormat type */
export type RootQueryToPostFormatConnection = Connection &
  PostFormatConnection & {
    __typename?: 'RootQueryToPostFormatConnection';
    /** Edges for the RootQueryToPostFormatConnection connection */
    edges: Array<RootQueryToPostFormatConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PostFormat>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToPostFormatConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToPostFormatConnectionEdge = Edge &
  PostFormatConnectionEdge & {
    __typename?: 'RootQueryToPostFormatConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PostFormat;
  };

/** Page Info on the &quot;RootQueryToPostFormatConnection&quot; */
export type RootQueryToPostFormatConnectionPageInfo = PageInfo &
  PostFormatConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToPostFormatConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToPostFormatConnection connection */
export type RootQueryToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the review type */
export type RootQueryToReviewConnection = Connection &
  ReviewConnection & {
    __typename?: 'RootQueryToReviewConnection';
    /** Edges for the RootQueryToReviewConnection connection */
    edges: Array<RootQueryToReviewConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Review>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToReviewConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToReviewConnectionEdge = Edge &
  ReviewConnectionEdge & {
    __typename?: 'RootQueryToReviewConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Review;
  };

/** Page Info on the &quot;RootQueryToReviewConnection&quot; */
export type RootQueryToReviewConnectionPageInfo = PageInfo &
  ReviewConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToReviewConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToReviewConnection connection */
export type RootQueryToReviewConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Reviews by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Reviews by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToReviewConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Reviews with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToReviewConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToReviewConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToReviewConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToReviewConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToReviewConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToReviewConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToReviewConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToRevisionsConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'RootQueryToRevisionsConnection';
    /** Edges for the RootQueryToRevisionsConnection connection */
    edges: Array<RootQueryToRevisionsConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToRevisionsConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToRevisionsConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'RootQueryToRevisionsConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;RootQueryToRevisionsConnection&quot; */
export type RootQueryToRevisionsConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'RootQueryToRevisionsConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the RootQueryToRevisionsConnection connection */
export type RootQueryToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<RootQueryToRevisionsConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToRevisionsConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToRevisionsConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToRevisionsConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToRevisionsConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToRevisionsConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToRevisionsConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToRevisionsConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the scholarship type */
export type RootQueryToScholarshipConnection = Connection &
  ScholarshipConnection & {
    __typename?: 'RootQueryToScholarshipConnection';
    /** Edges for the RootQueryToScholarshipConnection connection */
    edges: Array<RootQueryToScholarshipConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Scholarship>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToScholarshipConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToScholarshipConnectionEdge = Edge &
  ScholarshipConnectionEdge & {
    __typename?: 'RootQueryToScholarshipConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Scholarship;
  };

/** Page Info on the &quot;RootQueryToScholarshipConnection&quot; */
export type RootQueryToScholarshipConnectionPageInfo = PageInfo &
  ScholarshipConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToScholarshipConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToScholarshipConnection connection */
export type RootQueryToScholarshipConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Scholarships by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Scholarships by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToScholarshipConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Scholarships with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToScholarshipConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToScholarshipConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToScholarshipConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToScholarshipConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToScholarshipConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToScholarshipConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToScholarshipConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the strain type */
export type RootQueryToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'RootQueryToStrainConnection';
    /** Edges for the RootQueryToStrainConnection connection */
    edges: Array<RootQueryToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'RootQueryToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;RootQueryToStrainConnection&quot; */
export type RootQueryToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToStrainConnection connection */
export type RootQueryToStrainConnectionWhereArgs = {
  /** Array of conditions IDs to query. */
  conditionsIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Strains by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Strains by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Strains with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Search in title */
  searchTitle: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Range of tch quantity. */
  thcQuantity: InputMaybe<RangeInput>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
  /** Filter by title start string */
  titleStartsWith: InputMaybe<Scalars['String']>;
};

export type RootQueryToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the strainType type */
export type RootQueryToStrainTypeConnection = Connection &
  StrainTypeConnection & {
    __typename?: 'RootQueryToStrainTypeConnection';
    /** Edges for the RootQueryToStrainTypeConnection connection */
    edges: Array<RootQueryToStrainTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<StrainType>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToStrainTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToStrainTypeConnectionEdge = Edge &
  StrainTypeConnectionEdge & {
    __typename?: 'RootQueryToStrainTypeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: StrainType;
  };

/** Page Info on the &quot;RootQueryToStrainTypeConnection&quot; */
export type RootQueryToStrainTypeConnectionPageInfo = PageInfo &
  StrainTypeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToStrainTypeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToStrainTypeConnection connection */
export type RootQueryToStrainTypeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by StrainTypes by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter StrainTypes by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the tag type */
export type RootQueryToTagConnection = Connection &
  TagConnection & {
    __typename?: 'RootQueryToTagConnection';
    /** Edges for the RootQueryToTagConnection connection */
    edges: Array<RootQueryToTagConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Tag>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTagConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTagConnectionEdge = Edge &
  TagConnectionEdge & {
    __typename?: 'RootQueryToTagConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Tag;
  };

/** Page Info on the &quot;RootQueryToTagConnection&quot; */
export type RootQueryToTagConnectionPageInfo = PageInfo &
  TagConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTagConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToTagConnection connection */
export type RootQueryToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Tags by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Tags by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Taxonomy type */
export type RootQueryToTaxonomyConnection = Connection &
  TaxonomyConnection & {
    __typename?: 'RootQueryToTaxonomyConnection';
    /** Edges for the RootQueryToTaxonomyConnection connection */
    edges: Array<RootQueryToTaxonomyConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Taxonomy>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTaxonomyConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTaxonomyConnectionEdge = Edge &
  TaxonomyConnectionEdge & {
    __typename?: 'RootQueryToTaxonomyConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Taxonomy;
  };

/** Page Info on the &quot;RootQueryToTaxonomyConnection&quot; */
export type RootQueryToTaxonomyConnectionPageInfo = PageInfo &
  TaxonomyConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTaxonomyConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the RootQuery type and the team type */
export type RootQueryToTeamConnection = Connection &
  TeamConnection & {
    __typename?: 'RootQueryToTeamConnection';
    /** Edges for the RootQueryToTeamConnection connection */
    edges: Array<RootQueryToTeamConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Team>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTeamConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTeamConnectionEdge = Edge &
  TeamConnectionEdge & {
    __typename?: 'RootQueryToTeamConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Team;
  };

/** Page Info on the &quot;RootQueryToTeamConnection&quot; */
export type RootQueryToTeamConnectionPageInfo = PageInfo &
  TeamConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTeamConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToTeamConnection connection */
export type RootQueryToTeamConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the teamMember type */
export type RootQueryToTeamMemberConnection = Connection &
  TeamMemberConnection & {
    __typename?: 'RootQueryToTeamMemberConnection';
    /** Edges for the RootQueryToTeamMemberConnection connection */
    edges: Array<RootQueryToTeamMemberConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TeamMember>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTeamMemberConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTeamMemberConnectionEdge = Edge &
  TeamMemberConnectionEdge & {
    __typename?: 'RootQueryToTeamMemberConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TeamMember;
  };

/** Page Info on the &quot;RootQueryToTeamMemberConnection&quot; */
export type RootQueryToTeamMemberConnectionPageInfo = PageInfo &
  TeamMemberConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTeamMemberConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToTeamMemberConnection connection */
export type RootQueryToTeamMemberConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by TeamMembers by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter TeamMembers by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToTeamMemberConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate TeamMembers with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToTeamMemberConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToTeamMemberConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToTeamMemberConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToTeamMemberConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToTeamMemberConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToTeamMemberConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToTeamMemberConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the TermNode type */
export type RootQueryToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'RootQueryToTermNodeConnection';
    /** Edges for the RootQueryToTermNodeConnection connection */
    edges: Array<RootQueryToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'RootQueryToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;RootQueryToTermNodeConnection&quot; */
export type RootQueryToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToTermNodeConnection connection */
export type RootQueryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the terpene type */
export type RootQueryToTerpeneConnection = Connection &
  TerpeneConnection & {
    __typename?: 'RootQueryToTerpeneConnection';
    /** Edges for the RootQueryToTerpeneConnection connection */
    edges: Array<RootQueryToTerpeneConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Terpene>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToTerpeneConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToTerpeneConnectionEdge = Edge &
  TerpeneConnectionEdge & {
    __typename?: 'RootQueryToTerpeneConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Terpene;
  };

/** Page Info on the &quot;RootQueryToTerpeneConnection&quot; */
export type RootQueryToTerpeneConnectionPageInfo = PageInfo &
  TerpeneConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToTerpeneConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToTerpeneConnection connection */
export type RootQueryToTerpeneConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Terpenes by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Terpenes by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Theme type */
export type RootQueryToThemeConnection = Connection &
  ThemeConnection & {
    __typename?: 'RootQueryToThemeConnection';
    /** Edges for the RootQueryToThemeConnection connection */
    edges: Array<RootQueryToThemeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Theme>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToThemeConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToThemeConnectionEdge = Edge &
  ThemeConnectionEdge & {
    __typename?: 'RootQueryToThemeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Theme;
  };

/** Page Info on the &quot;RootQueryToThemeConnection&quot; */
export type RootQueryToThemeConnectionPageInfo = PageInfo &
  ThemeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToThemeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the RootQuery type and the usLanding type */
export type RootQueryToUsLandingConnection = Connection &
  UsLandingConnection & {
    __typename?: 'RootQueryToUsLandingConnection';
    /** Edges for the RootQueryToUsLandingConnection connection */
    edges: Array<RootQueryToUsLandingConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<UsLanding>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToUsLandingConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToUsLandingConnectionEdge = Edge &
  UsLandingConnectionEdge & {
    __typename?: 'RootQueryToUsLandingConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: UsLanding;
  };

/** Page Info on the &quot;RootQueryToUsLandingConnection&quot; */
export type RootQueryToUsLandingConnectionPageInfo = PageInfo &
  UsLandingConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToUsLandingConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToUsLandingConnection connection */
export type RootQueryToUsLandingConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<RootQueryToUsLandingConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate UsLandings with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToUsLandingConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToUsLandingConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToUsLandingConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToUsLandingConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToUsLandingConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToUsLandingConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToUsLandingConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the RootQuery type and the User type */
export type RootQueryToUserConnection = Connection &
  UserConnection & {
    __typename?: 'RootQueryToUserConnection';
    /** Edges for the RootQueryToUserConnection connection */
    edges: Array<RootQueryToUserConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<User>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToUserConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToUserConnectionEdge = Edge &
  UserConnectionEdge & {
    __typename?: 'RootQueryToUserConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: User;
  };

/** Page Info on the &quot;RootQueryToUserConnection&quot; */
export type RootQueryToUserConnectionPageInfo = PageInfo &
  UserConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToUserConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToUserConnection connection */
export type RootQueryToUserConnectionWhereArgs = {
  /** Array of userIds to exclude. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Pass an array of post types to filter results to users who have published posts in those post types. */
  hasPublishedPosts: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of userIds to include. */
  include: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The user login. */
  login: InputMaybe<Scalars['String']>;
  /** An array of logins to include. Users matching one of these logins will be included in results. */
  loginIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of logins to exclude. Users matching one of these logins will not be included in results. */
  loginNotIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The user nicename. */
  nicename: InputMaybe<Scalars['String']>;
  /** An array of nicenames to include. Users matching one of these nicenames will be included in results. */
  nicenameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of nicenames to exclude. Users matching one of these nicenames will not be included in results. */
  nicenameNotIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Paginate users with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<UsersConnectionOrderbyInput>>>;
  /** An array of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role. */
  role: InputMaybe<UserRoleEnum>;
  /** An array of role names. Matched users must have at least one of these roles. */
  roleIn: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** An array of role names to exclude. Users matching one or more of these roles will not be included in results. */
  roleNotIn: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** Search keyword. Searches for possible string matches on columns. When "searchColumns" is left empty, it tries to determine which column to search in based on search string. */
  search: InputMaybe<Scalars['String']>;
  /** Array of column names to be searched. Accepts 'ID', 'login', 'nicename', 'email', 'url'. */
  searchColumns: InputMaybe<Array<InputMaybe<UsersConnectionSearchColumnEnum>>>;
};

/** Connection between the RootQuery type and the UserRole type */
export type RootQueryToUserRoleConnection = Connection &
  UserRoleConnection & {
    __typename?: 'RootQueryToUserRoleConnection';
    /** Edges for the RootQueryToUserRoleConnection connection */
    edges: Array<RootQueryToUserRoleConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<UserRole>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToUserRoleConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToUserRoleConnectionEdge = Edge &
  UserRoleConnectionEdge & {
    __typename?: 'RootQueryToUserRoleConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: UserRole;
  };

/** Page Info on the &quot;RootQueryToUserRoleConnection&quot; */
export type RootQueryToUserRoleConnectionPageInfo = PageInfo &
  UserRoleConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'RootQueryToUserRoleConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the RootQuery type and the webinar type */
export type RootQueryToWebinarConnection = Connection &
  WebinarConnection & {
    __typename?: 'RootQueryToWebinarConnection';
    /** Edges for the RootQueryToWebinarConnection connection */
    edges: Array<RootQueryToWebinarConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Webinar>;
    /** Information about pagination in a connection. */
    pageInfo: RootQueryToWebinarConnectionPageInfo;
  };

/** An edge in a connection */
export type RootQueryToWebinarConnectionEdge = Edge &
  WebinarConnectionEdge & {
    __typename?: 'RootQueryToWebinarConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Webinar;
  };

/** Page Info on the &quot;RootQueryToWebinarConnection&quot; */
export type RootQueryToWebinarConnectionPageInfo = PageInfo &
  WpPageInfo &
  WebinarConnectionPageInfo & {
    __typename?: 'RootQueryToWebinarConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the RootQueryToWebinarConnection connection */
export type RootQueryToWebinarConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter by Webinars by language code (Polylang) */
  language: InputMaybe<LanguageCodeFilterEnum>;
  /** Filter Webinars by one or more languages (Polylang) */
  languages: InputMaybe<Array<LanguageCodeEnum>>;
  metaQuery: InputMaybe<RootQueryToWebinarConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Webinars with offsets */
  offsetPagination: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type RootQueryToWebinarConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<RootQueryToWebinarConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<RootQueryToWebinarConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum RootQueryToWebinarConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type RootQueryToWebinarConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<RootQueryToWebinarConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum RootQueryToWebinarConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** The scholarship type */
export type Scholarship = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Scholarship';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<ScholarshipToScholarshipConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the scholarship object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the scholarship object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<ScholarshipToParentConnectionEdge>;
    /** The password for the scholarship object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Scholarship type and the scholarship type */
    preview: Maybe<ScholarshipToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Scholarship type and the scholarship type */
    revisions: Maybe<ScholarshipToRevisionConnection>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    scholarshipId: Scalars['Int'];
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Scholarship>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Scholarship>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The scholarship type */
export type ScholarshipAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The scholarship type */
export type ScholarshipContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The scholarship type */
export type ScholarshipEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The scholarship type */
export type ScholarshipEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The scholarship type */
export type ScholarshipRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ScholarshipToRevisionConnectionWhereArgs>;
};

/** The scholarship type */
export type ScholarshipTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The scholarship type */
export type ScholarshipTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to scholarship Nodes */
export type ScholarshipConnection = {
  /** A list of edges (relational context) between RootQuery and connected scholarship Nodes */
  edges: Array<ScholarshipConnectionEdge>;
  /** A list of connected scholarship Nodes */
  nodes: Array<Scholarship>;
  /** Information about pagination in a connection. */
  pageInfo: ScholarshipConnectionPageInfo;
};

/** Edge between a Node and a connected scholarship */
export type ScholarshipConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected scholarship Node */
  node: Scholarship;
};

/** Page Info on the connected ScholarshipConnectionEdge */
export type ScholarshipConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ScholarshipIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Scholarship type and the scholarship type */
export type ScholarshipToParentConnectionEdge = Edge &
  OneToOneConnection &
  ScholarshipConnectionEdge & {
    __typename?: 'ScholarshipToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Scholarship;
  };

/** Connection between the Scholarship type and the scholarship type */
export type ScholarshipToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  ScholarshipConnectionEdge & {
    __typename?: 'ScholarshipToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Scholarship;
  };

/** Connection between the Scholarship type and the scholarship type */
export type ScholarshipToRevisionConnection = Connection &
  ScholarshipConnection & {
    __typename?: 'ScholarshipToRevisionConnection';
    /** Edges for the ScholarshipToRevisionConnection connection */
    edges: Array<ScholarshipToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Scholarship>;
    /** Information about pagination in a connection. */
    pageInfo: ScholarshipToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type ScholarshipToRevisionConnectionEdge = Edge &
  ScholarshipConnectionEdge & {
    __typename?: 'ScholarshipToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Scholarship;
  };

/** Page Info on the &quot;ScholarshipToRevisionConnection&quot; */
export type ScholarshipToRevisionConnectionPageInfo = PageInfo &
  ScholarshipConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ScholarshipToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the ScholarshipToRevisionConnection connection */
export type ScholarshipToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<ScholarshipToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type ScholarshipToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<ScholarshipToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<ScholarshipToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum ScholarshipToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type ScholarshipToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<ScholarshipToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum ScholarshipToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Scholarship type and the scholarship type */
export type ScholarshipToScholarshipConnection = Connection &
  ScholarshipConnection & {
    __typename?: 'ScholarshipToScholarshipConnection';
    /** Edges for the ScholarshipToScholarshipConnection connection */
    edges: Array<ScholarshipToScholarshipConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Scholarship>;
    /** Information about pagination in a connection. */
    pageInfo: ScholarshipToScholarshipConnectionPageInfo;
  };

/** An edge in a connection */
export type ScholarshipToScholarshipConnectionEdge = Edge &
  ScholarshipConnectionEdge & {
    __typename?: 'ScholarshipToScholarshipConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Scholarship;
  };

/** Page Info on the &quot;ScholarshipToScholarshipConnection&quot; */
export type ScholarshipToScholarshipConnectionPageInfo = PageInfo &
  ScholarshipConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'ScholarshipToScholarshipConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** The strategy to use when loading the script */
export enum ScriptLoadingStrategyEnum {
  /** Use the script `async` attribute */
  Async = 'ASYNC',
  /** Use the script `defer` attribute */
  Defer = 'DEFER',
}

/** Input for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username or email address. */
  username: Scalars['String'];
};

/** The payload for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  success: Maybe<Scalars['Boolean']>;
  /**
   * The user that the password reset email was sent to
   * @deprecated This field will be removed in a future version of WPGraphQL
   */
  user: Maybe<User>;
};

/** The Seo Framework fields */
export type Seo = {
  __typename?: 'Seo';
  /** Seo canonical url */
  canonical: Maybe<Scalars['String']>;
  /** Seo post description */
  description: Maybe<Scalars['String']>;
  /** Opengraph image */
  images: Maybe<Array<Maybe<MediaItem>>>;
  /** Archiving */
  metaRobotsNoarchive: Maybe<Scalars['Boolean']>;
  /** Link following */
  metaRobotsNofollow: Maybe<Scalars['Boolean']>;
  /** Indexing */
  metaRobotsNoindex: Maybe<Scalars['Boolean']>;
  /** Seo opengraph fields */
  opengraph: Maybe<SeoOpengraph>;
  /** 301 Redirect URL */
  redirect: Maybe<Scalars['String']>;
  /** Seo post title */
  title: Maybe<Scalars['String']>;
  /** The Seo Framework twitter meta tags */
  twitter: Maybe<SeoTwitter>;
};

/** Homepage Integration Settings */
export type SeoHomepage = {
  __typename?: 'SeoHomepage';
  /** Homepage Description String */
  homepageDescription: Maybe<Scalars['String']>;
  /** Homepage Title String */
  homepageTitle: Maybe<Scalars['String']>;
};

/** The Seo Framework opengraph meta tags */
export type SeoOpengraph = {
  __typename?: 'SeoOpengraph';
  /** Opengraph description */
  description: Maybe<Scalars['String']>;
  /** Opengraph title */
  title: Maybe<Scalars['String']>;
  /** Opengraph type */
  type: Maybe<Scalars['String']>;
};

/** Authorized Presence Options */
export type SeoPresence = {
  __typename?: 'SeoPresence';
  /** Logo URL */
  logo: Maybe<Scalars['String']>;
  /** The organization or personal name */
  name: Maybe<Scalars['String']>;
  /** Wether website represents an organization or person */
  type: Maybe<Scalars['String']>;
};

/** The Seo Framework settings fields */
export type SeoSettings = {
  __typename?: 'SeoSettings';
  /** Homepage Integration Settings */
  homepage: Maybe<SeoHomepage>;
  /** Authorized Presence Options */
  presence: Maybe<SeoPresence>;
  /** Title separator setting for seo titles */
  separator: Maybe<Scalars['String']>;
  /** Website url */
  siteUrl: Maybe<Scalars['String']>;
  /** Social Meta Tags Settings */
  social: Maybe<SeoSocial>;
  /** Webmaster Integration Settings */
  webmaster: Maybe<SeoWebmaster>;
};

/** Facebook Integration Settings */
export type SeoSettingsFacebook = {
  __typename?: 'SeoSettingsFacebook';
  /** Facebook App ID */
  appId: Maybe<Scalars['String']>;
  /** Facebook Author Fallback Page */
  authorFallback: Maybe<Scalars['String']>;
  /** Facebook Publisher page */
  publisher: Maybe<Scalars['String']>;
};

/** Twitter Integration Settings */
export type SeoSettingsTwitter = {
  __typename?: 'SeoSettingsTwitter';
  /** Twitter Author Fallback Profile */
  authorFallback: Maybe<Scalars['String']>;
  /** Twitter Card Type */
  cardType: Maybe<Scalars['String']>;
  /** Website Twitter Profile */
  profile: Maybe<Scalars['String']>;
};

/** Social Meta Tags Settings */
export type SeoSocial = {
  __typename?: 'SeoSocial';
  /** Facebook Integration Settings */
  facebook: Maybe<SeoSettingsFacebook>;
  /** Facebook Integration Settings */
  twitter: Maybe<SeoSettingsTwitter>;
};

/** The Seo Framework twitter meta tags */
export type SeoTwitter = {
  __typename?: 'SeoTwitter';
  /** Twitter Description */
  description: Maybe<Scalars['String']>;
  /** Twitter Title */
  title: Maybe<Scalars['String']>;
};

/** Webmaster Integration Settings */
export type SeoWebmaster = {
  __typename?: 'SeoWebmaster';
  /** Baidu Search Resource Platform Code */
  baiduVerification: Maybe<Scalars['String']>;
  /** Bing Webmaster Verification Code */
  bingVerification: Maybe<Scalars['String']>;
  /** Google Search Console Verification Code */
  googleVerification: Maybe<Scalars['String']>;
  /** Pinterest Analytics Verification Code */
  pinterestVerification: Maybe<Scalars['String']>;
  /** Yandex Webmaster Verification Code */
  yandexVerification: Maybe<Scalars['String']>;
};

/** All of the registered settings */
export type Settings = {
  __typename?: 'Settings';
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultCommentStatus: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultPingStatus: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDateFormat: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDescription: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsEmail: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsLanguage: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  generalSettingsStartOfWeek: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimeFormat: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimezone: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTitle: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsUrl: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageForPosts: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageOnFront: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPostsPerPage: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  readingSettingsShowOnFront: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  writingSettingsDefaultCategory: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  writingSettingsDefaultPostFormat: Maybe<Scalars['String']>;
  /** Settings of the the boolean Settings Group */
  writingSettingsUseSmilies: Maybe<Scalars['Boolean']>;
};

/** The strain type */
export type Strain = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Strain';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<StrainToStrainConnection>;
    /** Connection between the Strain type and the aroma type */
    aromas: Maybe<StrainToAromaConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** Connection between the Strain type and the curatedStrainsList type */
    curatedStrainsLists: Maybe<StrainToCuratedStrainsListConnection>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** Connection between the Strain type and the flavor type */
    flavors: Maybe<StrainToFlavorConnection>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the strain object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the strain object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** Connection between the Strain type and the negativeEffect type */
    negativeEffects: Maybe<StrainToNegativeEffectConnection>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<StrainToParentConnectionEdge>;
    /** The password for the strain object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Strain type and the positiveEffect type */
    positiveEffects: Maybe<StrainToPositiveEffectConnection>;
    /** Connection between the Strain type and the strain type */
    preview: Maybe<StrainToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Strain type and the strain type */
    revisions: Maybe<StrainToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Strain details&quot; was set to Show in GraphQL. */
    strainDetails: Maybe<Strain_Straindetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    strainId: Scalars['Int'];
    /** Connection between the Strain type and the strainType type */
    strainTypes: Maybe<StrainToStrainTypeConnection>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the Strain type and the TermNode type */
    terms: Maybe<StrainToTermNodeConnection>;
    /** Connection between the Strain type and the terpene type */
    terpenes: Maybe<StrainToTerpeneConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Strain>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Strain>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The strain type */
export type StrainAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The strain type */
export type StrainAromasArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToAromaConnectionWhereArgs>;
};

/** The strain type */
export type StrainContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The strain type */
export type StrainCuratedStrainsListsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToCuratedStrainsListConnectionWhereArgs>;
};

/** The strain type */
export type StrainEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The strain type */
export type StrainEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The strain type */
export type StrainFlavorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToFlavorConnectionWhereArgs>;
};

/** The strain type */
export type StrainNegativeEffectsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToNegativeEffectConnectionWhereArgs>;
};

/** The strain type */
export type StrainPositiveEffectsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToPositiveEffectConnectionWhereArgs>;
};

/** The strain type */
export type StrainRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToRevisionConnectionWhereArgs>;
};

/** The strain type */
export type StrainStrainTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToStrainTypeConnectionWhereArgs>;
};

/** The strain type */
export type StrainTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToTermNodeConnectionWhereArgs>;
};

/** The strain type */
export type StrainTerpenesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainToTerpeneConnectionWhereArgs>;
};

/** The strain type */
export type StrainTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The strain type */
export type StrainTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Set relationships between the strain to aromas */
export type StrainAromasInput = {
  /** If true, this will append the aroma to existing related aromas. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainAromasNodeInput>>>;
};

/** List of aromas to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainAromasNodeInput = {
  /** The description of the aroma. This field is used to set a description of the aroma if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the aroma. If present, this will be used to connect to the strain. If no existing aroma exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the aroma. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the aroma. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection to strain Nodes */
export type StrainConnection = {
  /** A list of edges (relational context) between RootQuery and connected strain Nodes */
  edges: Array<StrainConnectionEdge>;
  /** A list of connected strain Nodes */
  nodes: Array<Strain>;
  /** Information about pagination in a connection. */
  pageInfo: StrainConnectionPageInfo;
};

/** Edge between a Node and a connected strain */
export type StrainConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected strain Node */
  node: Strain;
};

/** Page Info on the connected StrainConnectionEdge */
export type StrainConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Set relationships between the strain to curatedStrainsLists */
export type StrainCuratedStrainsListsInput = {
  /** If true, this will append the curatedStrainsList to existing related curatedStrainsLists. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainCuratedStrainsListsNodeInput>>>;
};

/** List of curatedStrainsLists to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainCuratedStrainsListsNodeInput = {
  /** The description of the curatedStrainsList. This field is used to set a description of the curatedStrainsList if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the curatedStrainsList. If present, this will be used to connect to the strain. If no existing curatedStrainsList exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the curatedStrainsList. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the curatedStrainsList. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Set relationships between the strain to flavors */
export type StrainFlavorsInput = {
  /** If true, this will append the flavor to existing related flavors. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainFlavorsNodeInput>>>;
};

/** List of flavors to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainFlavorsNodeInput = {
  /** The description of the flavor. This field is used to set a description of the flavor if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the flavor. If present, this will be used to connect to the strain. If no existing flavor exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the flavor. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the flavor. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum StrainIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Set relationships between the strain to negativeEffects */
export type StrainNegativeEffectsInput = {
  /** If true, this will append the negativeEffect to existing related negativeEffects. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainNegativeEffectsNodeInput>>>;
};

/** List of negativeEffects to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainNegativeEffectsNodeInput = {
  /** The description of the negativeEffect. This field is used to set a description of the negativeEffect if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the negativeEffect. If present, this will be used to connect to the strain. If no existing negativeEffect exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the negativeEffect. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the negativeEffect. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Set relationships between the strain to positiveEffects */
export type StrainPositiveEffectsInput = {
  /** If true, this will append the positiveEffect to existing related positiveEffects. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainPositiveEffectsNodeInput>>>;
};

/** List of positiveEffects to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainPositiveEffectsNodeInput = {
  /** The description of the positiveEffect. This field is used to set a description of the positiveEffect if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the positiveEffect. If present, this will be used to connect to the strain. If no existing positiveEffect exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the positiveEffect. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the positiveEffect. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Set relationships between the strain to strainTypes */
export type StrainStrainTypesInput = {
  /** If true, this will append the strainType to existing related strainTypes. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainStrainTypesNodeInput>>>;
};

/** List of strainTypes to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainStrainTypesNodeInput = {
  /** The description of the strainType. This field is used to set a description of the strainType if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the strainType. If present, this will be used to connect to the strain. If no existing strainType exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the strainType. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the strainType. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Set relationships between the strain to terpenes */
export type StrainTerpenesInput = {
  /** If true, this will append the terpene to existing related terpenes. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<StrainTerpenesNodeInput>>>;
};

/** List of terpenes to connect the strain to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type StrainTerpenesNodeInput = {
  /** The description of the terpene. This field is used to set a description of the terpene if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the terpene. If present, this will be used to connect to the strain. If no existing terpene exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the terpene. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the terpene. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection between the Strain type and the aroma type */
export type StrainToAromaConnection = AromaConnection &
  Connection & {
    __typename?: 'StrainToAromaConnection';
    /** Edges for the StrainToAromaConnection connection */
    edges: Array<StrainToAromaConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Aroma>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToAromaConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToAromaConnectionEdge = AromaConnectionEdge &
  Edge & {
    __typename?: 'StrainToAromaConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Aroma;
  };

/** Page Info on the &quot;StrainToAromaConnection&quot; */
export type StrainToAromaConnectionPageInfo = AromaConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'StrainToAromaConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToAromaConnection connection */
export type StrainToAromaConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the curatedStrainsList type */
export type StrainToCuratedStrainsListConnection = Connection &
  CuratedStrainsListConnection & {
    __typename?: 'StrainToCuratedStrainsListConnection';
    /** Edges for the StrainToCuratedStrainsListConnection connection */
    edges: Array<StrainToCuratedStrainsListConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<CuratedStrainsList>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToCuratedStrainsListConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToCuratedStrainsListConnectionEdge =
  CuratedStrainsListConnectionEdge &
    Edge & {
      __typename?: 'StrainToCuratedStrainsListConnectionEdge';
      /** A cursor for use in pagination */
      cursor: Maybe<Scalars['String']>;
      /** The item at the end of the edge */
      node: CuratedStrainsList;
    };

/** Page Info on the &quot;StrainToCuratedStrainsListConnection&quot; */
export type StrainToCuratedStrainsListConnectionPageInfo =
  CuratedStrainsListConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'StrainToCuratedStrainsListConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the StrainToCuratedStrainsListConnection connection */
export type StrainToCuratedStrainsListConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the flavor type */
export type StrainToFlavorConnection = Connection &
  FlavorConnection & {
    __typename?: 'StrainToFlavorConnection';
    /** Edges for the StrainToFlavorConnection connection */
    edges: Array<StrainToFlavorConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Flavor>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToFlavorConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToFlavorConnectionEdge = Edge &
  FlavorConnectionEdge & {
    __typename?: 'StrainToFlavorConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Flavor;
  };

/** Page Info on the &quot;StrainToFlavorConnection&quot; */
export type StrainToFlavorConnectionPageInfo = FlavorConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'StrainToFlavorConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToFlavorConnection connection */
export type StrainToFlavorConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the negativeEffect type */
export type StrainToNegativeEffectConnection = Connection &
  NegativeEffectConnection & {
    __typename?: 'StrainToNegativeEffectConnection';
    /** Edges for the StrainToNegativeEffectConnection connection */
    edges: Array<StrainToNegativeEffectConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<NegativeEffect>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToNegativeEffectConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToNegativeEffectConnectionEdge = Edge &
  NegativeEffectConnectionEdge & {
    __typename?: 'StrainToNegativeEffectConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: NegativeEffect;
  };

/** Page Info on the &quot;StrainToNegativeEffectConnection&quot; */
export type StrainToNegativeEffectConnectionPageInfo =
  NegativeEffectConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'StrainToNegativeEffectConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the StrainToNegativeEffectConnection connection */
export type StrainToNegativeEffectConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the strain type */
export type StrainToParentConnectionEdge = Edge &
  OneToOneConnection &
  StrainConnectionEdge & {
    __typename?: 'StrainToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Strain;
  };

/** Connection between the Strain type and the positiveEffect type */
export type StrainToPositiveEffectConnection = Connection &
  PositiveEffectConnection & {
    __typename?: 'StrainToPositiveEffectConnection';
    /** Edges for the StrainToPositiveEffectConnection connection */
    edges: Array<StrainToPositiveEffectConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<PositiveEffect>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToPositiveEffectConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToPositiveEffectConnectionEdge = Edge &
  PositiveEffectConnectionEdge & {
    __typename?: 'StrainToPositiveEffectConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: PositiveEffect;
  };

/** Page Info on the &quot;StrainToPositiveEffectConnection&quot; */
export type StrainToPositiveEffectConnectionPageInfo = PageInfo &
  PositiveEffectConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToPositiveEffectConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToPositiveEffectConnection connection */
export type StrainToPositiveEffectConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the strain type */
export type StrainToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  StrainConnectionEdge & {
    __typename?: 'StrainToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Strain;
  };

/** Connection between the Strain type and the strain type */
export type StrainToRevisionConnection = Connection &
  StrainConnection & {
    __typename?: 'StrainToRevisionConnection';
    /** Edges for the StrainToRevisionConnection connection */
    edges: Array<StrainToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToRevisionConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'StrainToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;StrainToRevisionConnection&quot; */
export type StrainToRevisionConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToRevisionConnection connection */
export type StrainToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<StrainToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type StrainToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<StrainToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<StrainToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum StrainToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type StrainToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<StrainToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum StrainToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Strain type and the strain type */
export type StrainToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'StrainToStrainConnection';
    /** Edges for the StrainToStrainConnection connection */
    edges: Array<StrainToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'StrainToStrainConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Strain;
  };

/** Page Info on the &quot;StrainToStrainConnection&quot; */
export type StrainToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the Strain type and the strainType type */
export type StrainToStrainTypeConnection = Connection &
  StrainTypeConnection & {
    __typename?: 'StrainToStrainTypeConnection';
    /** Edges for the StrainToStrainTypeConnection connection */
    edges: Array<StrainToStrainTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<StrainType>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToStrainTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToStrainTypeConnectionEdge = Edge &
  StrainTypeConnectionEdge & {
    __typename?: 'StrainToStrainTypeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: StrainType;
  };

/** Page Info on the &quot;StrainToStrainTypeConnection&quot; */
export type StrainToStrainTypeConnectionPageInfo = PageInfo &
  StrainTypeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToStrainTypeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToStrainTypeConnection connection */
export type StrainToStrainTypeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the TermNode type */
export type StrainToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'StrainToTermNodeConnection';
    /** Edges for the StrainToTermNodeConnection connection */
    edges: Array<StrainToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'StrainToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;StrainToTermNodeConnection&quot; */
export type StrainToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToTermNodeConnection connection */
export type StrainToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Strain type and the terpene type */
export type StrainToTerpeneConnection = Connection &
  TerpeneConnection & {
    __typename?: 'StrainToTerpeneConnection';
    /** Edges for the StrainToTerpeneConnection connection */
    edges: Array<StrainToTerpeneConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Terpene>;
    /** Information about pagination in a connection. */
    pageInfo: StrainToTerpeneConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainToTerpeneConnectionEdge = Edge &
  TerpeneConnectionEdge & {
    __typename?: 'StrainToTerpeneConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Terpene;
  };

/** Page Info on the &quot;StrainToTerpeneConnection&quot; */
export type StrainToTerpeneConnectionPageInfo = PageInfo &
  TerpeneConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainToTerpeneConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainToTerpeneConnection connection */
export type StrainToTerpeneConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** The strainType type */
export type StrainType = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'StrainType';
    /** Connection between the StrainType type and the ContentNode type */
    contentNodes: Maybe<StrainTypeToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Strain type details&quot; was set to Show in GraphQL. */
    strainTypeDetails: Maybe<StrainType_Straintypedetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    strainTypeId: Maybe<Scalars['Int']>;
    /** Connection between the StrainType type and the strain type */
    strains: Maybe<StrainTypeToStrainConnection>;
    /** Connection between the StrainType type and the Taxonomy type */
    taxonomy: Maybe<StrainTypeToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<StrainType>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<StrainType>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The strainType type */
export type StrainTypeContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainTypeToContentNodeConnectionWhereArgs>;
};

/** The strainType type */
export type StrainTypeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The strainType type */
export type StrainTypeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The strainType type */
export type StrainTypeStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<StrainTypeToStrainConnectionWhereArgs>;
};

/** The strainType type */
export type StrainTypeTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to strainType Nodes */
export type StrainTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected strainType Nodes */
  edges: Array<StrainTypeConnectionEdge>;
  /** A list of connected strainType Nodes */
  nodes: Array<StrainType>;
  /** Information about pagination in a connection. */
  pageInfo: StrainTypeConnectionPageInfo;
};

/** Edge between a Node and a connected strainType */
export type StrainTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected strainType Node */
  node: StrainType;
};

/** Page Info on the connected StrainTypeConnectionEdge */
export type StrainTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum StrainTypeIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the StrainType type and the ContentNode type */
export type StrainTypeToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'StrainTypeToContentNodeConnection';
    /** Edges for the StrainTypeToContentNodeConnection connection */
    edges: Array<StrainTypeToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: StrainTypeToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainTypeToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'StrainTypeToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;StrainTypeToContentNodeConnection&quot; */
export type StrainTypeToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'StrainTypeToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the StrainTypeToContentNodeConnection connection */
export type StrainTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfStrainTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<StrainTypeToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type StrainTypeToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<StrainTypeToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<StrainTypeToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum StrainTypeToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type StrainTypeToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<StrainTypeToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum StrainTypeToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the StrainType type and the strain type */
export type StrainTypeToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'StrainTypeToStrainConnection';
    /** Edges for the StrainTypeToStrainConnection connection */
    edges: Array<StrainTypeToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: StrainTypeToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type StrainTypeToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'StrainTypeToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;StrainTypeToStrainConnection&quot; */
export type StrainTypeToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'StrainTypeToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the StrainTypeToStrainConnection connection */
export type StrainTypeToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<StrainTypeToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type StrainTypeToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<StrainTypeToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<StrainTypeToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum StrainTypeToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type StrainTypeToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<StrainTypeToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum StrainTypeToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the StrainType type and the Taxonomy type */
export type StrainTypeToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'StrainTypeToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type StrainType_Straintypedetails = AcfFieldGroup & {
  __typename?: 'StrainType_Straintypedetails';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
};

/** Field Group */
export type Strain_Straindetails = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails';
  cannabinoids: Maybe<Array<Maybe<Strain_Straindetails_Cannabinoids>>>;
  cannabisCounselingCta: Maybe<Strain_Straindetails_CannabisCounselingCta>;
  /** Leave blank if there is no composition info for this strain. */
  composition: Maybe<Array<Maybe<Strain_Straindetails_Composition>>>;
  conditions: Maybe<Array<Maybe<Strain_Straindetails_Conditions>>>;
  conditionsDescription: Maybe<Scalars['String']>;
  dosing: Maybe<Scalars['String']>;
  /** Extra info to display next to the effects list. */
  effectsExtraInfo: Maybe<Scalars['String']>;
  faqs: Maybe<Array<Maybe<Strain_Straindetails_Faqs>>>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  flavonoids: Maybe<Scalars['String']>;
  growing: Maybe<Scalars['String']>;
  growingFlowering: Maybe<Scalars['String']>;
  growingHeight: Maybe<Scalars['String']>;
  growingHumidity: Maybe<Scalars['String']>;
  growingImage: Maybe<MediaItem>;
  /** Intro text to display next to the terpenes list. */
  terpenesDescription: Maybe<Scalars['String']>;
  thc: Maybe<Strain_Straindetails_Thc>;
};

/** Field Group */
export type Strain_Straindetails_CannabisCounselingCta = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_CannabisCounselingCta';
  button: Maybe<AcfLink>;
  cannabisCounselingCtaPosition: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  externalImage: Maybe<MediaItem>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  internalImage: Maybe<MediaItem>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Field Group */
export type Strain_Straindetails_Thc = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_Thc';
  /** Extra info to display on the details box, leave empty to omit. */
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /**
   * If the quantity is a range, add the top quantity in this field.&lt;br/&gt;
   * If the quantity is not range &lt;strong&gt;fill with the same value defined in quality from&lt;/strong&gt;.
   */
  quantityEnd: Maybe<Scalars['Float']>;
  /**
   * If the quantity is a range, add the range start in this field.&lt;br/&gt;
   * If the quantity is not a range, add the quantity value here.
   */
  quantityStart: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Strain_Straindetails_Cannabinoids = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_cannabinoids';
  abbreviation: Maybe<Scalars['String']>;
  /** Extra info to display on the details box, leave empty to omit. */
  extraInfo: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /**
   * If the quantity is a range, add the top quantity in this field.&lt;br/&gt;
   * If the quantity is not range &lt;strong&gt;fill with the same value defined in quality from&lt;/strong&gt;.
   */
  quantityEnd: Maybe<Scalars['Float']>;
  /**
   * If the quantity is a range, add the range start in this field.&lt;br/&gt;
   * If the quantity is not a range, add the quantity value here.
   */
  quantityStart: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Strain_Straindetails_Composition = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_composition';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Float']>;
  type: Maybe<Scalars['String']>;
};

/** Field Group */
export type Strain_Straindetails_Conditions = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_conditions';
  condition: Maybe<Strain_Straindetails_Conditions_Condition>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

export type Strain_Straindetails_Conditions_Condition = Condition;

/** Field Group */
export type Strain_Straindetails_Faqs = AcfFieldGroup & {
  __typename?: 'Strain_Straindetails_faqs';
  content: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** The tag type */
export type Tag = DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Tag';
    /** Connection between the Tag type and the ContentNode type */
    contentNodes: Maybe<TagToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Connection between the Tag type and the post type */
    posts: Maybe<TagToPostConnection>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    tagId: Maybe<Scalars['Int']>;
    /** Connection between the Tag type and the Taxonomy type */
    taxonomy: Maybe<TagToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Tag>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Tag>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The tag type */
export type TagContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TagToContentNodeConnectionWhereArgs>;
};

/** The tag type */
export type TagEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The tag type */
export type TagEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The tag type */
export type TagPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TagToPostConnectionWhereArgs>;
};

/** The tag type */
export type TagTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to tag Nodes */
export type TagConnection = {
  /** A list of edges (relational context) between RootQuery and connected tag Nodes */
  edges: Array<TagConnectionEdge>;
  /** A list of connected tag Nodes */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: TagConnectionPageInfo;
};

/** Edge between a Node and a connected tag */
export type TagConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected tag Node */
  node: Tag;
};

/** Page Info on the connected TagConnectionEdge */
export type TagConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TagIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Tag type and the ContentNode type */
export type TagToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'TagToContentNodeConnection';
    /** Edges for the TagToContentNodeConnection connection */
    edges: Array<TagToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: TagToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type TagToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'TagToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;TagToContentNodeConnection&quot; */
export type TagToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'TagToContentNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TagToContentNodeConnection connection */
export type TagToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfTagEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TagToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TagToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TagToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TagToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TagToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TagToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TagToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TagToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Tag type and the post type */
export type TagToPostConnection = Connection &
  PostConnection & {
    __typename?: 'TagToPostConnection';
    /** Edges for the TagToPostConnection connection */
    edges: Array<TagToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: TagToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type TagToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'TagToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;TagToPostConnection&quot; */
export type TagToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TagToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TagToPostConnection connection */
export type TagToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TagToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TagToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TagToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TagToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TagToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TagToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TagToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TagToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Tag type and the Taxonomy type */
export type TagToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'TagToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

export type TaxArray = {
  field: InputMaybe<TaxQueryField>;
  /** Whether or not to include children for hierarchical taxonomies. Defaults to false to improve performance (note that this is opposite of the default for WP_Query). */
  includeChildren: InputMaybe<Scalars['Boolean']>;
  operator: InputMaybe<TaxQueryOperator>;
  taxonomy: InputMaybe<TaxonomyEnum>;
  /** A list of term slugs */
  terms: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Query objects based on taxonomy parameters */
export type TaxQuery = {
  relation: InputMaybe<RelationEnum>;
  taxArray: InputMaybe<Array<InputMaybe<TaxArray>>>;
};

/** Which field to select taxonomy term by. Default value is "term_id" */
export enum TaxQueryField {
  Id = 'ID',
  Name = 'NAME',
  Slug = 'SLUG',
  TaxonomyId = 'TAXONOMY_ID',
}

export enum TaxQueryOperator {
  And = 'AND',
  Exists = 'EXISTS',
  In = 'IN',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
}

/** A taxonomy object */
export type Taxonomy = Node & {
  __typename?: 'Taxonomy';
  /** List of Content Types associated with the Taxonomy */
  connectedContentTypes: Maybe<TaxonomyToContentTypeConnection>;
  /** List of Term Nodes associated with the Taxonomy */
  connectedTerms: Maybe<TaxonomyToTermNodeConnection>;
  /** Description of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;description */
  description: Maybe<Scalars['String']>;
  /** The plural name of the post type within the GraphQL Schema. */
  graphqlPluralName: Maybe<Scalars['String']>;
  /** The singular name of the post type within the GraphQL Schema. */
  graphqlSingleName: Maybe<Scalars['String']>;
  /** Whether the taxonomy is hierarchical */
  hierarchical: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the taxonomy object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Name of the taxonomy shown in the menu. Usually plural. */
  label: Maybe<Scalars['String']>;
  /** The display name of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;label */
  name: Maybe<Scalars['String']>;
  /** Whether the taxonomy is publicly queryable */
  public: Maybe<Scalars['Boolean']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase: Maybe<Scalars['String']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass: Maybe<Scalars['String']>;
  /** Whether to show the taxonomy as part of a tag cloud widget. This field is equivalent to WP_Taxonomy-&gt;show_tagcloud */
  showCloud: Maybe<Scalars['Boolean']>;
  /** Whether to display a column for the taxonomy on its post type listing screens. */
  showInAdminColumn: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type to the GraphQL Schema. */
  showInGraphql: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the admin menu */
  showInMenu: Maybe<Scalars['Boolean']>;
  /** Whether the taxonomy is available for selection in navigation menus. */
  showInNavMenus: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the quick/bulk edit panel. */
  showInQuickEdit: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type route in the REST API &quot;wp/v2&quot; namespace. */
  showInRest: Maybe<Scalars['Boolean']>;
  /** Whether to generate and allow a UI for managing terms in this taxonomy in the admin */
  showUi: Maybe<Scalars['Boolean']>;
};

/** A taxonomy object */
export type TaxonomyConnectedContentTypesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A taxonomy object */
export type TaxonomyConnectedTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Connection to Taxonomy Nodes */
export type TaxonomyConnection = {
  /** A list of edges (relational context) between RootQuery and connected Taxonomy Nodes */
  edges: Array<TaxonomyConnectionEdge>;
  /** A list of connected Taxonomy Nodes */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyConnectionPageInfo;
};

/** Edge between a Node and a connected Taxonomy */
export type TaxonomyConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Taxonomy Node */
  node: Taxonomy;
};

/** Page Info on the connected TaxonomyConnectionEdge */
export type TaxonomyConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Allowed taxonomies */
export enum TaxonomyEnum {
  /** Taxonomy enum affiliate */
  Affiliate = 'AFFILIATE',
  /** Taxonomy enum aroma */
  Aroma = 'AROMA',
  /** Taxonomy enum category */
  Category = 'CATEGORY',
  /** Taxonomy enum medical_conditions_types */
  Conditiontype = 'CONDITIONTYPE',
  /** Taxonomy enum curated_strains_list */
  Curatedstrainslist = 'CURATEDSTRAINSLIST',
  /** Taxonomy enum flavor */
  Flavor = 'FLAVOR',
  /** Taxonomy enum graphql_document_group */
  Graphqldocumentgroup = 'GRAPHQLDOCUMENTGROUP',
  /** Taxonomy enum job */
  Job = 'JOB',
  /** Taxonomy enum state_laws_status */
  Lawstatus = 'LAWSTATUS',
  /** Taxonomy enum negative_effect */
  Negativeeffect = 'NEGATIVEEFFECT',
  /** Taxonomy enum positive_effect */
  Positiveeffect = 'POSITIVEEFFECT',
  /** Taxonomy enum post_author */
  Postauthor = 'POSTAUTHOR',
  /** Taxonomy enum post_format */
  Postformat = 'POSTFORMAT',
  /** Taxonomy enum strain_type */
  Straintype = 'STRAINTYPE',
  /** Taxonomy enum post_tag */
  Tag = 'TAG',
  /** Taxonomy enum job_area */
  Team = 'TEAM',
  /** Taxonomy enum terpene */
  Terpene = 'TERPENE',
}

/** The Type of Identifier used to fetch a single Taxonomy node. To be used along with the "id" field. Default is "ID". */
export enum TaxonomyIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the taxonomy */
  Name = 'NAME',
}

/** Connection between the Taxonomy type and the ContentType type */
export type TaxonomyToContentTypeConnection = Connection &
  ContentTypeConnection & {
    __typename?: 'TaxonomyToContentTypeConnection';
    /** Edges for the TaxonomyToContentTypeConnection connection */
    edges: Array<TaxonomyToContentTypeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentType>;
    /** Information about pagination in a connection. */
    pageInfo: TaxonomyToContentTypeConnectionPageInfo;
  };

/** An edge in a connection */
export type TaxonomyToContentTypeConnectionEdge = ContentTypeConnectionEdge &
  Edge & {
    __typename?: 'TaxonomyToContentTypeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentType;
  };

/** Page Info on the &quot;TaxonomyToContentTypeConnection&quot; */
export type TaxonomyToContentTypeConnectionPageInfo =
  ContentTypeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'TaxonomyToContentTypeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the Taxonomy type and the TermNode type */
export type TaxonomyToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'TaxonomyToTermNodeConnection';
    /** Edges for the TaxonomyToTermNodeConnection connection */
    edges: Array<TaxonomyToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: TaxonomyToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type TaxonomyToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'TaxonomyToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;TaxonomyToTermNodeConnection&quot; */
export type TaxonomyToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TaxonomyToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** The team type */
export type Team = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Team';
    /** Connection between the Team type and the ContentNode type */
    contentNodes: Maybe<TeamToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Connection between the Team type and the jobOffer type */
    jobOffers: Maybe<TeamToJobOfferConnection>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Team type and the Taxonomy type */
    taxonomy: Maybe<TeamToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    teamId: Maybe<Scalars['Int']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The team type */
export type TeamContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TeamToContentNodeConnectionWhereArgs>;
};

/** The team type */
export type TeamEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The team type */
export type TeamEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The team type */
export type TeamJobOffersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TeamToJobOfferConnectionWhereArgs>;
};

/** Connection to team Nodes */
export type TeamConnection = {
  /** A list of edges (relational context) between RootQuery and connected team Nodes */
  edges: Array<TeamConnectionEdge>;
  /** A list of connected team Nodes */
  nodes: Array<Team>;
  /** Information about pagination in a connection. */
  pageInfo: TeamConnectionPageInfo;
};

/** Edge between a Node and a connected team */
export type TeamConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected team Node */
  node: Team;
};

/** Page Info on the connected TeamConnectionEdge */
export type TeamConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TeamIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** The teamMember type */
export type TeamMember = ContentNode &
  DatabaseIdentifier &
  Node &
  NodeWithContentEditor &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'TeamMember';
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<TeamMemberToTeamMemberConnection>;
    /** The content of the post. */
    content: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the team object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the team object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Connection between the TeamMember type and the job type */
    jobs: Maybe<TeamMemberToJobConnection>;
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<TeamMemberToParentConnectionEdge>;
    /** The password for the team object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the TeamMember type and the teamMember type */
    preview: Maybe<TeamMemberToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the TeamMember type and the teamMember type */
    revisions: Maybe<TeamMemberToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    teamMemberId: Scalars['Int'];
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** Connection between the TeamMember type and the TermNode type */
    terms: Maybe<TeamMemberToTermNodeConnection>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<TeamMember>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<TeamMember>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The teamMember type */
export type TeamMemberAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The teamMember type */
export type TeamMemberContentArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The teamMember type */
export type TeamMemberEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The teamMember type */
export type TeamMemberEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The teamMember type */
export type TeamMemberJobsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TeamMemberToJobConnectionWhereArgs>;
};

/** The teamMember type */
export type TeamMemberRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TeamMemberToRevisionConnectionWhereArgs>;
};

/** The teamMember type */
export type TeamMemberTermsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TeamMemberToTermNodeConnectionWhereArgs>;
};

/** The teamMember type */
export type TeamMemberTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The teamMember type */
export type TeamMemberTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to teamMember Nodes */
export type TeamMemberConnection = {
  /** A list of edges (relational context) between RootQuery and connected teamMember Nodes */
  edges: Array<TeamMemberConnectionEdge>;
  /** A list of connected teamMember Nodes */
  nodes: Array<TeamMember>;
  /** Information about pagination in a connection. */
  pageInfo: TeamMemberConnectionPageInfo;
};

/** Edge between a Node and a connected teamMember */
export type TeamMemberConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected teamMember Node */
  node: TeamMember;
};

/** Page Info on the connected TeamMemberConnectionEdge */
export type TeamMemberConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TeamMemberIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Set relationships between the teamMember to jobs */
export type TeamMemberJobsInput = {
  /** If true, this will append the job to existing related jobs. If false, this will replace existing relationships. Default true. */
  append: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes: InputMaybe<Array<InputMaybe<TeamMemberJobsNodeInput>>>;
};

/** List of jobs to connect the teamMember to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type TeamMemberJobsNodeInput = {
  /** The description of the job. This field is used to set a description of the job if a new one is created during the mutation. */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the job. If present, this will be used to connect to the teamMember. If no existing job exists with this ID, no connection will be made. */
  id: InputMaybe<Scalars['ID']>;
  /** The name of the job. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name: InputMaybe<Scalars['String']>;
  /** The slug of the job. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug: InputMaybe<Scalars['String']>;
};

/** Connection between the TeamMember type and the job type */
export type TeamMemberToJobConnection = Connection &
  JobConnection & {
    __typename?: 'TeamMemberToJobConnection';
    /** Edges for the TeamMemberToJobConnection connection */
    edges: Array<TeamMemberToJobConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Job>;
    /** Information about pagination in a connection. */
    pageInfo: TeamMemberToJobConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamMemberToJobConnectionEdge = Edge &
  JobConnectionEdge & {
    __typename?: 'TeamMemberToJobConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Job;
  };

/** Page Info on the &quot;TeamMemberToJobConnection&quot; */
export type TeamMemberToJobConnectionPageInfo = JobConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'TeamMemberToJobConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TeamMemberToJobConnection connection */
export type TeamMemberToJobConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the TeamMember type and the teamMember type */
export type TeamMemberToParentConnectionEdge = Edge &
  OneToOneConnection &
  TeamMemberConnectionEdge & {
    __typename?: 'TeamMemberToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: TeamMember;
  };

/** Connection between the TeamMember type and the teamMember type */
export type TeamMemberToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  TeamMemberConnectionEdge & {
    __typename?: 'TeamMemberToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: TeamMember;
  };

/** Connection between the TeamMember type and the teamMember type */
export type TeamMemberToRevisionConnection = Connection &
  TeamMemberConnection & {
    __typename?: 'TeamMemberToRevisionConnection';
    /** Edges for the TeamMemberToRevisionConnection connection */
    edges: Array<TeamMemberToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TeamMember>;
    /** Information about pagination in a connection. */
    pageInfo: TeamMemberToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamMemberToRevisionConnectionEdge = Edge &
  TeamMemberConnectionEdge & {
    __typename?: 'TeamMemberToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TeamMember;
  };

/** Page Info on the &quot;TeamMemberToRevisionConnection&quot; */
export type TeamMemberToRevisionConnectionPageInfo = PageInfo &
  TeamMemberConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TeamMemberToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TeamMemberToRevisionConnection connection */
export type TeamMemberToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TeamMemberToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TeamMemberToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TeamMemberToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TeamMemberToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TeamMemberToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TeamMemberToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TeamMemberToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TeamMemberToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the TeamMember type and the teamMember type */
export type TeamMemberToTeamMemberConnection = Connection &
  TeamMemberConnection & {
    __typename?: 'TeamMemberToTeamMemberConnection';
    /** Edges for the TeamMemberToTeamMemberConnection connection */
    edges: Array<TeamMemberToTeamMemberConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TeamMember>;
    /** Information about pagination in a connection. */
    pageInfo: TeamMemberToTeamMemberConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamMemberToTeamMemberConnectionEdge = Edge &
  TeamMemberConnectionEdge & {
    __typename?: 'TeamMemberToTeamMemberConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: TeamMember;
  };

/** Page Info on the &quot;TeamMemberToTeamMemberConnection&quot; */
export type TeamMemberToTeamMemberConnectionPageInfo = PageInfo &
  TeamMemberConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TeamMemberToTeamMemberConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Connection between the TeamMember type and the TermNode type */
export type TeamMemberToTermNodeConnection = Connection &
  TermNodeConnection & {
    __typename?: 'TeamMemberToTermNodeConnection';
    /** Edges for the TeamMemberToTermNodeConnection connection */
    edges: Array<TeamMemberToTermNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<TermNode>;
    /** Information about pagination in a connection. */
    pageInfo: TeamMemberToTermNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamMemberToTermNodeConnectionEdge = Edge &
  TermNodeConnectionEdge & {
    __typename?: 'TeamMemberToTermNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: TermNode;
  };

/** Page Info on the &quot;TeamMemberToTermNodeConnection&quot; */
export type TeamMemberToTermNodeConnectionPageInfo = PageInfo &
  TermNodeConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TeamMemberToTermNodeConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TeamMemberToTermNodeConnection connection */
export type TeamMemberToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Team type and the ContentNode type */
export type TeamToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'TeamToContentNodeConnection';
    /** Edges for the TeamToContentNodeConnection connection */
    edges: Array<TeamToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: TeamToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'TeamToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;TeamToContentNodeConnection&quot; */
export type TeamToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'TeamToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the TeamToContentNodeConnection connection */
export type TeamToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfTeamEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TeamToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TeamToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TeamToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TeamToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TeamToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TeamToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TeamToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TeamToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Team type and the jobOffer type */
export type TeamToJobOfferConnection = Connection &
  JobOfferConnection & {
    __typename?: 'TeamToJobOfferConnection';
    /** Edges for the TeamToJobOfferConnection connection */
    edges: Array<TeamToJobOfferConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<JobOffer>;
    /** Information about pagination in a connection. */
    pageInfo: TeamToJobOfferConnectionPageInfo;
  };

/** An edge in a connection */
export type TeamToJobOfferConnectionEdge = Edge &
  JobOfferConnectionEdge & {
    __typename?: 'TeamToJobOfferConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: JobOffer;
  };

/** Page Info on the &quot;TeamToJobOfferConnection&quot; */
export type TeamToJobOfferConnectionPageInfo = JobOfferConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'TeamToJobOfferConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TeamToJobOfferConnection connection */
export type TeamToJobOfferConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TeamToJobOfferConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TeamToJobOfferConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TeamToJobOfferConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TeamToJobOfferConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TeamToJobOfferConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TeamToJobOfferConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TeamToJobOfferConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TeamToJobOfferConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Team type and the Taxonomy type */
export type TeamToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'TeamToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNode = {
  /** The number of objects connected to the object */
  count: Maybe<Scalars['Int']>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name: Maybe<Scalars['String']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug: Maybe<Scalars['String']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Connection to TermNode Nodes */
export type TermNodeConnection = {
  /** A list of edges (relational context) between RootQuery and connected TermNode Nodes */
  edges: Array<TermNodeConnectionEdge>;
  /** A list of connected TermNode Nodes */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeConnectionPageInfo;
};

/** Edge between a Node and a connected TermNode */
export type TermNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected TermNode Node */
  node: TermNode;
};

/** Page Info on the connected TermNodeConnectionEdge */
export type TermNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export enum TermNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the TermNode type and the EnqueuedScript type */
export type TermNodeToEnqueuedScriptConnection = Connection &
  EnqueuedScriptConnection & {
    __typename?: 'TermNodeToEnqueuedScriptConnection';
    /** Edges for the TermNodeToEnqueuedScriptConnection connection */
    edges: Array<TermNodeToEnqueuedScriptConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedScript>;
    /** Information about pagination in a connection. */
    pageInfo: TermNodeToEnqueuedScriptConnectionPageInfo;
  };

/** An edge in a connection */
export type TermNodeToEnqueuedScriptConnectionEdge = Edge &
  EnqueuedScriptConnectionEdge & {
    __typename?: 'TermNodeToEnqueuedScriptConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedScript;
  };

/** Page Info on the &quot;TermNodeToEnqueuedScriptConnection&quot; */
export type TermNodeToEnqueuedScriptConnectionPageInfo =
  EnqueuedScriptConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'TermNodeToEnqueuedScriptConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the TermNode type and the EnqueuedStylesheet type */
export type TermNodeToEnqueuedStylesheetConnection = Connection &
  EnqueuedStylesheetConnection & {
    __typename?: 'TermNodeToEnqueuedStylesheetConnection';
    /** Edges for the TermNodeToEnqueuedStylesheetConnection connection */
    edges: Array<TermNodeToEnqueuedStylesheetConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedStylesheet>;
    /** Information about pagination in a connection. */
    pageInfo: TermNodeToEnqueuedStylesheetConnectionPageInfo;
  };

/** An edge in a connection */
export type TermNodeToEnqueuedStylesheetConnectionEdge = Edge &
  EnqueuedStylesheetConnectionEdge & {
    __typename?: 'TermNodeToEnqueuedStylesheetConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedStylesheet;
  };

/** Page Info on the &quot;TermNodeToEnqueuedStylesheetConnection&quot; */
export type TermNodeToEnqueuedStylesheetConnectionPageInfo =
  EnqueuedStylesheetConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'TermNodeToEnqueuedStylesheetConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Options for ordering the connection by */
export enum TermObjectsConnectionOrderbyEnum {
  /** Order the connection by item count. */
  Count = 'COUNT',
  /** Order the connection by description. */
  Description = 'DESCRIPTION',
  /** Order the connection by name. */
  Name = 'NAME',
  /** Order the connection by slug. */
  Slug = 'SLUG',
  /** Order the connection by term group. */
  TermGroup = 'TERM_GROUP',
  /** Order the connection by term id. */
  TermId = 'TERM_ID',
  /** Order the connection by term order. */
  TermOrder = 'TERM_ORDER',
}

/** The terpene type */
export type Terpene = DatabaseIdentifier &
  Node &
  TermNode &
  UniformResourceIdentifiable & {
    __typename?: 'Terpene';
    /** Connection between the Terpene type and the ContentNode type */
    contentNodes: Maybe<TerpeneToContentNodeConnection>;
    /** The number of objects connected to the object */
    count: Maybe<Scalars['Int']>;
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** The description of the object */
    description: Maybe<Scalars['String']>;
    /** Connection between the TermNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<TermNodeToEnqueuedScriptConnection>;
    /** Connection between the TermNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<TermNodeToEnqueuedStylesheetConnection>;
    /** The globally unique ID for the object */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** List available translations for this post */
    language: Maybe<Language>;
    /** The link to the term */
    link: Maybe<Scalars['String']>;
    /** The human friendly name of the object. */
    name: Maybe<Scalars['String']>;
    /** Taxonomy Seo fields */
    seo: Maybe<Seo>;
    /** An alphanumeric identifier for the object unique to its type. */
    slug: Maybe<Scalars['String']>;
    /** Connection between the Terpene type and the strain type */
    strains: Maybe<TerpeneToStrainConnection>;
    /** Connection between the Terpene type and the Taxonomy type */
    taxonomy: Maybe<TerpeneToTaxonomyConnectionEdge>;
    /** The name of the taxonomy that the object is associated with */
    taxonomyName: Maybe<Scalars['String']>;
    /** The ID of the term group that this term object belongs to */
    termGroupId: Maybe<Scalars['Int']>;
    /** The taxonomy ID that the object is associated with */
    termTaxonomyId: Maybe<Scalars['Int']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Terpene details&quot; was set to Show in GraphQL. */
    terpeneDetails: Maybe<Terpene_Terpenedetails>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of databaseId
     */
    terpeneId: Maybe<Scalars['Int']>;
    /** Get specific translation version of this object */
    translation: Maybe<Terpene>;
    /** List all translated versions of this term */
    translations: Maybe<Array<Maybe<Terpene>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
  };

/** The terpene type */
export type TerpeneContentNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TerpeneToContentNodeConnectionWhereArgs>;
};

/** The terpene type */
export type TerpeneEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The terpene type */
export type TerpeneEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The terpene type */
export type TerpeneStrainsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<TerpeneToStrainConnectionWhereArgs>;
};

/** The terpene type */
export type TerpeneTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to terpene Nodes */
export type TerpeneConnection = {
  /** A list of edges (relational context) between RootQuery and connected terpene Nodes */
  edges: Array<TerpeneConnectionEdge>;
  /** A list of connected terpene Nodes */
  nodes: Array<Terpene>;
  /** Information about pagination in a connection. */
  pageInfo: TerpeneConnectionPageInfo;
};

/** Edge between a Node and a connected terpene */
export type TerpeneConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected terpene Node */
  node: Terpene;
};

/** Page Info on the connected TerpeneConnectionEdge */
export type TerpeneConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TerpeneIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
}

/** Connection between the Terpene type and the ContentNode type */
export type TerpeneToContentNodeConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'TerpeneToContentNodeConnection';
    /** Edges for the TerpeneToContentNodeConnection connection */
    edges: Array<TerpeneToContentNodeConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: TerpeneToContentNodeConnectionPageInfo;
  };

/** An edge in a connection */
export type TerpeneToContentNodeConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'TerpeneToContentNodeConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;TerpeneToContentNodeConnection&quot; */
export type TerpeneToContentNodeConnectionPageInfo =
  ContentNodeConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'TerpeneToContentNodeConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Arguments for filtering the TerpeneToContentNodeConnection connection */
export type TerpeneToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypesOfTerpeneEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TerpeneToContentNodeConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TerpeneToContentNodeConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TerpeneToContentNodeConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TerpeneToContentNodeConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TerpeneToContentNodeConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TerpeneToContentNodeConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TerpeneToContentNodeConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TerpeneToContentNodeConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Terpene type and the strain type */
export type TerpeneToStrainConnection = Connection &
  StrainConnection & {
    __typename?: 'TerpeneToStrainConnection';
    /** Edges for the TerpeneToStrainConnection connection */
    edges: Array<TerpeneToStrainConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Strain>;
    /** Information about pagination in a connection. */
    pageInfo: TerpeneToStrainConnectionPageInfo;
  };

/** An edge in a connection */
export type TerpeneToStrainConnectionEdge = Edge &
  StrainConnectionEdge & {
    __typename?: 'TerpeneToStrainConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Strain;
  };

/** Page Info on the &quot;TerpeneToStrainConnection&quot; */
export type TerpeneToStrainConnectionPageInfo = PageInfo &
  StrainConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'TerpeneToStrainConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the TerpeneToStrainConnection connection */
export type TerpeneToStrainConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<TerpeneToStrainConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type TerpeneToStrainConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<TerpeneToStrainConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<TerpeneToStrainConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum TerpeneToStrainConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type TerpeneToStrainConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<TerpeneToStrainConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum TerpeneToStrainConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Terpene type and the Taxonomy type */
export type TerpeneToTaxonomyConnectionEdge = Edge &
  OneToOneConnection &
  TaxonomyConnectionEdge & {
    __typename?: 'TerpeneToTaxonomyConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Taxonomy;
  };

/** Field Group */
export type Terpene_Terpenedetails = AcfFieldGroup & {
  __typename?: 'Terpene_Terpenedetails';
  color: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

/** A theme object */
export type Theme = Node & {
  __typename?: 'Theme';
  /** Name of the theme author(s), could also be a company name. This field is equivalent to WP_Theme-&gt;get( &quot;Author&quot; ). */
  author: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;AuthorURI&quot; ). */
  authorUri: Maybe<Scalars['String']>;
  /** The description of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Description&quot; ). */
  description: Maybe<Scalars['String']>;
  /** The globally unique identifier of the theme object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** Display name of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Name&quot; ). */
  name: Maybe<Scalars['String']>;
  /** The URL of the screenshot for the theme. The screenshot is intended to give an overview of what the theme looks like. This field is equivalent to WP_Theme-&gt;get_screenshot(). */
  screenshot: Maybe<Scalars['String']>;
  /** The theme slug is used to internally match themes. Theme slugs can have subdirectories like: my-theme/sub-theme. This field is equivalent to WP_Theme-&gt;get_stylesheet(). */
  slug: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;Tags&quot; ). */
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A URI if the theme has a website associated with it. The Theme URI is handy for directing users to a theme site for support etc. This field is equivalent to WP_Theme-&gt;get( &quot;ThemeURI&quot; ). */
  themeUri: Maybe<Scalars['String']>;
  /** The current version of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Version&quot; ). */
  version: Maybe<Scalars['String']>;
};

/** Connection to Theme Nodes */
export type ThemeConnection = {
  /** A list of edges (relational context) between RootQuery and connected Theme Nodes */
  edges: Array<ThemeConnectionEdge>;
  /** A list of connected Theme Nodes */
  nodes: Array<Theme>;
  /** Information about pagination in a connection. */
  pageInfo: ThemeConnectionPageInfo;
};

/** Edge between a Node and a connected Theme */
export type ThemeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected Theme Node */
  node: Theme;
};

/** Page Info on the connected ThemeConnectionEdge */
export type ThemeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Theme Settings options. */
export type ThemeSettings = {
  __typename?: 'ThemeSettings';
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
  activeStates: Maybe<ThemeSettings_Activestates>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Leafwell Open States&quot; was set to Show in GraphQL. */
  leafwellOpenStates: Maybe<ThemeSettings_Leafwellopenstates>;
  pageSlug: Maybe<Scalars['String']>;
  pageTitle: Maybe<Scalars['String']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Site info&quot; was set to Show in GraphQL. */
  siteInfo: Maybe<ThemeSettings_Siteinfo>;
};

/** Field Group */
export type ThemeSettings_Activestates = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type ThemeSettings_Leafwellopenstates = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Leafwellopenstates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  leafwellOpenStates: Maybe<
    Array<Maybe<ThemeSettings_Leafwellopenstates_LeafwellOpenStates>>
  >;
};

/** Field Group */
export type ThemeSettings_Leafwellopenstates_LeafwellOpenStates =
  AcfFieldGroup & {
    __typename?: 'ThemeSettings_Leafwellopenstates_leafwellOpenStates';
    /** The name of the ACF Field Group */
    fieldGroupName: Maybe<Scalars['String']>;
    openStates: Maybe<Scalars['String']>;
    renewalsOnly: Maybe<Scalars['Boolean']>;
  };

/** Field Group */
export type ThemeSettings_Siteinfo = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo';
  app: Maybe<ThemeSettings_Siteinfo_App>;
  authorsPageRoundedSection: Maybe<ThemeSettings_Siteinfo_AuthorsPageRoundedSection>;
  blogMedicalCardCta: Maybe<ThemeSettings_Siteinfo_BlogMedicalCardCta>;
  blogPage: Maybe<ThemeSettings_Siteinfo_BlogPage>;
  cannabisGuidanceCta: Maybe<ThemeSettings_Siteinfo_CannabisGuidanceCta>;
  cardPage: Maybe<ThemeSettings_Siteinfo_CardPage>;
  conditionTypesImage: Maybe<MediaItem>;
  conditionsPage: Maybe<ThemeSettings_Siteinfo_ConditionsPage>;
  conditionsTopCtaImage: Maybe<MediaItem>;
  contacts: Maybe<Scalars['String']>;
  contactsPage: Maybe<ThemeSettings_Siteinfo_ContactsPage>;
  copyright: Maybe<Scalars['String']>;
  /**
   * This needs to be set for each language individually.&lt;br /&gt;
   * You can change language on the menu bar at the top of the screen.
   */
  disableMedicalCard: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  lawsPage: Maybe<ThemeSettings_Siteinfo_LawsPage>;
  /** This image is used for SEO microdata */
  logo: Maybe<MediaItem>;
  mustReadTag: Maybe<Tag>;
  newsCategory: Maybe<Category>;
  newsletterForm: Maybe<ThemeSettings_Siteinfo_NewsletterForm>;
  partnerMapPage: Maybe<ThemeSettings_Siteinfo_PartnerMapPage>;
  /** Email addresses that receive new review notifications, separated by comma (example: aa@drfrank.test, bb@drfrank.test) */
  reviewModerators: Maybe<Scalars['String']>;
  social: Maybe<ThemeSettings_Siteinfo_Social>;
  strainsArchivePage: Maybe<ThemeSettings_Siteinfo_StrainsArchivePage>;
  strainsDefaultPhoto: Maybe<MediaItem>;
  strainsLandingPage: Maybe<ThemeSettings_Siteinfo_StrainsLandingPage>;
  trustpilotNumberReviews: Maybe<Scalars['Float']>;
  trustpilotRating: Maybe<Scalars['Float']>;
};

/** Field Group */
export type ThemeSettings_Siteinfo_App = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_App';
  appStore: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  googlePlay: Maybe<Scalars['String']>;
};

/** Field Group */
export type ThemeSettings_Siteinfo_AuthorsPageRoundedSection = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_AuthorsPageRoundedSection';
  color: Maybe<Scalars['String']>;
  /** 3 columns layout is only available if subtitle is not empty. */
  columns: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  /** Add content to be displayed on the right side of the section. Only applies if image alignment is center. */
  contentRight: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  link: Maybe<AcfLink>;
  sectionId: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline underline-green-400 underline-offset-small&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  title: Maybe<Scalars['String']>;
  titleFont: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

/** Field Group */
export type ThemeSettings_Siteinfo_BlogMedicalCardCta = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_BlogMedicalCardCta';
  backgroundColor: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  image: Maybe<MediaItem>;
  imageAlignment: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

export type ThemeSettings_Siteinfo_BlogPage = Page;

/** Field Group */
export type ThemeSettings_Siteinfo_CannabisGuidanceCta = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_CannabisGuidanceCta';
  defaultBlogPostImage: Maybe<MediaItem>;
  defaultButtonLink: Maybe<AcfLink>;
  defaultExternalImage: Maybe<MediaItem>;
  defaultInternalImage: Maybe<MediaItem>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
};

export type ThemeSettings_Siteinfo_CardPage = Page;

export type ThemeSettings_Siteinfo_ConditionsPage = Page;

export type ThemeSettings_Siteinfo_ContactsPage = Page;

export type ThemeSettings_Siteinfo_LawsPage = Page;

/** Field Group */
export type ThemeSettings_Siteinfo_NewsletterForm = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_NewsletterForm';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** The form ID from hubspot */
  formId: Maybe<Scalars['String']>;
  /**
   * Use these tags for the text layout:&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;circle&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to wrap text in circle highlight&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;text-green&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use green color for text&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;underline&quot;&gt;content inside&lt;/em&gt;&lt;/code&gt; - to use zigzag green underline&lt;br/&gt;
   * &lt;code&gt;&lt;span class=&quot;underline&quot;&gt;content inside&lt;/span&gt;&lt;/code&gt; - to use simple green underline&lt;br/&gt;
   * &lt;code&gt;&lt;em data-highlight=&quot;leaf&quot;&gt;&lt;/em&gt;&lt;/code&gt; - to use leaf icon
   */
  label: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ThemeSettings_Siteinfo_PartnerMapPage = Page;

/** Field Group */
export type ThemeSettings_Siteinfo_Social = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_Social';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<ThemeSettings_Siteinfo_Social_Items>>>;
  label: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

/** Field Group */
export type ThemeSettings_Siteinfo_Social_Items = AcfFieldGroup & {
  __typename?: 'ThemeSettings_Siteinfo_Social_items';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  socialNetwork: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ThemeSettings_Siteinfo_StrainsArchivePage = Page;

export type ThemeSettings_Siteinfo_StrainsLandingPage = Page;

/** Any node that has a URI */
export type UniformResourceIdentifiable = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The unique resource identifier path */
  uri: Maybe<Scalars['String']>;
};

/** Input for the updateAffiliate mutation. */
export type UpdateAffiliateInput = {
  /** The slug that the affiliate will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the affiliate object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the affiliate object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the affiliate object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateAffiliate mutation. */
export type UpdateAffiliatePayload = {
  __typename?: 'UpdateAffiliatePayload';
  /** The created affiliate */
  affiliate: Maybe<Affiliate>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the updateAroma mutation. */
export type UpdateAromaInput = {
  /** The slug that the aroma will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the aroma object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the aroma object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the aroma object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateAroma mutation. */
export type UpdateAromaPayload = {
  __typename?: 'UpdateAromaPayload';
  /** The created aroma */
  aroma: Maybe<Aroma>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the updateCategory mutation. */
export type UpdateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the category object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the category object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** The ID of the category that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateCategory mutation. */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The created category */
  category: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Input for the updateComment mutation. */
export type UpdateCommentInput = {
  /** The approval status of the comment. */
  approved: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the comment being updated. */
  id: Scalars['ID'];
  /** Parent comment ID of current comment. */
  parent: InputMaybe<Scalars['ID']>;
  /** The approval status of the comment */
  status: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type: InputMaybe<Scalars['String']>;
};

/** The payload for the updateComment mutation. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success: Maybe<Scalars['Boolean']>;
};

/** Input for the updateCondition mutation. */
export type UpdateConditionInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Set connections between the condition and conditionTypes */
  conditionTypes: InputMaybe<ConditionConditionTypesInput>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the condition object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateCondition mutation. */
export type UpdateConditionPayload = {
  __typename?: 'UpdateConditionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  condition: Maybe<Condition>;
};

/** Input for the updateConditionType mutation. */
export type UpdateConditionTypeInput = {
  /** The slug that the medical_conditions_types will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the medical_conditions_types object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the conditionType object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the medical_conditions_types object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** The ID of the medical_conditions_types that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateConditionType mutation. */
export type UpdateConditionTypePayload = {
  __typename?: 'UpdateConditionTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created medical_conditions_types */
  conditionType: Maybe<ConditionType>;
};

/** Input for the updateCuratedStrainsList mutation. */
export type UpdateCuratedStrainsListInput = {
  /** The slug that the curated_strains_list will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the curated_strains_list object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the curatedStrainsList object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the curated_strains_list object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateCuratedStrainsList mutation. */
export type UpdateCuratedStrainsListPayload = {
  __typename?: 'UpdateCuratedStrainsListPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created curated_strains_list */
  curatedStrainsList: Maybe<CuratedStrainsList>;
};

/** Input for the updateEvent mutation. */
export type UpdateEventInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the event object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateEvent mutation. */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  event: Maybe<Event>;
};

/** Input for the updateFaq mutation. */
export type UpdateFaqInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the faq object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateFaq mutation. */
export type UpdateFaqPayload = {
  __typename?: 'UpdateFaqPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  faq: Maybe<Faq>;
};

/** Input for the updateFlavor mutation. */
export type UpdateFlavorInput = {
  /** The slug that the flavor will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the flavor object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the flavor object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the flavor object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateFlavor mutation. */
export type UpdateFlavorPayload = {
  __typename?: 'UpdateFlavorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created flavor */
  flavor: Maybe<Flavor>;
};

/** Input for the updateGraphqlDocumentGroup mutation. */
export type UpdateGraphqlDocumentGroupInput = {
  /** The slug that the graphql_document_group will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the graphql_document_group object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the graphqlDocumentGroup object to update */
  id: Scalars['ID'];
  /** The name of the graphql_document_group object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateGraphqlDocumentGroup mutation. */
export type UpdateGraphqlDocumentGroupPayload = {
  __typename?: 'UpdateGraphqlDocumentGroupPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created graphql_document_group */
  graphqlDocumentGroup: Maybe<GraphqlDocumentGroup>;
};

/** Input for the updateGraphqlDocument mutation. */
export type UpdateGraphqlDocumentInput = {
  /** Alias names for saved GraphQL query documents */
  alias: InputMaybe<Array<Scalars['String']>>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Description for the saved GraphQL document */
  description: InputMaybe<Scalars['String']>;
  /** Allow, deny or default access grant for specific query */
  grant: InputMaybe<Scalars['String']>;
  /** Set connections between the graphqlDocument and graphqlDocumentGroups */
  graphqlDocumentGroups: InputMaybe<GraphqlDocumentGraphqlDocumentGroupsInput>;
  /** The ID of the graphqlDocument object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  /** HTTP Cache-Control max-age directive for a saved GraphQL document */
  maxAgeHeader: InputMaybe<Scalars['Int']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateGraphqlDocument mutation. */
export type UpdateGraphqlDocumentPayload = {
  __typename?: 'UpdateGraphqlDocumentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  graphqlDocument: Maybe<GraphqlDocument>;
};

/** Input for the updateJob mutation. */
export type UpdateJobInput = {
  /** The slug that the job will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the job object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the job object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the job object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** Input for the updateJobOffer mutation. */
export type UpdateJobOfferInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the jobOffer object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the jobOffer and teams */
  teams: InputMaybe<JobOfferTeamsInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateJobOffer mutation. */
export type UpdateJobOfferPayload = {
  __typename?: 'UpdateJobOfferPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  jobOffer: Maybe<JobOffer>;
};

/** The payload for the updateJob mutation. */
export type UpdateJobPayload = {
  __typename?: 'UpdateJobPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created job */
  job: Maybe<Job>;
};

/** Input for the updateLaw mutation. */
export type UpdateLawInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the law object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** Set connections between the law and lawStatuses */
  lawStatuses: InputMaybe<LawLawStatusesInput>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateLaw mutation. */
export type UpdateLawPayload = {
  __typename?: 'UpdateLawPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  law: Maybe<Law>;
};

/** Input for the updateLawStatus mutation. */
export type UpdateLawStatusInput = {
  /** The slug that the state_laws_status will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the state_laws_status object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the lawStatus object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the state_laws_status object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** The ID of the state_laws_status that should be set as the parent */
  parentId: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateLawStatus mutation. */
export type UpdateLawStatusPayload = {
  __typename?: 'UpdateLawStatusPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created state_laws_status */
  lawStatus: Maybe<LawStatus>;
};

/** Input for the updateMediaItem mutation. */
export type UpdateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType: InputMaybe<MimeTypeEnum>;
  /** The ID of the mediaItem object */
  id: Scalars['ID'];
  /** The ID of the parent object */
  parentId: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateMediaItem mutation. */
export type UpdateMediaItemPayload = {
  __typename?: 'UpdateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem: Maybe<MediaItem>;
};

/** Input for the updateNegativeEffect mutation. */
export type UpdateNegativeEffectInput = {
  /** The slug that the negative_effect will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the negative_effect object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the negativeEffect object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the negative_effect object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateNegativeEffect mutation. */
export type UpdateNegativeEffectPayload = {
  __typename?: 'UpdateNegativeEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created negative_effect */
  negativeEffect: Maybe<NegativeEffect>;
};

/** Input for the updatePage mutation. */
export type UpdatePageInput = {
  /** Set connections between the page and affiliates */
  affiliates: InputMaybe<PageAffiliatesInput>;
  /** The userId to assign as the author of the object */
  authorId: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the page object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePage mutation. */
export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page: Maybe<Page>;
};

/** Input for the updatePositiveEffect mutation. */
export type UpdatePositiveEffectInput = {
  /** The slug that the positive_effect will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the positive_effect object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the positiveEffect object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the positive_effect object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePositiveEffect mutation. */
export type UpdatePositiveEffectPayload = {
  __typename?: 'UpdatePositiveEffectPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created positive_effect */
  positiveEffect: Maybe<PositiveEffect>;
};

/** Input for the updatePostAuthor mutation. */
export type UpdatePostAuthorInput = {
  /** The slug that the post_author will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_author object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the postAuthor object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the post_author object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePostAuthor mutation. */
export type UpdatePostAuthorPayload = {
  __typename?: 'UpdatePostAuthorPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_author */
  postAuthor: Maybe<PostAuthor>;
};

/** Input for the updatePostFormat mutation. */
export type UpdatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat object to update */
  id: Scalars['ID'];
  /** The name of the post_format object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePostFormat mutation. */
export type UpdatePostFormatPayload = {
  __typename?: 'UpdatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat: Maybe<PostFormat>;
};

/** Input for the updatePost mutation. */
export type UpdatePostInput = {
  /** The userId to assign as the author of the object */
  authorId: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt: InputMaybe<Scalars['String']>;
  /** The ID of the post object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postAuthors */
  postAuthors: InputMaybe<PostPostAuthorsInput>;
  /** Set connections between the post and postFormats */
  postFormats: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the updatePost mutation. */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post: Maybe<Post>;
};

/** Input for the updateReview mutation. */
export type UpdateReviewInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the review object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateReview mutation. */
export type UpdateReviewPayload = {
  __typename?: 'UpdateReviewPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  review: Maybe<Review>;
};

/** Input for the updateScholarship mutation. */
export type UpdateScholarshipInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the scholarship object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateScholarship mutation. */
export type UpdateScholarshipPayload = {
  __typename?: 'UpdateScholarshipPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  scholarship: Maybe<Scholarship>;
};

/** Input for the updateSettings mutation. */
export type UpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** Allow people to submit comments on new posts. */
  discussionSettingsDefaultCommentStatus: InputMaybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  discussionSettingsDefaultPingStatus: InputMaybe<Scalars['String']>;
  /** A date format for all date strings. */
  generalSettingsDateFormat: InputMaybe<Scalars['String']>;
  /** Site tagline. */
  generalSettingsDescription: InputMaybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  generalSettingsEmail: InputMaybe<Scalars['String']>;
  /** WordPress locale code. */
  generalSettingsLanguage: InputMaybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  generalSettingsStartOfWeek: InputMaybe<Scalars['Int']>;
  /** A time format for all time strings. */
  generalSettingsTimeFormat: InputMaybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  generalSettingsTimezone: InputMaybe<Scalars['String']>;
  /** Site title. */
  generalSettingsTitle: InputMaybe<Scalars['String']>;
  /** Site URL. */
  generalSettingsUrl: InputMaybe<Scalars['String']>;
  /** The ID of the page that should display the latest posts */
  readingSettingsPageForPosts: InputMaybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  readingSettingsPageOnFront: InputMaybe<Scalars['Int']>;
  /** Blog pages show at most. */
  readingSettingsPostsPerPage: InputMaybe<Scalars['Int']>;
  /** What to show on the front page */
  readingSettingsShowOnFront: InputMaybe<Scalars['String']>;
  /** Default post category. */
  writingSettingsDefaultCategory: InputMaybe<Scalars['Int']>;
  /** Default post format. */
  writingSettingsDefaultPostFormat: InputMaybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  writingSettingsUseSmilies: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the updateSettings mutation. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** Update all settings. */
  allSettings: Maybe<Settings>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Update the DiscussionSettings setting. */
  discussionSettings: Maybe<DiscussionSettings>;
  /** Update the GeneralSettings setting. */
  generalSettings: Maybe<GeneralSettings>;
  /** Update the ReadingSettings setting. */
  readingSettings: Maybe<ReadingSettings>;
  /** Update the WritingSettings setting. */
  writingSettings: Maybe<WritingSettings>;
};

/** Input for the updateStrain mutation. */
export type UpdateStrainInput = {
  /** Set connections between the strain and aromas */
  aromas: InputMaybe<StrainAromasInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and curatedStrainsLists */
  curatedStrainsLists: InputMaybe<StrainCuratedStrainsListsInput>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and flavors */
  flavors: InputMaybe<StrainFlavorsInput>;
  /** The ID of the strain object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** Set connections between the strain and negativeEffects */
  negativeEffects: InputMaybe<StrainNegativeEffectsInput>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** Set connections between the strain and positiveEffects */
  positiveEffects: InputMaybe<StrainPositiveEffectsInput>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** Set connections between the strain and strainTypes */
  strainTypes: InputMaybe<StrainStrainTypesInput>;
  /** Set connections between the strain and terpenes */
  terpenes: InputMaybe<StrainTerpenesInput>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateStrain mutation. */
export type UpdateStrainPayload = {
  __typename?: 'UpdateStrainPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  strain: Maybe<Strain>;
};

/** Input for the updateStrainType mutation. */
export type UpdateStrainTypeInput = {
  /** The slug that the strain_type will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the strain_type object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the strainType object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the strain_type object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateStrainType mutation. */
export type UpdateStrainTypePayload = {
  __typename?: 'UpdateStrainTypePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created strain_type */
  strainType: Maybe<StrainType>;
};

/** Input for the updateTag mutation. */
export type UpdateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the tag object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the post_tag object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateTag mutation. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag: Maybe<Tag>;
};

/** Input for the updateTeam mutation. */
export type UpdateTeamInput = {
  /** The slug that the job_area will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the job_area object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the team object to update */
  id: Scalars['ID'];
  /** The name of the job_area object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** Input for the updateTeamMember mutation. */
export type UpdateTeamMemberInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the teamMember object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  /** Set connections between the teamMember and jobs */
  jobs: InputMaybe<TeamMemberJobsInput>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateTeamMember mutation. */
export type UpdateTeamMemberPayload = {
  __typename?: 'UpdateTeamMemberPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  teamMember: Maybe<TeamMember>;
};

/** The payload for the updateTeam mutation. */
export type UpdateTeamPayload = {
  __typename?: 'UpdateTeamPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created job_area */
  team: Maybe<Team>;
};

/** Input for the updateTerpene mutation. */
export type UpdateTerpeneInput = {
  /** The slug that the terpene will be an alias of */
  aliasOf: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The description of the terpene object */
  description: InputMaybe<Scalars['String']>;
  /** The ID of the terpene object to update */
  id: Scalars['ID'];
  language: InputMaybe<LanguageCodeEnum>;
  /** The name of the terpene object to mutate */
  name: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug: InputMaybe<Scalars['String']>;
};

/** The payload for the updateTerpene mutation. */
export type UpdateTerpenePayload = {
  __typename?: 'UpdateTerpenePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created terpene */
  terpene: Maybe<Terpene>;
};

/** Input for the updateUsLanding mutation. */
export type UpdateUsLandingInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the usLanding object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateUsLanding mutation. */
export type UpdateUsLandingPayload = {
  __typename?: 'UpdateUsLandingPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  usLanding: Maybe<UsLanding>;
};

/** Input for the updateUser mutation. */
export type UpdateUserInput = {
  /** User's AOL IM account. */
  aim: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName: InputMaybe<Scalars['String']>;
  /** The ID of the user */
  id: Scalars['ID'];
  /** User's Jabber account. */
  jabber: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password: InputMaybe<Scalars['String']>;
  /** If true, this will refresh the users JWT secret. */
  refreshJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered: InputMaybe<Scalars['String']>;
  /** If true, this will revoke the users JWT secret. If false, this will unrevoke the JWT secret AND issue a new one. To revoke, the user must have proper capabilities to edit users JWT secrets. */
  revokeJwtUserSecret: InputMaybe<Scalars['Boolean']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string containing the user's URL for the user's web site. */
  websiteUrl: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim: InputMaybe<Scalars['String']>;
};

/** The payload for the updateUser mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user: Maybe<User>;
};

/** Input for the updateWebinar mutation. */
export type UpdateWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date: InputMaybe<Scalars['String']>;
  /** The ID of the webinar object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<LanguageCodeEnum>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title: InputMaybe<Scalars['String']>;
};

/** The payload for the updateWebinar mutation. */
export type UpdateWebinarPayload = {
  __typename?: 'UpdateWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  webinar: Maybe<Webinar>;
};

/** The usLanding type */
export type UsLanding = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithFeaturedImage &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'UsLanding';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<UsLanding_Activestates>;
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<UsLandingToUsLandingConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
    featuredImage: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
    /** The database identifier for the featured image node assigned to the content node */
    featuredImageDatabaseId: Maybe<Scalars['Int']>;
    /** Globally unique ID of the featured image assigned to the node */
    featuredImageId: Maybe<Scalars['ID']>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the us_landing object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the us_landing object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Page settings&quot; was set to Show in GraphQL. */
    pageDetails: Maybe<Acf_Page_Pagedetails>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<UsLandingToParentConnectionEdge>;
    /** The password for the us_landing object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the UsLanding type and the usLanding type */
    preview: Maybe<UsLandingToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the UsLanding type and the usLanding type */
    revisions: Maybe<UsLandingToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    usLandingId: Scalars['Int'];
  };

/** The usLanding type */
export type UsLandingAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The usLanding type */
export type UsLandingEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The usLanding type */
export type UsLandingEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The usLanding type */
export type UsLandingRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UsLandingToRevisionConnectionWhereArgs>;
};

/** The usLanding type */
export type UsLandingTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Connection to usLanding Nodes */
export type UsLandingConnection = {
  /** A list of edges (relational context) between RootQuery and connected usLanding Nodes */
  edges: Array<UsLandingConnectionEdge>;
  /** A list of connected usLanding Nodes */
  nodes: Array<UsLanding>;
  /** Information about pagination in a connection. */
  pageInfo: UsLandingConnectionPageInfo;
};

/** Edge between a Node and a connected usLanding */
export type UsLandingConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected usLanding Node */
  node: UsLanding;
};

/** Page Info on the connected UsLandingConnectionEdge */
export type UsLandingConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum UsLandingIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the UsLanding type and the usLanding type */
export type UsLandingToParentConnectionEdge = Edge &
  OneToOneConnection &
  UsLandingConnectionEdge & {
    __typename?: 'UsLandingToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: UsLanding;
  };

/** Connection between the UsLanding type and the usLanding type */
export type UsLandingToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  UsLandingConnectionEdge & {
    __typename?: 'UsLandingToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: UsLanding;
  };

/** Connection between the UsLanding type and the usLanding type */
export type UsLandingToRevisionConnection = Connection &
  UsLandingConnection & {
    __typename?: 'UsLandingToRevisionConnection';
    /** Edges for the UsLandingToRevisionConnection connection */
    edges: Array<UsLandingToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<UsLanding>;
    /** Information about pagination in a connection. */
    pageInfo: UsLandingToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type UsLandingToRevisionConnectionEdge = Edge &
  UsLandingConnectionEdge & {
    __typename?: 'UsLandingToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: UsLanding;
  };

/** Page Info on the &quot;UsLandingToRevisionConnection&quot; */
export type UsLandingToRevisionConnectionPageInfo = PageInfo &
  UsLandingConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'UsLandingToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UsLandingToRevisionConnection connection */
export type UsLandingToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<UsLandingToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type UsLandingToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<UsLandingToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<UsLandingToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum UsLandingToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type UsLandingToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<UsLandingToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum UsLandingToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the UsLanding type and the usLanding type */
export type UsLandingToUsLandingConnection = Connection &
  UsLandingConnection & {
    __typename?: 'UsLandingToUsLandingConnection';
    /** Edges for the UsLandingToUsLandingConnection connection */
    edges: Array<UsLandingToUsLandingConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<UsLanding>;
    /** Information about pagination in a connection. */
    pageInfo: UsLandingToUsLandingConnectionPageInfo;
  };

/** An edge in a connection */
export type UsLandingToUsLandingConnectionEdge = Edge &
  UsLandingConnectionEdge & {
    __typename?: 'UsLandingToUsLandingConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: UsLanding;
  };

/** Page Info on the &quot;UsLandingToUsLandingConnection&quot; */
export type UsLandingToUsLandingConnectionPageInfo = PageInfo &
  UsLandingConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'UsLandingToUsLandingConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Field Group */
export type UsLanding_Activestates = AcfFieldGroup & {
  __typename?: 'UsLanding_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A User object */
export type User = Commenter &
  DatabaseIdentifier &
  Node &
  UniformResourceIdentifiable & {
    __typename?: 'User';
    /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
    avatar: Maybe<Avatar>;
    /** User metadata option name. Usually it will be &quot;wp_capabilities&quot;. */
    capKey: Maybe<Scalars['String']>;
    /** A list of capabilities (permissions) granted to the user */
    capabilities: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Connection between the User type and the Comment type */
    comments: Maybe<UserToCommentConnection>;
    /** Identifies the primary key from the database. */
    databaseId: Scalars['Int'];
    /** Description of the user. */
    description: Maybe<Scalars['String']>;
    /** Email address of the user. This is equivalent to the WP_User-&gt;user_email property. */
    email: Maybe<Scalars['String']>;
    /** Connection between the User type and the EnqueuedScript type */
    enqueuedScripts: Maybe<UserToEnqueuedScriptConnection>;
    /** Connection between the User type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<UserToEnqueuedStylesheetConnection>;
    /** A complete list of capabilities including capabilities inherited from a role. This is equivalent to the array keys of WP_User-&gt;allcaps. */
    extraCapabilities: Maybe<Array<Maybe<Scalars['String']>>>;
    /** First name of the user. This is equivalent to the WP_User-&gt;user_first_name property. */
    firstName: Maybe<Scalars['String']>;
    /** The globally unique identifier for the user object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether the JWT User secret has been revoked. If the secret has been revoked, auth tokens will not be issued until an admin, or user with proper capabilities re-issues a secret for the user. */
    isJwtAuthSecretRevoked: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** The expiration for the JWT Token for the user. If not set custom for the user, it will use the default sitewide expiration setting */
    jwtAuthExpiration: Maybe<Scalars['String']>;
    /** A JWT token that can be used in future requests for authentication/authorization */
    jwtAuthToken: Maybe<Scalars['String']>;
    /** A JWT token that can be used in future requests to get a refreshed jwtAuthToken. If the refresh token used in a request is revoked or otherwise invalid, a valid Auth token will NOT be issued in the response headers. */
    jwtRefreshToken: Maybe<Scalars['String']>;
    /** A unique secret tied to the users JWT token that can be revoked or refreshed. Revoking the secret prevents JWT tokens from being issued to the user. Refreshing the token invalidates previously issued tokens, but allows new tokens to be issued. */
    jwtUserSecret: Maybe<Scalars['String']>;
    /** Last name of the user. This is equivalent to the WP_User-&gt;user_last_name property. */
    lastName: Maybe<Scalars['String']>;
    /** The preferred language locale set for the user. Value derived from get_user_locale(). */
    locale: Maybe<Scalars['String']>;
    /** Connection between the User type and the mediaItem type */
    mediaItems: Maybe<UserToMediaItemConnection>;
    /** Display name of the user. This is equivalent to the WP_User-&gt;display_name property. */
    name: Maybe<Scalars['String']>;
    /** The nicename for the user. This field is equivalent to WP_User-&gt;user_nicename */
    nicename: Maybe<Scalars['String']>;
    /** Nickname of the user. */
    nickname: Maybe<Scalars['String']>;
    /** Connection between the User type and the page type */
    pages: Maybe<UserToPageConnection>;
    /** Connection between the User type and the post type */
    posts: Maybe<UserToPostConnection>;
    /** The date the user registered or was created. The field follows a full ISO8601 date string format. */
    registeredDate: Maybe<Scalars['String']>;
    /** Connection between the User and Revisions authored by the user */
    revisions: Maybe<UserToRevisionsConnection>;
    /** Connection between the User type and the UserRole type */
    roles: Maybe<UserToUserRoleConnection>;
    /** Whether the Toolbar should be displayed when the user is viewing the site. */
    shouldShowAdminToolbar: Maybe<Scalars['Boolean']>;
    /** The slug for the user. This field is equivalent to WP_User-&gt;user_nicename */
    slug: Maybe<Scalars['String']>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
    /** A website url that is associated with the user. */
    url: Maybe<Scalars['String']>;
    /**
     * The Id of the user. Equivalent to WP_User-&gt;ID
     * @deprecated Deprecated in favor of the databaseId field
     */
    userId: Maybe<Scalars['Int']>;
    /** Username for the user. This field is equivalent to WP_User-&gt;user_login. */
    username: Maybe<Scalars['String']>;
  };

/** A User object */
export type UserAvatarArgs = {
  forceDefault: InputMaybe<Scalars['Boolean']>;
  rating: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};

/** A User object */
export type UserCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UserToCommentConnectionWhereArgs>;
};

/** A User object */
export type UserEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A User object */
export type UserEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A User object */
export type UserMediaItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UserToMediaItemConnectionWhereArgs>;
};

/** A User object */
export type UserPagesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UserToPageConnectionWhereArgs>;
};

/** A User object */
export type UserPostsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UserToPostConnectionWhereArgs>;
};

/** A User object */
export type UserRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<UserToRevisionsConnectionWhereArgs>;
};

/** A User object */
export type UserRolesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** Connection to User Nodes */
export type UserConnection = {
  /** A list of edges (relational context) between RootQuery and connected User Nodes */
  edges: Array<UserConnectionEdge>;
  /** A list of connected User Nodes */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: UserConnectionPageInfo;
};

/** Edge between a Node and a connected User */
export type UserConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected User Node */
  node: User;
};

/** Page Info on the connected UserConnectionEdge */
export type UserConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single User node. To be used along with the "id" field. Default is "ID". */
export enum UserNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The Email of the User */
  Email = 'EMAIL',
  /** The hashed Global ID */
  Id = 'ID',
  /** The slug of the User */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
  /** The username the User uses to login with */
  Username = 'USERNAME',
}

/** A user role object */
export type UserRole = Node & {
  __typename?: 'UserRole';
  /** The capabilities that belong to this role */
  capabilities: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The display name of the role */
  displayName: Maybe<Scalars['String']>;
  /** The globally unique identifier for the user role object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted: Maybe<Scalars['Boolean']>;
  /** The registered name of the role */
  name: Maybe<Scalars['String']>;
};

/** Connection to UserRole Nodes */
export type UserRoleConnection = {
  /** A list of edges (relational context) between RootQuery and connected UserRole Nodes */
  edges: Array<UserRoleConnectionEdge>;
  /** A list of connected UserRole Nodes */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: UserRoleConnectionPageInfo;
};

/** Edge between a Node and a connected UserRole */
export type UserRoleConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected UserRole Node */
  node: UserRole;
};

/** Page Info on the connected UserRoleConnectionEdge */
export type UserRoleConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Names of available user roles */
export enum UserRoleEnum {
  /** User role with specific capabilities */
  Administrator = 'ADMINISTRATOR',
  /** User role with specific capabilities */
  Author = 'AUTHOR',
  /** User role with specific capabilities */
  Contributor = 'CONTRIBUTOR',
  /** User role with specific capabilities */
  Editor = 'EDITOR',
  /** User role with specific capabilities */
  Revisor = 'REVISOR',
  /** User role with specific capabilities */
  SeoManager = 'SEO_MANAGER',
  /** User role with specific capabilities */
  Subscriber = 'SUBSCRIBER',
  /** User role with specific capabilities */
  SuperEditor = 'SUPER_EDITOR',
  /** User role with specific capabilities */
  Translator = 'TRANSLATOR',
}

/** Connection between the User type and the Comment type */
export type UserToCommentConnection = CommentConnection &
  Connection & {
    __typename?: 'UserToCommentConnection';
    /** Edges for the UserToCommentConnection connection */
    edges: Array<UserToCommentConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Comment>;
    /** Information about pagination in a connection. */
    pageInfo: UserToCommentConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToCommentConnectionEdge = CommentConnectionEdge &
  Edge & {
    __typename?: 'UserToCommentConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Comment;
  };

/** Page Info on the &quot;UserToCommentConnection&quot; */
export type UserToCommentConnectionPageInfo = CommentConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'UserToCommentConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UserToCommentConnection connection */
export type UserToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** Connection between the User type and the EnqueuedScript type */
export type UserToEnqueuedScriptConnection = Connection &
  EnqueuedScriptConnection & {
    __typename?: 'UserToEnqueuedScriptConnection';
    /** Edges for the UserToEnqueuedScriptConnection connection */
    edges: Array<UserToEnqueuedScriptConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedScript>;
    /** Information about pagination in a connection. */
    pageInfo: UserToEnqueuedScriptConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToEnqueuedScriptConnectionEdge = Edge &
  EnqueuedScriptConnectionEdge & {
    __typename?: 'UserToEnqueuedScriptConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedScript;
  };

/** Page Info on the &quot;UserToEnqueuedScriptConnection&quot; */
export type UserToEnqueuedScriptConnectionPageInfo =
  EnqueuedScriptConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'UserToEnqueuedScriptConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the User type and the EnqueuedStylesheet type */
export type UserToEnqueuedStylesheetConnection = Connection &
  EnqueuedStylesheetConnection & {
    __typename?: 'UserToEnqueuedStylesheetConnection';
    /** Edges for the UserToEnqueuedStylesheetConnection connection */
    edges: Array<UserToEnqueuedStylesheetConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<EnqueuedStylesheet>;
    /** Information about pagination in a connection. */
    pageInfo: UserToEnqueuedStylesheetConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToEnqueuedStylesheetConnectionEdge = Edge &
  EnqueuedStylesheetConnectionEdge & {
    __typename?: 'UserToEnqueuedStylesheetConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: EnqueuedStylesheet;
  };

/** Page Info on the &quot;UserToEnqueuedStylesheetConnection&quot; */
export type UserToEnqueuedStylesheetConnectionPageInfo =
  EnqueuedStylesheetConnectionPageInfo &
    PageInfo &
    WpPageInfo & {
      __typename?: 'UserToEnqueuedStylesheetConnectionPageInfo';
      /** When paginating forwards, the cursor to continue. */
      endCursor: Maybe<Scalars['String']>;
      /** When paginating forwards, are there more items? */
      hasNextPage: Scalars['Boolean'];
      /** When paginating backwards, are there more items? */
      hasPreviousPage: Scalars['Boolean'];
      /** Get information about the offset pagination state in the current connection */
      offsetPagination: Maybe<OffsetPaginationPageInfo>;
      /** When paginating backwards, the cursor to continue. */
      startCursor: Maybe<Scalars['String']>;
    };

/** Connection between the User type and the mediaItem type */
export type UserToMediaItemConnection = Connection &
  MediaItemConnection & {
    __typename?: 'UserToMediaItemConnection';
    /** Edges for the UserToMediaItemConnection connection */
    edges: Array<UserToMediaItemConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<MediaItem>;
    /** Information about pagination in a connection. */
    pageInfo: UserToMediaItemConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToMediaItemConnectionEdge = Edge &
  MediaItemConnectionEdge & {
    __typename?: 'UserToMediaItemConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: MediaItem;
  };

/** Page Info on the &quot;UserToMediaItemConnection&quot; */
export type UserToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'UserToMediaItemConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UserToMediaItemConnection connection */
export type UserToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<UserToMediaItemConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type UserToMediaItemConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<UserToMediaItemConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<UserToMediaItemConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum UserToMediaItemConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type UserToMediaItemConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<UserToMediaItemConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum UserToMediaItemConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the User type and the page type */
export type UserToPageConnection = Connection &
  PageConnection & {
    __typename?: 'UserToPageConnection';
    /** Edges for the UserToPageConnection connection */
    edges: Array<UserToPageConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Page>;
    /** Information about pagination in a connection. */
    pageInfo: UserToPageConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToPageConnectionEdge = Edge &
  PageConnectionEdge & {
    __typename?: 'UserToPageConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Page;
  };

/** Page Info on the &quot;UserToPageConnection&quot; */
export type UserToPageConnectionPageInfo = PageConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'UserToPageConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UserToPageConnection connection */
export type UserToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<UserToPageConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type UserToPageConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<UserToPageConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<UserToPageConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum UserToPageConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type UserToPageConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<UserToPageConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum UserToPageConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the User type and the post type */
export type UserToPostConnection = Connection &
  PostConnection & {
    __typename?: 'UserToPostConnection';
    /** Edges for the UserToPostConnection connection */
    edges: Array<UserToPostConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Post>;
    /** Information about pagination in a connection. */
    pageInfo: UserToPostConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToPostConnectionEdge = Edge &
  PostConnectionEdge & {
    __typename?: 'UserToPostConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Post;
  };

/** Page Info on the &quot;UserToPostConnection&quot; */
export type UserToPostConnectionPageInfo = PageInfo &
  PostConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'UserToPostConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UserToPostConnection connection */
export type UserToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<UserToPostConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type UserToPostConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<UserToPostConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<UserToPostConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum UserToPostConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type UserToPostConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<UserToPostConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum UserToPostConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the User type and the ContentNode type */
export type UserToRevisionsConnection = Connection &
  ContentNodeConnection & {
    __typename?: 'UserToRevisionsConnection';
    /** Edges for the UserToRevisionsConnection connection */
    edges: Array<UserToRevisionsConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<ContentNode>;
    /** Information about pagination in a connection. */
    pageInfo: UserToRevisionsConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToRevisionsConnectionEdge = ContentNodeConnectionEdge &
  Edge & {
    __typename?: 'UserToRevisionsConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: ContentNode;
  };

/** Page Info on the &quot;UserToRevisionsConnection&quot; */
export type UserToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo &
  PageInfo &
  WpPageInfo & {
    __typename?: 'UserToRevisionsConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the UserToRevisionsConnection connection */
export type UserToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<UserToRevisionsConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type UserToRevisionsConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<UserToRevisionsConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<UserToRevisionsConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum UserToRevisionsConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type UserToRevisionsConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<UserToRevisionsConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum UserToRevisionsConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the User type and the UserRole type */
export type UserToUserRoleConnection = Connection &
  UserRoleConnection & {
    __typename?: 'UserToUserRoleConnection';
    /** Edges for the UserToUserRoleConnection connection */
    edges: Array<UserToUserRoleConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<UserRole>;
    /** Information about pagination in a connection. */
    pageInfo: UserToUserRoleConnectionPageInfo;
  };

/** An edge in a connection */
export type UserToUserRoleConnectionEdge = Edge &
  UserRoleConnectionEdge & {
    __typename?: 'UserToUserRoleConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: UserRole;
  };

/** Page Info on the &quot;UserToUserRoleConnection&quot; */
export type UserToUserRoleConnectionPageInfo = PageInfo &
  UserRoleConnectionPageInfo &
  WpPageInfo & {
    __typename?: 'UserToUserRoleConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Field to order the connection by */
export enum UsersConnectionOrderbyEnum {
  /** Order by display name */
  DisplayName = 'DISPLAY_NAME',
  /** Order by email address */
  Email = 'EMAIL',
  /** Order by login */
  Login = 'LOGIN',
  /** Preserve the login order given in the LOGIN_IN array */
  LoginIn = 'LOGIN_IN',
  /** Order by nice name */
  NiceName = 'NICE_NAME',
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  NiceNameIn = 'NICE_NAME_IN',
  /** Order by registration date */
  Registered = 'REGISTERED',
  /** Order by URL */
  Url = 'URL',
}

/** Options for ordering the connection */
export type UsersConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  field: UsersConnectionOrderbyEnum;
  /** The cardinality of the order of the connection */
  order: InputMaybe<OrderEnum>;
};

/** Column used for searching for users. */
export enum UsersConnectionSearchColumnEnum {
  /** The user's email address. */
  Email = 'EMAIL',
  /** The globally unique ID. */
  Id = 'ID',
  /** The username the User uses to login with. */
  Login = 'LOGIN',
  /** A URL-friendly name for the user. The default is the user's username. */
  Nicename = 'NICENAME',
  /** The URL of the user's website. */
  Url = 'URL',
}

/** Information about pagination in a connection. */
export type WpPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The webinar type */
export type Webinar = ContentNode &
  DatabaseIdentifier &
  MenuItemLinkable &
  Node &
  NodeWithRevisions &
  NodeWithTemplate &
  NodeWithTitle &
  Previewable &
  UniformResourceIdentifiable & {
    __typename?: 'Webinar';
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Active States&quot; was set to Show in GraphQL. */
    activeStates: Maybe<Webinar_Activestates>;
    /**
     * The ancestors of the content node.
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    ancestors: Maybe<WebinarToWebinarConnection>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Medical Card Page Settings&quot; was set to Show in GraphQL. */
    cardPageSettings: Maybe<Webinar_Cardpagesettings>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Content Blocks&quot; was set to Show in GraphQL. */
    contentBlocks: Maybe<Acf_Content_Contentblocks>;
    /** Connection between the ContentNode type and the ContentType type */
    contentType: Maybe<ContentNodeToContentTypeConnectionEdge>;
    /** The name of the Content Type the node belongs to */
    contentTypeName: Scalars['String'];
    /** The unique identifier stored in the database */
    databaseId: Scalars['Int'];
    /** Post publishing date. */
    date: Maybe<Scalars['String']>;
    /** The publishing date set in GMT. */
    dateGmt: Maybe<Scalars['String']>;
    /** The desired slug of the post */
    desiredSlug: Maybe<Scalars['String']>;
    /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
    editingLockedBy: Maybe<ContentNodeToEditLockConnectionEdge>;
    /** The RSS enclosure for the object */
    enclosure: Maybe<Scalars['String']>;
    /** Connection between the ContentNode type and the EnqueuedScript type */
    enqueuedScripts: Maybe<ContentNodeToEnqueuedScriptConnection>;
    /** Connection between the ContentNode type and the EnqueuedStylesheet type */
    enqueuedStylesheets: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
    /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
    guid: Maybe<Scalars['String']>;
    /** Whether the webinar object is password protected. */
    hasPassword: Maybe<Scalars['Boolean']>;
    /** The globally unique identifier of the webinar object. */
    id: Scalars['ID'];
    /** Whether the node is a Comment */
    isComment: Scalars['Boolean'];
    /** Whether the node is a Content Node */
    isContentNode: Scalars['Boolean'];
    /** Whether the node represents the front page. */
    isFrontPage: Scalars['Boolean'];
    /** Whether  the node represents the blog page. */
    isPostsPage: Scalars['Boolean'];
    /** Whether the object is a node in the preview state */
    isPreview: Maybe<Scalars['Boolean']>;
    /** Whether the object is restricted from the current viewer */
    isRestricted: Maybe<Scalars['Boolean']>;
    /** True if the node is a revision of another node */
    isRevision: Maybe<Scalars['Boolean']>;
    /** Whether the node is a Term */
    isTermNode: Scalars['Boolean'];
    /** Polylang language */
    language: Maybe<Language>;
    /** The user that most recently edited the node */
    lastEditedBy: Maybe<ContentNodeToEditLastConnectionEdge>;
    /** The permalink of the post */
    link: Maybe<Scalars['String']>;
    /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
    modified: Maybe<Scalars['String']>;
    /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
    modifiedGmt: Maybe<Scalars['String']>;
    /** Added to the GraphQL Schema because the ACF Field Group &quot;Page settings&quot; was set to Show in GraphQL. */
    pageDetails: Maybe<Acf_Page_Pagedetails>;
    /**
     * The parent of the content node.
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    parent: Maybe<WebinarToParentConnectionEdge>;
    /** The password for the webinar object. */
    password: Maybe<Scalars['String']>;
    /** Connection between the Webinar type and the webinar type */
    preview: Maybe<WebinarToPreviewConnectionEdge>;
    /** The database id of the preview node */
    previewRevisionDatabaseId: Maybe<Scalars['Int']>;
    /** Whether the object is a node in the preview state */
    previewRevisionId: Maybe<Scalars['ID']>;
    /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
    revisionOf: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
    /** Connection between the Webinar type and the webinar type */
    revisions: Maybe<WebinarToRevisionConnection>;
    /** Post type Seo fields */
    seo: Maybe<Seo>;
    /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
    slug: Maybe<Scalars['String']>;
    /** The current status of the object */
    status: Maybe<Scalars['String']>;
    /** The template assigned to the node */
    template: Maybe<ContentTemplate>;
    /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
    title: Maybe<Scalars['String']>;
    /** Get specific translation version of this object */
    translation: Maybe<Webinar>;
    /** List all translated versions of this post */
    translations: Maybe<Array<Maybe<Webinar>>>;
    /** The unique resource identifier path */
    uri: Maybe<Scalars['String']>;
    /**
     * The id field matches the WP_Post-&gt;ID field.
     * @deprecated Deprecated in favor of the databaseId field
     */
    webinarId: Scalars['Int'];
  };

/** The webinar type */
export type WebinarAncestorsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The webinar type */
export type WebinarEnqueuedScriptsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The webinar type */
export type WebinarEnqueuedStylesheetsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The webinar type */
export type WebinarRevisionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  where: InputMaybe<WebinarToRevisionConnectionWhereArgs>;
};

/** The webinar type */
export type WebinarTitleArgs = {
  format: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The webinar type */
export type WebinarTranslationArgs = {
  language: LanguageCodeEnum;
};

/** Connection to webinar Nodes */
export type WebinarConnection = {
  /** A list of edges (relational context) between RootQuery and connected webinar Nodes */
  edges: Array<WebinarConnectionEdge>;
  /** A list of connected webinar Nodes */
  nodes: Array<Webinar>;
  /** Information about pagination in a connection. */
  pageInfo: WebinarConnectionPageInfo;
};

/** Edge between a Node and a connected webinar */
export type WebinarConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor: Maybe<Scalars['String']>;
  /** The connected webinar Node */
  node: Webinar;
};

/** Page Info on the connected WebinarConnectionEdge */
export type WebinarConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum WebinarIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI',
}

/** Connection between the Webinar type and the webinar type */
export type WebinarToParentConnectionEdge = Edge &
  OneToOneConnection &
  WebinarConnectionEdge & {
    __typename?: 'WebinarToParentConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /**
     * The node of the connection, without the edges
     * @deprecated This content type is not hierarchical and typically will not have a parent
     */
    node: Webinar;
  };

/** Connection between the Webinar type and the webinar type */
export type WebinarToPreviewConnectionEdge = Edge &
  OneToOneConnection &
  WebinarConnectionEdge & {
    __typename?: 'WebinarToPreviewConnectionEdge';
    /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
    cursor: Maybe<Scalars['String']>;
    /** The node of the connection, without the edges */
    node: Webinar;
  };

/** Connection between the Webinar type and the webinar type */
export type WebinarToRevisionConnection = Connection &
  WebinarConnection & {
    __typename?: 'WebinarToRevisionConnection';
    /** Edges for the WebinarToRevisionConnection connection */
    edges: Array<WebinarToRevisionConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Webinar>;
    /** Information about pagination in a connection. */
    pageInfo: WebinarToRevisionConnectionPageInfo;
  };

/** An edge in a connection */
export type WebinarToRevisionConnectionEdge = Edge &
  WebinarConnectionEdge & {
    __typename?: 'WebinarToRevisionConnectionEdge';
    /** A cursor for use in pagination */
    cursor: Maybe<Scalars['String']>;
    /** The item at the end of the edge */
    node: Webinar;
  };

/** Page Info on the &quot;WebinarToRevisionConnection&quot; */
export type WebinarToRevisionConnectionPageInfo = PageInfo &
  WpPageInfo &
  WebinarConnectionPageInfo & {
    __typename?: 'WebinarToRevisionConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Arguments for filtering the WebinarToRevisionConnection connection */
export type WebinarToRevisionConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  metaQuery: InputMaybe<WebinarToRevisionConnectionWhereArgsMetaQuery>;
  /** Get objects with a specific mimeType property */
  mimeType: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status: InputMaybe<PostStatusEnum>;
  taxQuery: InputMaybe<TaxQuery>;
  /** Title of the object */
  title: InputMaybe<Scalars['String']>;
};

export type WebinarToRevisionConnectionWhereArgsMetaArray = {
  /** Custom field value */
  compare: InputMaybe<WebinarToRevisionConnectionWhereArgsMetaCompareEnum>;
  /** Custom field key */
  key: InputMaybe<Scalars['String']>;
  /** Custom field value */
  type: InputMaybe<WebinarToRevisionConnectionWhereArgsMetaTypeEnum>;
  /** Custom field value */
  value: InputMaybe<Scalars['String']>;
};

export enum WebinarToRevisionConnectionWhereArgsMetaCompareEnum {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotBetween = 'NOT_BETWEEN',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
}

export type WebinarToRevisionConnectionWhereArgsMetaQuery = {
  metaArray: InputMaybe<
    Array<InputMaybe<WebinarToRevisionConnectionWhereArgsMetaArray>>
  >;
  relation: InputMaybe<RelationEnum>;
};

export enum WebinarToRevisionConnectionWhereArgsMetaTypeEnum {
  Binary = 'BINARY',
  Char = 'CHAR',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Numeric = 'NUMERIC',
  Signed = 'SIGNED',
  Time = 'TIME',
  Unsigned = 'UNSIGNED',
}

/** Connection between the Webinar type and the webinar type */
export type WebinarToWebinarConnection = Connection &
  WebinarConnection & {
    __typename?: 'WebinarToWebinarConnection';
    /** Edges for the WebinarToWebinarConnection connection */
    edges: Array<WebinarToWebinarConnectionEdge>;
    /** The nodes of the connection, without the edges */
    nodes: Array<Webinar>;
    /** Information about pagination in a connection. */
    pageInfo: WebinarToWebinarConnectionPageInfo;
  };

/** An edge in a connection */
export type WebinarToWebinarConnectionEdge = Edge &
  WebinarConnectionEdge & {
    __typename?: 'WebinarToWebinarConnectionEdge';
    /**
     * A cursor for use in pagination
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    cursor: Maybe<Scalars['String']>;
    /**
     * The item at the end of the edge
     * @deprecated This content type is not hierarchical and typically will not have ancestors
     */
    node: Webinar;
  };

/** Page Info on the &quot;WebinarToWebinarConnection&quot; */
export type WebinarToWebinarConnectionPageInfo = PageInfo &
  WpPageInfo &
  WebinarConnectionPageInfo & {
    __typename?: 'WebinarToWebinarConnectionPageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor: Maybe<Scalars['String']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean'];
    /** Get information about the offset pagination state in the current connection */
    offsetPagination: Maybe<OffsetPaginationPageInfo>;
    /** When paginating backwards, the cursor to continue. */
    startCursor: Maybe<Scalars['String']>;
  };

/** Field Group */
export type Webinar_Activestates = AcfFieldGroup & {
  __typename?: 'Webinar_Activestates';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Field Group */
export type Webinar_Cardpagesettings = AcfFieldGroup & {
  __typename?: 'Webinar_Cardpagesettings';
  affiliateLogo: Maybe<MediaItem>;
  affiliatePage: Maybe<Array<Maybe<Webinar_Cardpagesettings_AffiliatePage>>>;
  affiliateWebsite: Maybe<Scalars['String']>;
  customStateCode: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  /** Custom form url. Leave blank to use the default. */
  formUrl: Maybe<Scalars['String']>;
  imageObjectCaption: Maybe<Scalars['String']>;
  isAffiliate: Maybe<Scalars['Boolean']>;
  /**
   * Leave this section blank if this is a regular medical card or affiliate page. &lt;br/&gt;
   * This flag is being used to control A/B Testing
   */
  isExperiment: Maybe<Scalars['Boolean']>;
  isRenewal: Maybe<Scalars['Boolean']>;
  isVpdLanding: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  /** If checked, the registration form will disconnect from Medical Card but continue to collect contact information so patients can be followed up. */
  pauseAppointments: Maybe<Scalars['Boolean']>;
  /**
   * Price: Price (in $) without any discount. &lt;strong&gt; Leave it blank if the VPD is set to multi-state&lt;/strong&gt;&lt;br/&gt;
   * New Price: Price (in $) after applying a discount. &lt;strong&gt; Leave it blank &lt;/strong&gt; if &lt;em&gt;no discount or a percentage discount&lt;/em&gt; should be applied&lt;br/&gt;
   * Percentage Discount: Between 0-100.&lt;strong&gt;Leave it blank&lt;/strong&gt; if the discount is a $ value&lt;br/&gt;
   * &lt;strong&gt;Note:&lt;/strong&gt; either fill &quot;New Price&quot; - for a value discount -  or &quot;Percentage Discount&quot; - for a percentage discount
   */
  price: Maybe<Webinar_Cardpagesettings_Price>;
  product: Maybe<Webinar_Cardpagesettings_Product>;
  redirectMedicalCard: Maybe<Scalars['Boolean']>;
  stateProductImage: Maybe<MediaItem>;
  totalMedicalCardPrice: Maybe<Scalars['String']>;
  vpdLogo: Maybe<MediaItem>;
  vpdPage: Maybe<Webinar_Cardpagesettings_VpdPage>;
  vpdPartnerName: Maybe<Scalars['String']>;
  webinarInfo: Maybe<Webinar_Cardpagesettings_WebinarInfo>;
};

export type Webinar_Cardpagesettings_AffiliatePage = Page;

/** Field Group */
export type Webinar_Cardpagesettings_Price = AcfFieldGroup & {
  __typename?: 'Webinar_Cardpagesettings_Price';
  discountCode: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  newPrice: Maybe<Scalars['Float']>;
  percentageDiscount: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
};

/** Field Group */
export type Webinar_Cardpagesettings_Product = AcfFieldGroup & {
  __typename?: 'Webinar_Cardpagesettings_Product';
  description: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  imageUrl: Maybe<MediaItem>;
  name: Maybe<Scalars['String']>;
};

export type Webinar_Cardpagesettings_VpdPage = Event;

/** Field Group */
export type Webinar_Cardpagesettings_WebinarInfo = AcfFieldGroup & {
  __typename?: 'Webinar_Cardpagesettings_WebinarInfo';
  /** The name of the ACF Field Group */
  fieldGroupName: Maybe<Scalars['String']>;
  webinarDescription: Maybe<Scalars['String']>;
  webinarTitle: Maybe<Scalars['String']>;
  webinarZoomUrl: Maybe<Scalars['String']>;
};

/** The writing setting type */
export type WritingSettings = {
  __typename?: 'WritingSettings';
  /** Default post category. */
  defaultCategory: Maybe<Scalars['Int']>;
  /** Default post format. */
  defaultPostFormat: Maybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  useSmilies: Maybe<Scalars['Boolean']>;
};

export type MediaFragment = {
  __typename?: 'MediaItem';
  altText: string | null;
  title: string | null;
  id: string;
  sourceUrl: string | null;
  srcSet: string | null;
  mediaDetails: {
    __typename?: 'MediaDetails';
    width: number | null;
    height: number | null;
  } | null;
};

export type PartnerInfoFragment = {
  __typename?: 'Affiliate';
  id: string;
  name: string | null;
  uri: string | null;
  scrapping: {
    __typename?: 'Affiliate_Scrappingsettings';
    id: string | null;
  } | null;
};

export type SeoFullFragment = {
  __typename?: 'Seo';
  canonical: string | null;
  description: string | null;
  title: string | null;
  metaRobotsNofollow: boolean | null;
  metaRobotsNoarchive: boolean | null;
  metaRobotsNoindex: boolean | null;
  redirect: string | null;
  images: Array<{
    __typename?: 'MediaItem';
    altText: string | null;
    sourceUrl: string | null;
    mediaDetails: {
      __typename?: 'MediaDetails';
      height: number | null;
      width: number | null;
    } | null;
  } | null> | null;
  opengraph: {
    __typename?: 'SeoOpengraph';
    type: string | null;
    title: string | null;
    description: string | null;
  } | null;
};

export type StrainExcerptFragment = {
  __typename?: 'Strain';
  id: string;
  title: string | null;
  uri: string | null;
  date: string | null;
  modified: string | null;
  featuredImage: {
    __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
    node: {
      __typename?: 'MediaItem';
      altText: string | null;
      title: string | null;
      id: string;
      sourceUrl: string | null;
      srcSet: string | null;
      mediaDetails: {
        __typename?: 'MediaDetails';
        width: number | null;
        height: number | null;
      } | null;
    };
  } | null;
  strainTypes: {
    __typename?: 'StrainToStrainTypeConnection';
    nodes: Array<{
      __typename?: 'StrainType';
      name: string | null;
      slug: string | null;
    }>;
  } | null;
  details: {
    __typename?: 'Strain_Straindetails';
    cannabinoids: Array<{
      __typename?: 'Strain_Straindetails_cannabinoids';
      abbreviation: string | null;
      quantityStart: number | null;
      quantityEnd: number | null;
    } | null> | null;
    thc: {
      __typename?: 'Strain_Straindetails_Thc';
      quantityStart: number | null;
      quantityEnd: number | null;
    } | null;
  } | null;
};

export type LoginMutationVariables = Exact<{
  clientMutationId: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
}>;

export type LoginMutation = {
  __typename?: 'RootMutation';
  login: {
    __typename?: 'LoginPayload';
    refreshToken: string | null;
    authToken: string | null;
  } | null;
};

export type RefreshAuthTokenMutationVariables = Exact<{
  clientMutationId: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
}>;

export type RefreshAuthTokenMutation = {
  __typename?: 'RootMutation';
  refreshJwtAuthToken: {
    __typename?: 'RefreshJwtAuthTokenPayload';
    authToken: string | null;
  } | null;
};

export type CreateReviewMutationVariables = Exact<{
  author: Scalars['String'];
  content: Scalars['String'];
  location: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  photo: InputMaybe<Base64File>;
}>;

export type CreateReviewMutation = {
  __typename?: 'RootMutation';
  createPublicReview: {
    __typename?: 'CreatePublicReviewPayload';
    author: string | null;
  } | null;
};

export type ConditionsByScrappingIdsQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  scrappingIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type ConditionsByScrappingIdsQuery = {
  __typename?: 'RootQuery';
  conditions: {
    __typename?: 'RootQueryToConditionConnection';
    nodes: Array<{
      __typename?: 'Condition';
      uri: string | null;
      scrapping: {
        __typename?: 'Condition_Scrappingsettings';
        id: string | null;
      } | null;
    }>;
  } | null;
};

export type ConditionsSearchQueryVariables = Exact<{
  languageCode?: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type ConditionsSearchQuery = {
  __typename?: 'RootQuery';
  conditionsIds: {
    __typename?: 'RootQueryToConditionConnection';
    nodes: Array<{
      __typename?: 'Condition';
      title: string | null;
      id: number;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToConditionConnectionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
    };
  } | null;
};

export type AllPartnersByLanguageQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
}>;

export type AllPartnersByLanguageQuery = {
  __typename?: 'RootQuery';
  affiliates: {
    __typename?: 'RootQueryToAffiliateConnection';
    nodes: Array<{
      __typename?: 'Affiliate';
      id: string;
      name: string | null;
      uri: string | null;
      scrapping: {
        __typename?: 'Affiliate_Scrappingsettings';
        id: string | null;
      } | null;
    }>;
  } | null;
};

export type PartnersByScrappingIdsQueryVariables = Exact<{
  scrappingIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type PartnersByScrappingIdsQuery = {
  __typename?: 'RootQuery';
  affiliates: {
    __typename?: 'RootQueryToAffiliateConnection';
    nodes: Array<{
      __typename?: 'Affiliate';
      id: string;
      name: string | null;
      uri: string | null;
      scrapping: {
        __typename?: 'Affiliate_Scrappingsettings';
        id: string | null;
      } | null;
    }>;
  } | null;
};

export type AllCuratedStrainsListsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllCuratedStrainsListsQuery = {
  __typename?: 'RootQuery';
  curatedStrainsLists: {
    __typename?: 'RootQueryToCuratedStrainsListConnection';
    nodes: Array<{
      __typename?: 'CuratedStrainsList';
      slug: string | null;
      language: { __typename?: 'Language'; slug: string | null } | null;
      translations: Array<{
        __typename?: 'CuratedStrainsList';
        uri: string | null;
        language: { __typename?: 'Language'; slug: string | null } | null;
      } | null> | null;
    }>;
  } | null;
};

export type AromasSearchQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type AromasSearchQuery = {
  __typename?: 'RootQuery';
  aromas: {
    __typename?: 'RootQueryToAromaConnection';
    nodes: Array<{
      __typename?: 'Aroma';
      name: string | null;
      slug: string | null;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToAromaConnectionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
    };
  } | null;
};

export type CuratedStrainsListQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type CuratedStrainsListQuery = {
  __typename?: 'RootQuery';
  curatedStrainsList: {
    __typename?: 'CuratedStrainsList';
    id: string;
    description: string | null;
    name: string | null;
    uri: string | null;
    seo: {
      __typename?: 'Seo';
      canonical: string | null;
      description: string | null;
      title: string | null;
      metaRobotsNofollow: boolean | null;
      metaRobotsNoarchive: boolean | null;
      metaRobotsNoindex: boolean | null;
      redirect: string | null;
      images: Array<{
        __typename?: 'MediaItem';
        altText: string | null;
        sourceUrl: string | null;
        mediaDetails: {
          __typename?: 'MediaDetails';
          height: number | null;
          width: number | null;
        } | null;
      } | null> | null;
      opengraph: {
        __typename?: 'SeoOpengraph';
        type: string | null;
        title: string | null;
        description: string | null;
      } | null;
    } | null;
    language: { __typename?: 'Language'; slug: string | null } | null;
    translations: Array<{
      __typename?: 'CuratedStrainsList';
      uri: string | null;
      language: {
        __typename?: 'Language';
        locale: string | null;
        slug: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type FlavorsSearchQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type FlavorsSearchQuery = {
  __typename?: 'RootQuery';
  flavors: {
    __typename?: 'RootQueryToFlavorConnection';
    nodes: Array<{
      __typename?: 'Flavor';
      name: string | null;
      slug: string | null;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToFlavorConnectionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
    };
  } | null;
};

export type PositiveEffectsSearchQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type PositiveEffectsSearchQuery = {
  __typename?: 'RootQuery';
  positiveEffects: {
    __typename?: 'RootQueryToPositiveEffectConnection';
    nodes: Array<{
      __typename?: 'PositiveEffect';
      name: string | null;
      slug: string | null;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToPositiveEffectConnectionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
    };
  } | null;
};

export type SearchStrainsQueryVariables = Exact<{
  imageSize?: InputMaybe<MediaItemSizeEnum>;
  where?: InputMaybe<RootQueryToStrainConnectionWhereArgs>;
}>;

export type SearchStrainsQuery = {
  __typename?: 'RootQuery';
  strains: {
    __typename?: 'RootQueryToStrainConnection';
    nodes: Array<{
      __typename?: 'Strain';
      id: string;
      title: string | null;
      uri: string | null;
      date: string | null;
      modified: string | null;
      featuredImage: {
        __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
        node: {
          __typename?: 'MediaItem';
          altText: string | null;
          title: string | null;
          id: string;
          sourceUrl: string | null;
          srcSet: string | null;
          mediaDetails: {
            __typename?: 'MediaDetails';
            width: number | null;
            height: number | null;
          } | null;
        };
      } | null;
      strainTypes: {
        __typename?: 'StrainToStrainTypeConnection';
        nodes: Array<{
          __typename?: 'StrainType';
          name: string | null;
          slug: string | null;
        }>;
      } | null;
      details: {
        __typename?: 'Strain_Straindetails';
        cannabinoids: Array<{
          __typename?: 'Strain_Straindetails_cannabinoids';
          abbreviation: string | null;
          quantityStart: number | null;
          quantityEnd: number | null;
        } | null> | null;
        thc: {
          __typename?: 'Strain_Straindetails_Thc';
          quantityStart: number | null;
          quantityEnd: number | null;
        } | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToStrainConnectionPageInfo';
      offsetPagination: {
        __typename?: 'OffsetPaginationPageInfo';
        hasMore: boolean | null;
        hasPrevious: boolean | null;
        total: number | null;
      } | null;
    };
  } | null;
};

export type StrainTypesSearchQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type StrainTypesSearchQuery = {
  __typename?: 'RootQuery';
  strainTypes: {
    __typename?: 'RootQueryToStrainTypeConnection';
    nodes: Array<{
      __typename?: 'StrainType';
      name: string | null;
      slug: string | null;
    }>;
  } | null;
};

export type TerpenesSearchQueryVariables = Exact<{
  languageCode: InputMaybe<LanguageCodeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  afterCursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type TerpenesSearchQuery = {
  __typename?: 'RootQuery';
  terpenes: {
    __typename?: 'RootQueryToTerpeneConnection';
    nodes: Array<{
      __typename?: 'Terpene';
      name: string | null;
      slug: string | null;
    }>;
    pageInfo: {
      __typename?: 'RootQueryToTerpeneConnectionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
    };
  } | null;
};

export const PartnerInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInfo on Affiliate {
    id
    name
    uri
    scrapping: scrappingSettings {
      id: leafwellScrappingId
    }
  }
`;
export const SeoFullFragmentDoc = /*#__PURE__*/ gql`
  fragment SeoFull on Seo {
    canonical
    description
    title
    images {
      altText
      sourceUrl
      mediaDetails {
        height
        width
      }
    }
    opengraph {
      type
      title
      description
    }
    metaRobotsNofollow
    metaRobotsNoarchive
    metaRobotsNoindex
    redirect
  }
`;
export const MediaFragmentDoc = /*#__PURE__*/ gql`
  fragment Media on MediaItem {
    altText
    title
    id
    sourceUrl
    srcSet(size: $imageSize)
    mediaDetails {
      width
      height
    }
  }
`;
export const StrainExcerptFragmentDoc = /*#__PURE__*/ gql`
  fragment StrainExcerpt on Strain {
    id
    title
    uri
    date
    modified
    featuredImage {
      node {
        ...Media
      }
    }
    strainTypes {
      nodes {
        name
        slug
      }
    }
    details: strainDetails {
      cannabinoids {
        abbreviation
        quantityStart
        quantityEnd
      }
      thc {
        quantityStart
        quantityEnd
      }
    }
  }
  ${MediaFragmentDoc}
`;
export const LoginDocument = /*#__PURE__*/ gql`
  mutation Login(
    $clientMutationId: String
    $password: String!
    $username: String!
  ) {
    login(
      input: {
        clientMutationId: $clientMutationId
        password: $password
        username: $username
      }
    ) {
      refreshToken
      authToken
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *      password: // value for 'password'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options,
  );
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>;
export const RefreshAuthTokenDocument = /*#__PURE__*/ gql`
  mutation RefreshAuthToken($clientMutationId: String, $refreshToken: String!) {
    refreshJwtAuthToken(
      input: {
        clientMutationId: $clientMutationId
        jwtRefreshToken: $refreshToken
      }
    ) {
      authToken
    }
  }
`;
export type RefreshAuthTokenMutationFn = Apollo.MutationFunction<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>;

/**
 * __useRefreshAuthTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthTokenMutation, { data, loading, error }] = useRefreshAuthTokenMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAuthTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshAuthTokenMutation,
    RefreshAuthTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshAuthTokenMutation,
    RefreshAuthTokenMutationVariables
  >(RefreshAuthTokenDocument, options);
}
export type RefreshAuthTokenMutationHookResult = ReturnType<
  typeof useRefreshAuthTokenMutation
>;
export type RefreshAuthTokenMutationResult =
  Apollo.MutationResult<RefreshAuthTokenMutation>;
export type RefreshAuthTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>;
export const CreateReviewDocument = /*#__PURE__*/ gql`
  mutation CreateReview(
    $author: String!
    $content: String!
    $location: String
    $email: String
    $rating: Int!
    $photo: Base64File
  ) {
    createPublicReview(
      input: {
        content: $content
        location: $location
        rating: $rating
        photo: $photo
        author: $author
        email: $email
        clientMutationId: "leafwell-user-review"
      }
    ) {
      author
    }
  }
`;
export type CreateReviewMutationFn = Apollo.MutationFunction<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      author: // value for 'author'
 *      content: // value for 'content'
 *      location: // value for 'location'
 *      email: // value for 'email'
 *      rating: // value for 'rating'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useCreateReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReviewMutation,
    CreateReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReviewMutation,
    CreateReviewMutationVariables
  >(CreateReviewDocument, options);
}
export type CreateReviewMutationHookResult = ReturnType<
  typeof useCreateReviewMutation
>;
export type CreateReviewMutationResult =
  Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;
export const ConditionsByScrappingIdsDocument = /*#__PURE__*/ gql`
  query ConditionsByScrappingIds(
    $languageCode: LanguageCodeFilterEnum
    $scrappingIds: [String] = []
  ) {
    conditions(
      first: 1000
      where: { language: $languageCode, scrappingIds: $scrappingIds }
    ) {
      nodes {
        uri
        scrapping: scrappingSettings {
          id: leafwellScrappingId
        }
      }
    }
  }
`;

/**
 * __useConditionsByScrappingIdsQuery__
 *
 * To run a query within a React component, call `useConditionsByScrappingIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionsByScrappingIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionsByScrappingIdsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      scrappingIds: // value for 'scrappingIds'
 *   },
 * });
 */
export function useConditionsByScrappingIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConditionsByScrappingIdsQuery,
    ConditionsByScrappingIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConditionsByScrappingIdsQuery,
    ConditionsByScrappingIdsQueryVariables
  >(ConditionsByScrappingIdsDocument, options);
}
export function useConditionsByScrappingIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConditionsByScrappingIdsQuery,
    ConditionsByScrappingIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConditionsByScrappingIdsQuery,
    ConditionsByScrappingIdsQueryVariables
  >(ConditionsByScrappingIdsDocument, options);
}
export type ConditionsByScrappingIdsQueryHookResult = ReturnType<
  typeof useConditionsByScrappingIdsQuery
>;
export type ConditionsByScrappingIdsLazyQueryHookResult = ReturnType<
  typeof useConditionsByScrappingIdsLazyQuery
>;
export type ConditionsByScrappingIdsQueryResult = Apollo.QueryResult<
  ConditionsByScrappingIdsQuery,
  ConditionsByScrappingIdsQueryVariables
>;
export function refetchConditionsByScrappingIdsQuery(
  variables?: ConditionsByScrappingIdsQueryVariables,
) {
  return { query: ConditionsByScrappingIdsDocument, variables: variables };
}
export const ConditionsSearchDocument = /*#__PURE__*/ gql`
  query ConditionsSearch(
    $languageCode: LanguageCodeFilterEnum = DEFAULT
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    conditionsIds: conditions(
      where: {
        language: $languageCode
        orderby: { field: TITLE, order: ASC }
        searchTitle: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        title
        id: databaseId
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useConditionsSearchQuery__
 *
 * To run a query within a React component, call `useConditionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionsSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useConditionsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConditionsSearchQuery,
    ConditionsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConditionsSearchQuery, ConditionsSearchQueryVariables>(
    ConditionsSearchDocument,
    options,
  );
}
export function useConditionsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConditionsSearchQuery,
    ConditionsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConditionsSearchQuery,
    ConditionsSearchQueryVariables
  >(ConditionsSearchDocument, options);
}
export type ConditionsSearchQueryHookResult = ReturnType<
  typeof useConditionsSearchQuery
>;
export type ConditionsSearchLazyQueryHookResult = ReturnType<
  typeof useConditionsSearchLazyQuery
>;
export type ConditionsSearchQueryResult = Apollo.QueryResult<
  ConditionsSearchQuery,
  ConditionsSearchQueryVariables
>;
export function refetchConditionsSearchQuery(
  variables?: ConditionsSearchQueryVariables,
) {
  return { query: ConditionsSearchDocument, variables: variables };
}
export const AllPartnersByLanguageDocument = /*#__PURE__*/ gql`
  query AllPartnersByLanguage($languageCode: LanguageCodeFilterEnum) {
    affiliates(
      where: { language: $languageCode, scrappingIds: [] }
      first: 1000
    ) {
      nodes {
        ...PartnerInfo
      }
    }
  }
  ${PartnerInfoFragmentDoc}
`;

/**
 * __useAllPartnersByLanguageQuery__
 *
 * To run a query within a React component, call `useAllPartnersByLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartnersByLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartnersByLanguageQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useAllPartnersByLanguageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllPartnersByLanguageQuery,
    AllPartnersByLanguageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AllPartnersByLanguageQuery,
    AllPartnersByLanguageQueryVariables
  >(AllPartnersByLanguageDocument, options);
}
export function useAllPartnersByLanguageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllPartnersByLanguageQuery,
    AllPartnersByLanguageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllPartnersByLanguageQuery,
    AllPartnersByLanguageQueryVariables
  >(AllPartnersByLanguageDocument, options);
}
export type AllPartnersByLanguageQueryHookResult = ReturnType<
  typeof useAllPartnersByLanguageQuery
>;
export type AllPartnersByLanguageLazyQueryHookResult = ReturnType<
  typeof useAllPartnersByLanguageLazyQuery
>;
export type AllPartnersByLanguageQueryResult = Apollo.QueryResult<
  AllPartnersByLanguageQuery,
  AllPartnersByLanguageQueryVariables
>;
export function refetchAllPartnersByLanguageQuery(
  variables?: AllPartnersByLanguageQueryVariables,
) {
  return { query: AllPartnersByLanguageDocument, variables: variables };
}
export const PartnersByScrappingIdsDocument = /*#__PURE__*/ gql`
  query PartnersByScrappingIds($scrappingIds: [String] = []) {
    affiliates(first: 1000, where: { scrappingIds: $scrappingIds }) {
      nodes {
        ...PartnerInfo
      }
    }
  }
  ${PartnerInfoFragmentDoc}
`;

/**
 * __usePartnersByScrappingIdsQuery__
 *
 * To run a query within a React component, call `usePartnersByScrappingIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersByScrappingIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersByScrappingIdsQuery({
 *   variables: {
 *      scrappingIds: // value for 'scrappingIds'
 *   },
 * });
 */
export function usePartnersByScrappingIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersByScrappingIdsQuery,
    PartnersByScrappingIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PartnersByScrappingIdsQuery,
    PartnersByScrappingIdsQueryVariables
  >(PartnersByScrappingIdsDocument, options);
}
export function usePartnersByScrappingIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersByScrappingIdsQuery,
    PartnersByScrappingIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PartnersByScrappingIdsQuery,
    PartnersByScrappingIdsQueryVariables
  >(PartnersByScrappingIdsDocument, options);
}
export type PartnersByScrappingIdsQueryHookResult = ReturnType<
  typeof usePartnersByScrappingIdsQuery
>;
export type PartnersByScrappingIdsLazyQueryHookResult = ReturnType<
  typeof usePartnersByScrappingIdsLazyQuery
>;
export type PartnersByScrappingIdsQueryResult = Apollo.QueryResult<
  PartnersByScrappingIdsQuery,
  PartnersByScrappingIdsQueryVariables
>;
export function refetchPartnersByScrappingIdsQuery(
  variables?: PartnersByScrappingIdsQueryVariables,
) {
  return { query: PartnersByScrappingIdsDocument, variables: variables };
}
export const AllCuratedStrainsListsDocument = /*#__PURE__*/ gql`
  query AllCuratedStrainsLists {
    curatedStrainsLists(
      where: { language: DEFAULT, orderby: NAME, order: ASC }
      first: 0
    ) {
      nodes {
        slug
        language {
          slug
        }
        translations {
          uri
          language {
            slug
          }
        }
      }
    }
  }
`;

/**
 * __useAllCuratedStrainsListsQuery__
 *
 * To run a query within a React component, call `useAllCuratedStrainsListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCuratedStrainsListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCuratedStrainsListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCuratedStrainsListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllCuratedStrainsListsQuery,
    AllCuratedStrainsListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AllCuratedStrainsListsQuery,
    AllCuratedStrainsListsQueryVariables
  >(AllCuratedStrainsListsDocument, options);
}
export function useAllCuratedStrainsListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllCuratedStrainsListsQuery,
    AllCuratedStrainsListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllCuratedStrainsListsQuery,
    AllCuratedStrainsListsQueryVariables
  >(AllCuratedStrainsListsDocument, options);
}
export type AllCuratedStrainsListsQueryHookResult = ReturnType<
  typeof useAllCuratedStrainsListsQuery
>;
export type AllCuratedStrainsListsLazyQueryHookResult = ReturnType<
  typeof useAllCuratedStrainsListsLazyQuery
>;
export type AllCuratedStrainsListsQueryResult = Apollo.QueryResult<
  AllCuratedStrainsListsQuery,
  AllCuratedStrainsListsQueryVariables
>;
export function refetchAllCuratedStrainsListsQuery(
  variables?: AllCuratedStrainsListsQueryVariables,
) {
  return { query: AllCuratedStrainsListsDocument, variables: variables };
}
export const AromasSearchDocument = /*#__PURE__*/ gql`
  query AromasSearch(
    $languageCode: LanguageCodeFilterEnum
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    aromas(
      where: {
        language: $languageCode
        order: ASC
        orderby: NAME
        search: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        name
        slug
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useAromasSearchQuery__
 *
 * To run a query within a React component, call `useAromasSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAromasSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAromasSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAromasSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AromasSearchQuery,
    AromasSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AromasSearchQuery, AromasSearchQueryVariables>(
    AromasSearchDocument,
    options,
  );
}
export function useAromasSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AromasSearchQuery,
    AromasSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AromasSearchQuery, AromasSearchQueryVariables>(
    AromasSearchDocument,
    options,
  );
}
export type AromasSearchQueryHookResult = ReturnType<
  typeof useAromasSearchQuery
>;
export type AromasSearchLazyQueryHookResult = ReturnType<
  typeof useAromasSearchLazyQuery
>;
export type AromasSearchQueryResult = Apollo.QueryResult<
  AromasSearchQuery,
  AromasSearchQueryVariables
>;
export function refetchAromasSearchQuery(
  variables?: AromasSearchQueryVariables,
) {
  return { query: AromasSearchDocument, variables: variables };
}
export const CuratedStrainsListDocument = /*#__PURE__*/ gql`
  query CuratedStrainsList($slug: ID!) {
    curatedStrainsList(id: $slug, idType: SLUG) {
      id
      description
      name
      uri
      seo {
        ...SeoFull
      }
      language {
        slug
      }
      translations {
        uri
        language {
          locale
          slug
        }
      }
    }
  }
  ${SeoFullFragmentDoc}
`;

/**
 * __useCuratedStrainsListQuery__
 *
 * To run a query within a React component, call `useCuratedStrainsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuratedStrainsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuratedStrainsListQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCuratedStrainsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    CuratedStrainsListQuery,
    CuratedStrainsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CuratedStrainsListQuery,
    CuratedStrainsListQueryVariables
  >(CuratedStrainsListDocument, options);
}
export function useCuratedStrainsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CuratedStrainsListQuery,
    CuratedStrainsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CuratedStrainsListQuery,
    CuratedStrainsListQueryVariables
  >(CuratedStrainsListDocument, options);
}
export type CuratedStrainsListQueryHookResult = ReturnType<
  typeof useCuratedStrainsListQuery
>;
export type CuratedStrainsListLazyQueryHookResult = ReturnType<
  typeof useCuratedStrainsListLazyQuery
>;
export type CuratedStrainsListQueryResult = Apollo.QueryResult<
  CuratedStrainsListQuery,
  CuratedStrainsListQueryVariables
>;
export function refetchCuratedStrainsListQuery(
  variables: CuratedStrainsListQueryVariables,
) {
  return { query: CuratedStrainsListDocument, variables: variables };
}
export const FlavorsSearchDocument = /*#__PURE__*/ gql`
  query FlavorsSearch(
    $languageCode: LanguageCodeFilterEnum
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    flavors(
      where: {
        language: $languageCode
        order: ASC
        orderby: NAME
        search: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        name
        slug
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useFlavorsSearchQuery__
 *
 * To run a query within a React component, call `useFlavorsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlavorsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlavorsSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFlavorsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FlavorsSearchQuery,
    FlavorsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlavorsSearchQuery, FlavorsSearchQueryVariables>(
    FlavorsSearchDocument,
    options,
  );
}
export function useFlavorsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlavorsSearchQuery,
    FlavorsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlavorsSearchQuery, FlavorsSearchQueryVariables>(
    FlavorsSearchDocument,
    options,
  );
}
export type FlavorsSearchQueryHookResult = ReturnType<
  typeof useFlavorsSearchQuery
>;
export type FlavorsSearchLazyQueryHookResult = ReturnType<
  typeof useFlavorsSearchLazyQuery
>;
export type FlavorsSearchQueryResult = Apollo.QueryResult<
  FlavorsSearchQuery,
  FlavorsSearchQueryVariables
>;
export function refetchFlavorsSearchQuery(
  variables?: FlavorsSearchQueryVariables,
) {
  return { query: FlavorsSearchDocument, variables: variables };
}
export const PositiveEffectsSearchDocument = /*#__PURE__*/ gql`
  query PositiveEffectsSearch(
    $languageCode: LanguageCodeFilterEnum
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    positiveEffects(
      where: {
        language: $languageCode
        order: ASC
        orderby: NAME
        search: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        name
        slug
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __usePositiveEffectsSearchQuery__
 *
 * To run a query within a React component, call `usePositiveEffectsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositiveEffectsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositiveEffectsSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePositiveEffectsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PositiveEffectsSearchQuery,
    PositiveEffectsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PositiveEffectsSearchQuery,
    PositiveEffectsSearchQueryVariables
  >(PositiveEffectsSearchDocument, options);
}
export function usePositiveEffectsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PositiveEffectsSearchQuery,
    PositiveEffectsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PositiveEffectsSearchQuery,
    PositiveEffectsSearchQueryVariables
  >(PositiveEffectsSearchDocument, options);
}
export type PositiveEffectsSearchQueryHookResult = ReturnType<
  typeof usePositiveEffectsSearchQuery
>;
export type PositiveEffectsSearchLazyQueryHookResult = ReturnType<
  typeof usePositiveEffectsSearchLazyQuery
>;
export type PositiveEffectsSearchQueryResult = Apollo.QueryResult<
  PositiveEffectsSearchQuery,
  PositiveEffectsSearchQueryVariables
>;
export function refetchPositiveEffectsSearchQuery(
  variables?: PositiveEffectsSearchQueryVariables,
) {
  return { query: PositiveEffectsSearchDocument, variables: variables };
}
export const SearchStrainsDocument = /*#__PURE__*/ gql`
  query SearchStrains(
    $imageSize: MediaItemSizeEnum = LARGE
    $where: RootQueryToStrainConnectionWhereArgs = null
  ) {
    strains(where: $where) {
      nodes {
        ...StrainExcerpt
      }
      pageInfo {
        offsetPagination {
          hasMore
          hasPrevious
          total
        }
      }
    }
  }
  ${StrainExcerptFragmentDoc}
`;

/**
 * __useSearchStrainsQuery__
 *
 * To run a query within a React component, call `useSearchStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStrainsQuery({
 *   variables: {
 *      imageSize: // value for 'imageSize'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchStrainsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchStrainsQuery,
    SearchStrainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchStrainsQuery, SearchStrainsQueryVariables>(
    SearchStrainsDocument,
    options,
  );
}
export function useSearchStrainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchStrainsQuery,
    SearchStrainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchStrainsQuery, SearchStrainsQueryVariables>(
    SearchStrainsDocument,
    options,
  );
}
export type SearchStrainsQueryHookResult = ReturnType<
  typeof useSearchStrainsQuery
>;
export type SearchStrainsLazyQueryHookResult = ReturnType<
  typeof useSearchStrainsLazyQuery
>;
export type SearchStrainsQueryResult = Apollo.QueryResult<
  SearchStrainsQuery,
  SearchStrainsQueryVariables
>;
export function refetchSearchStrainsQuery(
  variables?: SearchStrainsQueryVariables,
) {
  return { query: SearchStrainsDocument, variables: variables };
}
export const StrainTypesSearchDocument = /*#__PURE__*/ gql`
  query StrainTypesSearch(
    $languageCode: LanguageCodeFilterEnum
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    strainTypes(
      where: {
        language: $languageCode
        order: ASC
        orderby: NAME
        search: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        name
        slug
      }
    }
  }
`;

/**
 * __useStrainTypesSearchQuery__
 *
 * To run a query within a React component, call `useStrainTypesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrainTypesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrainTypesSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useStrainTypesSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StrainTypesSearchQuery,
    StrainTypesSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StrainTypesSearchQuery,
    StrainTypesSearchQueryVariables
  >(StrainTypesSearchDocument, options);
}
export function useStrainTypesSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StrainTypesSearchQuery,
    StrainTypesSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StrainTypesSearchQuery,
    StrainTypesSearchQueryVariables
  >(StrainTypesSearchDocument, options);
}
export type StrainTypesSearchQueryHookResult = ReturnType<
  typeof useStrainTypesSearchQuery
>;
export type StrainTypesSearchLazyQueryHookResult = ReturnType<
  typeof useStrainTypesSearchLazyQuery
>;
export type StrainTypesSearchQueryResult = Apollo.QueryResult<
  StrainTypesSearchQuery,
  StrainTypesSearchQueryVariables
>;
export function refetchStrainTypesSearchQuery(
  variables?: StrainTypesSearchQueryVariables,
) {
  return { query: StrainTypesSearchDocument, variables: variables };
}
export const TerpenesSearchDocument = /*#__PURE__*/ gql`
  query TerpenesSearch(
    $languageCode: LanguageCodeFilterEnum
    $limit: Int = 20
    $afterCursor: String = null
    $search: String = null
  ) {
    terpenes(
      where: {
        language: $languageCode
        order: ASC
        orderby: NAME
        search: $search
      }
      after: $afterCursor
      first: $limit
    ) {
      nodes {
        name
        slug
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useTerpenesSearchQuery__
 *
 * To run a query within a React component, call `useTerpenesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerpenesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerpenesSearchQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      afterCursor: // value for 'afterCursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTerpenesSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TerpenesSearchQuery,
    TerpenesSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TerpenesSearchQuery, TerpenesSearchQueryVariables>(
    TerpenesSearchDocument,
    options,
  );
}
export function useTerpenesSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TerpenesSearchQuery,
    TerpenesSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TerpenesSearchQuery, TerpenesSearchQueryVariables>(
    TerpenesSearchDocument,
    options,
  );
}
export type TerpenesSearchQueryHookResult = ReturnType<
  typeof useTerpenesSearchQuery
>;
export type TerpenesSearchLazyQueryHookResult = ReturnType<
  typeof useTerpenesSearchLazyQuery
>;
export type TerpenesSearchQueryResult = Apollo.QueryResult<
  TerpenesSearchQuery,
  TerpenesSearchQueryVariables
>;
export function refetchTerpenesSearchQuery(
  variables?: TerpenesSearchQueryVariables,
) {
  return { query: TerpenesSearchDocument, variables: variables };
}
